(function() {window.pinuts = window.pinuts || {};window.pinuts.formtpl = window.pinuts.formtpl || {};window.pinuts.formtpl.base = window.pinuts.formtpl.base || {};window.pinuts.formPartials = window.pinuts.formPartials || {};window.pinuts.formPartials.base = window.pinuts.formPartials.base || {};window.pinuts.formClasses = ["FormWidget","handlebars","fields/Field","fields/SelectField","fields/RadioField","fields/CheckboxField","fields/FieldGroup","fields/MultiSelectField","fields/TextField","fields/TextareaField","fields/ReCaptchaV2","fields/FriendlyCaptcha","fields/CaptchaEU","fields/Pino4Field","fields/StringField","fields/HiddenField","fields/DateFieldNative","fields/TimeFieldNative","fields/CalendarField","fields/UploadField","fields/UploadField2","fields/ChtmlField","fields/TplField","fields/Nothing","fields/PasswordField","fields/PasswordLoginField","fields/DisabledTextField","fields/EmailConfirmField","lib/helpers/and","lib/helpers/caption","lib/helpers/captionNoTags","lib/helpers/contains","lib/helpers/dynamicPartial","lib/helpers/has","lib/helpers/ifContains","lib/helpers/ifCond","lib/helpers/ifEq","lib/helpers/ifNot","lib/helpers/valByPath","lib/require","fields/ConsentGroup","fields/NlFormWidget","fields/ShowChannelField","fields/UnsubscribeReasons","fields/CustomDataLoader","fields/EncryptedEditorMail","fields/NLArchive","fields/IndustryCardList","fields/IndustryCardUploadForm","fields/EMFormWidget","fields/EventAdditionalTexts","fields/EventDescription","fields/EventInfoBox","fields/EventListWidget","fields/EventNewsletter","fields/EventParticipants","fields/EventPersonalizedParticipants","fields/EventWorkshopGroup","fields/BaseSliderField","fields/DateFieldFmg","fields/DeleteProfileField","fields/EventParticipantsFmg","fields/EventPersonalizedParticipantsFmg","fields/FromToField","fields/LoungeCodeField","fields/ParkingCalenderField","fields/PasswordFieldFmg","fields/Phone3Field","fields/RangeSliderField","fields/SelectFieldFmg","fields/SliderField","fields/ToggelField","fields/UploadValidationDateField"];window.pinuts.formErrorClass = window.pinuts.formErrorClass || {};window.pinuts.formErrorClass.base = 'has-error';window.pinuts.formSuccessClass = window.pinuts.formSuccessClass || {};window.pinuts.formSuccessClass.base = 'dummy';window.pinuts.formIsEditClass = window.pinuts.formIsEditClass || {};;window.pinuts.formtpl.base.CalendarField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":92},"end":{"line":1,"column":106}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"calender\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":73},"end":{"line":1,"column":113}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <div class=\"piCalendar\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":36},"end":{"line":7,"column":49}}}) : helper)))
    + "\" ></div>\n        <input type=\"hidden\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":8,"column":36},"end":{"line":8,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":53},"end":{"line":8,"column":61}}}) : helper)))
    + "\" id=\"input_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":73},"end":{"line":8,"column":86}}}) : helper)))
    + "\">\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":41},"end":{"line":11,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.CaptchaEU = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-captchaeu-status\">\n            <div class=\"waiting\">\n                <div class=\"icon\">\n                    <i class=\"pi-spinner\" id=\"piSpinner\"></i>\n                </div>\n                <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"loadingText") : stack1), depth0))
    + "</span>\n            </div>\n            <div class=\"ready\">\n                <div class=\"icon\">\n                    <span>✔</span>\n                </div>\n                <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"successText") : stack1), depth0))
    + "</span>\n            </div>\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":18,"column":45},"end":{"line":18,"column":58}}}) : helper)))
    + "\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"renderSpiner") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":19,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.CheckboxTpl = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":39},"end":{"line":11,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":32},"end":{"line":15,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>                \n                <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":20,"column":60},"end":{"line":20,"column":68}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":20,"column":88},"end":{"line":20,"column":96}}}) : helper)))
    + "]\" value=\"on\" \n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":16},"end":{"line":21,"column":46}}})) != null ? stack1 : "")
    + "  />\n                <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":22,"column":45},"end":{"line":22,"column":53}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":22,"column":90},"end":{"line":22,"column":147}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":20},"end":{"line":25,"column":32}}})) != null ? stack1 : "")
    + "                </label>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":16},"end":{"line":29,"column":28}}})) != null ? stack1 : "")
    + "            </li>\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "checked";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":24,"column":114},"end":{"line":24,"column":124}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":28,"column":45},"end":{"line":28,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":6,"column":20}}})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "    <ul class=\"extended-item-space\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":31,"column":17}}})) != null ? stack1 : "")
    + "    </ul>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.CheckboxesTpl = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":9,"column":52},"end":{"line":9,"column":62}}}) : helper))) != null ? stack1 : "")
    + "</div> \n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":14,"column":39},"end":{"line":14,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":18,"column":32},"end":{"line":18,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "inline-list ";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":60},"end":{"line":23,"column":68}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":88},"end":{"line":23,"column":96}}}) : helper)))
    + "]\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":106},"end":{"line":23,"column":114}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":116},"end":{"line":23,"column":169}}})) != null ? stack1 : "")
    + " >\n                <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":24,"column":45},"end":{"line":24,"column":53}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":24,"column":90},"end":{"line":24,"column":147}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":20},"end":{"line":27,"column":32}}})) != null ? stack1 : "")
    + "                </label>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":16},"end":{"line":31,"column":28}}})) != null ? stack1 : "")
    + "            </li>\n";
},"13":function(container,depth0,helpers,partials,data) {
    return " checked ";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":26,"column":114},"end":{"line":26,"column":124}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":30,"column":45},"end":{"line":30,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":6,"column":20}}})) != null ? stack1 : "")
    + "    </div>    \n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":10,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":19,"column":16}}})) != null ? stack1 : "")
    + "    <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":15},"end":{"line":20,"column":66}}})) != null ? stack1 : "")
    + "extended-item-space pi-form-input pi-w-100\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":8},"end":{"line":33,"column":17}}})) != null ? stack1 : "")
    + "    </ul>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.DateField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" class=\"form-control\" \n               autocomplete=\"of\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"format") || (depth0 != null ? lookupProperty(depth0,"format") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"format","hash":{},"data":data,"loc":{"start":{"line":9,"column":28},"end":{"line":9,"column":38}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":10,"column":22},"end":{"line":10,"column":35}}}) : helper)))
    + "\"  />\n            <input type=\"hidden\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":45},"end":{"line":11,"column":58}}}) : helper)))
    + "_alt\" value=\"\"/>     \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.DateFieldNative = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"date\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"date\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               min=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"min") || (depth0 != null ? lookupProperty(depth0,"min") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"min","hash":{},"data":data,"loc":{"start":{"line":10,"column":20},"end":{"line":10,"column":27}}}) : helper)))
    + "\"\n               max=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"max") || (depth0 != null ? lookupProperty(depth0,"max") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"max","hash":{},"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":11,"column":27}}}) : helper)))
    + "\"\n        />\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.DisabledTextField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input name=\"dummy\" type=\"text\" disabled value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":7,"column":56},"end":{"line":7,"column":65}}}) : helper)))
    + "\" class=\"form-control\"  />        \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.EmailConfirmField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":7,"column":90},"end":{"line":7,"column":103}}}) : helper)))
    + "\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"captionNoTags")||(depth0 && lookupProperty(depth0,"captionNoTags"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"captionNoTags","hash":{},"data":data,"loc":{"start":{"line":8,"column":54},"end":{"line":8,"column":97}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":98},"end":{"line":8,"column":123}}})) != null ? stack1 : "")
    + "\"";
},"6":function(container,depth0,helpers,partials,data) {
    return "*";
},"8":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelConfirmEmail") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":87},"end":{"line":24,"column":112}}})) != null ? stack1 : "")
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    return "onpaste=\"return false\" autocomplete=\"off\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\" >\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":62},"end":{"line":7,"column":111}}})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":12},"end":{"line":8,"column":131}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" oncopy=\"return false\" />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":12,"column":41},"end":{"line":12,"column":54}}}) : helper)))
    + "\"></div>\n</div>\n<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":14,"column":17},"end":{"line":14,"column":25}}}) : helper)))
    + "-confirm\" data-pi-type=\"text\" class=\"pi-form-control pi-confirm-field"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":94},"end":{"line":14,"column":134}}})) != null ? stack1 : "")
    + "\" >\n    <div class=\"pi-form-label pi-confirm-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":16,"column":20},"end":{"line":16,"column":33}}}) : helper)))
    + "-confirm\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":16,"column":47},"end":{"line":16,"column":60}}}) : helper)))
    + "confirm_label\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelConfirmEmail") : stack1), depth0)) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":19,"column":19}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":19},"end":{"line":23,"column":32}}}) : helper)))
    + "-confirm\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":48},"end":{"line":23,"column":56}}}) : helper)))
    + "-confirm\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":78},"end":{"line":23,"column":127}}})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":12},"end":{"line":24,"column":120}}})) != null ? stack1 : "")
    + "\n               value=\"\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"copyPaste") : stack1),"no",{"name":"ifEq","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":24},"end":{"line":25,"column":109}}})) != null ? stack1 : "")
    + " />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":28,"column":41},"end":{"line":28,"column":54}}}) : helper)))
    + "-confirm\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.FieldGroup = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"field-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":24},"end":{"line":1,"column":38}}}) : helper)))
    + " pigroup\">\n</div>";
},"useData":true};window.pinuts.formtpl.base.FormWidget = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <button type=\"submit\" class=\"btn "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":13,"column":53},"end":{"line":13,"column":101}}})) != null ? stack1 : "")
    + " ml15\" form=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"submitId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":13,"column":152},"end":{"line":13,"column":160}}}) : helper)))
    + "\" data-submitbtn=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":13,"column":178},"end":{"line":13,"column":186}}}) : helper)))
    + "\">\n                        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pre-icon") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":24},"end":{"line":14,"column":61}}})) != null ? stack1 : "")
    + "\n                        <span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":15,"column":30},"end":{"line":15,"column":47}}}))
    + "</span>\n                    </button>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":13,"column":66},"end":{"line":13,"column":75}}}) : helper)));
},"4":function(container,depth0,helpers,partials,data) {
    return "btn-primary";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"pre-icon") || (depth0 != null ? lookupProperty(depth0,"pre-icon") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pre-icon","hash":{},"data":data,"loc":{"start":{"line":14,"column":40},"end":{"line":14,"column":54}}}) : helper))) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":1,"column":22},"end":{"line":1,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":1,"column":45},"end":{"line":1,"column":60}}}) : helper)))
    + "\"> \n    <header class=\"pi-heading\"><hgroup id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"titleId") || (depth0 != null ? lookupProperty(depth0,"titleId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"titleId","hash":{},"data":data,"loc":{"start":{"line":2,"column":43},"end":{"line":2,"column":54}}}) : helper)))
    + "\"><h2>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.heading",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":60},"end":{"line":2,"column":86}}}))
    + "</h2></hgroup></header> \n    <div class=\"pi-message\"><div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":3,"column":37},"end":{"line":3,"column":52}}}) : helper)))
    + "\" class=\"pi-message-text mb15\" style=\"display: none\"></div></div>\n    <form action=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":4,"column":24},"end":{"line":4,"column":37}}}) : helper)))
    + "\" class=\"row\"> \n        <div class=\"pi-form\" >\n        </div> \n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgFromId") || (depth0 != null ? lookupProperty(depth0,"msgFromId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgFromId","hash":{},"data":data,"loc":{"start":{"line":8,"column":17},"end":{"line":8,"column":30}}}) : helper)))
    + "\" class=\"error-container col-xs-12\"></div> \n        <div class=\"pi-form-actions col-xs-12\" >\n            <div class=\"btn-group btn-group-hspace pi-form-button\"> \n                <button type=\"submit\" class=\"btn btn-primary\" form=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":68},"end":{"line":11,"column":81}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"submitId") || (depth0 != null ? lookupProperty(depth0,"submitId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"submitId","hash":{},"data":data,"loc":{"start":{"line":11,"column":87},"end":{"line":11,"column":99}}}) : helper)))
    + "\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.submitBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":11,"column":107},"end":{"line":11,"column":135}}}))
    + "</span></button>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"submitButtons") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":17,"column":25}}})) != null ? stack1 : "")
    + "            </div>\n        </div> \n    </form>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.FormErrors = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":25}}}) : helper)))
    + ": "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msg") || (depth0 != null ? lookupProperty(depth0,"msg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msg","hash":{},"data":data,"loc":{"start":{"line":5,"column":27},"end":{"line":5,"column":34}}}) : helper)))
    + "</li>        \n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-message-text \" role=\"alert\"> \n    <p>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"errors.formerror",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":37}}}))
    + "</p>\n    <ul>               \n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"errors") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":17}}})) != null ? stack1 : "")
    + "    </ul>   \n</div>";
},"useData":true};window.pinuts.formtpl.base.HiddenField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":11},"end":{"line":1,"column":24}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":32},"end":{"line":1,"column":40}}}) : helper)))
    + "\" type=\"hidden\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":1,"column":63},"end":{"line":1,"column":72}}}) : helper)))
    + "\" />";
},"useData":true};window.pinuts.formtpl.base.piHorizontalSeparation = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pi-form-control\" data-pi-input-type=\"spacer-row-default\">\n    <hr class=\"pi-hr\">\n</div>";
},"useData":true};window.pinuts.formtpl.base.piHorizontalSeparationStrong = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pi-form-control\" data-pi-input-type=\"spacer-row-strong\">\n    <hr class=\"pi-hr-strong\">\n</div>";
},"useData":true};window.pinuts.formtpl.base.PasswordField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":9,"column":58},"end":{"line":9,"column":95}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":96},"end":{"line":9,"column":124}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":18,"column":80},"end":{"line":18,"column":90}}}) : helper))) != null ? stack1 : "")
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":19,"column":82}}})) != null ? stack1 : "")
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "<span class=\"pi-mandatory\">&#42;</span>";
},"7":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":24,"column":143},"end":{"line":24,"column":156}}}) : helper)))
    + "\"";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label2",{"name":"caption","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":61},"end":{"line":25,"column":149}}})) != null ? stack1 : "")
    + "\"";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":25,"column":100},"end":{"line":25,"column":108}}}) : helper)))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":109},"end":{"line":25,"column":137}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\n    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":2,"column":21},"end":{"line":2,"column":29}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":53}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":2,"column":73},"end":{"line":2,"column":87}}}) : helper)))
    + "\" >\n        <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </div>\n        <div class=\"pi-form-helptext\"></div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":23},"end":{"line":8,"column":36}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":44},"end":{"line":8,"column":52}}}) : helper)))
    + "\" type=\"password\" autocomplete=\"off\"  class=\"form-control\"\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":9,"column":132}}})) != null ? stack1 : "")
    + "\n                value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":10,"column":23},"end":{"line":10,"column":32}}}) : helper)))
    + "\" />\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error mt5\"></div>\n    </div>\n\n    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":16,"column":21},"end":{"line":16,"column":29}}}) : helper)))
    + "_2\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":47},"end":{"line":16,"column":55}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":16,"column":75},"end":{"line":16,"column":89}}}) : helper)))
    + "\">\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":18,"column":24},"end":{"line":18,"column":37}}}) : helper)))
    + "_2\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label2",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":41},"end":{"line":20,"column":24}}})) != null ? stack1 : "")
    + "            </label>\n        </div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":24,"column":23},"end":{"line":24,"column":36}}}) : helper)))
    + "_2\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":24,"column":46},"end":{"line":24,"column":54}}}) : helper)))
    + "_2\" type=\"password\" autocomplete=\"off\"  class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":115},"end":{"line":24,"column":164}}})) != null ? stack1 : "")
    + "\n                   "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":19},"end":{"line":25,"column":157}}})) != null ? stack1 : "")
    + "\n                   value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value2") || (depth0 != null ? lookupProperty(depth0,"value2") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value2","hash":{},"data":data,"loc":{"start":{"line":26,"column":26},"end":{"line":26,"column":36}}}) : helper)))
    + "\"/>\n        </div>\n        <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":28,"column":38},"end":{"line":28,"column":80}}})) != null ? stack1 : "")
    + "</div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error mt5\"></div>\n    </div>\n</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.base.PasswordLoginField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":57},"end":{"line":8,"column":94}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":95},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"password\" autocomplete=\"off\"  class=\"form-control\" \n               "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":15},"end":{"line":8,"column":128}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" />        \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.piTextBox = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label >"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customLabel") : stack1), depth0))
    + "</label>\n        </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pi-form-input\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"string\" class=\"pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClass") || (depth0 != null ? lookupProperty(depth0,"cssClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClass","hash":{},"data":data,"loc":{"start":{"line":1,"column":72},"end":{"line":1,"column":84}}}) : helper)))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClass") : stack1), depth0))
    + "\" >\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customLabel") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.Pino4Field = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":2,"column":21},"end":{"line":2,"column":29}}}) : helper)))
    + "\" data-pi-type=\"pino4\" class=\"pi-form-control\" >\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":4,"column":24},"end":{"line":4,"column":37}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Label") || (depth0 != null ? lookupProperty(depth0,"pino4Label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Label","hash":{},"data":data,"loc":{"start":{"line":4,"column":39},"end":{"line":4,"column":53}}}) : helper)))
    + "</label>    \n        </div> \n        <div class=\"pi-form-helptext\"></div> \n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":23},"end":{"line":8,"column":36}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Name") || (depth0 != null ? lookupProperty(depth0,"pino4Name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Name","hash":{},"data":data,"loc":{"start":{"line":8,"column":44},"end":{"line":8,"column":57}}}) : helper)))
    + "\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":71},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\n                   "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":19},"end":{"line":9,"column":83}}})) != null ? stack1 : "")
    + "\n                   value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":10,"column":26},"end":{"line":10,"column":35}}}) : helper)))
    + "\" />        \n        </div> \n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n        <div class=\"pi-form-error\"></div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":8,"column":99},"end":{"line":8,"column":112}}}) : helper)))
    + "\"";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Label") || (depth0 != null ? lookupProperty(depth0,"pino4Label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Label","hash":{},"data":data,"loc":{"start":{"line":9,"column":61},"end":{"line":9,"column":75}}}) : helper)))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pfields") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":15,"column":9}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.base.RadioField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":73},"end":{"line":2,"column":83}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":12},"end":{"line":5,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n            ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"pi-info-window\">\n                    <span class=\"pi-info-icon\"></span>\n                    <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":9,"column":47},"end":{"line":9,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</span>\n                </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":13,"column":40},"end":{"line":13,"column":50}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "inline-list";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>                \n                <input type=\"radio\" class=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":18,"column":71},"end":{"line":18,"column":79}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":18,"column":107},"end":{"line":18,"column":115}}}) : helper)))
    + "\" \n                "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":19,"column":66}}})) != null ? stack1 : "")
    + "  />\n                <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":20,"column":45},"end":{"line":20,"column":53}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":20,"column":90},"end":{"line":20,"column":147}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":20},"end":{"line":23,"column":32}}})) != null ? stack1 : "")
    + "                </label>\n            </li>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return " checked=\"checked\"";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":22,"column":110},"end":{"line":22,"column":120}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n        <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":35},"end":{"line":5,"column":31}}})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":11,"column":24}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":14,"column":24}}})) != null ? stack1 : "")
    + "        <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":19},"end":{"line":15,"column":69}}})) != null ? stack1 : "")
    + " extended-item-space\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":26,"column":21}}})) != null ? stack1 : "")
    + "        </ul>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n        <div class=\"pi-form-error mt5\"></div>\n    </div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.SelectField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "         <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":9,"column":24},"end":{"line":9,"column":32}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":34},"end":{"line":9,"column":74}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),"__",{"name":"ifEq","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":75},"end":{"line":9,"column":165}}})) != null ? stack1 : "")
    + ">\n                 "
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":10,"column":17},"end":{"line":10,"column":72}}}))
    + "\n         </option>                      \n";
},"2":function(container,depth0,helpers,partials,data) {
    return "selected";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "class=\"placeholder\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"value") : depths[2]),{"name":"unless","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":114},"end":{"line":9,"column":156}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":22},"end":{"line":7,"column":30}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":36},"end":{"line":7,"column":49}}}) : helper)))
    + "\" class=\"form-control selectBox\" >\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":12,"column":17}}})) != null ? stack1 : "")
    + "        </select>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.base.StringField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":4,"column":98},"end":{"line":4,"column":108}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" >\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":2,"column":70}}})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":5,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":8,"column":16}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.TextField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":57},"end":{"line":8,"column":94}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":95},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "               <span class=\"input-group-btn\">\n                   <button class=\"btn-info js-tooltip-trigger\" type=\"button\">\n                       <span class=\"sr-only\">Information</span>\n                       <svg class=\"icon icon-info\" role=\"img\" aria-hidden=\"true\">\n                           <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-info\"></use>\n                       </svg>\n                   </button>\n                </span>\n                <div class=\"info-container js-tooltip bg-bright sr-only\">\n                    <button class=\"btn btn-close js-tooltip-close\">\n                        <span class=\"sr-only\">schlie&szlig;en</span>\n                        <svg class=\"icon icon-close\" role=\"img\" aria-hidden=\"true\">\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-close\"></use>\n                        </svg>\n                    </button>\n                    <div class=\"info-content\">\n                        <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":27,"column":27},"end":{"line":27,"column":37}}}) : helper))) != null ? stack1 : "")
    + "</p>\n                    </div>\n                </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input input-group info-wrapper js-tooltip-context\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" class=\"form-control\" \n               "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":15},"end":{"line":8,"column":128}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" />\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":30,"column":24}}})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.TextareaField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":60},"end":{"line":8,"column":97}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":98},"end":{"line":8,"column":123}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">        \n        <textarea id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":22},"end":{"line":7,"column":35}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":43},"end":{"line":7,"column":51}}}) : helper)))
    + "\" class=\"form-control\" \n                  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":18},"end":{"line":8,"column":131}}})) != null ? stack1 : "")
    + "\n                  >"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":19},"end":{"line":9,"column":28}}}) : helper)))
    + "</textarea>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.TimeField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":93},"end":{"line":1,"column":107}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"timestamp\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":114}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"text\"  \n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               autocomplete=\"new-password\" />\n        <input class=\"time\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":11,"column":34},"end":{"line":11,"column":42}}}) : helper)))
    + "_time\" id=\"pitime_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":60},"end":{"line":11,"column":73}}}) : helper)))
    + "\" type=\"text\" placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"format_time") || (depth0 != null ? lookupProperty(depth0,"format_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"format_time","hash":{},"data":data,"loc":{"start":{"line":11,"column":100},"end":{"line":11,"column":115}}}) : helper)))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValueTime") || (depth0 != null ? lookupProperty(depth0,"formValueTime") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValueTime","hash":{},"data":data,"loc":{"start":{"line":11,"column":124},"end":{"line":11,"column":141}}}) : helper)))
    + "\" autocomplete=\"new-password\"/>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":14,"column":41},"end":{"line":14,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.TimeFieldNative = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":93},"end":{"line":1,"column":107}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"timestamp\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":114}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n        "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "NATIV\n    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"datetime-local\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               min=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"min") || (depth0 != null ? lookupProperty(depth0,"min") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"min","hash":{},"data":data,"loc":{"start":{"line":10,"column":20},"end":{"line":10,"column":27}}}) : helper)))
    + "\"\n               max=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"max") || (depth0 != null ? lookupProperty(depth0,"max") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"max","hash":{},"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":11,"column":27}}}) : helper)))
    + "\"\n               autocomplete=\"new-password\" />\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.UploadField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":101},"end":{"line":1,"column":115}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"upload\" class=\"form-group pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":82},"end":{"line":1,"column":122}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":46}}}) : helper)))
    + "</div> \n    <div class=\"pi-form-input\">\n        <div class=\"upload-container\">\n            <ul class=\"upload-filelist\"></ul>\n            <iframe src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"uploadIframeUrlQuery") || (depth0 != null ? lookupProperty(depth0,"uploadIframeUrlQuery") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"uploadIframeUrlQuery","hash":{},"data":data,"loc":{"start":{"line":9,"column":25},"end":{"line":9,"column":49}}}) : helper)))
    + "\" frameborder=\"0\" class=\"iframe-upload\" width=\"100%\"></iframe>\n        </div>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.UploadFileinfo = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li id=\"upload-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":15},"end":{"line":1,"column":25}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":35}}}) : helper)))
    + " ("
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"size") || (depth0 != null ? lookupProperty(depth0,"size") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"size","hash":{},"data":data,"loc":{"start":{"line":1,"column":37},"end":{"line":1,"column":45}}}) : helper)))
    + " Bytes) <a href=\"#\" data-ticket=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":78},"end":{"line":1,"column":88}}}) : helper)))
    + "\" class=\"upload-delete-file\"></a></li>";
},"useData":true};window.pinuts.formtpl.base.UploadField2 = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":90},"end":{"line":1,"column":104}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"upload\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":71},"end":{"line":1,"column":111}}})) != null ? stack1 : "")
    + "\">\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"pi-form-helptext\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":46}}}) : helper)))
    + "</div>\n    <div class=\"pi-form-input\">\n        <ul class=\"upload-filelist\"></ul>\n        <div class=\"upload2-container\">\n            <span class=\"pi-spinner pi-hoi\" ></span>\n            <input class=\"upload2-input\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":45},"end":{"line":10,"column":58}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":74}}}) : helper)))
    + "\" type=\"file\">\n        </div>\n    </div>\n\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.base.UploadFileinfo2 = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li id=\"upload-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":15},"end":{"line":1,"column":25}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":35}}}) : helper)))
    + " ("
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"size") || (depth0 != null ? lookupProperty(depth0,"size") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"size","hash":{},"data":data,"loc":{"start":{"line":1,"column":37},"end":{"line":1,"column":45}}}) : helper)))
    + " Bytes) <span class=\"delicon\" data-ticket=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":98}}}) : helper)))
    + "\"><a class=\"upload-delete-file\" href=\"#\"></a></span></li>";
},"useData":true};window.pinuts.formtpl.base.ConsentGroup = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label >"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":79}}})) != null ? stack1 : "")
    + "\n            </label>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "<span class=\"pi-mandatory\">&#42;</span>";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext\">\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "       <div class=\"pi-form-input\">\n          <span class=\"pi-checkbox-control-vertical\">\n            <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":56},"end":{"line":17,"column":65}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":85},"end":{"line":17,"column":94}}}) : helper)))
    + "]\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":104},"end":{"line":17,"column":113}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"default") : depth0),"==","true",{"name":"ifCond","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":115},"end":{"line":17,"column":164}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"value") : depth0),(depths[1] != null ? lookupProperty(depths[1],"checkedBoxes") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":165},"end":{"line":17,"column":224}}})) != null ? stack1 : "")
    + "/>\n            <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":18,"column":41},"end":{"line":18,"column":50}}}) : helper)))
    + "\">"
    + ((stack1 = (lookupProperty(helpers,"valByPath")||(depth0 && lookupProperty(depth0,"valByPath"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),(depths[1] != null ? lookupProperty(depths[1],"locale") : depths[1]),{"name":"valByPath","hash":{},"data":data,"loc":{"start":{"line":18,"column":52},"end":{"line":18,"column":83}}})) != null ? stack1 : "")
    + "</label>\n          </span>\n       </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"checkbox\" class=\"pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":88}}}) : helper)))
    + "\" >\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"label") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"consentFields") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":21,"column":13}}})) != null ? stack1 : "")
    + "    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.UnsubscribeReasonsOther = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"pi-form-input\" id=\"otherTextDiv\" style=\"display:none\">        \n    <textarea id=\"otherText\" class=\"form-control\" name=\"otherText\" ></textarea>\n</li>";
},"useData":true};window.pinuts.formtpl.base.nlBtnDeleteProfile = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":39}}}) : helper)))
    + "-btnDeleteProfile\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.deleteProfileBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":64},"end":{"line":1,"column":99}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.base.nlBtnLogin = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":39}}}) : helper)))
    + "-btnLogin\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"buttons.login",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":83}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.base.nlLinkProfile = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"javascript:void(0)\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":33},"end":{"line":1,"column":46}}}) : helper)))
    + "-piEditProfile\"><div>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"buttons.editProfile",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":67},"end":{"line":1,"column":100}}}))
    + "</div></a>";
},"useData":true};window.pinuts.formtpl.base.nlAnonymLink = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"javascript:void(0)\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":33},"end":{"line":1,"column":46}}}) : helper)))
    + "-btnAnonymous\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.btnAnonymous",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":61},"end":{"line":1,"column":92}}}))
    + "</a>";
},"useData":true};window.pinuts.formtpl.base.ShowChannelField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"groups") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":14,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\n            <ul class=\"channels\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"channels") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":11,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                 <li>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",depth0,"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":10,"column":21},"end":{"line":10,"column":78}}})) != null ? stack1 : "")
    + "</li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"pi-form-control\" >    \n     <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"groups") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.base.NLArchive = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <div class=\"row\">\n                    <div class=\"cell\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"date","hash":{},"data":data,"loc":{"start":{"line":9,"column":38},"end":{"line":9,"column":46}}}) : helper)))
    + " <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"url","hash":{},"data":data,"loc":{"start":{"line":9,"column":56},"end":{"line":9,"column":63}}}) : helper)))
    + "\" target=\"_blank\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":9,"column":81},"end":{"line":9,"column":90}}}) : helper)))
    + "</a></div>\n                </div>                  \n            </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">    \n    <h3>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":19}}}) : helper)))
    + "</h3>\n    <div class=\"group table-listing\">      \n        <ul>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"newsletters") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":12,"column":20}}})) != null ? stack1 : "")
    + "        </ul>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.IndustryCardList = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"table-container\">\n        <table class=\"table\">\n            <thead>\n                <th>Dateiname</th>\n                <th>Gültig bis</th>\n                <th>Upload-Datum</th>\n            </thead>\n            <tbody>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"uploadList") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":16},"end":{"line":22,"column":25}}})) != null ? stack1 : "")
    + "            </tbody>\n        </table>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <tr>\n                        <td>\n                            <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"link") || (depth0 != null ? lookupProperty(depth0,"link") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":13,"column":37},"end":{"line":13,"column":45}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":47},"end":{"line":13,"column":55}}}) : helper)))
    + "</a>\n                        </td>\n                        <td>\n                            "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"validity") || (depth0 != null ? lookupProperty(depth0,"validity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"validity","hash":{},"data":data,"loc":{"start":{"line":16,"column":28},"end":{"line":16,"column":40}}}) : helper)))
    + "\n                        </td>\n                        <td>\n                            "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"date","hash":{},"data":data,"loc":{"start":{"line":19,"column":28},"end":{"line":19,"column":36}}}) : helper)))
    + "\n                        </td>\n                    </tr>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"uploadList") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":26,"column":7}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.base.EventAdditionalTexts = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":21},"end":{"line":3,"column":29}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":73},"end":{"line":3,"column":113}}})) != null ? stack1 : "")
    + "\" >\n        <div class=\"pi-form-label\">\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":5,"column":23}}}) : helper))) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"pi-form-helptext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":7,"column":38},"end":{"line":7,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":3,"column":92},"end":{"line":3,"column":106}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"additionalTexts") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":9,"column":9}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.base.EventCustomText = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"eventtext pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClass") || (depth0 != null ? lookupProperty(depth0,"cssClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":38},"end":{"line":2,"column":50}}}) : helper)))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClass") : stack1), depth0))
    + "\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1), depth0)) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.evBtnDeleteBooking = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" class=\"btn btn-primary mr15\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":2,"column":55},"end":{"line":2,"column":68}}}) : helper)))
    + "-evDeleteBooking\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.cancelBookingBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":92},"end":{"line":2,"column":127}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.base.EventDescription = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"eventtext pi-form-control \">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ev_description") || (depth0 != null ? lookupProperty(depth0,"ev_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_description","hash":{},"data":data,"loc":{"start":{"line":2,"column":40},"end":{"line":2,"column":60}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.EventInfoBox = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":6,"column":13},"end":{"line":6,"column":24}}}) : helper)))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_time") || (depth0 != null ? lookupProperty(depth0,"ev_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_time","hash":{},"data":data,"loc":{"start":{"line":11,"column":13},"end":{"line":11,"column":24}}}) : helper)))
    + "</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"eventRoom") || (depth0 != null ? lookupProperty(depth0,"eventRoom") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"eventRoom","hash":{},"data":data,"loc":{"start":{"line":14,"column":13},"end":{"line":14,"column":26}}}) : helper)))
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_street") || (depth0 != null ? lookupProperty(depth0,"location_street") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_street","hash":{},"data":data,"loc":{"start":{"line":17,"column":13},"end":{"line":17,"column":32}}}) : helper)))
    + "</div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_zip") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":13},"end":{"line":20,"column":57}}})) != null ? stack1 : "")
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_city") || (depth0 != null ? lookupProperty(depth0,"location_city") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_city","hash":{},"data":data,"loc":{"start":{"line":20,"column":57},"end":{"line":20,"column":74}}}) : helper)))
    + "</div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_zip") || (depth0 != null ? lookupProperty(depth0,"location_zip") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_zip","hash":{},"data":data,"loc":{"start":{"line":20,"column":33},"end":{"line":20,"column":49}}}) : helper)))
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-form-control eventinfobox\">\n    <h3>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_title") || (depth0 != null ? lookupProperty(depth0,"ev_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_title","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":20}}}) : helper)))
    + "</h3>\n    <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nice_date") || (depth0 != null ? lookupProperty(depth0,"nice_date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nice_date","hash":{},"data":data,"loc":{"start":{"line":4,"column":9},"end":{"line":4,"column":22}}}) : helper)))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ed_time") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "    <div>&nbsp;</div>\n    <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_name") || (depth0 != null ? lookupProperty(depth0,"location_name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_name","hash":{},"data":data,"loc":{"start":{"line":9,"column":9},"end":{"line":9,"column":26}}}) : helper)))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ev_time") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":12,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"eventRoom") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_street") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_city") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":4},"end":{"line":21,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.base.EventListWidget = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <div class=\"row\">\n                    <div class=\"cell\" data-label=\"Titel\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_title") || (depth0 != null ? lookupProperty(depth0,"ev_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_title","hash":{},"data":data,"loc":{"start":{"line":20,"column":57},"end":{"line":20,"column":69}}}) : helper)))
    + "</div>\n                    <div class=\"cell\" data-label=\"Datum\"><time datetime=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_from") || (depth0 != null ? lookupProperty(depth0,"ed_from") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_from","hash":{},"data":data,"loc":{"start":{"line":21,"column":73},"end":{"line":21,"column":84}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_from") || (depth0 != null ? lookupProperty(depth0,"ed_from") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_from","hash":{},"data":data,"loc":{"start":{"line":21,"column":86},"end":{"line":21,"column":97}}}) : helper)))
    + "</time></div>\n                    <div class=\"cell\" data-label=\"Uhrzeit\"><time datetime=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":22,"column":75},"end":{"line":22,"column":86}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":22,"column":88},"end":{"line":22,"column":99}}}) : helper)))
    + "</time></div>\n                    <div class=\"cell\" data-label=\"Freie Plätze\"><span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"vacancies") || (depth0 != null ? lookupProperty(depth0,"vacancies") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"vacancies","hash":{},"data":data,"loc":{"start":{"line":23,"column":70},"end":{"line":23,"column":83}}}) : helper)))
    + " <span class=\"aural\">Freie Plätze</span></span></div>\n                    <div class=\"cell\">\n                        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":24},"end":{"line":26,"column":152}}})) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n                </li>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ed_altformurl") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(5, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":49},"end":{"line":25,"column":121}}})) != null ? stack1 : "")
    + "?ev="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cookie") || (depth0 != null ? lookupProperty(depth0,"cookie") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cookie","hash":{},"data":data,"loc":{"start":{"line":25,"column":125},"end":{"line":25,"column":135}}}) : helper)))
    + "\" class=\"btn\" title=\"Diesen Termin buchen\">\n                            <span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.selectev",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":26,"column":34},"end":{"line":26,"column":61}}}))
    + "</span></a>";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_altformurl") || (depth0 != null ? lookupProperty(depth0,"ed_altformurl") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_altformurl","hash":{},"data":data,"loc":{"start":{"line":25,"column":70},"end":{"line":25,"column":87}}}) : helper)));
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"eventFormUrl") : depths[1]), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"btn btn-disabled\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.selectev",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":26,"column":111},"end":{"line":26,"column":138}}}))
    + "</span>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">\n    <div class=\"pi-message\">\n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":4,"column":17},"end":{"line":4,"column":32}}}) : helper)))
    + "\" class=\"pi-message-text\" style=\"display: none\"></div>\n    </div>\n    <div class=\"group table-listing\">\n        <header>\n            <div class=\"row\">\n                <div class=\"cell\"><span>Titel</span></div>\n                <div class=\"cell\"><span>Datum</span></div>\n                <div class=\"cell\"><span>Uhrzeit</span></div>\n                <div class=\"cell\"><span>Freie&nbsp;Plätze</span></div>\n                <div class=\"cell\"><span class=\"aural\">Buchen</span></div>\n            </div>\n        </header>\n        <ul>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"evenList") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":30,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.eventMsg = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">\n    <div class=\"pi-heading\"><p id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"titleId") || (depth0 != null ? lookupProperty(depth0,"titleId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"titleId","hash":{},"data":data,"loc":{"start":{"line":3,"column":35},"end":{"line":3,"column":46}}}) : helper)))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.heading",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":3,"column":48},"end":{"line":3,"column":74}}}))
    + "</p></div>\n    <div class=\"pi-message\">\n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":32}}}) : helper)))
    + "\" class=\"pi-message-text\" ></div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.EventNewsletter = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- just a dummy, show nothing  -->";
},"useData":true};window.pinuts.formtpl.base.EventParticipants = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"eventtext pi-form-control pi-infotext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"participantLimit") || (depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"participantLimit","hash":{},"data":data,"loc":{"start":{"line":3,"column":55},"end":{"line":3,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"helpText") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":9,"column":21},"end":{"line":9,"column":29}}}) : helper)))
    + "\" data-pi-type=\"select\" class=\"pi-form-control participants pi_event_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":9,"column":98},"end":{"line":9,"column":106}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":9,"column":129},"end":{"line":9,"column":137}}}) : helper)))
    + "\">\n        <div class=\"pi-form-label\"><label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":10,"column":64},"end":{"line":10,"column":72}}}) : helper)))
    + "\" class=\"pi-form-label selectbox participants\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":10,"column":119},"end":{"line":10,"column":130}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":13,"column":19}}})) != null ? stack1 : "")
    + "        </label></div>\n        <div class=\"pi-form-input\">\n            <select id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":41},"end":{"line":16,"column":49}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":62},"end":{"line":16,"column":70}}}) : helper)))
    + "\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":16,"column":82},"end":{"line":16,"column":89}}}) : helper)))
    + "\" class=\"participants_select form-control selectBox\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"num") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":19,"column":25}}})) != null ? stack1 : "")
    + "            </select>\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error-text\" id=\"errorMsg"
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":23,"column":68},"end":{"line":23,"column":76}}}) : helper)))
    + "\"></div>\n        <div class=\"pi-form-helptext\"></div>\n    </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"eventtext pi-form-control pi-infotext\"><p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":7,"column":62},"end":{"line":7,"column":74}}}) : helper)))
    + "</p></div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "                    <option value=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</option>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group col-xs-12 col-sm-12\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.EventPersonalizedParticipants = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"personalize_participants\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"helpText") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "\n        <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":25},"end":{"line":8,"column":33}}}) : helper)))
    + "\" data-pi-type=\"select\" class=\"pi-form-control participants pi_event_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":8,"column":102},"end":{"line":8,"column":110}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":8,"column":133},"end":{"line":8,"column":141}}}) : helper)))
    + "\">\n\n            <div class=\"pi-form-label\"><label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":10,"column":68},"end":{"line":10,"column":76}}}) : helper)))
    + "\" class=\"pi-form-label selectbox participants\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":16},"end":{"line":13,"column":23}}})) != null ? stack1 : "")
    + "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"locales") : depth0)) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\n            </label></div>\n            <div class=\"pi-form-input\">\n                <select id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":17,"column":45},"end":{"line":17,"column":53}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":17,"column":66},"end":{"line":17,"column":74}}}) : helper)))
    + "\" class=\"participants_select form-control selectBox\">\n                    <option value=\"\"></option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":20},"end":{"line":21,"column":29}}})) != null ? stack1 : "")
    + "                </select>\n            </div>\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":36,"column":21}}})) != null ? stack1 : "")
    + "\n            <div class=\"no_participants_select_info\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"locales") : depth0)) != null ? lookupProperty(stack1,"nomore_info") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n            <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n            <div class=\"pi-form-error-text\" id=\"errorMsg"
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":40,"column":72},"end":{"line":40,"column":80}}}) : helper)))
    + "\"></div>\n            <div class=\"pi-form-helptext\"></div>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"eventtext pi-form-control pi-infotext\"><p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":66},"end":{"line":5,"column":78}}}) : helper)))
    + "</p></div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "                    <span class=\"pi-mandatory\">&#42;</span>\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":20,"column":39},"end":{"line":20,"column":47}}}) : helper)))
    + "\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":20,"column":59},"end":{"line":20,"column":66}}}) : helper)))
    + "\" data-label=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":20,"column":80},"end":{"line":20,"column":91}}}) : helper))) != null ? stack1 : "")
    + "\" data-maxreached=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"maxreached") : stack1), depth0)) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":20,"column":139},"end":{"line":20,"column":150}}}) : helper))) != null ? stack1 : "")
    + "</option>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"pi-form-actions\">\n                    <div class=\"pi-form-button pi-participants-form-button\">\n                        <button class=\"um-btn btn btn-primary participants_select_button\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":28,"column":100},"end":{"line":28,"column":107}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":28,"column":120},"end":{"line":28,"column":128}}}) : helper)))
    + "\" type=\"button\" name=\"button\" title=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":28,"column":214},"end":{"line":28,"column":222}}}) : helper)))
    + "\" data-label=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\" data-maxreached=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"maxreached") : stack1), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":24},"end":{"line":31,"column":31}}})) != null ? stack1 : "")
    + "                            "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </button>\n                    </div>\n                </div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "                            <span class=\"pi-mandatory\">&#42;</span>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"eventtext pi-form-control pi-infotext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"participantLimit") || (depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"participantLimit","hash":{},"data":data,"loc":{"start":{"line":46,"column":59},"end":{"line":46,"column":81}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group col-xs-12 col-sm-12\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":43,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":4},"end":{"line":47,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.EventPersonalizedParticipant = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-message-text\" id=\"participant_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":1,"column":45},"end":{"line":1,"column":52}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":65},"end":{"line":1,"column":73}}}) : helper)))
    + "\" data-num=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":1,"column":85},"end":{"line":1,"column":92}}}) : helper)))
    + "\">\n    <div class=\"pi-form-control form-group\">\n        <div class=\"pi-form-label pi-form-label-has-button\" >\n            <div class=\"pi-form-label-left participant-title\">\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\n            </div>\n            <div class=\"pi-form-label-button\">\n                <button class=\"pi-form-label-button-right ui-button ui-corner-all ui-widget ui-button-icon-only participant_remove\" title=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"buttonLabel") || (depth0 != null ? lookupProperty(depth0,"buttonLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"buttonLabel","hash":{},"data":data,"loc":{"start":{"line":8,"column":139},"end":{"line":8,"column":156}}}) : helper))) != null ? stack1 : "")
    + "\" id=\"participant_remove_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":8,"column":181},"end":{"line":8,"column":188}}}) : helper)))
    + "\" data-num=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":8,"column":200},"end":{"line":8,"column":207}}}) : helper)))
    + "\">\n                    <span class='ui-icon ui-icon-trash'></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.evBtnSubmitAndNextBooking = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"submit\" class=\"btn btn-primary ml15\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":2,"column":55},"end":{"line":2,"column":68}}}) : helper)))
    + "-evSubmitAndNextBooking\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.collectionBookingBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":99},"end":{"line":2,"column":138}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.base.EventTotalprice = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"eventtext pi-form-control\">Gesamtpreis: <span id=\"pitotalprice\">0,00</span>&nbsp;&euro; (inkl. MwSt.)</div>";
},"useData":true};window.pinuts.formtpl.base.EventWorkshopGroup = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":136}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":4,"column":19},"end":{"line":4,"column":28}}}) : helper)))
    + "</label>\n        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":8,"column":38},"end":{"line":8,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-input\">\n            <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":23},"end":{"line":13,"column":74}}})) != null ? stack1 : "")
    + "extended-item-space pi-form-input pi-w-100\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"members") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":12},"end":{"line":32,"column":21}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "inline-list ";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li>\n                    <span class=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"cssClass") : depths[1]), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":17,"column":20},"end":{"line":22,"column":27}}})) != null ? stack1 : "")
    + "                        <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":23,"column":53},"end":{"line":23,"column":63}}}) : helper)))
    + "\"><span></span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_title") || (depth0 != null ? lookupProperty(depth0,"ws_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_title","hash":{},"data":data,"loc":{"start":{"line":23,"column":78},"end":{"line":23,"column":90}}}) : helper)))
    + "</label>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_description") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":24},"end":{"line":26,"column":31}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"booking_info") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":24},"end":{"line":29,"column":31}}})) != null ? stack1 : "")
    + "                    </span>\n                </li>\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":18,"column":68},"end":{"line":18,"column":78}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":18,"column":98},"end":{"line":18,"column":108}}}) : helper)))
    + "]\"\n                               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":19,"column":38},"end":{"line":19,"column":48}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":50},"end":{"line":19,"column":103}}})) != null ? stack1 : "")
    + " />\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "checked";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":21,"column":68},"end":{"line":21,"column":78}}}) : helper)))
    + "\" readonly=\"readonly\" disabled=\"disabled\"/>\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ws_description") || (depth0 != null ? lookupProperty(depth0,"ws_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_description","hash":{},"data":data,"loc":{"start":{"line":25,"column":53},"end":{"line":25,"column":73}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"booking_info") || (depth0 != null ? lookupProperty(depth0,"booking_info") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"booking_info","hash":{},"data":data,"loc":{"start":{"line":28,"column":53},"end":{"line":28,"column":71}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"20":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-input\">\n            <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":23},"end":{"line":38,"column":73}}})) != null ? stack1 : "")
    + " extended-item-space\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"members") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":16},"end":{"line":57,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"21":function(container,depth0,helpers,partials,data) {
    return "inline-list";
},"23":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <li>\n                        <span class=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"cssClass") : depths[1]), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.program(27, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":42,"column":28},"end":{"line":46,"column":35}}})) != null ? stack1 : "")
    + "\n                            <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":48,"column":57},"end":{"line":48,"column":67}}}) : helper)))
    + "\"><span></span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_title") || (depth0 != null ? lookupProperty(depth0,"ws_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_title","hash":{},"data":data,"loc":{"start":{"line":48,"column":82},"end":{"line":48,"column":94}}}) : helper)))
    + "</label>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_description") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":28},"end":{"line":51,"column":35}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"booking_info") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":28},"end":{"line":54,"column":35}}})) != null ? stack1 : "")
    + "                        </span>\n                    </li>\n";
},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <input type=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":43,"column":73},"end":{"line":43,"column":83}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":43,"column":111},"end":{"line":43,"column":121}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":123},"end":{"line":43,"column":175}}})) != null ? stack1 : "")
    + "/>\n";
},"25":function(container,depth0,helpers,partials,data) {
    return " checked=\"checked\"";
},"27":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <input type=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":45,"column":73},"end":{"line":45,"column":83}}}) : helper)))
    + "\" readonly=\"readonly\" disabled=\"disabled\"/>\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ws_description") || (depth0 != null ? lookupProperty(depth0,"ws_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_description","hash":{},"data":data,"loc":{"start":{"line":50,"column":57},"end":{"line":50,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"booking_info") || (depth0 != null ? lookupProperty(depth0,"booking_info") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"booking_info","hash":{},"data":data,"loc":{"start":{"line":53,"column":57},"end":{"line":53,"column":75}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"wsgroup\" class=\"pi-form-control pi-wsgroup col-xs-12 col-sm-12"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":103},"end":{"line":1,"column":143}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mode") : depth0),"checkbox",{"name":"ifEq","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":35,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mode") : depth0),"radio",{"name":"ifEq","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":4},"end":{"line":60,"column":13}}})) != null ? stack1 : "")
    + "\n    <div class=\"pi-form-error\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.DeleteProfileField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- No field -->";
},"useData":true};window.pinuts.formtpl.base.formlinebreak = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"clearfix\"></div>";
},"useData":true};window.pinuts.formtpl.base.infotext = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n    <div class=\"control-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.ParkingCalendarField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-parking-calendar\">\n    <div class=\"form-group\">\n        <div class=\"parking-calendar-container\">\n        <div class=\"parking-date-container\">\n            <label>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"arrival") : stack1), depth0))
    + "</label>\n            <input type=\"text\" value=\"\" name=\"parking-date-from\" id=\"parking-date-from\" class=\"form-control datepicker-style\">\n        </div>\n        <div id=\"parking-calendar-from\" class=\"parking-calendar bg-bright\"></div>\n        <div class=\"parking-departure-date parking-date-container\">\n            <label>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"departure") : stack1), depth0))
    + "</label>\n            <input type=\"text\" value=\"\" name=\"parking-date-to\" id=\"parking-date-to\" class=\"form-control datepicker-style\">\n        </div>\n        <div id=\"parking-calendar-to\" class=\"parking-calendar hidden bg-bright\"></div>\n        </div>\n    </div>\n    <div class=\"form-group time-group parking-arrival\">\n        <label for=\"parking-time-arrival\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"arrival_time") : stack1), depth0))
    + ":</label>\n        <select name=\"parking-time-arrival\" id=\"parking-time-arrival\" class=\"form-control\">\n        </select>\n    </div>\n    <div class=\"form-group time-group parking-departure\">\n        <label for=\"parking-time-departure\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"departure_time") : stack1), depth0))
    + ":</label>\n        <select name=\"parking-time-departure\" id=\"parking-time-departure\" class=\"form-control\">\n        </select>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.Phone3Field = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCountry") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":6,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "         <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":24},"end":{"line":13,"column":32}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"valueCountry") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":34},"end":{"line":13,"column":81}}})) != null ? stack1 : "")
    + ">         \n                 "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":14,"column":17},"end":{"line":14,"column":26}}}) : helper)))
    + "\n         </option>                      \n";
},"5":function(container,depth0,helpers,partials,data) {
    return "selected";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":16},"end":{"line":26,"column":23}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    return "                    <span class=\"pi-mandatory\">&#42;</span>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":144},"end":{"line":31,"column":169}}})) != null ? stack1 : "")
    + "\" ";
},"11":function(container,depth0,helpers,partials,data) {
    return "*";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":16},"end":{"line":40,"column":23}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":142},"end":{"line":45,"column":167}}})) != null ? stack1 : "")
    + "\" ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesCountry") : stack1), depth0))
    + "\">\n    <div class=\"pi-form-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":3,"column":20},"end":{"line":3,"column":33}}}) : helper)))
    + "-country\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCountry") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":65},"end":{"line":7,"column":15}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":11,"column":22},"end":{"line":11,"column":30}}}) : helper)))
    + "Country\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":43},"end":{"line":11,"column":56}}}) : helper)))
    + "-country\" class=\"form-control selectBox\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":16,"column":17}}})) != null ? stack1 : "")
    + "        </select>\n    </div>    \n</div>\n\n<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesCity") : stack1), depth0))
    + "\">\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":24},"end":{"line":23,"column":37}}}) : helper)))
    + "-city\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":66},"end":{"line":27,"column":19}}})) != null ? stack1 : "")
    + "            </label>\n        </div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":31,"column":23},"end":{"line":31,"column":36}}}) : helper)))
    + "-city\" type=\"text\" class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":76},"end":{"line":31,"column":178}}})) != null ? stack1 : "")
    + " value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"valueCity") || (depth0 != null ? lookupProperty(depth0,"valueCity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"valueCity","hash":{},"data":data,"loc":{"start":{"line":31,"column":186},"end":{"line":31,"column":199}}}) : helper)))
    + "\" />\n        </div>    \n</div>\n\n<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesPhone") : stack1), depth0))
    + "\">\n    <div class=\"pi-form-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":37,"column":20},"end":{"line":37,"column":33}}}) : helper)))
    + "-phone\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":63},"end":{"line":41,"column":19}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":45,"column":19},"end":{"line":45,"column":32}}}) : helper)))
    + "-phone\" type=\"text\" class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":73},"end":{"line":45,"column":176}}})) != null ? stack1 : "")
    + " value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"valueCity") || (depth0 != null ? lookupProperty(depth0,"valueCity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"valueCity","hash":{},"data":data,"loc":{"start":{"line":45,"column":184},"end":{"line":45,"column":197}}}) : helper)))
    + "\" />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n</div>\n\n<div class=\"col-xs-12 col-sm-12 col-md-12\">\n    <div class=\"form-group control-label\">\n        <div class=\"pi-form-error mt5 has-error\"></div>\n    </div>\n</div>\n<div class=\"clearfix\"></div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.rangeslider = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":41}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <span class=\"pi-info-window\">\n                <span class=\"pi-info-icon\"></span>\n                <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":43},"end":{"line":11,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</span>\n            </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":36},"end":{"line":15,"column":46}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <label for=\"\" class=\"control-label range-slider-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"showValue") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":37},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + "    </label>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n            <span class=\"range-slider-min\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + "</span> - <span class=\"range-slider-max\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "</span> \n";
},"11":function(container,depth0,helpers,partials,data) {
    return "data-slider-time=\"true\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "  <div class=\"rangeslider-wrapper js-range-slider\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":24,"column":11}}})) != null ? stack1 : "")
    + "    <input type=\"text\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":25,"column":35},"end":{"line":25,"column":48}}}) : helper)))
    + "\" class=\"range-slider-control\" \n        data-slider-enabled=\"true\" \n        data-slider-min=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMin") : stack1), depth0))
    + "\" \n        data-slider-max=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMax") : stack1), depth0))
    + "\" \n        data-slider-step=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStep") : stack1), depth0))
    + "\" \n        data-slider-value=\"["
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + ", "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "]\" \n        "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"isTime") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":31,"column":73}}})) != null ? stack1 : "")
    + "\n        data-slider-tooltip=\"hide\" \n        value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + " - "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "\"\n      />\n  </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.slider = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":41}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":39},"end":{"line":11,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":32},"end":{"line":15,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <label for=\"\" class=\"control-label range-slider-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"showValue") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":37},"end":{"line":20,"column":153}}})) != null ? stack1 : "")
    + "\n    </label>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"range-slider-value\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "</span>";
},"11":function(container,depth0,helpers,partials,data) {
    return "data-slider-time=\"true\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "  <div class=\"rangeslider-wrapper js-range-slider\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":22,"column":11}}})) != null ? stack1 : "")
    + "    <input type=\"text\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":35},"end":{"line":23,"column":48}}}) : helper)))
    + "\" class=\"range-slider-control\" \n        data-slider-enabled=\"true\" \n        data-slider-min=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMin") : stack1), depth0))
    + "\" \n        data-slider-max=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMax") : stack1), depth0))
    + "\" \n        data-slider-step=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStep") : stack1), depth0))
    + "\" \n        data-slider-value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "\" \n        "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"isTime") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":29,"column":73}}})) != null ? stack1 : "")
    + "\n        data-slider-tooltip=\"hide\" \n        value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "\"\n      />\n  </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.subheading = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":16},"end":{"line":1,"column":30}}}) : helper)))
    + "\">\n    <div class=\"col-xs-12\">\n      <div class=\"mb15\">\n        <h3>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0))
    + "</h3>\n      </div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.base.switchtoggel = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":5,"column":27}}})) != null ? stack1 : "")
    + "</div>\n\n\n    <div class=\"pi-form-input switch-toggle\">\n        <div class=\"toggle-slide\">\n            <input type=\"checkbox\" value=\"1\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":10,"column":51},"end":{"line":10,"column":59}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":65},"end":{"line":10,"column":78}}}) : helper)))
    + "\" class=\"switch-toggle-input js-switch-toggle-input\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":24},"end":{"line":11,"column":37}}}) : helper)))
    + "\" class=\"toggle-inner\">\n                <div class=\"toggle-on\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"toggelOn") : stack1), depth0))
    + "</div>\n                <div class=\"toggle-blob\"></div>\n                <div class=\"toggle-off\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"toggelOff") : stack1), depth0))
    + "</div>\n            </label>\n        </div>\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.UploadValidationDateField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":10,"column":112},"end":{"line":10,"column":122}}}) : helper))) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"month") || (depth0 != null ? lookupProperty(depth0,"month") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"month","hash":{},"data":data,"loc":{"start":{"line":16,"column":43},"end":{"line":16,"column":52}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":54},"end":{"line":16,"column":100}}})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"month") || (depth0 != null ? lookupProperty(depth0,"month") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"month","hash":{},"data":data,"loc":{"start":{"line":16,"column":101},"end":{"line":16,"column":110}}}) : helper)))
    + "</option>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "disabled=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"disabled") || (depth0 != null ? lookupProperty(depth0,"disabled") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"disabled","hash":{},"data":data,"loc":{"start":{"line":16,"column":80},"end":{"line":16,"column":92}}}) : helper)))
    + "\"";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"year") || (depth0 != null ? lookupProperty(depth0,"year") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"year","hash":{},"data":data,"loc":{"start":{"line":32,"column":43},"end":{"line":32,"column":51}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":53},"end":{"line":32,"column":99}}})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"year") || (depth0 != null ? lookupProperty(depth0,"year") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"year","hash":{},"data":data,"loc":{"start":{"line":32,"column":100},"end":{"line":32,"column":108}}}) : helper)))
    + "</option>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" >\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n\n    <div class=\"row\">\n        <div class=\"col-sm-6\">\n            <div class=\"pi-form-group\">\n                <div class=\"pi-form-label\">\n                    <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":32},"end":{"line":10,"column":45}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"labelMonth",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":69},"end":{"line":10,"column":134}}})) != null ? stack1 : "")
    + "</label>\n                </div>\n                <div class=\"pi-form-input\">\n                    <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":34},"end":{"line":13,"column":42}}}) : helper)))
    + "-month\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":13,"column":54},"end":{"line":13,"column":67}}}) : helper)))
    + "-month\" class=\"form-control selectBox\">\n                        <option value=\"\" selected>--</option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"month") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":24},"end":{"line":17,"column":33}}})) != null ? stack1 : "")
    + "                    </select>\n                </div>\n            </div>\n        </div>\n            \n        <div class=\"col-sm-6\">\n            <div class=\"pi-form-group\">\n                <div class=\"pi-form-label\">\n                    <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":26,"column":32},"end":{"line":26,"column":45}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"labelYear",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":69},"end":{"line":26,"column":133}}})) != null ? stack1 : "")
    + "</label>\n                </div>\n                <div class=\"pi-form-input\">\n                    <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":29,"column":34},"end":{"line":29,"column":42}}}) : helper)))
    + "-year\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":29,"column":53},"end":{"line":29,"column":66}}}) : helper)))
    + "-year\" class=\"form-control selectBox\">\n                        <option value=\"\" selected>--</option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"year") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":24},"end":{"line":33,"column":33}}})) != null ? stack1 : "")
    + "                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formPartials.base.label = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":87},"end":{"line":1,"column":97}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":4,"column":11}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":38}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":25}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":49},"end":{"line":5,"column":16}}})) != null ? stack1 : "")
    + "</label>  \n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":9,"column":12}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true};window.pinuts.formtpl.base.chtml_sfs_text = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":18},"end":{"line":1,"column":32}}}) : helper)))
    + "\"><div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":39},"end":{"line":1,"column":47}}}) : helper)))
    + "</div></div>";
},"useData":true}
;window.pinuts = window.pinuts || {};window.pinuts.formtpl = window.pinuts.formtpl || {};window.pinuts.formtpl.NewsletterIcon = window.pinuts.formtpl.NewsletterIcon || {};window.pinuts.formPartials = window.pinuts.formPartials || {};window.pinuts.formPartials.NewsletterIcon = window.pinuts.formPartials.NewsletterIcon || {};window.pinuts.formClasses = ["FormWidget","handlebars","fields/Field","fields/SelectField","fields/RadioField","fields/CheckboxField","fields/FieldGroup","fields/MultiSelectField","fields/TextField","fields/TextareaField","fields/ReCaptchaV2","fields/FriendlyCaptcha","fields/CaptchaEU","fields/Pino4Field","fields/StringField","fields/HiddenField","fields/DateFieldNative","fields/TimeFieldNative","fields/CalendarField","fields/UploadField","fields/UploadField2","fields/ChtmlField","fields/TplField","fields/Nothing","fields/PasswordField","fields/PasswordLoginField","fields/DisabledTextField","fields/EmailConfirmField","lib/helpers/and","lib/helpers/caption","lib/helpers/captionNoTags","lib/helpers/contains","lib/helpers/dynamicPartial","lib/helpers/has","lib/helpers/ifContains","lib/helpers/ifCond","lib/helpers/ifEq","lib/helpers/ifNot","lib/helpers/valByPath","lib/require","fields/ConsentGroup","fields/NlFormWidget","fields/ShowChannelField","fields/UnsubscribeReasons","fields/CustomDataLoader","fields/EncryptedEditorMail","fields/NLArchive","fields/IndustryCardList","fields/IndustryCardUploadForm","fields/EMFormWidget","fields/EventAdditionalTexts","fields/EventDescription","fields/EventInfoBox","fields/EventListWidget","fields/EventNewsletter","fields/EventParticipants","fields/EventPersonalizedParticipants","fields/EventWorkshopGroup","fields/BaseSliderField","fields/DateFieldFmg","fields/DeleteProfileField","fields/EventParticipantsFmg","fields/EventPersonalizedParticipantsFmg","fields/FromToField","fields/LoungeCodeField","fields/ParkingCalenderField","fields/PasswordFieldFmg","fields/Phone3Field","fields/RangeSliderField","fields/SelectFieldFmg","fields/SliderField","fields/ToggelField","fields/UploadValidationDateField"];window.pinuts.formErrorClass = window.pinuts.formErrorClass || {};window.pinuts.formSuccessClass = window.pinuts.formSuccessClass || {};window.pinuts.formIsEditClass = window.pinuts.formIsEditClass || {};;window.pinuts.formtpl.NewsletterIcon.CalendarField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":92},"end":{"line":1,"column":106}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"calender\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":73},"end":{"line":1,"column":113}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <div class=\"piCalendar\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":36},"end":{"line":7,"column":49}}}) : helper)))
    + "\" ></div>\n        <input type=\"hidden\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":8,"column":36},"end":{"line":8,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":53},"end":{"line":8,"column":61}}}) : helper)))
    + "\" id=\"input_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":73},"end":{"line":8,"column":86}}}) : helper)))
    + "\">\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":41},"end":{"line":11,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.CaptchaEU = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-captchaeu-status\">\n            <div class=\"waiting\">\n                <div class=\"icon\">\n                    <i class=\"pi-spinner\" id=\"piSpinner\"></i>\n                </div>\n                <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"loadingText") : stack1), depth0))
    + "</span>\n            </div>\n            <div class=\"ready\">\n                <div class=\"icon\">\n                    <span>✔</span>\n                </div>\n                <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"successText") : stack1), depth0))
    + "</span>\n            </div>\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":18,"column":45},"end":{"line":18,"column":58}}}) : helper)))
    + "\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"renderSpiner") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":19,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.CheckboxTpl = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":39},"end":{"line":11,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":32},"end":{"line":15,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>                \n                <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":20,"column":60},"end":{"line":20,"column":68}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":20,"column":88},"end":{"line":20,"column":96}}}) : helper)))
    + "]\" value=\"on\" \n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":16},"end":{"line":21,"column":46}}})) != null ? stack1 : "")
    + "  />\n                <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":22,"column":45},"end":{"line":22,"column":53}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":22,"column":90},"end":{"line":22,"column":147}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":20},"end":{"line":25,"column":32}}})) != null ? stack1 : "")
    + "                </label>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":16},"end":{"line":29,"column":28}}})) != null ? stack1 : "")
    + "            </li>\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "checked";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":24,"column":114},"end":{"line":24,"column":124}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":28,"column":45},"end":{"line":28,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":6,"column":20}}})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "    <ul class=\"extended-item-space\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":31,"column":17}}})) != null ? stack1 : "")
    + "    </ul>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.CheckboxesTpl = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":9,"column":52},"end":{"line":9,"column":62}}}) : helper))) != null ? stack1 : "")
    + "</div> \n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":14,"column":39},"end":{"line":14,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":18,"column":32},"end":{"line":18,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "inline-list ";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":60},"end":{"line":23,"column":68}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":88},"end":{"line":23,"column":96}}}) : helper)))
    + "]\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":106},"end":{"line":23,"column":114}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":116},"end":{"line":23,"column":169}}})) != null ? stack1 : "")
    + " >\n                <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":24,"column":45},"end":{"line":24,"column":53}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":24,"column":90},"end":{"line":24,"column":147}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":20},"end":{"line":27,"column":32}}})) != null ? stack1 : "")
    + "                </label>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":16},"end":{"line":31,"column":28}}})) != null ? stack1 : "")
    + "            </li>\n";
},"13":function(container,depth0,helpers,partials,data) {
    return " checked ";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":26,"column":114},"end":{"line":26,"column":124}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":30,"column":45},"end":{"line":30,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":6,"column":20}}})) != null ? stack1 : "")
    + "    </div>    \n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":10,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":19,"column":16}}})) != null ? stack1 : "")
    + "    <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":15},"end":{"line":20,"column":66}}})) != null ? stack1 : "")
    + "extended-item-space pi-form-input pi-w-100\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":8},"end":{"line":33,"column":17}}})) != null ? stack1 : "")
    + "    </ul>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.DateField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" class=\"form-control\" \n               autocomplete=\"of\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"format") || (depth0 != null ? lookupProperty(depth0,"format") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"format","hash":{},"data":data,"loc":{"start":{"line":9,"column":28},"end":{"line":9,"column":38}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":10,"column":22},"end":{"line":10,"column":35}}}) : helper)))
    + "\"  />\n            <input type=\"hidden\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":45},"end":{"line":11,"column":58}}}) : helper)))
    + "_alt\" value=\"\"/>     \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.DateFieldNative = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"date\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"date\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               min=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"min") || (depth0 != null ? lookupProperty(depth0,"min") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"min","hash":{},"data":data,"loc":{"start":{"line":10,"column":20},"end":{"line":10,"column":27}}}) : helper)))
    + "\"\n               max=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"max") || (depth0 != null ? lookupProperty(depth0,"max") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"max","hash":{},"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":11,"column":27}}}) : helper)))
    + "\"\n        />\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.DisabledTextField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input name=\"dummy\" type=\"text\" disabled value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":7,"column":56},"end":{"line":7,"column":65}}}) : helper)))
    + "\" class=\"form-control\"  />        \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.EmailConfirmField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":102}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":7,"column":90},"end":{"line":7,"column":103}}}) : helper)))
    + "\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"captionNoTags")||(depth0 && lookupProperty(depth0,"captionNoTags"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"captionNoTags","hash":{},"data":data,"loc":{"start":{"line":8,"column":54},"end":{"line":8,"column":97}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":98},"end":{"line":8,"column":123}}})) != null ? stack1 : "")
    + "\"";
},"6":function(container,depth0,helpers,partials,data) {
    return "*";
},"8":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelConfirmEmail") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":87},"end":{"line":24,"column":112}}})) != null ? stack1 : "")
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    return "onpaste=\"return false\" autocomplete=\"off\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + "\" >\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":62},"end":{"line":7,"column":111}}})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":12},"end":{"line":8,"column":131}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" oncopy=\"return false\" />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":12,"column":41},"end":{"line":12,"column":54}}}) : helper)))
    + "\"></div>\n</div>\n<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":14,"column":17},"end":{"line":14,"column":25}}}) : helper)))
    + "-confirm\" data-pi-type=\"text\" class=\"pi-form-control pi-confirm-field"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":94},"end":{"line":14,"column":134}}})) != null ? stack1 : "")
    + "\" >\n    <div class=\"pi-form-label pi-confirm-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":16,"column":20},"end":{"line":16,"column":33}}}) : helper)))
    + "-confirm\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":16,"column":47},"end":{"line":16,"column":60}}}) : helper)))
    + "confirm_label\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelConfirmEmail") : stack1), depth0)) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":19,"column":19}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":19},"end":{"line":23,"column":32}}}) : helper)))
    + "-confirm\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":48},"end":{"line":23,"column":56}}}) : helper)))
    + "-confirm\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":78},"end":{"line":23,"column":127}}})) != null ? stack1 : "")
    + "\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":12},"end":{"line":24,"column":120}}})) != null ? stack1 : "")
    + "\n               value=\"\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"copyPaste") : stack1),"no",{"name":"ifEq","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":24},"end":{"line":25,"column":109}}})) != null ? stack1 : "")
    + " />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":28,"column":41},"end":{"line":28,"column":54}}}) : helper)))
    + "-confirm\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.FieldGroup = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"field-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":24},"end":{"line":1,"column":38}}}) : helper)))
    + " pigroup\">\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.FormWidget = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <button type=\"submit\" class=\"btn "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":13,"column":53},"end":{"line":13,"column":101}}})) != null ? stack1 : "")
    + " ml15\" form=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"submitId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":13,"column":152},"end":{"line":13,"column":160}}}) : helper)))
    + "\" data-submitbtn=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":13,"column":178},"end":{"line":13,"column":186}}}) : helper)))
    + "\">\n                        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pre-icon") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":24},"end":{"line":14,"column":61}}})) != null ? stack1 : "")
    + "\n                        <span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":15,"column":30},"end":{"line":15,"column":47}}}))
    + "</span>\n                    </button>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":13,"column":66},"end":{"line":13,"column":75}}}) : helper)));
},"4":function(container,depth0,helpers,partials,data) {
    return "btn-primary";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"pre-icon") || (depth0 != null ? lookupProperty(depth0,"pre-icon") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pre-icon","hash":{},"data":data,"loc":{"start":{"line":14,"column":40},"end":{"line":14,"column":54}}}) : helper))) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":1,"column":22},"end":{"line":1,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":1,"column":45},"end":{"line":1,"column":60}}}) : helper)))
    + "\"> \n    <header class=\"pi-heading\"><hgroup id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"titleId") || (depth0 != null ? lookupProperty(depth0,"titleId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"titleId","hash":{},"data":data,"loc":{"start":{"line":2,"column":43},"end":{"line":2,"column":54}}}) : helper)))
    + "\"><h2>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.heading",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":60},"end":{"line":2,"column":86}}}))
    + "</h2></hgroup></header> \n    <div class=\"pi-message\"><div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":3,"column":37},"end":{"line":3,"column":52}}}) : helper)))
    + "\" class=\"pi-message-text mb15\" style=\"display: none\"></div></div>\n    <form action=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":4,"column":24},"end":{"line":4,"column":37}}}) : helper)))
    + "\" class=\"row\"> \n        <div class=\"pi-form\" >\n        </div> \n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgFromId") || (depth0 != null ? lookupProperty(depth0,"msgFromId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgFromId","hash":{},"data":data,"loc":{"start":{"line":8,"column":17},"end":{"line":8,"column":30}}}) : helper)))
    + "\" class=\"error-container col-xs-12\"></div> \n        <div class=\"pi-form-actions col-xs-12\" >\n            <div class=\"btn-group btn-group-hspace pi-form-button\"> \n                <button type=\"submit\" class=\"btn btn-primary\" form=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":68},"end":{"line":11,"column":81}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"submitId") || (depth0 != null ? lookupProperty(depth0,"submitId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"submitId","hash":{},"data":data,"loc":{"start":{"line":11,"column":87},"end":{"line":11,"column":99}}}) : helper)))
    + "\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.submitBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":11,"column":107},"end":{"line":11,"column":135}}}))
    + "</span></button>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"submitButtons") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":17,"column":25}}})) != null ? stack1 : "")
    + "            </div>\n        </div> \n    </form>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.FormErrors = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":25}}}) : helper)))
    + ": "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msg") || (depth0 != null ? lookupProperty(depth0,"msg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msg","hash":{},"data":data,"loc":{"start":{"line":5,"column":27},"end":{"line":5,"column":34}}}) : helper)))
    + "</li>        \n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-message-text \" role=\"alert\"> \n    <p>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"errors.formerror",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":37}}}))
    + "</p>\n    <ul>               \n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"errors") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":17}}})) != null ? stack1 : "")
    + "    </ul>   \n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.HiddenField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":11},"end":{"line":1,"column":24}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":32},"end":{"line":1,"column":40}}}) : helper)))
    + "\" type=\"hidden\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":1,"column":63},"end":{"line":1,"column":72}}}) : helper)))
    + "\" />";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.piHorizontalSeparation = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pi-form-control\" data-pi-input-type=\"spacer-row-default\">\n    <hr class=\"pi-hr\">\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.piHorizontalSeparationStrong = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pi-form-control\" data-pi-input-type=\"spacer-row-strong\">\n    <hr class=\"pi-hr-strong\">\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.PasswordField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":9,"column":58},"end":{"line":9,"column":95}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":96},"end":{"line":9,"column":124}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":18,"column":80},"end":{"line":18,"column":90}}}) : helper))) != null ? stack1 : "")
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":19,"column":82}}})) != null ? stack1 : "")
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "<span class=\"pi-mandatory\">&#42;</span>";
},"7":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":24,"column":143},"end":{"line":24,"column":156}}}) : helper)))
    + "\"";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label2",{"name":"caption","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":61},"end":{"line":25,"column":149}}})) != null ? stack1 : "")
    + "\"";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":25,"column":100},"end":{"line":25,"column":108}}}) : helper)))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":109},"end":{"line":25,"column":137}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\n    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":2,"column":21},"end":{"line":2,"column":29}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":53}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":2,"column":73},"end":{"line":2,"column":87}}}) : helper)))
    + "\" >\n        <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </div>\n        <div class=\"pi-form-helptext\"></div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":23},"end":{"line":8,"column":36}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":44},"end":{"line":8,"column":52}}}) : helper)))
    + "\" type=\"password\" autocomplete=\"off\"  class=\"form-control\"\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":9,"column":132}}})) != null ? stack1 : "")
    + "\n                value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":10,"column":23},"end":{"line":10,"column":32}}}) : helper)))
    + "\" />\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error mt5\"></div>\n    </div>\n\n    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":16,"column":21},"end":{"line":16,"column":29}}}) : helper)))
    + "_2\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":47},"end":{"line":16,"column":55}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":16,"column":75},"end":{"line":16,"column":89}}}) : helper)))
    + "\">\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":18,"column":24},"end":{"line":18,"column":37}}}) : helper)))
    + "_2\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label2",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":41},"end":{"line":20,"column":24}}})) != null ? stack1 : "")
    + "            </label>\n        </div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":24,"column":23},"end":{"line":24,"column":36}}}) : helper)))
    + "_2\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":24,"column":46},"end":{"line":24,"column":54}}}) : helper)))
    + "_2\" type=\"password\" autocomplete=\"off\"  class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":115},"end":{"line":24,"column":164}}})) != null ? stack1 : "")
    + "\n                   "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":19},"end":{"line":25,"column":157}}})) != null ? stack1 : "")
    + "\n                   value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value2") || (depth0 != null ? lookupProperty(depth0,"value2") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value2","hash":{},"data":data,"loc":{"start":{"line":26,"column":26},"end":{"line":26,"column":36}}}) : helper)))
    + "\"/>\n        </div>\n        <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":28,"column":38},"end":{"line":28,"column":80}}})) != null ? stack1 : "")
    + "</div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error mt5\"></div>\n    </div>\n</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.PasswordLoginField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":57},"end":{"line":8,"column":94}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":95},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"password\" autocomplete=\"off\"  class=\"form-control\" \n               "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":15},"end":{"line":8,"column":128}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" />        \n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.piTextBox = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label >"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customLabel") : stack1), depth0))
    + "</label>\n        </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pi-form-input\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"string\" class=\"pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClass") || (depth0 != null ? lookupProperty(depth0,"cssClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClass","hash":{},"data":data,"loc":{"start":{"line":1,"column":72},"end":{"line":1,"column":84}}}) : helper)))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClass") : stack1), depth0))
    + "\" >\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customLabel") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.Pino4Field = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":2,"column":21},"end":{"line":2,"column":29}}}) : helper)))
    + "\" data-pi-type=\"pino4\" class=\"pi-form-control\" >\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":4,"column":24},"end":{"line":4,"column":37}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Label") || (depth0 != null ? lookupProperty(depth0,"pino4Label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Label","hash":{},"data":data,"loc":{"start":{"line":4,"column":39},"end":{"line":4,"column":53}}}) : helper)))
    + "</label>    \n        </div> \n        <div class=\"pi-form-helptext\"></div> \n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":8,"column":23},"end":{"line":8,"column":36}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Name") || (depth0 != null ? lookupProperty(depth0,"pino4Name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Name","hash":{},"data":data,"loc":{"start":{"line":8,"column":44},"end":{"line":8,"column":57}}}) : helper)))
    + "\" type=\"text\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"maxLength") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":71},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\n                   "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":19},"end":{"line":9,"column":83}}})) != null ? stack1 : "")
    + "\n                   value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":10,"column":26},"end":{"line":10,"column":35}}}) : helper)))
    + "\" />        \n        </div> \n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n        <div class=\"pi-form-error\"></div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "maxlength=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"maxLength") || (depth0 != null ? lookupProperty(depth0,"maxLength") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"maxLength","hash":{},"data":data,"loc":{"start":{"line":8,"column":99},"end":{"line":8,"column":112}}}) : helper)))
    + "\"";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"pino4Label") || (depth0 != null ? lookupProperty(depth0,"pino4Label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pino4Label","hash":{},"data":data,"loc":{"start":{"line":9,"column":61},"end":{"line":9,"column":75}}}) : helper)))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pfields") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":15,"column":9}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.NewsletterIcon.RadioField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":73},"end":{"line":2,"column":83}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":12},"end":{"line":5,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n            ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"pi-info-window\">\n                    <span class=\"pi-info-icon\"></span>\n                    <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":9,"column":47},"end":{"line":9,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</span>\n                </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":13,"column":40},"end":{"line":13,"column":50}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "inline-list";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":28,"column":25}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li>                \n                    <input type=\"radio\" class=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":19,"column":75},"end":{"line":19,"column":83}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":19,"column":111},"end":{"line":19,"column":119}}}) : helper)))
    + "\" \n                    "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":20},"end":{"line":20,"column":70}}})) != null ? stack1 : "")
    + "  />\n                    <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":21,"column":49},"end":{"line":21,"column":57}}}) : helper)))
    + "\" class=\"pl20\"><span></span>\n                        <p class=\"sr-only\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":22,"column":43},"end":{"line":22,"column":100}}})) != null ? stack1 : "")
    + "</p>\n                        <svg class=\"icon icon-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":23,"column":46},"end":{"line":23,"column":54}}}) : helper)))
    + "\" role=\"img\" aria-hidden=\"true\">\n                            <use xlink:href=\"#icon-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":24,"column":51},"end":{"line":24,"column":59}}}) : helper)))
    + "\" />\n                        </svg>\n                    </label>\n                </li>\n";
},"12":function(container,depth0,helpers,partials,data) {
    return " checked=\"checked\"";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":16},"end":{"line":41,"column":25}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li>                \n                    <input type=\"radio\" class=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":33,"column":75},"end":{"line":33,"column":83}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":33,"column":111},"end":{"line":33,"column":119}}}) : helper)))
    + "\" \n                    "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":20},"end":{"line":34,"column":70}}})) != null ? stack1 : "")
    + "  />\n                    <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":35,"column":49},"end":{"line":35,"column":57}}}) : helper)))
    + "\" class=\"control-label\"><span></span>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":35,"column":94},"end":{"line":35,"column":151}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":24},"end":{"line":38,"column":36}}})) != null ? stack1 : "")
    + "                    </label>\n                </li>                                \n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":37,"column":114},"end":{"line":37,"column":124}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n        <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":35},"end":{"line":5,"column":31}}})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":11,"column":24}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":14,"column":24}}})) != null ? stack1 : "")
    + "        <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":19},"end":{"line":15,"column":69}}})) != null ? stack1 : "")
    + " extended-item-space\">\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),"==","salut",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":29,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),"!=","salut",{"name":"ifCond","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":12},"end":{"line":42,"column":23}}})) != null ? stack1 : "")
    + "        </ul>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n        <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.SelectField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "         <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":9,"column":24},"end":{"line":9,"column":32}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":34},"end":{"line":9,"column":74}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),"__",{"name":"ifEq","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":75},"end":{"line":9,"column":165}}})) != null ? stack1 : "")
    + ">\n                 "
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":10,"column":17},"end":{"line":10,"column":72}}}))
    + "\n         </option>                      \n";
},"2":function(container,depth0,helpers,partials,data) {
    return "selected";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "class=\"placeholder\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"value") : depths[2]),{"name":"unless","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":114},"end":{"line":9,"column":156}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">\n        <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":22},"end":{"line":7,"column":30}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":36},"end":{"line":7,"column":49}}}) : helper)))
    + "\" class=\"form-control selectBox\" >\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":12,"column":17}}})) != null ? stack1 : "")
    + "        </select>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.StringField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\"><span class=\"pi-info-icon\"></span><span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":4,"column":98},"end":{"line":4,"column":108}}}) : helper))) != null ? stack1 : "")
    + "</span></span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" >\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":2,"column":70}}})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":5,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":8,"column":16}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.TextField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":57},"end":{"line":8,"column":94}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":95},"end":{"line":8,"column":120}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "               <span class=\"input-group-btn\">\n                   <button class=\"btn-info js-tooltip-trigger\" type=\"button\">\n                       <span class=\"sr-only\">Information</span>\n                       <svg class=\"icon icon-info\" role=\"img\" aria-hidden=\"true\">\n                           <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-info\"></use>\n                       </svg>\n                   </button>\n                </span>\n                <div class=\"info-container js-tooltip bg-bright sr-only\">\n                    <button class=\"btn btn-close js-tooltip-close\">\n                        <span class=\"sr-only\">schlie&szlig;en</span>\n                        <svg class=\"icon icon-close\" role=\"img\" aria-hidden=\"true\">\n                            <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-close\"></use>\n                        </svg>\n                    </button>\n                    <div class=\"info-content\">\n                        <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":27,"column":27},"end":{"line":27,"column":37}}}) : helper))) != null ? stack1 : "")
    + "</p>\n                    </div>\n                </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input input-group info-wrapper js-tooltip-context\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":19},"end":{"line":7,"column":32}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":40},"end":{"line":7,"column":48}}}) : helper)))
    + "\" type=\"text\" class=\"form-control\" \n               "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":15},"end":{"line":8,"column":128}}})) != null ? stack1 : "")
    + "\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":31}}}) : helper)))
    + "\" />\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":30,"column":24}}})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.TextareaField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "placeholder=\""
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":8,"column":60},"end":{"line":8,"column":97}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":98},"end":{"line":8,"column":123}}})) != null ? stack1 : "")
    + "\"";
},"2":function(container,depth0,helpers,partials,data) {
    return "*";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\"></div> \n    <div class=\"pi-form-input\">        \n        <textarea id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":22},"end":{"line":7,"column":35}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":43},"end":{"line":7,"column":51}}}) : helper)))
    + "\" class=\"form-control\" \n                  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":18},"end":{"line":8,"column":131}}})) != null ? stack1 : "")
    + "\n                  >"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":9,"column":19},"end":{"line":9,"column":28}}}) : helper)))
    + "</textarea>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.TimeField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":93},"end":{"line":1,"column":107}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"timestamp\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":114}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"text\"  \n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               autocomplete=\"new-password\" />\n        <input class=\"time\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":11,"column":34},"end":{"line":11,"column":42}}}) : helper)))
    + "_time\" id=\"pitime_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":60},"end":{"line":11,"column":73}}}) : helper)))
    + "\" type=\"text\" placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"format_time") || (depth0 != null ? lookupProperty(depth0,"format_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"format_time","hash":{},"data":data,"loc":{"start":{"line":11,"column":100},"end":{"line":11,"column":115}}}) : helper)))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValueTime") || (depth0 != null ? lookupProperty(depth0,"formValueTime") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValueTime","hash":{},"data":data,"loc":{"start":{"line":11,"column":124},"end":{"line":11,"column":141}}}) : helper)))
    + "\" autocomplete=\"new-password\"/>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":14,"column":41},"end":{"line":14,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.TimeFieldNative = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":93},"end":{"line":1,"column":107}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"timestamp\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":114}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n        "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "NATIV\n    </div> \n    <div class=\"pi-form-helptext\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"helptext",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":76}}})) != null ? stack1 : "")
    + "</div> \n    <div class=\"pi-form-input\">\n        <input class=\"date\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":7,"column":32},"end":{"line":7,"column":45}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":61}}}) : helper)))
    + "\" type=\"datetime-local\"\n               placeholder=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"placeholder") || (depth0 != null ? lookupProperty(depth0,"placeholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"placeholder","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":43}}}) : helper)))
    + "\"\n               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formValue") || (depth0 != null ? lookupProperty(depth0,"formValue") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formValue","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":35}}}) : helper)))
    + "\"\n               min=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"min") || (depth0 != null ? lookupProperty(depth0,"min") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"min","hash":{},"data":data,"loc":{"start":{"line":10,"column":20},"end":{"line":10,"column":27}}}) : helper)))
    + "\"\n               max=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"max") || (depth0 != null ? lookupProperty(depth0,"max") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"max","hash":{},"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":11,"column":27}}}) : helper)))
    + "\"\n               autocomplete=\"new-password\" />\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.UploadField = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":101},"end":{"line":1,"column":115}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"upload\" class=\"form-group pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":82},"end":{"line":1,"column":122}}})) != null ? stack1 : "")
    + "\" > \n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n    <div class=\"pi-form-helptext\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":46}}}) : helper)))
    + "</div> \n    <div class=\"pi-form-input\">\n        <div class=\"upload-container\">\n            <ul class=\"upload-filelist\"></ul>\n            <iframe src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"uploadIframeUrlQuery") || (depth0 != null ? lookupProperty(depth0,"uploadIframeUrlQuery") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"uploadIframeUrlQuery","hash":{},"data":data,"loc":{"start":{"line":9,"column":25},"end":{"line":9,"column":49}}}) : helper)))
    + "\" frameborder=\"0\" class=\"iframe-upload\" width=\"100%\"></iframe>\n        </div>\n    </div> \n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error\"></div> \n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.UploadFileinfo = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li id=\"upload-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":15},"end":{"line":1,"column":25}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":35}}}) : helper)))
    + " ("
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"size") || (depth0 != null ? lookupProperty(depth0,"size") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"size","hash":{},"data":data,"loc":{"start":{"line":1,"column":37},"end":{"line":1,"column":45}}}) : helper)))
    + " Bytes) <a href=\"#\" data-ticket=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":78},"end":{"line":1,"column":88}}}) : helper)))
    + "\" class=\"upload-delete-file\"></a></li>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.UploadField2 = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":90},"end":{"line":1,"column":104}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"upload\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":71},"end":{"line":1,"column":111}}})) != null ? stack1 : "")
    + "\">\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"pi-form-helptext\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":46}}}) : helper)))
    + "</div>\n    <div class=\"pi-form-input\">\n        <ul class=\"upload-filelist\"></ul>\n        <div class=\"upload2-container\">\n            <span class=\"pi-spinner pi-hoi\" ></span>\n            <input class=\"upload2-input\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":45},"end":{"line":10,"column":58}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":74}}}) : helper)))
    + "\" type=\"file\">\n        </div>\n    </div>\n\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error\" id=\"error_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":15,"column":41},"end":{"line":15,"column":54}}}) : helper)))
    + "\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formtpl.NewsletterIcon.UploadFileinfo2 = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li id=\"upload-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":15},"end":{"line":1,"column":25}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":35}}}) : helper)))
    + " ("
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"size") || (depth0 != null ? lookupProperty(depth0,"size") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"size","hash":{},"data":data,"loc":{"start":{"line":1,"column":37},"end":{"line":1,"column":45}}}) : helper)))
    + " Bytes) <span class=\"delicon\" data-ticket=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ticket") || (depth0 != null ? lookupProperty(depth0,"ticket") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticket","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":98}}}) : helper)))
    + "\"><a class=\"upload-delete-file\" href=\"#\"></a></span></li>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.ConsentGroup = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label >"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":79}}})) != null ? stack1 : "")
    + "\n            </label>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "<span class=\"pi-mandatory\">&#42;</span>";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext\">\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "       <div class=\"pi-form-input\">\n          <span class=\"pi-checkbox-control-vertical\">\n            <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":56},"end":{"line":17,"column":65}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":85},"end":{"line":17,"column":94}}}) : helper)))
    + "]\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":17,"column":104},"end":{"line":17,"column":113}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"default") : depth0),"==","true",{"name":"ifCond","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":115},"end":{"line":17,"column":164}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"value") : depth0),(depths[1] != null ? lookupProperty(depths[1],"checkedBoxes") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":165},"end":{"line":17,"column":224}}})) != null ? stack1 : "")
    + "/>\n            <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data,"loc":{"start":{"line":18,"column":41},"end":{"line":18,"column":50}}}) : helper)))
    + "\">"
    + ((stack1 = (lookupProperty(helpers,"valByPath")||(depth0 && lookupProperty(depth0,"valByPath"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),(depths[1] != null ? lookupProperty(depths[1],"locale") : depths[1]),{"name":"valByPath","hash":{},"data":data,"loc":{"start":{"line":18,"column":52},"end":{"line":18,"column":83}}})) != null ? stack1 : "")
    + "</label>\n          </span>\n       </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"checkbox\" class=\"pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":74},"end":{"line":1,"column":88}}}) : helper)))
    + "\" >\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"label") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"consentFields") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":21,"column":13}}})) != null ? stack1 : "")
    + "    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.UnsubscribeReasonsOther = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"pi-form-input\" id=\"otherTextDiv\" style=\"display:none\">        \n    <textarea id=\"otherText\" class=\"form-control\" name=\"otherText\" ></textarea>\n</li>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.nlBtnDeleteProfile = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":39}}}) : helper)))
    + "-btnDeleteProfile\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.deleteProfileBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":64},"end":{"line":1,"column":99}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.nlBtnLogin = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":39}}}) : helper)))
    + "-btnLogin\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"buttons.login",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":83}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.nlLinkProfile = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"javascript:void(0)\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":33},"end":{"line":1,"column":46}}}) : helper)))
    + "-piEditProfile\"><div>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"buttons.editProfile",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":67},"end":{"line":1,"column":100}}}))
    + "</div></a>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.nlAnonymLink = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"javascript:void(0)\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":33},"end":{"line":1,"column":46}}}) : helper)))
    + "-btnAnonymous\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.btnAnonymous",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":1,"column":61},"end":{"line":1,"column":92}}}))
    + "</a>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.ShowChannelField = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"groups") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":14,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>\n            <ul class=\"channels\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"channels") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":11,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                 <li>"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),"options",depth0,"label",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":10,"column":21},"end":{"line":10,"column":78}}})) != null ? stack1 : "")
    + "</li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"pi-form-control\" >    \n     <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"groups") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.NLArchive = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <div class=\"row\">\n                    <div class=\"cell\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"date","hash":{},"data":data,"loc":{"start":{"line":9,"column":38},"end":{"line":9,"column":46}}}) : helper)))
    + " <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"url","hash":{},"data":data,"loc":{"start":{"line":9,"column":56},"end":{"line":9,"column":63}}}) : helper)))
    + "\" target=\"_blank\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":9,"column":81},"end":{"line":9,"column":90}}}) : helper)))
    + "</a></div>\n                </div>                  \n            </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">    \n    <h3>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":19}}}) : helper)))
    + "</h3>\n    <div class=\"group table-listing\">      \n        <ul>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"newsletters") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":12,"column":20}}})) != null ? stack1 : "")
    + "        </ul>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.IndustryCardList = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"table-container\">\n        <table class=\"table\">\n            <thead>\n                <th>Dateiname</th>\n                <th>Gültig bis</th>\n                <th>Upload-Datum</th>\n            </thead>\n            <tbody>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"uploadList") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":16},"end":{"line":22,"column":25}}})) != null ? stack1 : "")
    + "            </tbody>\n        </table>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <tr>\n                        <td>\n                            <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"link") || (depth0 != null ? lookupProperty(depth0,"link") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":13,"column":37},"end":{"line":13,"column":45}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":47},"end":{"line":13,"column":55}}}) : helper)))
    + "</a>\n                        </td>\n                        <td>\n                            "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"validity") || (depth0 != null ? lookupProperty(depth0,"validity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"validity","hash":{},"data":data,"loc":{"start":{"line":16,"column":28},"end":{"line":16,"column":40}}}) : helper)))
    + "\n                        </td>\n                        <td>\n                            "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"date","hash":{},"data":data,"loc":{"start":{"line":19,"column":28},"end":{"line":19,"column":36}}}) : helper)))
    + "\n                        </td>\n                    </tr>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"uploadList") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":26,"column":7}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventAdditionalTexts = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":21},"end":{"line":3,"column":29}}}) : helper)))
    + "\" data-pi-type=\"text\" class=\"pi-form-control"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":73},"end":{"line":3,"column":113}}})) != null ? stack1 : "")
    + "\" >\n        <div class=\"pi-form-label\">\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":5,"column":23}}}) : helper))) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"pi-form-helptext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":7,"column":38},"end":{"line":7,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":3,"column":92},"end":{"line":3,"column":106}}}) : helper)));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"additionalTexts") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":9,"column":9}}})) != null ? stack1 : "");
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventCustomText = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"eventtext pi-form-control "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClass") || (depth0 != null ? lookupProperty(depth0,"cssClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":38},"end":{"line":2,"column":50}}}) : helper)))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClass") : stack1), depth0))
    + "\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"customText") : stack1), depth0)) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.evBtnDeleteBooking = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"button\" class=\"btn btn-primary mr15\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":2,"column":55},"end":{"line":2,"column":68}}}) : helper)))
    + "-evDeleteBooking\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.cancelBookingBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":92},"end":{"line":2,"column":127}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventDescription = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"eventtext pi-form-control \">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ev_description") || (depth0 != null ? lookupProperty(depth0,"ev_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_description","hash":{},"data":data,"loc":{"start":{"line":2,"column":40},"end":{"line":2,"column":60}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventInfoBox = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":6,"column":13},"end":{"line":6,"column":24}}}) : helper)))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_time") || (depth0 != null ? lookupProperty(depth0,"ev_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_time","hash":{},"data":data,"loc":{"start":{"line":11,"column":13},"end":{"line":11,"column":24}}}) : helper)))
    + "</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"eventRoom") || (depth0 != null ? lookupProperty(depth0,"eventRoom") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"eventRoom","hash":{},"data":data,"loc":{"start":{"line":14,"column":13},"end":{"line":14,"column":26}}}) : helper)))
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_street") || (depth0 != null ? lookupProperty(depth0,"location_street") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_street","hash":{},"data":data,"loc":{"start":{"line":17,"column":13},"end":{"line":17,"column":32}}}) : helper)))
    + "</div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_zip") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":13},"end":{"line":20,"column":57}}})) != null ? stack1 : "")
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_city") || (depth0 != null ? lookupProperty(depth0,"location_city") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_city","hash":{},"data":data,"loc":{"start":{"line":20,"column":57},"end":{"line":20,"column":74}}}) : helper)))
    + "</div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_zip") || (depth0 != null ? lookupProperty(depth0,"location_zip") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_zip","hash":{},"data":data,"loc":{"start":{"line":20,"column":33},"end":{"line":20,"column":49}}}) : helper)))
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-form-control eventinfobox\">\n    <h3>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_title") || (depth0 != null ? lookupProperty(depth0,"ev_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_title","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":20}}}) : helper)))
    + "</h3>\n    <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nice_date") || (depth0 != null ? lookupProperty(depth0,"nice_date") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nice_date","hash":{},"data":data,"loc":{"start":{"line":4,"column":9},"end":{"line":4,"column":22}}}) : helper)))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ed_time") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "    <div>&nbsp;</div>\n    <div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"location_name") || (depth0 != null ? lookupProperty(depth0,"location_name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"location_name","hash":{},"data":data,"loc":{"start":{"line":9,"column":9},"end":{"line":9,"column":26}}}) : helper)))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ev_time") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":12,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"eventRoom") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_street") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"location_city") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":4},"end":{"line":21,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventListWidget = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <div class=\"row\">\n                    <div class=\"cell\" data-label=\"Titel\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ev_title") || (depth0 != null ? lookupProperty(depth0,"ev_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ev_title","hash":{},"data":data,"loc":{"start":{"line":20,"column":57},"end":{"line":20,"column":69}}}) : helper)))
    + "</div>\n                    <div class=\"cell\" data-label=\"Datum\"><time datetime=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_from") || (depth0 != null ? lookupProperty(depth0,"ed_from") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_from","hash":{},"data":data,"loc":{"start":{"line":21,"column":73},"end":{"line":21,"column":84}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_from") || (depth0 != null ? lookupProperty(depth0,"ed_from") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_from","hash":{},"data":data,"loc":{"start":{"line":21,"column":86},"end":{"line":21,"column":97}}}) : helper)))
    + "</time></div>\n                    <div class=\"cell\" data-label=\"Uhrzeit\"><time datetime=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":22,"column":75},"end":{"line":22,"column":86}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_time") || (depth0 != null ? lookupProperty(depth0,"ed_time") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_time","hash":{},"data":data,"loc":{"start":{"line":22,"column":88},"end":{"line":22,"column":99}}}) : helper)))
    + "</time></div>\n                    <div class=\"cell\" data-label=\"Freie Plätze\"><span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"vacancies") || (depth0 != null ? lookupProperty(depth0,"vacancies") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"vacancies","hash":{},"data":data,"loc":{"start":{"line":23,"column":70},"end":{"line":23,"column":83}}}) : helper)))
    + " <span class=\"aural\">Freie Plätze</span></span></div>\n                    <div class=\"cell\">\n                        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":24},"end":{"line":26,"column":152}}})) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n                </li>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ed_altformurl") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(5, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":49},"end":{"line":25,"column":121}}})) != null ? stack1 : "")
    + "?ev="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cookie") || (depth0 != null ? lookupProperty(depth0,"cookie") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cookie","hash":{},"data":data,"loc":{"start":{"line":25,"column":125},"end":{"line":25,"column":135}}}) : helper)))
    + "\" class=\"btn\" title=\"Diesen Termin buchen\">\n                            <span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.selectev",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":26,"column":34},"end":{"line":26,"column":61}}}))
    + "</span></a>";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ed_altformurl") || (depth0 != null ? lookupProperty(depth0,"ed_altformurl") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ed_altformurl","hash":{},"data":data,"loc":{"start":{"line":25,"column":70},"end":{"line":25,"column":87}}}) : helper)));
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"eventFormUrl") : depths[1]), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"btn btn-disabled\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.selectev",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":26,"column":111},"end":{"line":26,"column":138}}}))
    + "</span>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">\n    <div class=\"pi-message\">\n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":4,"column":17},"end":{"line":4,"column":32}}}) : helper)))
    + "\" class=\"pi-message-text\" style=\"display: none\"></div>\n    </div>\n    <div class=\"group table-listing\">\n        <header>\n            <div class=\"row\">\n                <div class=\"cell\"><span>Titel</span></div>\n                <div class=\"cell\"><span>Datum</span></div>\n                <div class=\"cell\"><span>Uhrzeit</span></div>\n                <div class=\"cell\"><span>Freie&nbsp;Plätze</span></div>\n                <div class=\"cell\"><span class=\"aural\">Buchen</span></div>\n            </div>\n        </header>\n        <ul>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"evenList") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":30,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.eventMsg = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-widget "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"containerClassName") || (depth0 != null ? lookupProperty(depth0,"containerClassName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"containerClassName","hash":{},"data":data,"loc":{"start":{"line":2,"column":22},"end":{"line":2,"column":44}}}) : helper)))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"customClass") || (depth0 != null ? lookupProperty(depth0,"customClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"customClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":60}}}) : helper)))
    + "\">\n    <div class=\"pi-heading\"><p id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"titleId") || (depth0 != null ? lookupProperty(depth0,"titleId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"titleId","hash":{},"data":data,"loc":{"start":{"line":3,"column":35},"end":{"line":3,"column":46}}}) : helper)))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.heading",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":3,"column":48},"end":{"line":3,"column":74}}}))
    + "</p></div>\n    <div class=\"pi-message\">\n        <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"msgWidgetId") || (depth0 != null ? lookupProperty(depth0,"msgWidgetId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"msgWidgetId","hash":{},"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":32}}}) : helper)))
    + "\" class=\"pi-message-text\" ></div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventNewsletter = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- just a dummy, show nothing  -->";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventParticipants = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"eventtext pi-form-control pi-infotext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"participantLimit") || (depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"participantLimit","hash":{},"data":data,"loc":{"start":{"line":3,"column":55},"end":{"line":3,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"helpText") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + "    <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":9,"column":21},"end":{"line":9,"column":29}}}) : helper)))
    + "\" data-pi-type=\"select\" class=\"pi-form-control participants pi_event_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":9,"column":98},"end":{"line":9,"column":106}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":9,"column":129},"end":{"line":9,"column":137}}}) : helper)))
    + "\">\n        <div class=\"pi-form-label\"><label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":10,"column":64},"end":{"line":10,"column":72}}}) : helper)))
    + "\" class=\"pi-form-label selectbox participants\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":10,"column":119},"end":{"line":10,"column":130}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":13,"column":19}}})) != null ? stack1 : "")
    + "        </label></div>\n        <div class=\"pi-form-input\">\n            <select id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":41},"end":{"line":16,"column":49}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":16,"column":62},"end":{"line":16,"column":70}}}) : helper)))
    + "\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":16,"column":82},"end":{"line":16,"column":89}}}) : helper)))
    + "\" class=\"participants_select form-control selectBox\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"num") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":19,"column":25}}})) != null ? stack1 : "")
    + "            </select>\n        </div>\n        <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n        <div class=\"pi-form-error-text\" id=\"errorMsg"
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":23,"column":68},"end":{"line":23,"column":76}}}) : helper)))
    + "\"></div>\n        <div class=\"pi-form-helptext\"></div>\n    </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"eventtext pi-form-control pi-infotext\"><p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":7,"column":62},"end":{"line":7,"column":74}}}) : helper)))
    + "</p></div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "                    <option value=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</option>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group col-xs-12 col-sm-12\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.EventPersonalizedParticipants = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"personalize_participants\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"helpText") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "\n        <div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":8,"column":25},"end":{"line":8,"column":33}}}) : helper)))
    + "\" data-pi-type=\"select\" class=\"pi-form-control participants pi_event_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":8,"column":102},"end":{"line":8,"column":110}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":8,"column":133},"end":{"line":8,"column":141}}}) : helper)))
    + "\">\n\n            <div class=\"pi-form-label\"><label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":10,"column":68},"end":{"line":10,"column":76}}}) : helper)))
    + "\" class=\"pi-form-label selectbox participants\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":16},"end":{"line":13,"column":23}}})) != null ? stack1 : "")
    + "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"locales") : depth0)) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\n            </label></div>\n            <div class=\"pi-form-input\">\n                <select id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":17,"column":45},"end":{"line":17,"column":53}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":17,"column":66},"end":{"line":17,"column":74}}}) : helper)))
    + "\" class=\"participants_select form-control selectBox\">\n                    <option value=\"\"></option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":20},"end":{"line":21,"column":29}}})) != null ? stack1 : "")
    + "                </select>\n            </div>\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":36,"column":21}}})) != null ? stack1 : "")
    + "\n            <div class=\"no_participants_select_info\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"locales") : depth0)) != null ? lookupProperty(stack1,"nomore_info") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n            <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n            <div class=\"pi-form-error-text\" id=\"errorMsg"
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":40,"column":72},"end":{"line":40,"column":80}}}) : helper)))
    + "\"></div>\n            <div class=\"pi-form-helptext\"></div>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"eventtext pi-form-control pi-infotext\"><p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"helpText") || (depth0 != null ? lookupProperty(depth0,"helpText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"helpText","hash":{},"data":data,"loc":{"start":{"line":5,"column":66},"end":{"line":5,"column":78}}}) : helper)))
    + "</p></div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "                    <span class=\"pi-mandatory\">&#42;</span>\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":20,"column":39},"end":{"line":20,"column":47}}}) : helper)))
    + "\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":20,"column":59},"end":{"line":20,"column":66}}}) : helper)))
    + "\" data-label=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":20,"column":80},"end":{"line":20,"column":91}}}) : helper))) != null ? stack1 : "")
    + "\" data-maxreached=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"maxreached") : stack1), depth0)) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":20,"column":139},"end":{"line":20,"column":150}}}) : helper))) != null ? stack1 : "")
    + "</option>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"pi-form-actions\">\n                    <div class=\"pi-form-button pi-participants-form-button\">\n                        <button class=\"um-btn btn btn-primary participants_select_button\" data-fee=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fee") || (depth0 != null ? lookupProperty(depth0,"fee") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fee","hash":{},"data":data,"loc":{"start":{"line":28,"column":100},"end":{"line":28,"column":107}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":28,"column":120},"end":{"line":28,"column":128}}}) : helper)))
    + "\" type=\"button\" name=\"button\" title=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":28,"column":214},"end":{"line":28,"column":222}}}) : helper)))
    + "\" data-label=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\" data-maxreached=\""
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"maxreached") : stack1), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":24},"end":{"line":31,"column":31}}})) != null ? stack1 : "")
    + "                            "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"locales") : depths[1])) != null ? lookupProperty(stack1,"add_label") : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </button>\n                    </div>\n                </div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "                            <span class=\"pi-mandatory\">&#42;</span>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"eventtext pi-form-control pi-infotext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"participantLimit") || (depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"participantLimit","hash":{},"data":data,"loc":{"start":{"line":46,"column":59},"end":{"line":46,"column":81}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group col-xs-12 col-sm-12\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participants") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":43,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"participantLimit") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":4},"end":{"line":47,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.EventPersonalizedParticipant = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-message-text\" id=\"participant_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":1,"column":45},"end":{"line":1,"column":52}}}) : helper)))
    + "\" data-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":65},"end":{"line":1,"column":73}}}) : helper)))
    + "\" data-num=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":1,"column":85},"end":{"line":1,"column":92}}}) : helper)))
    + "\">\n    <div class=\"pi-form-control form-group\">\n        <div class=\"pi-form-label pi-form-label-has-button\" >\n            <div class=\"pi-form-label-left participant-title\">\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\n            </div>\n            <div class=\"pi-form-label-button\">\n                <button class=\"pi-form-label-button-right ui-button ui-corner-all ui-widget ui-button-icon-only participant_remove\" title=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"buttonLabel") || (depth0 != null ? lookupProperty(depth0,"buttonLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"buttonLabel","hash":{},"data":data,"loc":{"start":{"line":8,"column":139},"end":{"line":8,"column":156}}}) : helper))) != null ? stack1 : "")
    + "\" id=\"participant_remove_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":8,"column":181},"end":{"line":8,"column":188}}}) : helper)))
    + "\" data-num=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"num") || (depth0 != null ? lookupProperty(depth0,"num") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"num","hash":{},"data":data,"loc":{"start":{"line":8,"column":200},"end":{"line":8,"column":207}}}) : helper)))
    + "\">\n                    <span class='ui-icon ui-icon-trash'></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.evBtnSubmitAndNextBooking = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button type=\"submit\" class=\"btn btn-primary ml15\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":2,"column":55},"end":{"line":2,"column":68}}}) : helper)))
    + "-evSubmitAndNextBooking\"><span>"
    + container.escapeExpression((lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form.collectionBookingBtn",{"name":"caption","hash":{},"data":data,"loc":{"start":{"line":2,"column":99},"end":{"line":2,"column":138}}}))
    + "</span></button>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventTotalprice = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"eventtext pi-form-control\">Gesamtpreis: <span id=\"pitotalprice\">0,00</span>&nbsp;&euro; (inkl. MwSt.)</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.EventWorkshopGroup = {"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":136}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-label\">\n            <label>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":4,"column":19},"end":{"line":4,"column":28}}}) : helper)))
    + "</label>\n        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-helptext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":8,"column":38},"end":{"line":8,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-input\">\n            <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":23},"end":{"line":13,"column":74}}})) != null ? stack1 : "")
    + "extended-item-space pi-form-input pi-w-100\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"members") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":12},"end":{"line":32,"column":21}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "inline-list ";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li>\n                    <span class=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"cssClass") : depths[1]), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":17,"column":20},"end":{"line":22,"column":27}}})) != null ? stack1 : "")
    + "                        <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":23,"column":53},"end":{"line":23,"column":63}}}) : helper)))
    + "\"><span></span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_title") || (depth0 != null ? lookupProperty(depth0,"ws_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_title","hash":{},"data":data,"loc":{"start":{"line":23,"column":78},"end":{"line":23,"column":90}}}) : helper)))
    + "</label>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_description") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":24},"end":{"line":26,"column":31}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"booking_info") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":24},"end":{"line":29,"column":31}}})) != null ? stack1 : "")
    + "                    </span>\n                </li>\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":18,"column":68},"end":{"line":18,"column":78}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "["
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":18,"column":98},"end":{"line":18,"column":108}}}) : helper)))
    + "]\"\n                               value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":19,"column":38},"end":{"line":19,"column":48}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifContains")||(depth0 && lookupProperty(depth0,"ifContains"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifContains","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":50},"end":{"line":19,"column":103}}})) != null ? stack1 : "")
    + " />\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "checked";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <input type=\"checkbox\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":21,"column":68},"end":{"line":21,"column":78}}}) : helper)))
    + "\" readonly=\"readonly\" disabled=\"disabled\"/>\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ws_description") || (depth0 != null ? lookupProperty(depth0,"ws_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_description","hash":{},"data":data,"loc":{"start":{"line":25,"column":53},"end":{"line":25,"column":73}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"booking_info") || (depth0 != null ? lookupProperty(depth0,"booking_info") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"booking_info","hash":{},"data":data,"loc":{"start":{"line":28,"column":53},"end":{"line":28,"column":71}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"20":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-form-input\">\n            <ul class=\""
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),"horizontal",{"name":"ifEq","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":23},"end":{"line":38,"column":73}}})) != null ? stack1 : "")
    + " extended-item-space\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"members") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":16},"end":{"line":57,"column":25}}})) != null ? stack1 : "")
    + "            </ul>\n        </div>\n";
},"21":function(container,depth0,helpers,partials,data) {
    return "inline-list";
},"23":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <li>\n                        <span class=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"cssClass") : depths[1]), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bookable") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.program(27, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":42,"column":28},"end":{"line":46,"column":35}}})) != null ? stack1 : "")
    + "\n                            <label for=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":48,"column":57},"end":{"line":48,"column":67}}}) : helper)))
    + "\"><span></span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_title") || (depth0 != null ? lookupProperty(depth0,"ws_title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_title","hash":{},"data":data,"loc":{"start":{"line":48,"column":82},"end":{"line":48,"column":94}}}) : helper)))
    + "</label>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_description") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":28},"end":{"line":51,"column":35}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"booking_info") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":28},"end":{"line":54,"column":35}}})) != null ? stack1 : "")
    + "                        </span>\n                    </li>\n";
},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <input type=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":43,"column":73},"end":{"line":43,"column":83}}}) : helper)))
    + "\" name=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]), depth0))
    + "\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":43,"column":111},"end":{"line":43,"column":121}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0),(depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":123},"end":{"line":43,"column":175}}})) != null ? stack1 : "")
    + "/>\n";
},"25":function(container,depth0,helpers,partials,data) {
    return " checked=\"checked\"";
},"27":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <input type=\"radio\" id=\""
    + container.escapeExpression(container.lambda((depths[1] != null ? lookupProperty(depths[1],"elementId") : depths[1]), depth0))
    + "-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ws_oid") || (depth0 != null ? lookupProperty(depth0,"ws_oid") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_oid","hash":{},"data":data,"loc":{"start":{"line":45,"column":73},"end":{"line":45,"column":83}}}) : helper)))
    + "\" readonly=\"readonly\" disabled=\"disabled\"/>\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ws_description") || (depth0 != null ? lookupProperty(depth0,"ws_description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ws_description","hash":{},"data":data,"loc":{"start":{"line":50,"column":57},"end":{"line":50,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <span class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"booking_info") || (depth0 != null ? lookupProperty(depth0,"booking_info") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"booking_info","hash":{},"data":data,"loc":{"start":{"line":53,"column":57},"end":{"line":53,"column":75}}}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\"wsgroup\" class=\"pi-form-control pi-wsgroup col-xs-12 col-sm-12"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":103},"end":{"line":1,"column":143}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"label") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mode") : depth0),"checkbox",{"name":"ifEq","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":35,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mode") : depth0),"radio",{"name":"ifEq","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":4},"end":{"line":60,"column":13}}})) != null ? stack1 : "")
    + "\n    <div class=\"pi-form-error\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.DeleteProfileField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- No field -->";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.formlinebreak = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"clearfix\"></div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.infotext = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n    <div class=\"control-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"infoText") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.ParkingCalendarField = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pi-parking-calendar\">\n    <div class=\"form-group\">\n        <div class=\"parking-calendar-container\">\n        <div class=\"parking-date-container\">\n            <label>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"arrival") : stack1), depth0))
    + "</label>\n            <input type=\"text\" value=\"\" name=\"parking-date-from\" id=\"parking-date-from\" class=\"form-control datepicker-style\">\n        </div>\n        <div id=\"parking-calendar-from\" class=\"parking-calendar bg-bright\"></div>\n        <div class=\"parking-departure-date parking-date-container\">\n            <label>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"departure") : stack1), depth0))
    + "</label>\n            <input type=\"text\" value=\"\" name=\"parking-date-to\" id=\"parking-date-to\" class=\"form-control datepicker-style\">\n        </div>\n        <div id=\"parking-calendar-to\" class=\"parking-calendar hidden bg-bright\"></div>\n        </div>\n    </div>\n    <div class=\"form-group time-group parking-arrival\">\n        <label for=\"parking-time-arrival\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"arrival_time") : stack1), depth0))
    + ":</label>\n        <select name=\"parking-time-arrival\" id=\"parking-time-arrival\" class=\"form-control\">\n        </select>\n    </div>\n    <div class=\"form-group time-group parking-departure\">\n        <label for=\"parking-time-departure\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"departure_time") : stack1), depth0))
    + ":</label>\n        <select name=\"parking-time-departure\" id=\"parking-time-departure\" class=\"form-control\">\n        </select>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.Phone3Field = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCountry") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":6,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "                <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "         <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":24},"end":{"line":13,"column":32}}}) : helper)))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),(depths[1] != null ? lookupProperty(depths[1],"valueCountry") : depths[1]),{"name":"ifEq","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":34},"end":{"line":13,"column":81}}})) != null ? stack1 : "")
    + ">         \n                 "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":14,"column":17},"end":{"line":14,"column":26}}}) : helper)))
    + "\n         </option>                      \n";
},"5":function(container,depth0,helpers,partials,data) {
    return "selected";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":16},"end":{"line":26,"column":23}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    return "                    <span class=\"pi-mandatory\">&#42;</span>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":144},"end":{"line":31,"column":169}}})) != null ? stack1 : "")
    + "\" ";
},"11":function(container,depth0,helpers,partials,data) {
    return "*";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":16},"end":{"line":40,"column":23}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mandatory") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":142},"end":{"line":45,"column":167}}})) != null ? stack1 : "")
    + "\" ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesCountry") : stack1), depth0))
    + "\">\n    <div class=\"pi-form-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":3,"column":20},"end":{"line":3,"column":33}}}) : helper)))
    + "-country\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCountry") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":65},"end":{"line":7,"column":15}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":11,"column":22},"end":{"line":11,"column":30}}}) : helper)))
    + "Country\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":43},"end":{"line":11,"column":56}}}) : helper)))
    + "-country\" class=\"form-control selectBox\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":16,"column":17}}})) != null ? stack1 : "")
    + "        </select>\n    </div>    \n</div>\n\n<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesCity") : stack1), depth0))
    + "\">\n        <div class=\"pi-form-label\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":24},"end":{"line":23,"column":37}}}) : helper)))
    + "-city\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelCity") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":66},"end":{"line":27,"column":19}}})) != null ? stack1 : "")
    + "            </label>\n        </div>\n        <div class=\"pi-form-input\">\n            <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":31,"column":23},"end":{"line":31,"column":36}}}) : helper)))
    + "-city\" type=\"text\" class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":76},"end":{"line":31,"column":178}}})) != null ? stack1 : "")
    + " value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"valueCity") || (depth0 != null ? lookupProperty(depth0,"valueCity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"valueCity","hash":{},"data":data,"loc":{"start":{"line":31,"column":186},"end":{"line":31,"column":199}}}) : helper)))
    + "\" />\n        </div>    \n</div>\n\n<div class=\"form-group "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"cssClassesPhone") : stack1), depth0))
    + "\">\n    <div class=\"pi-form-label\">\n        <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":37,"column":20},"end":{"line":37,"column":33}}}) : helper)))
    + "-phone\" class=\"control-label\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"labelPhone") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":63},"end":{"line":41,"column":19}}})) != null ? stack1 : "")
    + "        </label>\n    </div>\n    <div class=\"pi-form-input\">\n        <input id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":45,"column":19},"end":{"line":45,"column":32}}}) : helper)))
    + "-phone\" type=\"text\" class=\"form-control\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"useLabelAsPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":73},"end":{"line":45,"column":176}}})) != null ? stack1 : "")
    + " value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"valueCity") || (depth0 != null ? lookupProperty(depth0,"valueCity") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"valueCity","hash":{},"data":data,"loc":{"start":{"line":45,"column":184},"end":{"line":45,"column":197}}}) : helper)))
    + "\" />\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n</div>\n\n<div class=\"col-xs-12 col-sm-12 col-md-12\">\n    <div class=\"form-group control-label\">\n        <div class=\"pi-form-error mt5 has-error\"></div>\n    </div>\n</div>\n<div class=\"clearfix\"></div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.rangeslider = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":41}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <span class=\"pi-info-window\">\n                <span class=\"pi-info-icon\"></span>\n                <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":43},"end":{"line":11,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</span>\n            </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":36},"end":{"line":15,"column":46}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <label for=\"\" class=\"control-label range-slider-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"showValue") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":37},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + "    </label>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n            <span class=\"range-slider-min\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + "</span> - <span class=\"range-slider-max\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "</span> \n";
},"11":function(container,depth0,helpers,partials,data) {
    return "data-slider-time=\"true\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "  <div class=\"rangeslider-wrapper js-range-slider\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":24,"column":11}}})) != null ? stack1 : "")
    + "    <input type=\"text\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":25,"column":35},"end":{"line":25,"column":48}}}) : helper)))
    + "\" class=\"range-slider-control\" \n        data-slider-enabled=\"true\" \n        data-slider-min=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMin") : stack1), depth0))
    + "\" \n        data-slider-max=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMax") : stack1), depth0))
    + "\" \n        data-slider-step=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStep") : stack1), depth0))
    + "\" \n        data-slider-value=\"["
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + ", "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "]\" \n        "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"isTime") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":31,"column":73}}})) != null ? stack1 : "")
    + "\n        data-slider-tooltip=\"hide\" \n        value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMin") : stack1), depth0))
    + " - "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValueMax") : stack1), depth0))
    + "\"\n      />\n  </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.slider = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"control-label\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":41}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"pi-info-window\">\n            <span class=\"pi-info-icon\"></span>\n            <span class=\"pi-info-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":11,"column":39},"end":{"line":11,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</span>\n        </span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":15,"column":32},"end":{"line":15,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <label for=\"\" class=\"control-label range-slider-label\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"showValue") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":37},"end":{"line":20,"column":153}}})) != null ? stack1 : "")
    + "\n    </label>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"range-slider-value\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "</span>";
},"11":function(container,depth0,helpers,partials,data) {
    return "data-slider-time=\"true\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":23},"end":{"line":1,"column":37}}}) : helper)))
    + "\">\n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"infotext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "  <div class=\"rangeslider-wrapper js-range-slider\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderLabel") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":22,"column":11}}})) != null ? stack1 : "")
    + "    <input type=\"text\" name=\"\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":23,"column":35},"end":{"line":23,"column":48}}}) : helper)))
    + "\" class=\"range-slider-control\" \n        data-slider-enabled=\"true\" \n        data-slider-min=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMin") : stack1), depth0))
    + "\" \n        data-slider-max=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderMax") : stack1), depth0))
    + "\" \n        data-slider-step=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStep") : stack1), depth0))
    + "\" \n        data-slider-value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "\" \n        "
    + ((stack1 = (lookupProperty(helpers,"ifEq")||(depth0 && lookupProperty(depth0,"ifEq"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"isTime") : stack1),"yes",{"name":"ifEq","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":29,"column":73}}})) != null ? stack1 : "")
    + "\n        data-slider-tooltip=\"hide\" \n        value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"sliderStartValue") : stack1), depth0))
    + "\"\n      />\n  </div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.subheading = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":16},"end":{"line":1,"column":30}}}) : helper)))
    + "\">\n    <div class=\"col-xs-12\">\n      <div class=\"mb15\">\n        <h3>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0))
    + "</h3>\n      </div>\n    </div>\n</div>";
},"useData":true};window.pinuts.formtpl.NewsletterIcon.switchtoggel = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":2,"column":69},"end":{"line":2,"column":79}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"pi-mandatory\">&#42;</span>\n        ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\">\n    <div class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":5,"column":27}}})) != null ? stack1 : "")
    + "</div>\n\n\n    <div class=\"pi-form-input switch-toggle\">\n        <div class=\"toggle-slide\">\n            <input type=\"checkbox\" value=\"1\" name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":10,"column":51},"end":{"line":10,"column":59}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":65},"end":{"line":10,"column":78}}}) : helper)))
    + "\" class=\"switch-toggle-input js-switch-toggle-input\">\n            <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":11,"column":24},"end":{"line":11,"column":37}}}) : helper)))
    + "\" class=\"toggle-inner\">\n                <div class=\"toggle-on\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"toggelOn") : stack1), depth0))
    + "</div>\n                <div class=\"toggle-blob\"></div>\n                <div class=\"toggle-off\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"attributes") : depth0)) != null ? lookupProperty(stack1,"toggelOff") : stack1), depth0))
    + "</div>\n            </label>\n        </div>\n    </div>\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div>\n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.UploadValidationDateField = {"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":10,"column":112},"end":{"line":10,"column":122}}}) : helper))) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"month") || (depth0 != null ? lookupProperty(depth0,"month") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"month","hash":{},"data":data,"loc":{"start":{"line":16,"column":43},"end":{"line":16,"column":52}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":54},"end":{"line":16,"column":100}}})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"month") || (depth0 != null ? lookupProperty(depth0,"month") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"month","hash":{},"data":data,"loc":{"start":{"line":16,"column":101},"end":{"line":16,"column":110}}}) : helper)))
    + "</option>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "disabled=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"disabled") || (depth0 != null ? lookupProperty(depth0,"disabled") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"disabled","hash":{},"data":data,"loc":{"start":{"line":16,"column":80},"end":{"line":16,"column":92}}}) : helper)))
    + "\"";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"year") || (depth0 != null ? lookupProperty(depth0,"year") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"year","hash":{},"data":data,"loc":{"start":{"line":32,"column":43},"end":{"line":32,"column":51}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":53},"end":{"line":32,"column":99}}})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"year") || (depth0 != null ? lookupProperty(depth0,"year") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"year","hash":{},"data":data,"loc":{"start":{"line":32,"column":100},"end":{"line":32,"column":108}}}) : helper)))
    + "</option>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-pi-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":25}}}) : helper)))
    + "\" data-pi-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":41},"end":{"line":1,"column":49}}}) : helper)))
    + "\" class=\"form-group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":83}}}) : helper)))
    + "\" >\n    <div class=\"pi-form-label\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"label"),depth0,{"name":"label","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div> \n\n    <div class=\"row\">\n        <div class=\"col-sm-6\">\n            <div class=\"pi-form-group\">\n                <div class=\"pi-form-label\">\n                    <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":10,"column":32},"end":{"line":10,"column":45}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"labelMonth",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":69},"end":{"line":10,"column":134}}})) != null ? stack1 : "")
    + "</label>\n                </div>\n                <div class=\"pi-form-input\">\n                    <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":34},"end":{"line":13,"column":42}}}) : helper)))
    + "-month\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":13,"column":54},"end":{"line":13,"column":67}}}) : helper)))
    + "-month\" class=\"form-control selectBox\">\n                        <option value=\"\" selected>--</option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"month") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":24},"end":{"line":17,"column":33}}})) != null ? stack1 : "")
    + "                    </select>\n                </div>\n            </div>\n        </div>\n            \n        <div class=\"col-sm-6\">\n            <div class=\"pi-form-group\">\n                <div class=\"pi-form-label\">\n                    <label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":26,"column":32},"end":{"line":26,"column":45}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"labelYear",{"name":"caption","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":69},"end":{"line":26,"column":133}}})) != null ? stack1 : "")
    + "</label>\n                </div>\n                <div class=\"pi-form-input\">\n                    <select name=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":29,"column":34},"end":{"line":29,"column":42}}}) : helper)))
    + "-year\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":29,"column":53},"end":{"line":29,"column":66}}}) : helper)))
    + "-year\" class=\"form-control selectBox\">\n                        <option value=\"\" selected>--</option>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"year") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":24},"end":{"line":33,"column":33}}})) != null ? stack1 : "")
    + "                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"pi-form-status\"><span class=\"pi-status-icon\"></span></div> \n    <div class=\"pi-form-error mt5\"></div>\n</div>";
},"usePartial":true,"useData":true};window.pinuts.formPartials.NewsletterIcon.label = {"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":87},"end":{"line":1,"column":97}}}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"mandatory") : depths[1]),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":4,"column":11}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"pi-mandatory\">&#42;</span>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pi-subtext\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":8,"column":28},"end":{"line":8,"column":38}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label for=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"elementId") || (depth0 != null ? lookupProperty(depth0,"elementId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"elementId","hash":{},"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":25}}}) : helper)))
    + "\" class=\"control-label\">"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"label",{"name":"caption","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":49},"end":{"line":5,"column":16}}})) != null ? stack1 : "")
    + "</label>  \n"
    + ((stack1 = (lookupProperty(helpers,"caption")||(depth0 && lookupProperty(depth0,"caption"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"attributes",(depth0 != null ? lookupProperty(depth0,"name") : depth0),"subtext",{"name":"caption","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":9,"column":12}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true};window.pinuts.formtpl.NewsletterIcon.chtml_sfs_text = {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"group "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"cssClasses") || (depth0 != null ? lookupProperty(depth0,"cssClasses") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cssClasses","hash":{},"data":data,"loc":{"start":{"line":1,"column":18},"end":{"line":1,"column":32}}}) : helper)))
    + "\"><div>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":39},"end":{"line":1,"column":47}}}) : helper)))
    + "</div></div>";
},"useData":true}
;var pirequire;(function () { if (!pirequire || !pirequire.requirejs) {
if (!pirequire) { pirequire = {}; } else { require = pirequire; }
/** vim: et:ts=4:sw=4:sts=4
 * @license RequireJS 2.3.6 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, https://github.com/requirejs/requirejs/blob/master/LICENSE
 */
//Not using strict: uneven strict support in browsers, #392, and causes
//problems with requirejs.exec()/transpiler plugins that may not be strict.
/*jslint regexp: true, nomen: true, sloppy: true */
/*global window, navigator, document, importScripts, setTimeout, opera */

var requirejs, require, define;
(function (global, setTimeout) {
    var req, s, head, baseElement, dataMain, src,
        interactiveScript, currentlyAddingScript, mainScript, subPath,
        version = '2.3.6',
        commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/mg,
        cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
        jsSuffixRegExp = /\.js$/,
        currDirRegExp = /^\.\//,
        op = Object.prototype,
        ostring = op.toString,
        hasOwn = op.hasOwnProperty,
        isBrowser = !!(typeof window !== 'undefined' && typeof navigator !== 'undefined' && window.document),
        isWebWorker = !isBrowser && typeof importScripts !== 'undefined',
        //PS3 indicates loaded and complete, but need to wait for complete
        //specifically. Sequence is 'loading', 'loaded', execution,
        // then 'complete'. The UA check is unfortunate, but not sure how
        //to feature test w/o causing perf issues.
        readyRegExp = isBrowser && navigator.platform === 'PLAYSTATION 3' ?
            /^complete$/ : /^(complete|loaded)$/,
        defContextName = '_',
        //Oh the tragedy, detecting opera. See the usage of isOpera for reason.
        isOpera = typeof opera !== 'undefined' && opera.toString() === '[object Opera]',
        contexts = {},
        cfg = {},
        globalDefQueue = [],
        useInteractive = false;

    //Could match something like ')//comment', do not lose the prefix to comment.
    function commentReplace(match, singlePrefix) {
        return singlePrefix || '';
    }

    function isFunction(it) {
        return ostring.call(it) === '[object Function]';
    }

    function isArray(it) {
        return ostring.call(it) === '[object Array]';
    }

    /**
     * Helper function for iterating over an array. If the func returns
     * a true value, it will break out of the loop.
     */
    function each(ary, func) {
        if (ary) {
            var i;
            for (i = 0; i < ary.length; i += 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    /**
     * Helper function for iterating over an array backwards. If the func
     * returns a true value, it will break out of the loop.
     */
    function eachReverse(ary, func) {
        if (ary) {
            var i;
            for (i = ary.length - 1; i > -1; i -= 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    function getOwn(obj, prop) {
        return hasProp(obj, prop) && obj[prop];
    }

    /**
     * Cycles over properties in an object and calls a function for each
     * property value. If the function returns a truthy value, then the
     * iteration is stopped.
     */
    function eachProp(obj, func) {
        var prop;
        for (prop in obj) {
            if (hasProp(obj, prop)) {
                if (func(obj[prop], prop)) {
                    break;
                }
            }
        }
    }

    /**
     * Simple function to mix in properties from source into target,
     * but only if target does not already have a property of the same name.
     */
    function mixin(target, source, force, deepStringMixin) {
        if (source) {
            eachProp(source, function (value, prop) {
                if (force || !hasProp(target, prop)) {
                    if (deepStringMixin && typeof value === 'object' && value &&
                        !isArray(value) && !isFunction(value) &&
                        !(value instanceof RegExp)) {

                        if (!target[prop]) {
                            target[prop] = {};
                        }
                        mixin(target[prop], value, force, deepStringMixin);
                    } else {
                        target[prop] = value;
                    }
                }
            });
        }
        return target;
    }

    //Similar to Function.prototype.bind, but the 'this' object is specified
    //first, since it is easier to read/figure out what 'this' will be.
    function bind(obj, fn) {
        return function () {
            return fn.apply(obj, arguments);
        };
    }

    function scripts() {
        return document.getElementsByTagName('script');
    }

    function defaultOnError(err) {
        throw err;
    }

    //Allow getting a global that is expressed in
    //dot notation, like 'a.b.c'.
    function getGlobal(value) {
        if (!value) {
            return value;
        }
        var g = global;
        each(value.split('.'), function (part) {
            g = g[part];
        });
        return g;
    }

    /**
     * Constructs an error with a pointer to an URL with more information.
     * @param {String} id the error ID that maps to an ID on a web page.
     * @param {String} message human readable error.
     * @param {Error} [err] the original error, if there is one.
     *
     * @returns {Error}
     */
    function makeError(id, msg, err, requireModules) {
        var e = new Error(msg + '\nhttps://requirejs.org/docs/errors.html#' + id);
        e.requireType = id;
        e.requireModules = requireModules;
        if (err) {
            e.originalError = err;
        }
        return e;
    }

    if (typeof define !== 'undefined') {
        //If a define is already in play via another AMD loader,
        //do not overwrite.
        return;
    }

    if (typeof requirejs !== 'undefined') {
        if (isFunction(requirejs)) {
            //Do not overwrite an existing requirejs instance.
            return;
        }
        cfg = requirejs;
        requirejs = undefined;
    }

    //Allow for a require config object
    if (typeof require !== 'undefined' && !isFunction(require)) {
        //assume it is a config object.
        cfg = require;
        require = undefined;
    }

    function newContext(contextName) {
        var inCheckLoaded, Module, context, handlers,
            checkLoadedTimeoutId,
            config = {
                //Defaults. Do not set a default for map
                //config to speed up normalize(), which
                //will run faster if there is no default.
                waitSeconds: 7,
                baseUrl: './',
                paths: {},
                bundles: {},
                pkgs: {},
                shim: {},
                config: {}
            },
            registry = {},
            //registry of just enabled modules, to speed
            //cycle breaking code when lots of modules
            //are registered, but not activated.
            enabledRegistry = {},
            undefEvents = {},
            defQueue = [],
            defined = {},
            urlFetched = {},
            bundlesMap = {},
            requireCounter = 1,
            unnormalizedCounter = 1;

        /**
         * Trims the . and .. from an array of path segments.
         * It will keep a leading path segment if a .. will become
         * the first path segment, to help with module name lookups,
         * which act like paths, but can be remapped. But the end result,
         * all paths that use this function should look normalized.
         * NOTE: this method MODIFIES the input array.
         * @param {Array} ary the array of path segments.
         */
        function trimDots(ary) {
            var i, part;
            for (i = 0; i < ary.length; i++) {
                part = ary[i];
                if (part === '.') {
                    ary.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && ary[2] === '..') || ary[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        ary.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
        }

        /**
         * Given a relative module name, like ./something, normalize it to
         * a real name that can be mapped to a path.
         * @param {String} name the relative name
         * @param {String} baseName a real name that the name arg is relative
         * to.
         * @param {Boolean} applyMap apply the map config to the value. Should
         * only be done if this normalization is for a dependency ID.
         * @returns {String} normalized name
         */
        function normalize(name, baseName, applyMap) {
            var pkgMain, mapValue, nameParts, i, j, nameSegment, lastIndex,
                foundMap, foundI, foundStarMap, starI, normalizedBaseParts,
                baseParts = (baseName && baseName.split('/')),
                map = config.map,
                starMap = map && map['*'];

            //Adjust any relative paths.
            if (name) {
                name = name.split('/');
                lastIndex = name.length - 1;

                // If wanting node ID compatibility, strip .js from end
                // of IDs. Have to do this here, and not in nameToUrl
                // because node allows either .js or non .js to map
                // to same file.
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                // Starts with a '.' so need the baseName
                if (name[0].charAt(0) === '.' && baseParts) {
                    //Convert baseName to array, and lop off the last part,
                    //so that . matches that 'directory' and not name of the baseName's
                    //module. For instance, baseName of 'one/two/three', maps to
                    //'one/two/three.js', but we want the directory, 'one/two' for
                    //this normalization.
                    normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                    name = normalizedBaseParts.concat(name);
                }

                trimDots(name);
                name = name.join('/');
            }

            //Apply map config if available.
            if (applyMap && map && (baseParts || starMap)) {
                nameParts = name.split('/');

                outerLoop: for (i = nameParts.length; i > 0; i -= 1) {
                    nameSegment = nameParts.slice(0, i).join('/');

                    if (baseParts) {
                        //Find the longest baseName segment match in the config.
                        //So, do joins on the biggest to smallest lengths of baseParts.
                        for (j = baseParts.length; j > 0; j -= 1) {
                            mapValue = getOwn(map, baseParts.slice(0, j).join('/'));

                            //baseName segment has config, find if it has one for
                            //this name.
                            if (mapValue) {
                                mapValue = getOwn(mapValue, nameSegment);
                                if (mapValue) {
                                    //Match, update name to the new value.
                                    foundMap = mapValue;
                                    foundI = i;
                                    break outerLoop;
                                }
                            }
                        }
                    }

                    //Check for a star map match, but just hold on to it,
                    //if there is a shorter segment match later in a matching
                    //config, then favor over this star map.
                    if (!foundStarMap && starMap && getOwn(starMap, nameSegment)) {
                        foundStarMap = getOwn(starMap, nameSegment);
                        starI = i;
                    }
                }

                if (!foundMap && foundStarMap) {
                    foundMap = foundStarMap;
                    foundI = starI;
                }

                if (foundMap) {
                    nameParts.splice(0, foundI, foundMap);
                    name = nameParts.join('/');
                }
            }

            // If the name points to a package's name, use
            // the package main instead.
            pkgMain = getOwn(config.pkgs, name);

            return pkgMain ? pkgMain : name;
        }

        function removeScript(name) {
            if (isBrowser) {
                each(scripts(), function (scriptNode) {
                    if (scriptNode.getAttribute('data-requiremodule') === name &&
                        scriptNode.getAttribute('data-requirecontext') === context.contextName) {
                        scriptNode.parentNode.removeChild(scriptNode);
                        return true;
                    }
                });
            }
        }

        function hasPathFallback(id) {
            var pathConfig = getOwn(config.paths, id);
            if (pathConfig && isArray(pathConfig) && pathConfig.length > 1) {
                //Pop off the first array value, since it failed, and
                //retry
                pathConfig.shift();
                context.require.undef(id);

                //Custom require that does not do map translation, since
                //ID is "absolute", already mapped/resolved.
                context.makeRequire(null, {
                    skipMap: true
                })([id]);

                return true;
            }
        }

        //Turns a plugin!resource to [plugin, resource]
        //with the plugin being undefined if the name
        //did not have a plugin prefix.
        function splitPrefix(name) {
            var prefix,
                index = name ? name.indexOf('!') : -1;
            if (index > -1) {
                prefix = name.substring(0, index);
                name = name.substring(index + 1, name.length);
            }
            return [prefix, name];
        }

        /**
         * Creates a module mapping that includes plugin prefix, module
         * name, and path. If parentModuleMap is provided it will
         * also normalize the name via require.normalize()
         *
         * @param {String} name the module name
         * @param {String} [parentModuleMap] parent module map
         * for the module name, used to resolve relative names.
         * @param {Boolean} isNormalized: is the ID already normalized.
         * This is true if this call is done for a define() module ID.
         * @param {Boolean} applyMap: apply the map config to the ID.
         * Should only be true if this map is for a dependency.
         *
         * @returns {Object}
         */
        function makeModuleMap(name, parentModuleMap, isNormalized, applyMap) {
            var url, pluginModule, suffix, nameParts,
                prefix = null,
                parentName = parentModuleMap ? parentModuleMap.name : null,
                originalName = name,
                isDefine = true,
                normalizedName = '';

            //If no name, then it means it is a require call, generate an
            //internal name.
            if (!name) {
                isDefine = false;
                name = '_@r' + (requireCounter += 1);
            }

            nameParts = splitPrefix(name);
            prefix = nameParts[0];
            name = nameParts[1];

            if (prefix) {
                prefix = normalize(prefix, parentName, applyMap);
                pluginModule = getOwn(defined, prefix);
            }

            //Account for relative paths if there is a base name.
            if (name) {
                if (prefix) {
                    if (isNormalized) {
                        normalizedName = name;
                    } else if (pluginModule && pluginModule.normalize) {
                        //Plugin is loaded, use its normalize method.
                        normalizedName = pluginModule.normalize(name, function (name) {
                            return normalize(name, parentName, applyMap);
                        });
                    } else {
                        // If nested plugin references, then do not try to
                        // normalize, as it will not normalize correctly. This
                        // places a restriction on resourceIds, and the longer
                        // term solution is not to normalize until plugins are
                        // loaded and all normalizations to allow for async
                        // loading of a loader plugin. But for now, fixes the
                        // common uses. Details in #1131
                        normalizedName = name.indexOf('!') === -1 ?
                            normalize(name, parentName, applyMap) :
                            name;
                    }
                } else {
                    //A regular module.
                    normalizedName = normalize(name, parentName, applyMap);

                    //Normalized name may be a plugin ID due to map config
                    //application in normalize. The map config values must
                    //already be normalized, so do not need to redo that part.
                    nameParts = splitPrefix(normalizedName);
                    prefix = nameParts[0];
                    normalizedName = nameParts[1];
                    isNormalized = true;

                    url = context.nameToUrl(normalizedName);
                }
            }

            //If the id is a plugin id that cannot be determined if it needs
            //normalization, stamp it with a unique ID so two matching relative
            //ids that may conflict can be separate.
            suffix = prefix && !pluginModule && !isNormalized ?
                '_unnormalized' + (unnormalizedCounter += 1) :
                '';

            return {
                prefix: prefix,
                name: normalizedName,
                parentMap: parentModuleMap,
                unnormalized: !!suffix,
                url: url,
                originalName: originalName,
                isDefine: isDefine,
                id: (prefix ?
                    prefix + '!' + normalizedName :
                    normalizedName) + suffix
            };
        }

        function getModule(depMap) {
            var id = depMap.id,
                mod = getOwn(registry, id);

            if (!mod) {
                mod = registry[id] = new context.Module(depMap);
            }

            return mod;
        }

        function on(depMap, name, fn) {
            var id = depMap.id,
                mod = getOwn(registry, id);

            if (hasProp(defined, id) &&
                (!mod || mod.defineEmitComplete)) {
                if (name === 'defined') {
                    fn(defined[id]);
                }
            } else {
                mod = getModule(depMap);
                if (mod.error && name === 'error') {
                    fn(mod.error);
                } else {
                    mod.on(name, fn);
                }
            }
        }

        function onError(err, errback) {
            var ids = err.requireModules,
                notified = false;

            if (errback) {
                errback(err);
            } else {
                each(ids, function (id) {
                    var mod = getOwn(registry, id);
                    if (mod) {
                        //Set error on module, so it skips timeout checks.
                        mod.error = err;
                        if (mod.events.error) {
                            notified = true;
                            mod.emit('error', err);
                        }
                    }
                });

                if (!notified) {
                    req.onError(err);
                }
            }
        }

        /**
         * Internal method to transfer globalQueue items to this context's
         * defQueue.
         */
        function takeGlobalQueue() {
            //Push all the globalDefQueue items into the context's defQueue
            if (globalDefQueue.length) {
                each(globalDefQueue, function(queueItem) {
                    var id = queueItem[0];
                    if (typeof id === 'string') {
                        context.defQueueMap[id] = true;
                    }
                    defQueue.push(queueItem);
                });
                globalDefQueue = [];
            }
        }

        handlers = {
            'require': function (mod) {
                if (mod.require) {
                    return mod.require;
                } else {
                    return (mod.require = context.makeRequire(mod.map));
                }
            },
            'exports': function (mod) {
                mod.usingExports = true;
                if (mod.map.isDefine) {
                    if (mod.exports) {
                        return (defined[mod.map.id] = mod.exports);
                    } else {
                        return (mod.exports = defined[mod.map.id] = {});
                    }
                }
            },
            'module': function (mod) {
                if (mod.module) {
                    return mod.module;
                } else {
                    return (mod.module = {
                        id: mod.map.id,
                        uri: mod.map.url,
                        config: function () {
                            return getOwn(config.config, mod.map.id) || {};
                        },
                        exports: mod.exports || (mod.exports = {})
                    });
                }
            }
        };

        function cleanRegistry(id) {
            //Clean up machinery used for waiting modules.
            delete registry[id];
            delete enabledRegistry[id];
        }

        function breakCycle(mod, traced, processed) {
            var id = mod.map.id;

            if (mod.error) {
                mod.emit('error', mod.error);
            } else {
                traced[id] = true;
                each(mod.depMaps, function (depMap, i) {
                    var depId = depMap.id,
                        dep = getOwn(registry, depId);

                    //Only force things that have not completed
                    //being defined, so still in the registry,
                    //and only if it has not been matched up
                    //in the module already.
                    if (dep && !mod.depMatched[i] && !processed[depId]) {
                        if (getOwn(traced, depId)) {
                            mod.defineDep(i, defined[depId]);
                            mod.check(); //pass false?
                        } else {
                            breakCycle(dep, traced, processed);
                        }
                    }
                });
                processed[id] = true;
            }
        }

        function checkLoaded() {
            var err, usingPathFallback,
                waitInterval = config.waitSeconds * 1000,
                //It is possible to disable the wait interval by using waitSeconds of 0.
                expired = waitInterval && (context.startTime + waitInterval) < new Date().getTime(),
                noLoads = [],
                reqCalls = [],
                stillLoading = false,
                needCycleCheck = true;

            //Do not bother if this call was a result of a cycle break.
            if (inCheckLoaded) {
                return;
            }

            inCheckLoaded = true;

            //Figure out the state of all the modules.
            eachProp(enabledRegistry, function (mod) {
                var map = mod.map,
                    modId = map.id;

                //Skip things that are not enabled or in error state.
                if (!mod.enabled) {
                    return;
                }

                if (!map.isDefine) {
                    reqCalls.push(mod);
                }

                if (!mod.error) {
                    //If the module should be executed, and it has not
                    //been inited and time is up, remember it.
                    if (!mod.inited && expired) {
                        if (hasPathFallback(modId)) {
                            usingPathFallback = true;
                            stillLoading = true;
                        } else {
                            noLoads.push(modId);
                            removeScript(modId);
                        }
                    } else if (!mod.inited && mod.fetched && map.isDefine) {
                        stillLoading = true;
                        if (!map.prefix) {
                            //No reason to keep looking for unfinished
                            //loading. If the only stillLoading is a
                            //plugin resource though, keep going,
                            //because it may be that a plugin resource
                            //is waiting on a non-plugin cycle.
                            return (needCycleCheck = false);
                        }
                    }
                }
            });

            if (expired && noLoads.length) {
                //If wait time expired, throw error of unloaded modules.
                err = makeError('timeout', 'Load timeout for modules: ' + noLoads, null, noLoads);
                err.contextName = context.contextName;
                return onError(err);
            }

            //Not expired, check for a cycle.
            if (needCycleCheck) {
                each(reqCalls, function (mod) {
                    breakCycle(mod, {}, {});
                });
            }

            //If still waiting on loads, and the waiting load is something
            //other than a plugin resource, or there are still outstanding
            //scripts, then just try back later.
            if ((!expired || usingPathFallback) && stillLoading) {
                //Something is still waiting to load. Wait for it, but only
                //if a timeout is not already in effect.
                if ((isBrowser || isWebWorker) && !checkLoadedTimeoutId) {
                    checkLoadedTimeoutId = setTimeout(function () {
                        checkLoadedTimeoutId = 0;
                        checkLoaded();
                    }, 50);
                }
            }

            inCheckLoaded = false;
        }

        Module = function (map) {
            this.events = getOwn(undefEvents, map.id) || {};
            this.map = map;
            this.shim = getOwn(config.shim, map.id);
            this.depExports = [];
            this.depMaps = [];
            this.depMatched = [];
            this.pluginMaps = {};
            this.depCount = 0;

            /* this.exports this.factory
               this.depMaps = [],
               this.enabled, this.fetched
            */
        };

        Module.prototype = {
            init: function (depMaps, factory, errback, options) {
                options = options || {};

                //Do not do more inits if already done. Can happen if there
                //are multiple define calls for the same module. That is not
                //a normal, common case, but it is also not unexpected.
                if (this.inited) {
                    return;
                }

                this.factory = factory;

                if (errback) {
                    //Register for errors on this module.
                    this.on('error', errback);
                } else if (this.events.error) {
                    //If no errback already, but there are error listeners
                    //on this module, set up an errback to pass to the deps.
                    errback = bind(this, function (err) {
                        this.emit('error', err);
                    });
                }

                //Do a copy of the dependency array, so that
                //source inputs are not modified. For example
                //"shim" deps are passed in here directly, and
                //doing a direct modification of the depMaps array
                //would affect that config.
                this.depMaps = depMaps && depMaps.slice(0);

                this.errback = errback;

                //Indicate this module has be initialized
                this.inited = true;

                this.ignore = options.ignore;

                //Could have option to init this module in enabled mode,
                //or could have been previously marked as enabled. However,
                //the dependencies are not known until init is called. So
                //if enabled previously, now trigger dependencies as enabled.
                if (options.enabled || this.enabled) {
                    //Enable this module and dependencies.
                    //Will call this.check()
                    this.enable();
                } else {
                    this.check();
                }
            },

            defineDep: function (i, depExports) {
                //Because of cycles, defined callback for a given
                //export can be called more than once.
                if (!this.depMatched[i]) {
                    this.depMatched[i] = true;
                    this.depCount -= 1;
                    this.depExports[i] = depExports;
                }
            },

            fetch: function () {
                if (this.fetched) {
                    return;
                }
                this.fetched = true;

                context.startTime = (new Date()).getTime();

                var map = this.map;

                //If the manager is for a plugin managed resource,
                //ask the plugin to load it now.
                if (this.shim) {
                    context.makeRequire(this.map, {
                        enableBuildCallback: true
                    })(this.shim.deps || [], bind(this, function () {
                        return map.prefix ? this.callPlugin() : this.load();
                    }));
                } else {
                    //Regular dependency.
                    return map.prefix ? this.callPlugin() : this.load();
                }
            },

            load: function () {
                var url = this.map.url;

                //Regular dependency.
                if (!urlFetched[url]) {
                    urlFetched[url] = true;
                    context.load(this.map.id, url);
                }
            },

            /**
             * Checks if the module is ready to define itself, and if so,
             * define it.
             */
            check: function () {
                if (!this.enabled || this.enabling) {
                    return;
                }

                var err, cjsModule,
                    id = this.map.id,
                    depExports = this.depExports,
                    exports = this.exports,
                    factory = this.factory;

                if (!this.inited) {
                    // Only fetch if not already in the defQueue.
                    if (!hasProp(context.defQueueMap, id)) {
                        this.fetch();
                    }
                } else if (this.error) {
                    this.emit('error', this.error);
                } else if (!this.defining) {
                    //The factory could trigger another require call
                    //that would result in checking this module to
                    //define itself again. If already in the process
                    //of doing that, skip this work.
                    this.defining = true;

                    if (this.depCount < 1 && !this.defined) {
                        if (isFunction(factory)) {
                            //If there is an error listener, favor passing
                            //to that instead of throwing an error. However,
                            //only do it for define()'d  modules. require
                            //errbacks should not be called for failures in
                            //their callbacks (#699). However if a global
                            //onError is set, use that.
                            if ((this.events.error && this.map.isDefine) ||
                                req.onError !== defaultOnError) {
                                try {
                                    exports = context.execCb(id, factory, depExports, exports);
                                } catch (e) {
                                    err = e;
                                }
                            } else {
                                exports = context.execCb(id, factory, depExports, exports);
                            }

                            // Favor return value over exports. If node/cjs in play,
                            // then will not have a return value anyway. Favor
                            // module.exports assignment over exports object.
                            if (this.map.isDefine && exports === undefined) {
                                cjsModule = this.module;
                                if (cjsModule) {
                                    exports = cjsModule.exports;
                                } else if (this.usingExports) {
                                    //exports already set the defined value.
                                    exports = this.exports;
                                }
                            }

                            if (err) {
                                err.requireMap = this.map;
                                err.requireModules = this.map.isDefine ? [this.map.id] : null;
                                err.requireType = this.map.isDefine ? 'define' : 'require';
                                return onError((this.error = err));
                            }

                        } else {
                            //Just a literal value
                            exports = factory;
                        }

                        this.exports = exports;

                        if (this.map.isDefine && !this.ignore) {
                            defined[id] = exports;

                            if (req.onResourceLoad) {
                                var resLoadMaps = [];
                                each(this.depMaps, function (depMap) {
                                    resLoadMaps.push(depMap.normalizedMap || depMap);
                                });
                                req.onResourceLoad(context, this.map, resLoadMaps);
                            }
                        }

                        //Clean up
                        cleanRegistry(id);

                        this.defined = true;
                    }

                    //Finished the define stage. Allow calling check again
                    //to allow define notifications below in the case of a
                    //cycle.
                    this.defining = false;

                    if (this.defined && !this.defineEmitted) {
                        this.defineEmitted = true;
                        this.emit('defined', this.exports);
                        this.defineEmitComplete = true;
                    }

                }
            },

            callPlugin: function () {
                var map = this.map,
                    id = map.id,
                    //Map already normalized the prefix.
                    pluginMap = makeModuleMap(map.prefix);

                //Mark this as a dependency for this plugin, so it
                //can be traced for cycles.
                this.depMaps.push(pluginMap);

                on(pluginMap, 'defined', bind(this, function (plugin) {
                    var load, normalizedMap, normalizedMod,
                        bundleId = getOwn(bundlesMap, this.map.id),
                        name = this.map.name,
                        parentName = this.map.parentMap ? this.map.parentMap.name : null,
                        localRequire = context.makeRequire(map.parentMap, {
                            enableBuildCallback: true
                        });

                    //If current map is not normalized, wait for that
                    //normalized name to load instead of continuing.
                    if (this.map.unnormalized) {
                        //Normalize the ID if the plugin allows it.
                        if (plugin.normalize) {
                            name = plugin.normalize(name, function (name) {
                                return normalize(name, parentName, true);
                            }) || '';
                        }

                        //prefix and name should already be normalized, no need
                        //for applying map config again either.
                        normalizedMap = makeModuleMap(map.prefix + '!' + name,
                            this.map.parentMap,
                            true);
                        on(normalizedMap,
                            'defined', bind(this, function (value) {
                                this.map.normalizedMap = normalizedMap;
                                this.init([], function () { return value; }, null, {
                                    enabled: true,
                                    ignore: true
                                });
                            }));

                        normalizedMod = getOwn(registry, normalizedMap.id);
                        if (normalizedMod) {
                            //Mark this as a dependency for this plugin, so it
                            //can be traced for cycles.
                            this.depMaps.push(normalizedMap);

                            if (this.events.error) {
                                normalizedMod.on('error', bind(this, function (err) {
                                    this.emit('error', err);
                                }));
                            }
                            normalizedMod.enable();
                        }

                        return;
                    }

                    //If a paths config, then just load that file instead to
                    //resolve the plugin, as it is built into that paths layer.
                    if (bundleId) {
                        this.map.url = context.nameToUrl(bundleId);
                        this.load();
                        return;
                    }

                    load = bind(this, function (value) {
                        this.init([], function () { return value; }, null, {
                            enabled: true
                        });
                    });

                    load.error = bind(this, function (err) {
                        this.inited = true;
                        this.error = err;
                        err.requireModules = [id];

                        //Remove temp unnormalized modules for this module,
                        //since they will never be resolved otherwise now.
                        eachProp(registry, function (mod) {
                            if (mod.map.id.indexOf(id + '_unnormalized') === 0) {
                                cleanRegistry(mod.map.id);
                            }
                        });

                        onError(err);
                    });

                    //Allow plugins to load other code without having to know the
                    //context or how to 'complete' the load.
                    load.fromText = bind(this, function (text, textAlt) {
                        /*jslint evil: true */
                        var moduleName = map.name,
                            moduleMap = makeModuleMap(moduleName),
                            hasInteractive = useInteractive;

                        //As of 2.1.0, support just passing the text, to reinforce
                        //fromText only being called once per resource. Still
                        //support old style of passing moduleName but discard
                        //that moduleName in favor of the internal ref.
                        if (textAlt) {
                            text = textAlt;
                        }

                        //Turn off interactive script matching for IE for any define
                        //calls in the text, then turn it back on at the end.
                        if (hasInteractive) {
                            useInteractive = false;
                        }

                        //Prime the system by creating a module instance for
                        //it.
                        getModule(moduleMap);

                        //Transfer any config to this other module.
                        if (hasProp(config.config, id)) {
                            config.config[moduleName] = config.config[id];
                        }

                        try {
                            req.exec(text);
                        } catch (e) {
                            return onError(makeError('fromtexteval',
                                'fromText eval for ' + id +
                                ' failed: ' + e,
                                e,
                                [id]));
                        }

                        if (hasInteractive) {
                            useInteractive = true;
                        }

                        //Mark this as a dependency for the plugin
                        //resource
                        this.depMaps.push(moduleMap);

                        //Support anonymous modules.
                        context.completeLoad(moduleName);

                        //Bind the value of that module to the value for this
                        //resource ID.
                        localRequire([moduleName], load);
                    });

                    //Use parentName here since the plugin's name is not reliable,
                    //could be some weird string with no path that actually wants to
                    //reference the parentName's path.
                    plugin.load(map.name, localRequire, load, config);
                }));

                context.enable(pluginMap, this);
                this.pluginMaps[pluginMap.id] = pluginMap;
            },

            enable: function () {
                enabledRegistry[this.map.id] = this;
                this.enabled = true;

                //Set flag mentioning that the module is enabling,
                //so that immediate calls to the defined callbacks
                //for dependencies do not trigger inadvertent load
                //with the depCount still being zero.
                this.enabling = true;

                //Enable each dependency
                each(this.depMaps, bind(this, function (depMap, i) {
                    var id, mod, handler;

                    if (typeof depMap === 'string') {
                        //Dependency needs to be converted to a depMap
                        //and wired up to this module.
                        depMap = makeModuleMap(depMap,
                            (this.map.isDefine ? this.map : this.map.parentMap),
                            false,
                            !this.skipMap);
                        this.depMaps[i] = depMap;

                        handler = getOwn(handlers, depMap.id);

                        if (handler) {
                            this.depExports[i] = handler(this);
                            return;
                        }

                        this.depCount += 1;

                        on(depMap, 'defined', bind(this, function (depExports) {
                            if (this.undefed) {
                                return;
                            }
                            this.defineDep(i, depExports);
                            this.check();
                        }));

                        if (this.errback) {
                            on(depMap, 'error', bind(this, this.errback));
                        } else if (this.events.error) {
                            // No direct errback on this module, but something
                            // else is listening for errors, so be sure to
                            // propagate the error correctly.
                            on(depMap, 'error', bind(this, function(err) {
                                this.emit('error', err);
                            }));
                        }
                    }

                    id = depMap.id;
                    mod = registry[id];

                    //Skip special modules like 'require', 'exports', 'module'
                    //Also, don't call enable if it is already enabled,
                    //important in circular dependency cases.
                    if (!hasProp(handlers, id) && mod && !mod.enabled) {
                        context.enable(depMap, this);
                    }
                }));

                //Enable each plugin that is used in
                //a dependency
                eachProp(this.pluginMaps, bind(this, function (pluginMap) {
                    var mod = getOwn(registry, pluginMap.id);
                    if (mod && !mod.enabled) {
                        context.enable(pluginMap, this);
                    }
                }));

                this.enabling = false;

                this.check();
            },

            on: function (name, cb) {
                var cbs = this.events[name];
                if (!cbs) {
                    cbs = this.events[name] = [];
                }
                cbs.push(cb);
            },

            emit: function (name, evt) {
                each(this.events[name], function (cb) {
                    cb(evt);
                });
                if (name === 'error') {
                    //Now that the error handler was triggered, remove
                    //the listeners, since this broken Module instance
                    //can stay around for a while in the registry.
                    delete this.events[name];
                }
            }
        };

        function callGetModule(args) {
            //Skip modules already defined.
            if (!hasProp(defined, args[0])) {
                getModule(makeModuleMap(args[0], null, true)).init(args[1], args[2]);
            }
        }

        function removeListener(node, func, name, ieName) {
            //Favor detachEvent because of IE9
            //issue, see attachEvent/addEventListener comment elsewhere
            //in this file.
            if (node.detachEvent && !isOpera) {
                //Probably IE. If not it will throw an error, which will be
                //useful to know.
                if (ieName) {
                    node.detachEvent(ieName, func);
                }
            } else {
                node.removeEventListener(name, func, false);
            }
        }

        /**
         * Given an event from a script node, get the requirejs info from it,
         * and then removes the event listeners on the node.
         * @param {Event} evt
         * @returns {Object}
         */
        function getScriptData(evt) {
            //Using currentTarget instead of target for Firefox 2.0's sake. Not
            //all old browsers will be supported, but this one was easy enough
            //to support and still makes sense.
            var node = evt.currentTarget || evt.srcElement;

            //Remove the listeners once here.
            removeListener(node, context.onScriptLoad, 'load', 'onreadystatechange');
            removeListener(node, context.onScriptError, 'error');

            return {
                node: node,
                id: node && node.getAttribute('data-requiremodule')
            };
        }

        function intakeDefines() {
            var args;

            //Any defined modules in the global queue, intake them now.
            takeGlobalQueue();

            //Make sure any remaining defQueue items get properly processed.
            while (defQueue.length) {
                args = defQueue.shift();
                if (args[0] === null) {
                    return onError(makeError('mismatch', 'Mismatched anonymous define() module: ' +
                        args[args.length - 1]));
                } else {
                    //args are id, deps, factory. Should be normalized by the
                    //define() function.
                    callGetModule(args);
                }
            }
            context.defQueueMap = {};
        }

        context = {
            config: config,
            contextName: contextName,
            registry: registry,
            defined: defined,
            urlFetched: urlFetched,
            defQueue: defQueue,
            defQueueMap: {},
            Module: Module,
            makeModuleMap: makeModuleMap,
            nextTick: req.nextTick,
            onError: onError,

            /**
             * Set a configuration for the context.
             * @param {Object} cfg config object to integrate.
             */
            configure: function (cfg) {
                //Make sure the baseUrl ends in a slash.
                if (cfg.baseUrl) {
                    if (cfg.baseUrl.charAt(cfg.baseUrl.length - 1) !== '/') {
                        cfg.baseUrl += '/';
                    }
                }

                // Convert old style urlArgs string to a function.
                if (typeof cfg.urlArgs === 'string') {
                    var urlArgs = cfg.urlArgs;
                    cfg.urlArgs = function(id, url) {
                        return (url.indexOf('?') === -1 ? '?' : '&') + urlArgs;
                    };
                }

                //Save off the paths since they require special processing,
                //they are additive.
                var shim = config.shim,
                    objs = {
                        paths: true,
                        bundles: true,
                        config: true,
                        map: true
                    };

                eachProp(cfg, function (value, prop) {
                    if (objs[prop]) {
                        if (!config[prop]) {
                            config[prop] = {};
                        }
                        mixin(config[prop], value, true, true);
                    } else {
                        config[prop] = value;
                    }
                });

                //Reverse map the bundles
                if (cfg.bundles) {
                    eachProp(cfg.bundles, function (value, prop) {
                        each(value, function (v) {
                            if (v !== prop) {
                                bundlesMap[v] = prop;
                            }
                        });
                    });
                }

                //Merge shim
                if (cfg.shim) {
                    eachProp(cfg.shim, function (value, id) {
                        //Normalize the structure
                        if (isArray(value)) {
                            value = {
                                deps: value
                            };
                        }
                        if ((value.exports || value.init) && !value.exportsFn) {
                            value.exportsFn = context.makeShimExports(value);
                        }
                        shim[id] = value;
                    });
                    config.shim = shim;
                }

                //Adjust packages if necessary.
                if (cfg.packages) {
                    each(cfg.packages, function (pkgObj) {
                        var location, name;

                        pkgObj = typeof pkgObj === 'string' ? {name: pkgObj} : pkgObj;

                        name = pkgObj.name;
                        location = pkgObj.location;
                        if (location) {
                            config.paths[name] = pkgObj.location;
                        }

                        //Save pointer to main module ID for pkg name.
                        //Remove leading dot in main, so main paths are normalized,
                        //and remove any trailing .js, since different package
                        //envs have different conventions: some use a module name,
                        //some use a file name.
                        config.pkgs[name] = pkgObj.name + '/' + (pkgObj.main || 'main')
                            .replace(currDirRegExp, '')
                            .replace(jsSuffixRegExp, '');
                    });
                }

                //If there are any "waiting to execute" modules in the registry,
                //update the maps for them, since their info, like URLs to load,
                //may have changed.
                eachProp(registry, function (mod, id) {
                    //If module already has init called, since it is too
                    //late to modify them, and ignore unnormalized ones
                    //since they are transient.
                    if (!mod.inited && !mod.map.unnormalized) {
                        mod.map = makeModuleMap(id, null, true);
                    }
                });

                //If a deps array or a config callback is specified, then call
                //require with those args. This is useful when require is defined as a
                //config object before require.js is loaded.
                if (cfg.deps || cfg.callback) {
                    context.require(cfg.deps || [], cfg.callback);
                }
            },

            makeShimExports: function (value) {
                function fn() {
                    var ret;
                    if (value.init) {
                        ret = value.init.apply(global, arguments);
                    }
                    return ret || (value.exports && getGlobal(value.exports));
                }
                return fn;
            },

            makeRequire: function (relMap, options) {
                options = options || {};

                function localRequire(deps, callback, errback) {
                    var id, map, requireMod;

                    if (options.enableBuildCallback && callback && isFunction(callback)) {
                        callback.__requireJsBuild = true;
                    }

                    if (typeof deps === 'string') {
                        if (isFunction(callback)) {
                            //Invalid call
                            return onError(makeError('requireargs', 'Invalid require call'), errback);
                        }

                        //If require|exports|module are requested, get the
                        //value for them from the special handlers. Caveat:
                        //this only works while module is being defined.
                        if (relMap && hasProp(handlers, deps)) {
                            return handlers[deps](registry[relMap.id]);
                        }

                        //Synchronous access to one module. If require.get is
                        //available (as in the Node adapter), prefer that.
                        if (req.get) {
                            return req.get(context, deps, relMap, localRequire);
                        }

                        //Normalize module name, if it contains . or ..
                        map = makeModuleMap(deps, relMap, false, true);
                        id = map.id;

                        if (!hasProp(defined, id)) {
                            return onError(makeError('notloaded', 'Module name "' +
                                id +
                                '" has not been loaded yet for context: ' +
                                contextName +
                                (relMap ? '' : '. Use require([])')));
                        }
                        return defined[id];
                    }

                    //Grab defines waiting in the global queue.
                    intakeDefines();

                    //Mark all the dependencies as needing to be loaded.
                    context.nextTick(function () {
                        //Some defines could have been added since the
                        //require call, collect them.
                        intakeDefines();

                        requireMod = getModule(makeModuleMap(null, relMap));

                        //Store if map config should be applied to this require
                        //call for dependencies.
                        requireMod.skipMap = options.skipMap;

                        requireMod.init(deps, callback, errback, {
                            enabled: true
                        });

                        checkLoaded();
                    });

                    return localRequire;
                }

                mixin(localRequire, {
                    isBrowser: isBrowser,

                    /**
                     * Converts a module name + .extension into an URL path.
                     * *Requires* the use of a module name. It does not support using
                     * plain URLs like nameToUrl.
                     */
                    toUrl: function (moduleNamePlusExt) {
                        var ext,
                            index = moduleNamePlusExt.lastIndexOf('.'),
                            segment = moduleNamePlusExt.split('/')[0],
                            isRelative = segment === '.' || segment === '..';

                        //Have a file extension alias, and it is not the
                        //dots from a relative path.
                        if (index !== -1 && (!isRelative || index > 1)) {
                            ext = moduleNamePlusExt.substring(index, moduleNamePlusExt.length);
                            moduleNamePlusExt = moduleNamePlusExt.substring(0, index);
                        }

                        return context.nameToUrl(normalize(moduleNamePlusExt,
                            relMap && relMap.id, true), ext,  true);
                    },

                    defined: function (id) {
                        return hasProp(defined, makeModuleMap(id, relMap, false, true).id);
                    },

                    specified: function (id) {
                        id = makeModuleMap(id, relMap, false, true).id;
                        return hasProp(defined, id) || hasProp(registry, id);
                    }
                });

                //Only allow undef on top level require calls
                if (!relMap) {
                    localRequire.undef = function (id) {
                        //Bind any waiting define() calls to this context,
                        //fix for #408
                        takeGlobalQueue();

                        var map = makeModuleMap(id, relMap, true),
                            mod = getOwn(registry, id);

                        mod.undefed = true;
                        removeScript(id);

                        delete defined[id];
                        delete urlFetched[map.url];
                        delete undefEvents[id];

                        //Clean queued defines too. Go backwards
                        //in array so that the splices do not
                        //mess up the iteration.
                        eachReverse(defQueue, function(args, i) {
                            if (args[0] === id) {
                                defQueue.splice(i, 1);
                            }
                        });
                        delete context.defQueueMap[id];

                        if (mod) {
                            //Hold on to listeners in case the
                            //module will be attempted to be reloaded
                            //using a different config.
                            if (mod.events.defined) {
                                undefEvents[id] = mod.events;
                            }

                            cleanRegistry(id);
                        }
                    };
                }

                return localRequire;
            },

            /**
             * Called to enable a module if it is still in the registry
             * awaiting enablement. A second arg, parent, the parent module,
             * is passed in for context, when this method is overridden by
             * the optimizer. Not shown here to keep code compact.
             */
            enable: function (depMap) {
                var mod = getOwn(registry, depMap.id);
                if (mod) {
                    getModule(depMap).enable();
                }
            },

            /**
             * Internal method used by environment adapters to complete a load event.
             * A load event could be a script load or just a load pass from a synchronous
             * load call.
             * @param {String} moduleName the name of the module to potentially complete.
             */
            completeLoad: function (moduleName) {
                var found, args, mod,
                    shim = getOwn(config.shim, moduleName) || {},
                    shExports = shim.exports;

                takeGlobalQueue();

                while (defQueue.length) {
                    args = defQueue.shift();
                    if (args[0] === null) {
                        args[0] = moduleName;
                        //If already found an anonymous module and bound it
                        //to this name, then this is some other anon module
                        //waiting for its completeLoad to fire.
                        if (found) {
                            break;
                        }
                        found = true;
                    } else if (args[0] === moduleName) {
                        //Found matching define call for this script!
                        found = true;
                    }

                    callGetModule(args);
                }
                context.defQueueMap = {};

                //Do this after the cycle of callGetModule in case the result
                //of those calls/init calls changes the registry.
                mod = getOwn(registry, moduleName);

                if (!found && !hasProp(defined, moduleName) && mod && !mod.inited) {
                    if (config.enforceDefine && (!shExports || !getGlobal(shExports))) {
                        if (hasPathFallback(moduleName)) {
                            return;
                        } else {
                            return onError(makeError('nodefine',
                                'No define call for ' + moduleName,
                                null,
                                [moduleName]));
                        }
                    } else {
                        //A script that does not call define(), so just simulate
                        //the call for it.
                        callGetModule([moduleName, (shim.deps || []), shim.exportsFn]);
                    }
                }

                checkLoaded();
            },

            /**
             * Converts a module name to a file path. Supports cases where
             * moduleName may actually be just an URL.
             * Note that it **does not** call normalize on the moduleName,
             * it is assumed to have already been normalized. This is an
             * internal API, not a public one. Use toUrl for the public API.
             */
            nameToUrl: function (moduleName, ext, skipExt) {
                var paths, syms, i, parentModule, url,
                    parentPath, bundleId,
                    pkgMain = getOwn(config.pkgs, moduleName);

                if (pkgMain) {
                    moduleName = pkgMain;
                }

                bundleId = getOwn(bundlesMap, moduleName);

                if (bundleId) {
                    return context.nameToUrl(bundleId, ext, skipExt);
                }

                //If a colon is in the URL, it indicates a protocol is used and it is just
                //an URL to a file, or if it starts with a slash, contains a query arg (i.e. ?)
                //or ends with .js, then assume the user meant to use an url and not a module id.
                //The slash is important for protocol-less URLs as well as full paths.
                if (req.jsExtRegExp.test(moduleName)) {
                    //Just a plain path, not module name lookup, so just return it.
                    //Add extension if it is included. This is a bit wonky, only non-.js things pass
                    //an extension, this method probably needs to be reworked.
                    url = moduleName + (ext || '');
                } else {
                    //A module that needs to be converted to a path.
                    paths = config.paths;

                    syms = moduleName.split('/');
                    //For each module name segment, see if there is a path
                    //registered for it. Start with most specific name
                    //and work up from it.
                    for (i = syms.length; i > 0; i -= 1) {
                        parentModule = syms.slice(0, i).join('/');

                        parentPath = getOwn(paths, parentModule);
                        if (parentPath) {
                            //If an array, it means there are a few choices,
                            //Choose the one that is desired
                            if (isArray(parentPath)) {
                                parentPath = parentPath[0];
                            }
                            syms.splice(0, i, parentPath);
                            break;
                        }
                    }

                    //Join the path parts together, then figure out if baseUrl is needed.
                    url = syms.join('/');
                    url += (ext || (/^data\:|^blob\:|\?/.test(url) || skipExt ? '' : '.js'));
                    url = (url.charAt(0) === '/' || url.match(/^[\w\+\.\-]+:/) ? '' : config.baseUrl) + url;
                }

                return config.urlArgs && !/^blob\:/.test(url) ?
                    url + config.urlArgs(moduleName, url) : url;
            },

            //Delegates to req.load. Broken out as a separate function to
            //allow overriding in the optimizer.
            load: function (id, url) {
                req.load(context, id, url);
            },

            /**
             * Executes a module callback function. Broken out as a separate function
             * solely to allow the build system to sequence the files in the built
             * layer in the right sequence.
             *
             * @private
             */
            execCb: function (name, callback, args, exports) {
                return callback.apply(exports, args);
            },

            /**
             * callback for script loads, used to check status of loading.
             *
             * @param {Event} evt the event from the browser for the script
             * that was loaded.
             */
            onScriptLoad: function (evt) {
                //Using currentTarget instead of target for Firefox 2.0's sake. Not
                //all old browsers will be supported, but this one was easy enough
                //to support and still makes sense.
                if (evt.type === 'load' ||
                    (readyRegExp.test((evt.currentTarget || evt.srcElement).readyState))) {
                    //Reset interactive script so a script node is not held onto for
                    //to long.
                    interactiveScript = null;

                    //Pull out the name of the module and the context.
                    var data = getScriptData(evt);
                    context.completeLoad(data.id);
                }
            },

            /**
             * Callback for script errors.
             */
            onScriptError: function (evt) {
                var data = getScriptData(evt);
                if (!hasPathFallback(data.id)) {
                    var parents = [];
                    eachProp(registry, function(value, key) {
                        if (key.indexOf('_@r') !== 0) {
                            each(value.depMaps, function(depMap) {
                                if (depMap.id === data.id) {
                                    parents.push(key);
                                    return true;
                                }
                            });
                        }
                    });
                    return onError(makeError('scripterror', 'Script error for "' + data.id +
                        (parents.length ?
                            '", needed by: ' + parents.join(', ') :
                            '"'), evt, [data.id]));
                }
            }
        };

        context.require = context.makeRequire();
        return context;
    }

    /**
     * Main entry point.
     *
     * If the only argument to require is a string, then the module that
     * is represented by that string is fetched for the appropriate context.
     *
     * If the first argument is an array, then it will be treated as an array
     * of dependency string names to fetch. An optional function callback can
     * be specified to execute when all of those dependencies are available.
     *
     * Make a local req variable to help Caja compliance (it assumes things
     * on a require that are not standardized), and to give a short
     * name for minification/local scope use.
     */
    req = requirejs = function (deps, callback, errback, optional) {

        //Find the right context, use default
        var context, config,
            contextName = defContextName;

        // Determine if have config object in the call.
        if (!isArray(deps) && typeof deps !== 'string') {
            // deps is a config object
            config = deps;
            if (isArray(callback)) {
                // Adjust args if there are dependencies
                deps = callback;
                callback = errback;
                errback = optional;
            } else {
                deps = [];
            }
        }

        if (config && config.context) {
            contextName = config.context;
        }

        context = getOwn(contexts, contextName);
        if (!context) {
            context = contexts[contextName] = req.s.newContext(contextName);
        }

        if (config) {
            context.configure(config);
        }

        return context.require(deps, callback, errback);
    };

    /**
     * Support pirequire.require.config() to make it easier to cooperate with other
     * AMD loaders on globally agreed names.
     */
    req.config = function (config) {
        return req(config);
    };

    /**
     * Execute something after the current tick
     * of the event loop. Override for other envs
     * that have a better solution than setTimeout.
     * @param  {Function} fn function to execute later.
     */
    req.nextTick = typeof setTimeout !== 'undefined' ? function (fn) {
        setTimeout(fn, 4);
    } : function (fn) { fn(); };

    /**
     * Export require as a global, but only if it does not already exist.
     */
    if (!require) {
        require = req;
    }

    req.version = version;

    //Used to filter out dependencies that are already paths.
    req.jsExtRegExp = /^\/|:|\?|\.js$/;
    req.isBrowser = isBrowser;
    s = req.s = {
        contexts: contexts,
        newContext: newContext
    };

    //Create default context.
    req({});

    //Exports some context-sensitive methods on global require.
    each([
        'toUrl',
        'undef',
        'defined',
        'specified'
    ], function (prop) {
        //Reference from contexts instead of early binding to default context,
        //so that during builds, the latest instance of the default context
        //with its config gets used.
        req[prop] = function () {
            var ctx = contexts[defContextName];
            return ctx.require[prop].apply(ctx, arguments);
        };
    });

    if (isBrowser) {
        head = s.head = document.getElementsByTagName('head')[0];
        //If BASE tag is in play, using appendChild is a problem for IE6.
        //When that browser dies, this can be removed. Details in this jQuery bug:
        //http://dev.jquery.com/ticket/2709
        baseElement = document.getElementsByTagName('base')[0];
        if (baseElement) {
            head = s.head = baseElement.parentNode;
        }
    }

    /**
     * Any errors that require explicitly generates will be passed to this
     * function. Intercept/override it if you want custom error handling.
     * @param {Error} err the error object.
     */
    req.onError = defaultOnError;

    /**
     * Creates the node for the load command. Only used in browser envs.
     */
    req.createNode = function (config, moduleName, url) {
        var node = config.xhtml ?
            document.createElementNS('http://www.w3.org/1999/xhtml', 'html:script') :
            document.createElement('script');
        node.type = config.scriptType || 'text/javascript';
        node.charset = 'utf-8';
        node.async = true;
        return node;
    };

    /**
     * Does the request to load a module for the browser case.
     * Make this a separate function to allow other environments
     * to override it.
     *
     * @param {Object} context the require context to find state.
     * @param {String} moduleName the name of the module.
     * @param {Object} url the URL to the module.
     */
    req.load = function (context, moduleName, url) {
        var config = (context && context.config) || {},
            node;
        if (isBrowser) {
            //In the browser so use a script tag
            node = req.createNode(config, moduleName, url);

            node.setAttribute('data-requirecontext', context.contextName);
            node.setAttribute('data-requiremodule', moduleName);

            //Set up load listener. Test attachEvent first because IE9 has
            //a subtle issue in its addEventListener and script onload firings
            //that do not match the behavior of all other browsers with
            //addEventListener support, which fire the onload event for a
            //script right after the script execution. See:
            //https://connect.microsoft.com/IE/feedback/details/648057/script-onload-event-is-not-fired-immediately-after-script-execution
            //UNFORTUNATELY Opera implements attachEvent but does not follow the script
            //script execution mode.
            if (node.attachEvent &&
                //Check if node.attachEvent is artificially added by custom script or
                //natively supported by browser
                //read https://github.com/requirejs/requirejs/issues/187
                //if we can NOT find [native code] then it must NOT natively supported.
                //in IE8, node.attachEvent does not have toString()
                //Note the test for "[native code" with no closing brace, see:
                //https://github.com/requirejs/requirejs/issues/273
                !(node.attachEvent.toString && node.attachEvent.toString().indexOf('[native code') < 0) &&
                !isOpera) {
                //Probably IE. IE (at least 6-8) do not fire
                //script onload right after executing the script, so
                //we cannot tie the anonymous define call to a name.
                //However, IE reports the script as being in 'interactive'
                //readyState at the time of the define call.
                useInteractive = true;

                node.attachEvent('onreadystatechange', context.onScriptLoad);
                //It would be great to add an error handler here to catch
                //404s in IE9+. However, onreadystatechange will fire before
                //the error handler, so that does not help. If addEventListener
                //is used, then IE will fire error before load, but we cannot
                //use that pathway given the connect.microsoft.com issue
                //mentioned above about not doing the 'script execute,
                //then fire the script load event listener before execute
                //next script' that other browsers do.
                //Best hope: IE10 fixes the issues,
                //and then destroys all installs of IE 6-9.
                //node.attachEvent('onerror', context.onScriptError);
            } else {
                node.addEventListener('load', context.onScriptLoad, false);
                node.addEventListener('error', context.onScriptError, false);
            }
            node.src = url;

            //Calling onNodeCreated after all properties on the node have been
            //set, but before it is placed in the DOM.
            if (config.onNodeCreated) {
                config.onNodeCreated(node, config, moduleName, url);
            }

            //For some cache cases in IE 6-8, the script executes before the end
            //of the appendChild execution, so to tie an anonymous define
            //call to the module name (which is stored on the node), hold on
            //to a reference to this node, but clear after the DOM insertion.
            currentlyAddingScript = node;
            if (baseElement) {
                head.insertBefore(node, baseElement);
            } else {
                head.appendChild(node);
            }
            currentlyAddingScript = null;

            return node;
        } else if (isWebWorker) {
            try {
                //In a web worker, use importScripts. This is not a very
                //efficient use of importScripts, importScripts will block until
                //its script is downloaded and evaluated. However, if web workers
                //are in play, the expectation is that a build has been done so
                //that only one script needs to be loaded anyway. This may need
                //to be reevaluated if other use cases become common.

                // Post a task to the event loop to work around a bug in WebKit
                // where the worker gets garbage-collected after calling
                // importScripts(): https://webkit.org/b/153317
                setTimeout(function() {}, 0);
                importScripts(url);

                //Account for anonymous modules
                context.completeLoad(moduleName);
            } catch (e) {
                context.onError(makeError('importscripts',
                    'importScripts failed for ' +
                    moduleName + ' at ' + url,
                    e,
                    [moduleName]));
            }
        }
    };

    function getInteractiveScript() {
        if (interactiveScript && interactiveScript.readyState === 'interactive') {
            return interactiveScript;
        }

        eachReverse(scripts(), function (script) {
            if (script.readyState === 'interactive') {
                return (interactiveScript = script);
            }
        });
        return interactiveScript;
    }

    //Look for a data-main script attribute, which could also adjust the baseUrl.
    if (isBrowser && !cfg.skipDataMain) {
        //Figure out baseUrl. Get it from the script tag with require.js in it.
        eachReverse(scripts(), function (script) {
            //Set the 'head' where we can append children by
            //using the script's parent.
            if (!head) {
                head = script.parentNode;
            }

            //Look for a data-main attribute to set main script for the page
            //to load. If it is there, the path to data main becomes the
            //baseUrl, if it is not already set.
            dataMain = script.getAttribute('data-main');
            if (dataMain) {
                //Preserve dataMain in case it is a path (i.e. contains '?')
                mainScript = dataMain;

                //Set final baseUrl if there is not already an explicit one,
                //but only do so if the data-main value is not a loader plugin
                //module ID.
                if (!cfg.baseUrl && mainScript.indexOf('!') === -1) {
                    //Pull off the directory of data-main for use as the
                    //baseUrl.
                    src = mainScript.split('/');
                    mainScript = src.pop();
                    subPath = src.length ? src.join('/')  + '/' : './';

                    cfg.baseUrl = subPath;
                }

                //Strip off any trailing .js since mainScript is now
                //like a module name.
                mainScript = mainScript.replace(jsSuffixRegExp, '');

                //If mainScript is still a path, fall back to dataMain
                if (req.jsExtRegExp.test(mainScript)) {
                    mainScript = dataMain;
                }

                //Put the data-main script in the files to load.
                cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript];

                return true;
            }
        });
    }

    /**
     * The function that handles definitions of modules. Differs from
     * require() in that a string for the module should be the first argument,
     * and the function to execute after dependencies are loaded should
     * return a value to define the module corresponding to the first argument's
     * name.
     */
    define = function (name, deps, callback) {
        var node, context;

        //Allow for anonymous modules
        if (typeof name !== 'string') {
            //Adjust args appropriately
            callback = deps;
            deps = name;
            name = null;
        }

        //This module may not have dependencies
        if (!isArray(deps)) {
            callback = deps;
            deps = null;
        }

        //If no name, and callback is a function, then figure out if it a
        //CommonJS thing with dependencies.
        if (!deps && isFunction(callback)) {
            deps = [];
            //Remove comments from the callback string,
            //look for require calls, and pull them into the dependencies,
            //but only if there are function args.
            if (callback.length) {
                callback
                    .toString()
                    .replace(commentRegExp, commentReplace)
                    .replace(cjsRequireRegExp, function (match, dep) {
                        deps.push(dep);
                    });

                //May be a CommonJS thing even without require calls, but still
                //could use exports, and module. Avoid doing exports and module
                //work though if it just needs require.
                //REQUIRES the function to expect the CommonJS variables in the
                //order listed below.
                deps = (callback.length === 1 ? ['require'] : ['require', 'exports', 'module']).concat(deps);
            }
        }

        //If in IE 6-8 and hit an anonymous define() call, do the interactive
        //work.
        if (useInteractive) {
            node = currentlyAddingScript || getInteractiveScript();
            if (node) {
                if (!name) {
                    name = node.getAttribute('data-requiremodule');
                }
                context = contexts[node.getAttribute('data-requirecontext')];
            }
        }

        //Always save off evaluating the def call until the script onload handler.
        //This allows multiple modules to be in a file without prematurely
        //tracing dependencies, and allows for anonymous module support,
        //where the module name is not known until the script onload event
        //occurs. If no context, use the global queue, and get it processed
        //in the onscript load callback.
        if (context) {
            context.defQueue.push([name, deps, callback]);
            context.defQueueMap[name] = true;
        } else {
            globalDefQueue.push([name, deps, callback]);
        }
    };

    define.amd = {
        jQuery: true
    };

    /**
     * Executes the text. Normally just uses eval, but can be modified
     * to use a better, environment-specific call. Only used for transpiling
     * loader plugins, not for plain JS modules.
     * @param {String} text the text to execute/evaluate.
     */
    req.exec = function (text) {
        /*jslint evil: true */
        return eval(text);
    };

    //Set up with config info.
    req(cfg);
}(this, (typeof setTimeout === 'undefined' ? undefined : setTimeout)));

pirequire.requirejs = requirejs;pirequire.require = require;pirequire.define = define;
}
}());
pirequire.define("lib/require", function(){});

/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w, true ); //FIXME das true hier muss rein!!
			};
	} else {
		factory( global, true ); //FIXME das true hier muss rein!!
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.


var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof pirequire.define === 'function' && pirequire.define.amd ) {
	pirequire.define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

pirequire.define('jquery-private', ['jquery'], function ($) {
    return $.noConflict( true );
});
/**
 * ++++++++++++++++++++++++++++
 * ACHTUNG in Zeile 649 ist eine Pinuts erweiterung!!!
 * global = global || {}; //FIXME NICHT löschen!!!
 * 
 * Das ist nötig da wir einen eigenen Namespabe verwenden und Handlebars nicht mit klar kommt!
 * Beim Update dran denken.
 * +++++++++++++++++++++++++++
 */
/**!

 @license
 handlebars v4.7.7 

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof pirequire.define === 'function' && pirequire.define.amd)
		pirequire.define('handlebars',[], factory);
	else if(typeof exports === 'object')
		exports["Handlebars"] = factory();
	else
		root["Handlebars"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
		
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(1)['default'];

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;

	var _handlebarsBase = __webpack_require__(3);

	var base = _interopRequireWildcard(_handlebarsBase);

	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)

	var _handlebarsSafeString = __webpack_require__(36);

	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

	var _handlebarsException = __webpack_require__(5);

	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

	var _handlebarsUtils = __webpack_require__(4);

	var Utils = _interopRequireWildcard(_handlebarsUtils);

	var _handlebarsRuntime = __webpack_require__(37);

	var runtime = _interopRequireWildcard(_handlebarsRuntime);

	var _handlebarsNoConflict = __webpack_require__(43);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();

	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;

	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj["default"] = obj;
	    return newObj;
	  }
	};

	exports.__esModule = true;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;

	var _utils = __webpack_require__(4);

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	var _helpers = __webpack_require__(9);

	var _decorators = __webpack_require__(29);

	var _logger = __webpack_require__(31);

	var _logger2 = _interopRequireDefault(_logger);

	var _internalProtoAccess = __webpack_require__(32);

	var VERSION = '4.7.7';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 8;
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var LAST_COMPATIBLE_COMPILER_REVISION = 7;

	exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0 <4.3.0',
	  8: '>= 4.3.0'
	};

	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';

	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};

	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}

	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,

	  logger: _logger2['default'],
	  log: _logger2['default'].log,

	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },

	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },

	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  },
	  /**
	   * Reset the memory of illegal property accesses that have already been logged.
	   * @deprecated should only be used in handlebars test-cases
	   */
	  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
	    _internalProtoAccess.resetLoggedProperties();
	  }
	};

	var log = _logger2['default'].log;

	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};

	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;

	function escapeChar(chr) {
	  return escape[chr];
	}

	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }

	  return obj;
	}

	var toString = Object.prototype.toString;

	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;

	/* eslint-enable func-style */

	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};

	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.

	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}

	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }

	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }

	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}

	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}

	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}

	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(6)['default'];

	exports.__esModule = true;
	var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      endLineNumber = undefined,
	      column = undefined,
	      endColumn = undefined;

	  if (loc) {
	    line = loc.start.line;
	    endLineNumber = loc.end.line;
	    column = loc.start.column;
	    endColumn = loc.end.column;

	    message += ' - ' + line + ':' + column;
	  }

	  var tmp = Error.prototype.constructor.call(this, message);

	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }

	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }

	  try {
	    if (loc) {
	      this.lineNumber = line;
	      this.endLineNumber = endLineNumber;

	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (_Object$defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	        Object.defineProperty(this, 'endColumn', {
	          value: endColumn,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	        this.endColumn = endColumn;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}

	Exception.prototype = new Error();

	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(7), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(8);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	exports.moveHelperToHooks = moveHelperToHooks;

	var _helpersBlockHelperMissing = __webpack_require__(10);

	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

	var _helpersEach = __webpack_require__(11);

	var _helpersEach2 = _interopRequireDefault(_helpersEach);

	var _helpersHelperMissing = __webpack_require__(24);

	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

	var _helpersIf = __webpack_require__(25);

	var _helpersIf2 = _interopRequireDefault(_helpersIf);

	var _helpersLog = __webpack_require__(26);

	var _helpersLog2 = _interopRequireDefault(_helpersLog);

	var _helpersLookup = __webpack_require__(27);

	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

	var _helpersWith = __webpack_require__(28);

	var _helpersWith2 = _interopRequireDefault(_helpersWith);

	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

	function moveHelperToHooks(instance, helperName, keepHelper) {
	  if (instance.helpers[helperName]) {
	    instance.hooks[helperName] = instance.helpers[helperName];
	    if (!keepHelper) {
	      delete instance.helpers[helperName];
	    }
	  }
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;

	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }

	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }

	      return fn(context, options);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	global = global || {}; //FIXME NICHT löschen!!!
	var _Object$keys = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }

	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;

	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }

	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }

	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;

	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }

	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }

	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else if (global.Symbol && context[global.Symbol.iterator]) {
	        var newContext = [];
	        var iterator = context[global.Symbol.iterator]();
	        for (var it = iterator.next(); !it.done; it = iterator.next()) {
	          newContext.push(it.value);
	        }
	        context = newContext;
	        for (var j = context.length; i < j; i++) {
	          execIteration(i, i, i === context.length - 1);
	        }
	      } else {
	        (function () {
	          var priorKey = undefined;

	          _Object$keys(context).forEach(function (key) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          });
	          if (priorKey !== undefined) {
	            execIteration(priorKey, i - 1, true);
	          }
	        })();
	      }
	    }

	    if (i === 0) {
	      ret = inverse(this);
	    }

	    return ret;
	  });
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(13), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	module.exports = __webpack_require__(20).Object.keys;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(15);

	__webpack_require__(17)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(16);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(18)
	  , core    = __webpack_require__(20)
	  , fails   = __webpack_require__(23);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(19)
	  , core      = __webpack_require__(20)
	  , ctx       = __webpack_require__(21)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(22);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#if requires exactly one argument');
	    }
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }

	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });

	  instance.registerHelper('unless', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#unless requires exactly one argument');
	    }
	    return instance.helpers['if'].call(this, conditional, {
	      fn: options.inverse,
	      inverse: options.fn,
	      hash: options.hash
	    });
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }

	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;

	    instance.log.apply(instance, args);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field, options) {
	    if (!obj) {
	      // Note for 5.0: Change to "obj == null" in 5.0
	      return obj;
	    }
	    return options.lookupProperty(obj, field);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#with requires exactly one argument');
	    }
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    var fn = options.fn;

	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }

	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;

	var _decoratorsInline = __webpack_require__(30);

	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }

	    props.partials[options.args[0]] = options.fn;

	    return ret;
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(4);

	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',

	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }

	    return level;
	  },

	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);

	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      // eslint-disable-next-line no-console
	      if (!console[method]) {
	        method = 'log';
	      }

	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }

	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};

	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(33)['default'];

	var _Object$keys = __webpack_require__(12)['default'];

	var _interopRequireWildcard = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.createProtoAccessControl = createProtoAccessControl;
	exports.resultIsAllowed = resultIsAllowed;
	exports.resetLoggedProperties = resetLoggedProperties;

	var _createNewLookupObject = __webpack_require__(35);

	var _logger = __webpack_require__(31);

	var logger = _interopRequireWildcard(_logger);

	var loggedProperties = _Object$create(null);

	function createProtoAccessControl(runtimeOptions) {
	  var defaultMethodWhiteList = _Object$create(null);
	  defaultMethodWhiteList['constructor'] = false;
	  defaultMethodWhiteList['__defineGetter__'] = false;
	  defaultMethodWhiteList['__defineSetter__'] = false;
	  defaultMethodWhiteList['__lookupGetter__'] = false;

	  var defaultPropertyWhiteList = _Object$create(null);
	  // eslint-disable-next-line no-proto
	  defaultPropertyWhiteList['__proto__'] = false;

	  return {
	    properties: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
	      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
	    },
	    methods: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
	      defaultValue: runtimeOptions.allowProtoMethodsByDefault
	    }
	  };
	}

	function resultIsAllowed(result, protoAccessControl, propertyName) {
	  if (typeof result === 'function') {
	    return checkWhiteList(protoAccessControl.methods, propertyName);
	  } else {
	    return checkWhiteList(protoAccessControl.properties, propertyName);
	  }
	}

	function checkWhiteList(protoAccessControlForType, propertyName) {
	  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
	    return protoAccessControlForType.whitelist[propertyName] === true;
	  }
	  if (protoAccessControlForType.defaultValue !== undefined) {
	    return protoAccessControlForType.defaultValue;
	  }
	  logUnexpecedPropertyAccessOnce(propertyName);
	  return false;
	}

	function logUnexpecedPropertyAccessOnce(propertyName) {
	  if (loggedProperties[propertyName] !== true) {
	    loggedProperties[propertyName] = true;
	    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
	  }
	}

	function resetLoggedProperties() {
	  _Object$keys(loggedProperties).forEach(function (propertyName) {
	    delete loggedProperties[propertyName];
	  });
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(34), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(8);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(33)['default'];

	exports.__esModule = true;
	exports.createNewLookupObject = createNewLookupObject;

	var _utils = __webpack_require__(4);

	/**
	 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
	 * The resulting object can be used with "object[property]" to check if a property exists
	 * @param {...object} sources a varargs parameter of source objects that will be merged
	 * @returns {object}
	 */

	function createNewLookupObject() {
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }

	  return _utils.extend.apply(undefined, [_Object$create(null)].concat(sources));
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';

	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}

	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};

	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$seal = __webpack_require__(38)['default'];

	var _Object$keys = __webpack_require__(12)['default'];

	var _interopRequireWildcard = __webpack_require__(1)['default'];

	var _interopRequireDefault = __webpack_require__(2)['default'];

	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;

	var _utils = __webpack_require__(4);

	var Utils = _interopRequireWildcard(_utils);

	var _exception = __webpack_require__(5);

	var _exception2 = _interopRequireDefault(_exception);

	var _base = __webpack_require__(3);

	var _helpers = __webpack_require__(9);

	var _internalWrapHelper = __webpack_require__(42);

	var _internalProtoAccess = __webpack_require__(32);

	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;

	  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
	    return;
	  }

	  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
	    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	  } else {
	    // Use the embedded version info since the runtime doesn't know about this revision yet
	    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	  }
	}

	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }

	  templateSpec.main.decorator = templateSpec.main_d;

	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as pseudo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);

	  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
	  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	    partial = env.VM.resolvePartial.call(this, partial, context, options);

	    var extendedOptions = Utils.extend({}, options, {
	      hooks: this.hooks,
	      protoAccessControl: this.protoAccessControl
	    });

	    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, extendedOptions);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }

	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }

	  // Just add water
	  var container = {
	    strict: function strict(obj, name, loc) {
	      if (!obj || !(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
	          loc: loc
	        });
	      }
	      return container.lookupProperty(obj, name);
	    },
	    lookupProperty: function lookupProperty(parent, propertyName) {
	      var result = parent[propertyName];
	      if (result == null) {
	        return result;
	      }
	      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	        return result;
	      }

	      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
	        return result;
	      }
	      return undefined;
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        var result = depths[i] && container.lookupProperty(depths[i], name);
	        if (result != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },

	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,

	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },

	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },

	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    mergeIfNeeded: function mergeIfNeeded(param, common) {
	      var obj = param || common;

	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }

	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: _Object$seal({}),

	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };

	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var data = options.data;

	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }

	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }

	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }

	  ret.isTop = true;

	  ret._setup = function (options) {
	    if (!options.partial) {
	      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
	      wrapHelpersToPassLookupProperty(mergedHelpers, container);
	      container.helpers = mergedHelpers;

	      if (templateSpec.usePartial) {
	        // Use mergeIfNeeded here to prevent compiling global partials multiple times
	        container.partials = container.mergeIfNeeded(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = Utils.extend({}, env.decorators, options.decorators);
	      }

	      container.hooks = {};
	      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

	      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
	      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
	      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
	    } else {
	      container.protoAccessControl = options.protoAccessControl; // internal option
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	      container.hooks = options.hooks;
	    }
	  };

	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }

	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}

	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }

	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }

	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}

	/**
	 * This is currently part of the official API, therefore implementation details should not be changed.
	 */

	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}

	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }

	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }

	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }

	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}

	function noop() {
	  return '';
	}

	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}

	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

	function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
	  _Object$keys(mergedHelpers).forEach(function (helperName) {
	    var helper = mergedHelpers[helperName];
	    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
	  });
	}

	function passLookupPropertyOption(helper, container) {
	  var lookupProperty = container.lookupProperty;
	  return _internalWrapHelper.wrapHelper(helper, function (options) {
	    return Utils.extend({ lookupProperty: lookupProperty }, options);
	  });
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(39), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(40);
	module.exports = __webpack_require__(20).Object.seal;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(41);

	__webpack_require__(17)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.wrapHelper = wrapHelper;

	function wrapHelper(helper, transformOptionsFn) {
	  if (typeof helper !== 'function') {
	    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
	    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
	    return helper;
	  }
	  var wrapper = function wrapper() /* dynamic arguments */{
	    var options = arguments[arguments.length - 1];
	    arguments[arguments.length - 1] = transformOptionsFn(options);
	    return helper.apply(this, arguments);
	  };
	  return wrapper;
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	exports.__esModule = true;

	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ])
});
;
pirequire.define('lib/Helper',[
    'handlebars'
], function loadHelper(Handlebars) {
    var tmplCache = {};

    if (!Array.isArray) {//for IE8 and below
        Array.isArray = function (obj) {
            return Object.prototype.toString.call(obj) === "[object Array]";
        };
    }

    // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                    hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
                    dontEnums = [
                        'toString',
                        'toLocaleString',
                        'valueOf',
                        'hasOwnProperty',
                        'isPrototypeOf',
                        'propertyIsEnumerable',
                        'constructor'
                    ],
                    dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [], prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    /**
     * Contains helper functions
     */
    return {
        /**
         * Create a field instance
         *
         * @param {Object} config  Field configuration. Comes usually from plugin.desc.json
         * @param {Object} formWidget  Map of values for all defined fields
         * @return {Object} field 
         */
        createField: function (config, formWidget) {
            // Create Field if the field type has a valid class
            if (typeof window.pinuts.fields[config.type] == 'undefined') {
                if (window.pinuts.fields[config.type + 'Native']) {
                    config.type = config.type + 'Native';
                } else {
                    throw new Error('No class for field type ' + config.type);
                }
            }
            var field = new window.pinuts.fields[config.type]();

            config.designSet = formWidget.designSet;
            config.widgetId = formWidget.widgetId;
            config.locale = formWidget.locale;
            config.langKey = formWidget.langKey;
            config.useLabelAsPlaceholder = formWidget.useLabelAsPlaceholder;
            config.formWidget = formWidget;

            field.setConfig(config);
            // Set values for using other fields values
            field.setValues(formWidget.values);
            
            var tplset = window.pinuts.formtpl[formWidget.designSet] || window.pinuts.formtpl.base;
            if (typeof tplset[config.type] !== 'undefined') {
                field.setTemplate(config.type);
            } else if (typeof tplset[config.templateId] !== 'undefined') {
                field.setTemplate(config.templateId);
            }

            // Set data required to render field
//            field.setData(data || {});
            var preSetValue = this.getValueByPath(formWidget.values, config.name);
            if (typeof preSetValue === "undefined") preSetValue = config.default;
            field.setValue(preSetValue, true, true);

            return field;
        },
        /**
         * register helpers and partitals.
         * @returns {undefined}
         */
        initHanldebars: function (designSet) {
            var st = window.pinuts.formPartials.base;
            for (var key in st) {
                if (st.hasOwnProperty(key)) {
                    Handlebars.registerPartial(key, Handlebars.template(st[key]));
                }
            }
            st = window.pinuts.formPartials[designSet];
            if (st) {
                for (key in st) {
                    if (st.hasOwnProperty(key)) {
                        Handlebars.registerPartial(key, Handlebars.template(st[key]));
                    }
                }
            }
        },
        /**
         * Get the precomplied handlebar template for a field.
         * @param {type} templateId
         * @returns {Object} precomplied Handlebar Template
         */
        getTemplate: function (templateId, designSet) {
            tmplCache[designSet] = tmplCache[designSet] || {};
            if (!tmplCache[designSet][templateId]) {
                var set = window.pinuts.formtpl[designSet] || window.pinuts.formtpl.base; 
                var tmppre = set[templateId] || window.pinuts.formtpl.base[templateId];

                if (tmppre) {
                    tmplCache[designSet][templateId] = Handlebars.template(tmppre);
                } else {
                    throw 'can not render template with id "' + templateId + '", element not found in designSet ' + designSet;
                }
            }
            return tmplCache[designSet][templateId];
        },
        /**
         * Get's a value on an object by following a dot separated path through the properties on the object
         *
         * @param object {object} Object the value is in
         * @param path {string} Dot separated path to property containing the wanted value
         * @returns {*}
         */
        getValueByPath: function (object, path) {
            if (!path) {
                return;
            }
            var keys = path.split('.');
            var value = object;
            for (var i = 0; i < keys.length; i++) {
                value = value ? value[keys[i]] : undefined;
            }

            return value;
        },
        /**
         * Set a value recursive on an object by defining the path
         *
         * @param object {object} Object the value should be set
         * @param path {string|Array} The path to the target property
         * @param value {*} The value to set
         */
        setValueByPath: function (object, path, value) {
            var path = Array.isArray(path) ? path : path.split('.');
            // @todo I guess no one will understand this, maybe we should simplify it if possible (will be slower)
            // In each iteration assign a value or empty object to the key property
            // and assign the reference of these property to the holder object.
            // Note: Assign value to properties => by reference, Assign value to variable => not by reference
            for (var key = path.shift(); key; key = path.shift()) {
                object = object[key] = path.length ? object[key] || {} : value;
            }
        },
        /**
         * Listen for changes on a property defined by a path
         *
         * @param object {object} Containing observed property
         * @param path {string} Access path to target property
         * @param callback {function} Callback to execute on value change
         */
        observeValue: function (object, path, callback) {
            var path = typeof path == 'string' ? path.split('.') : path;
            var temp = object;
            for (var i = 0; i < path.length; i++) {
                // Get the reference to the parent property
                if (i + 1 < path.length) {
                    temp = temp[path[i]] = temp[path[i]] || {};
                } else {
                    // Create observer list of not done yet
                    if (typeof temp.__observer__ === 'undefined') {
                        // Define property which lists the observers
                        Object.defineProperty(temp, '__observer__', {
                            enumerable: false,
                            value: {}
                        });
                    }
                    // Add callback to observer list
                    temp.__observer__[path[i]] = temp.__observer__[path[i]] || [];
                    temp.__observer__[path[i]].push(callback);
                    // Check if the property is already observed
                    var descriptor = Object.getOwnPropertyDescriptor(temp, path[i]);
                    if (descriptor && descriptor.set) {
                        continue;
                    }
                    // Observe this property by custom getter and setter
                    var self = this;
                    (function (target, property, originalValue) {
                        var value = originalValue;
                        // Define property with getter and setter
                        Object.defineProperty(target, property, {
                            enumerable: true,
                            set: function (v) {
                                value = v;
                                // Get the observer for this property
                                var __observer__ = this.__observer__[property];
                                for (var i = 0; i < __observer__.length; i++) {
                                    // Invoke callback of observer
                                    __observer__[i](object, path);
                                }
                            },
                            get: function () {
                                return value;
                            }
                        });
                    })(temp, path[i], temp[path[i]]);
                }
            }
        },
        /**
         * Casts a value into target data type
         *
         * @param value {*} Value to cast
         * @param type {string} Textual representation of data type
         * @returns {*}
         */
        cast: function (value, type) {
            if (type == 'int') {
                return parseInt(value);
            } else if (type == 'float') {
                return parseFloat(value);
            } else if (type == 'boolean') {
                if (value == 'false' || value == 'off') {
                    return false;
                }
                return !!value;
            } else if (type == 'array') {
                if (Array.isArray(value)) {
                    return value;
                } else if (typeof value === "string"
                        && value.indexOf("|") === 0
                        && value.lastIndexOf("|") === value.length - 1) {
                    //UM multiselect
                    return this.multiselectSplit(value);
                }
                return value;
            }
        },
        /**
         * Split the given string value according to the rules of a multi-select field into a proper JavaScript Array.
         *
         * @param {String} value the UM value to split, not null.
         * @return {Array} possibly empty.
         * @function Multiselect.split
         */
        multiselectSplit: function (value) {
            var out = [];

            // Empty string is also empty array
            if (!value)
                return out;

            var cur = "";
            var len = value.length;
            var esc = false;

            for (var idx = 1; idx < len; idx++) { // skip the first pipe
                var c = value[idx];

                if (c == '|') {
                    if (esc) {
                        cur += c;
                        esc = false;
                    } else {
                        out.push(cur);
                        cur = '';
                    }
                } else if (c == "'") {
                    if (esc) { // double-escape: plain escape char
                        cur += c;
                        esc = false;
                    } else {
                        esc = true;
                    }
                } else {
                    if (esc) { // escape of non-special character
                        cur += '"';
                        esc = false;
                    }
                    cur += c;
                }
            }

            return out;
        },
        /*
         * Make hashCodes for form ids.
         */
        hashCode: function hashCode(s) {
            var md5 = "" + s.split("").reduce(function (a, b) {
                a = ((a << 5) - a) + b.charCodeAt(0);
                return  a & a
            }, 0);
            return md5.substr(1);//del minus
        }
    };
});

// https://tc39.github.io/ecma262/#sec-array.prototype.find //for IE11 and below
Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(r){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),t=e.length>>>0;if("function"!=typeof r)throw new TypeError("predicate must be a function");for(var n=arguments[1],i=0;i<t;){var o=e[i];if(r.call(n,o,i,e))return o;i++}},configurable:!0,writable:!0});
if (!Array.isArray) {//for IE8 and below
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
}
//https://tc39.github.io/ecma262/#sec-array.prototype.findindex //for IE11 and below
Array.prototype.findIndex||Object.defineProperty(Array.prototype,"findIndex",{value:function(r){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),t=e.length>>>0;if("function"!=typeof r)throw new TypeError("predicate must be a function");for(var n=arguments[1],i=0;i<t;){var o=e[i];if(r.call(n,o,i,e))return i;i++}return-1},configurable:!0,writable:!0});

if (!String.prototype.startsWith) { //for IE11 and below
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}
;
pirequire.define('lib/Captions',[
    'lib/Helper'
], function loadI18n(Helper) {

    /**
     * Runtime implementation for i18n class on backend
     *
     * @constructor
     */
    function Captions() {
    }

    /**
     * Set current captions
     * @param captions Map of key and translation values for current locale
     */
    Captions.prototype.setCaptions = function (captions) {
        this.captions = captions;
    };

    /**
     * Determine if the current captions contains a specific text
     *
     * @param key {string} Path to localisation inside locale object. Properties are separated by dots.
     * @returns {boolean}
     */
    Captions.prototype.has = function (key) {
        return !!Helper.getValueByPath(this.captions, key);
    };

    /**
     * Get value for specific key
     *
     * @param key {string} Path to localisation inside locale object. Properties are separated by dots.
     * @param placeholders {object|Array} List or Map of placeholders
     * @param {object} [captions] Map of key and translation values for current locale
     * 
     * @returns {String} maybe empty, if no caption found 
     */
    Captions.prototype.t = function (key, placeholders, captions) {
        if (captions) {
            this.captions = captions;
        }

        // Get localize value for the key or return the key
        var caption = Helper.getValueByPath(this.captions, key);
        if (!caption) {
            return '';
        }

        // Replace the placeholders inside caption
        if (placeholders) {
            if (Array.isArray(placeholders)) {
                for (var i = 0; i < placeholders.length; i++) {
                    caption = caption.replace('%' + i, placeholders[i]);
                }
            } else {
                for (var keyp in placeholders) {
                    var regexp = new RegExp('%{' + keyp + '}', 'g');
                    caption = caption.replace(regexp, placeholders[keyp]);
                }
            }
        }

        return caption;
    };

    //FIXME nicht gut!! wie ändert mann das ohne das die hbs Templates brechen?
    return new Captions();
});

//Pinuts File Encoding: UTF-8
/* global console: false */
pirequire.define('FormWidget', [
    'jquery',
    'lib/Helper',
    'lib/Captions'
], function loadFormWidget($, Helper, Captions) {

    function FormWidget(config) {
        this.containerClassName = 'pi-widget-type';
        this.designSet = "init";
        this.submitMethod = 'POST';

        this.isFirstRender = true;

        for (var key in config) {
            this[key] = config[key];
        }

        this.idPrefix = this.containerClassName.replace(/ /g, "_");

        Helper.initHanldebars(this.designSet);
        this.template = Helper.getTemplate("FormWidget", this.designSet);

        //FIXME Captions ist ein globales singelton, das ist ganz böse!! Der letzte schreiber gewinnt!
        Captions.setCaptions(this.captions);

        this.widgetId = this.containerId ? Helper.hashCode(this.containerId) : Date.now();

        this.elementId = this.idPrefix + "-form-" + this.widgetId;
        this.msgFromId = this.idPrefix + '-msgFormId-' + this.widgetId;//form msg unten
        this.msgWidgetId = this.idPrefix + '-msgWidgetId-' + this.widgetId;//widget msg oben
        this.submitId = "btnSubmit-" + this.widgetId;
        this.titleId = 'piTitleId-' + this.widgetId;
        this.fields = [];
        this.errors = [];
        this.errorsMsg = {};

        this.values = this.values || {};
        this.hiddens = [];

        this.cssClasses = {
            errorClass: window.pinuts.formErrorClass[this.designSet] || window.pinuts.formErrorClass.base,
            successClass: window.pinuts.formSuccessClass[this.designSet] || window.pinuts.formSuccessClass.base,
            isEditClass: window.pinuts.formIsEditClass[this.designSet] || window.pinuts.formIsEditClass.base
        };

        this.scrollOffset = 150;
        this.doNotScroll = false;

        /*
         * Observed Events:
         * onRender
         * onSubmit: called afer Submit Button pressed, before the validation start.
         * onFormSend: called before Form send, after all validation done
         * onFormReturn
         *
         * Note: runCustomScript call before event onRender and onFormReturn
         */
        this.events = {};
        //FIXME pass-through

        if (window.pinuts.formCallbacks &&
            window.pinuts.formCallbacks[this.addOnType] &&
            typeof window.pinuts.formCallbacks[this.addOnType] === "object") {
            for (var eventType in window.pinuts.formCallbacks[this.addOnType]) {
                var st = window.pinuts.formCallbacks[this.addOnType][eventType];
                if (typeof st === 'object' && st.type && st.callback) {
                    this.registerFormCallback(st.type, st.callback);
                } else if (typeof st === 'function') {
                    this.registerFormCallback(eventType, window.pinuts.formCallbacks[this.addOnType][eventType]);
                } else {
                    if (console && console.warn) {
                        console.warn("FormWidget found invalid callback definition. Check your custom scripts.");
                        console.log(st);
                    }
                }
            }
        }
    }

    FormWidget.prototype.init = function (modus) {

        if (this.getUserDataByMsgid()) {
            // render is done in getUserDataByMsgid, if necessary
        } else {
            this.render(modus);
        }
    };

    FormWidget.prototype.getUserDataByMsgid = function () {
        let self = this;
        this.addToken2BaseAjaxData = true;

        if (this.prefillFormOptionMsgid === true) {

            this.readUrlParams();

            if (this.urlParams && this.urlParams.hasOwnProperty("msgid")) {

                this.data = this.data || {
                    locale: this.locale || 'de',
                    name: this.addOnName
                }

                this.data.msgid = this.urlParams.msgid;

                let options = {
                    url: this.getUserDataByMsgidUrl,
                    data: this.data,
                    method: 'GET',
                    success: function (response) {
                        self.response = response;
                        if (response.success) {
                            self.setPrefillForm(response.data);
                            self.render();
                        } else {
                            self.render();
                            if (response.error.type === "msgiderror" && response.error.message) {
                                self.hideForm();
                                self.showMessage(response.error.message[self.locale], response.error.cssClass);
                                self.scrollFormTop();
                                return;
                            }

                            if (response.error.type === "apierror" && response.error.message) {
                                self.showMessage(response.error.message, response.error.cssClass);
                            }
                        }
                    }
                }

                this.ajaxCall(options);

                return true;

            } else if (this.prefillFormMsgidErrorHandling === "showError") {
                this.render();
                this.showMessage(this.prefillFormMsgidError[this.locale], this.cssClasses.errorClass);
                this.hideForm();
                this.scrollFormTop();

                return true;
            }
        }

        return false;
    };

    FormWidget.prototype.setPrefillForm = function (response) {
        for (const id in response) {
            this.values[id] = response[id];
        }
    };


    FormWidget.prototype.render = function (modus) {
        var element = $(this.template(this));
        if (this.element) {
            this.element.replaceWith(element);
        }
        this.element = element;

        //reset for re-render
        this.fields = [];
        this.errors = [];
        this.errorsMsg = {};

        this.$form = this.element.find(".pi-form");
        for (var i = 0; i < this.attributes.length; i++) {
            this.fields[i] = Helper.createField(this.attributes[i], this);
            //
            Helper.observeValue(this.fields[i], 'error', $.proxy(this.onErrorChange, this));

            this.$form.append(this.fields[i].render());
        }

        $("#" + this.containerId + "-loader").remove();
        $("#" + this.containerId).append(this.element);//FIXME hier besser ein replaceWith??
        $("#" + this.elementId).on('submit', $.proxy(this.onSubmit, this));

        this.$messageContainer = this.element.find("#" + this.msgWidgetId);
        this.runCustomScript({ modus: modus || 'rendered', widget: this });

        if (this.isFirstRender) {
            this.element.find('.pi-hoi').hide();
        }

        this.triggerEvent("onRender");

        //take pageTitle and url
        var self = this;
        this.registerFormCallback("onSubmit", function () {
            if (!self.values.url) {
                self.values.url = document.location.href;
            }
            if (!self.values.pageTitle) {
                self.values.pageTitle = document.title;
            }
        });

        this.isFirstRender = false;
    };


    FormWidget.prototype.hideForm = function () {
        $("#" + this.elementId).hide();
    };

    FormWidget.prototype.hideMessage = function () {
        this.$messageContainer.hide();
        this.$messageContainer.parent(".pi-message").removeClass(this.cssClasses.errorClass + " " + this.cssClasses.successClass);
    };

    /**
     * Show the upper Message with key
     * @param {string} key, absolute path in captions or relative to "captions.messages."
     * @param {string} cssClass
     * @param {boolean} dontScroll
     */
    FormWidget.prototype.showMessage = function (key, cssClass, dontScroll) {
        this.hideMessage();
        cssClass = this.cssClasses[cssClass] || cssClass;
        this.$messageContainer.parent(".pi-message").addClass(cssClass);
        var msg = "";

        function extendsKey(key) {
            var lkey = (key.indexOf('.') === -1 && key.indexOf('<') === -1) ? "messages." : "";
            return lkey + key;
        }

        if (typeof key === 'object') {
            for (var i = 0; i < key.length; i++) {
                msg += (i > 0) ? "<br/>" : "";
                msg += Captions.t(extendsKey(key[i]), null, this.captions) || key[i];
            }
        } else {
            msg = Captions.t(extendsKey(key), null, this.captions) || key;
        }

        this.$messageContainer.html(msg);
        this.$messageContainer.fadeIn('slow');

        if (!dontScroll) {
            this.scrollMessage();
        }
    };

    FormWidget.prototype.disableButtons = function () {
        this.element.find(".pi-form-button > button")
            .attr("disabled", "disabled")
            .addClass("pi-btn-loading")
            .append($("<i/>", { class: "pi-spinner", id: "piSpinner" }))
            .off();
    };

    FormWidget.prototype.enableButtons = function () {
        this.element.find(".pi-form-button > button > #piSpinner").remove();
        this.element.find(".pi-form-button > button")
            .removeAttr("disabled")
            .removeClass("pi-btn-loading").off();

    };

    FormWidget.prototype.scrollFormTop = function () {
        var offset = $('#' + this.titleId).offset();
        var self = this;
        if (offset && !this.doNotScroll) {
            $('html,body').animate({
                scrollTop: offset.top - self.scrollOffset
            }, 400);
        }
    };

    FormWidget.prototype.scrollMessage = function () {
        var offset = this.$messageContainer.offset();
        var self = this;
        if (offset && !this.doNotScroll) {
            $('html,body').animate({
                scrollTop: offset.top - self.scrollOffset
            }, 400);
        }
    };

    /**
     * Handle errors from server site validation
     *
     * @param {Object} errors response from server
     */
    FormWidget.prototype.setFormErrors = function (errors) {
        var hasError = false;

        for (var fieldName in errors) {
            var error = errors[fieldName];
            var field = this.getFieldByName(fieldName);
            if (field) {
                field.error = true;
                var errorMsg = field.createErrorText(error[0], error[1]);
                field.toggleErrorClass(true);
                this.errorsMsg[field.name] = { msg: errorMsg, label: field.getLabel() };
                hasError = true;
            }
        }

        if (hasError) {
            this.showErrorMsg();
            this.triggerEvent("serverSideValidationFailed");
        }
    };

    FormWidget.prototype.showErrorMsg = function () {
        var errorBoxTemplate = Helper.getTemplate("FormErrors", this.designSet);
        var $msgBox = $("#" + this.msgFromId);
        $msgBox.append(errorBoxTemplate({ errors: this.errorsMsg }));
        $msgBox.addClass(this.cssClasses.errorClass);
    };

    /**
     * Listen on changes of error's on fields within this fieldset
     *
     * @param field {object} The field object where the error status changed
     */
    FormWidget.prototype.onErrorChange = function (field) {
        var self = this;

        function removeFieldFromErrors(f) {
            var index = self.errors.indexOf(f.name);
            if (index !== -1) {
                self.errors.splice(index, 1);
                delete self.errorsMsg[f.name];
            }
        }

        // Remove field from errors
        if (field.fields && field.fields.length) { //field group
            field.fields.forEach(function (f) {
                removeFieldFromErrors(f);
            });
        } else {
            removeFieldFromErrors(field);
        }

        if (field.error) {
            if (field.errors) { // fieldGroup
                for (var i in field.errors) {
                    this.errors.push(field.errors[i]);
                }
            } else {
                this.errors.push(field.name);
            }

            if (field.errorMsg) {
                this.errorsMsg[field.name] = { msg: field.errorMsg, label: field.getLabel() };
            } else if (field.errorsMsg) {
                for (var fname in field.errorsMsg) {
                    this.errorsMsg[fname] = field.errorsMsg[fname];
                }
            }
        }

        // Show or hide error on tab entry
        this.error = !!this.errors.length;
    };

    //    FormWidget.prototype.deactivateButtons = function() {
    //        deactivate
    //    };

    /**
     * @returns {boolean} False if field is valid
     */
    FormWidget.prototype.validate = function (noMandatory) {
        //reset msg

        $("#" + this.msgFromId).html("");
        $("#" + this.msgFromId).removeClass(this.cssClasses.errorClass);
        for (var i = 0; i < this.fields.length; i++) {
            this.fields[i].validate(noMandatory);
        }

        // Check if we have errors
        if (this.errors.length) {
            this.showErrorMsg();
            this.triggerEvent("validationFailed");
            return true;
        }

        return false;
    };

    FormWidget.prototype.onSubmitSuccess = function (response) {
        // Check if update was successful
        if (response.success) {
            this.hideForm();
            if (response.message) {
                this.showMessage(response.message, response.cssClass, true);
            }
            this.scrollFormTop();
        } else {
            if (response.error.type === "formerror") {//server site validation failed
                this.setFormErrors(response.error.errors || {});
                if (response.error.message) this.showMessage(response.error.message, response.error.cssClass);
            } else if (response.error.type === "apierror" && response.error.message) {
                this.showMessage(response.error.message, response.error.cssClass);
            }
            $('.status').attr('class', 'status error');
            this.enableButtons();
        }
        if (response.callback && typeof this[response.callback] === 'function') {
            this[response.callback](response);
        }
        this.response = response;
        this.runCustomScript({ modus: 'formreturn', success: response.success, data: this.data, response: response });
        this.triggerEvent("onFormReturn");
    }


    FormWidget.prototype.onSubmit = function (event) {
        event.preventDefault();
        this.triggerEvent("onSubmit");

        var $submitBtn = $(event.target).find('button[type="submit"]:focus');
        var submitBtn, noMandatory = false;

        if ($submitBtn && !!$submitBtn.data('submitbtn')) {
            submitBtn = $submitBtn.data('submitbtn');

            if (this.submitButtons[submitBtn] && this.submitButtons[submitBtn].hasOwnProperty("validateMandatory") && !this.submitButtons[submitBtn].validateMandatory) {
                noMandatory = true;
            }
        }

        // Check if we have errors
        var error = this.validate(noMandatory);
        this.triggerEvent("afterValidation");

        if (error) {
            return false;
        }

        var self = this;

        // Send data to backend
        this.data = this.data || {};
        this.data.values = JSON.stringify(this.values);
        this.data.hiddens = JSON.stringify(this.hiddens);
        this.data.locale = this.locale;

        if (submitBtn) {
            this.data.submitBtn = submitBtn;
        }

        if (noMandatory) {
            this.data.noMandatory = noMandatory;
        }

        if (this.addOnName) {
            this.data.name = this.addOnName;
        }

        if (this.ctp) {
            this.data.ctp = this.ctp;
        }

        if (window.umtrack) {
            this.data.tc = window.umtrack.getFormTrackValue();
        }

        this.triggerEvent("onFormSend");
        this.disableButtons();

        //return false;
        var ajaxOptions = {
            url: this.postUrl,
            method: this.submitMethod,
            data: this.data,
            success: this.onSubmitSuccess.bind(this),
            error: this.onSubmitError.bind(this),
        };

        this.ajaxCall(ajaxOptions);
        return false;
    };

    //see https://api.jquery.com/jQuery.ajax/ error callback
    FormWidget.prototype.onSubmitError = function (jqXHR, textStatus, errorThrown) {
        // old wizard || new wizard || ompf
        var msg = Captions.t("messages.errorsOccurred", null, this.captions) || Captions.t("formErrors.formError", null, this.captions) || errorThrown;
        this.showMessage(msg, "errorClass");
        this.response = { success: false };
        this.jqXHR = jqXHR;
        this.runCustomScript({
            modus: 'formreturn',
            success: false,
            data: this.data,
            response: this.response,
            jqXHR: jqXHR
        });
        this.triggerEvent("onFormReturn");
    };

    FormWidget.prototype.ajaxWithCredentials = function (sendCredentials) {
        this.sendCredentials = sendCredentials;
    };

    /**
     * Warpper for ajax call.
     * Set the right method, jsonp or x-http-method-override headers
     * @param {type} options
     * @returns {undefined}
     */
    FormWidget.prototype.ajaxCall = function (options) {
        var self = this;
        var ajaxOptions = {
            url: options.url,
            dataType: 'json',
            data: options.data,
            success: options.success,
            error: options.error || function (error) {
                $("#" + this.msgFromId).addClass(self.cssClasses.errorClass);
                $("#" + this.msgFromId).append(error);
            }
        };

        if (options.method === 'GET') {
            ajaxOptions.type = 'GET';
            ajaxOptions.cache = false;
        } else {
            ajaxOptions.type = 'POST';
        }

        ajaxOptions.headers = options.headers || {};
        ajaxOptions.headers['X-CSRF-Safe'] = 'yes';
        ajaxOptions.headers['X-Cmsbs-Origin'] = document.location.origin + document.location.pathname;

        if (options.xhrFields) {
            ajaxOptions.xhrFields = options.xhrFields;
        }

        if (this.sendCredentials) {
            ajaxOptions.xhrFields = ajaxOptions.xhrFields || {};
            ajaxOptions.xhrFields.withCredentials = true;
        }

        if (!$.support.cors) {
            if (window.console) {
                console.error('Browser does not support CORS. Giving up.');
            }
        } else if (options.method === 'POST' || options.method === 'PUT' || options.method === 'DELETE') {
            // In a CORS situation, an OPTIONS request will be triggered.
            // Include addOnName as URL parameter 'name' if it would be passed as part
            // of the request body and no URL parameters are present:
            if (options.data && options.data.name == this.addOnName) {
                if (ajaxOptions.url.indexOf('?') == -1) {
                    ajaxOptions.url += '?name=' + encodeURIComponent(this.addOnName);
                }
            }
            if (options.method === 'PUT' || options.method === 'DELETE') {
                ajaxOptions.beforeSend = function (xhr) {
                    xhr.setRequestHeader("x-http-method-override", options.method);
                };
            }
        }

        $.ajax(ajaxOptions);
    };

    FormWidget.prototype.runCustomScript = function (ctx) {
        ctx.formWidget = this;
        // see https://pinutsjira.atlassian.net/browse/UM-1196
        if (typeof this.customScriptFunc === 'function') {
            try {
                this.customScriptFunc(ctx, $);
            } catch (e) {
                if (console && console.error) {
                    console.error("Error in jsCustomScript Function:\n", e, this.jsCustomScript);
                }
            }
        } else if (this.jsCustomScript) {
            try {
                var c = new Function("ctx", "$", this.jsCustomScript);//jshint ignore:line
                c(ctx, $);
            } catch (e) {
                if (console && console.log) {
                    console.log("Custom Callback dont work:\n" + e, this.jsCustomScript);
                }
            }
        }
    };

    FormWidget.prototype.registerFormCallback = function (event, callback) {
        if (this.events[event]) {
            this.events[event].push(callback);
        } else {
            this.events[event] = [callback];
        }
    };

    FormWidget.prototype.unregisterFormCallback = function (event, callback) {
        if (this.events[event]) {
            delete (this.events[callback]);
        }
    };

    /**
     * @param {String} event, name of event
     * @param {Object} [context] , if not given, set to this
     */
    FormWidget.prototype.triggerEvent = function (event, context) {
        var i;
        if (this.events[event]) {
            for (i = 0; i < this.events[event].length; i++) {
                if (!context) {
                    context = this;
                    context.formWidget = this;
                }
                this.events[event][i](context, $);
            }
        }
    };

    /**
     * @param {String} name
     * @returns {Field}
     */
    FormWidget.prototype.getFieldByName = function (name) {
        for (var i = 0; i < this.fields.length; i++) {
            if (this.fields[i].name === name) {
                return this.fields[i];
            }
            //there is never more then one nesting level
            if (this.fields[i].fieldObjects && this.fields[i].fieldObjects.length) {
                for (var j = 0; j < this.fields[i].fieldObjects.length; j++) {
                    if (this.fields[i].fieldObjects[j].name === name) {
                        return this.fields[i].fieldObjects[j];
                    }
                }
            }
        }
    };

    /**
     * Set value for field and re-render it
     * @param {String} name
     * @param {String} value
     */
    FormWidget.prototype.setFieldValue = function (name, value) {
        var field = this.getFieldByName(name);
        if (field) {
            field.setFormValue(value);
        } else if (console && console.log) {
            console.log("No field with name " + name + " found.");
        }
    };


    FormWidget.prototype.setFieldMandatory = function (name, showMessage, showMessageInline, showMessageText) {
        var field = this.getFieldByName(name);
        field.setMandatoryValidator(showMessage, showMessageInline, showMessageText);
    };

    FormWidget.prototype.unsetFieldMandatory = function (name) {
        var field = this.getFieldByName(name);
        field.unsetMandatoryValidator();
    };

    /**
     * Read the all parameters from the current URL and store it in this.urlParams
     */
    FormWidget.prototype.readUrlParams = function () {
        var query_string = {};
        var query = window.location.search.substring(1);
        //remove last arraw character ">"
        query = (query || '').replace(/^(.*)%3E$/, "$1");

        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = pair[1];
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                var arr = [query_string[pair[0]], pair[1]];
                query_string[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(pair[1]);
            }
        }
        this.urlParams = query_string;
    };

    return FormWidget;
});

var PiLib = {
    config: {
        baseUrl: window.pinuts.restUrl + "/de.pinuts.cmsbs.lib.widget.Pi/__resource/js",
        paths: {
           'jquery-ui': 'jquery-ui.min',
           'jquery-timepicker': 'jquery-ui-timepicker-addon.min',
           'jcal': 'jcal.min'
        },
        map: {
            // '*' means all modules will get 'jquery-private'
            // for their 'jquery' dependency.
            '*': {'jquery': 'jquery-private'},
            // 'jquery-private' wants the real jQuery module
            // though. If this line was not here, there would
            // be an unresolvable cyclic dependency.
            'jquery-private': {'jquery': 'jquery'}
        }
    },
    setConfig: function (config) {
        config = config || this.config;
        pirequire.requirejs.config(config);
    }
};



pirequire.define("PiLib", function(){});

pirequire.define('lib/OO',[],function loadOO() {

    var OO = {};

    /**
     * Make an existing class be the subclass of another class.
     *
     * @param {Function} subClass the class extending the super class.
     * @param {Function} baseClass the super class.
     * @static
     * @function OO.extend
     */
    OO.extend = function (subClass, baseClass) {
        var st = (typeof subClass);
        if (st != "function") {
            throw "OO.extend: Subclass is not function, but " + st;
        }

        var bt = (typeof baseClass);
        if (bt != "function") {
            throw "OO.extend: Baseclass is not function, but " + bt;
        }

        function inheritance() {}
        inheritance.prototype = baseClass.prototype;

        subClass.prototype = new inheritance();
        subClass.prototype.constructor = subClass;

        subClass.superConstructor = baseClass;
        subClass.superClass = baseClass.prototype;
    };

    return OO;
});
pirequire.define('lib/Callbacks',[],function loadCallbacks() {

    /**
     * Helper class to manage callbacks across the widget
     *
     * @constructor
     */
    function Callbacks() {
        this.callbacks = {};
    }

    /**
     * Add a callback to the list
     *
     * @param key {string} The identifier of this callback. (should be unique)
     * @param callable {function} The callback itself
     */
    Callbacks.prototype.add = function add(key, callable) {
        // Check if this is a callable function
        if (typeof callable !== 'function') {
            throw new Error('Callback ' + key + ' is not a function');
        }
        this.callbacks[key] = callable;
    };

    /**
     * Get a callback identified by the given key
     *
     * @param key {string} The identifier of the target callback
     * @returns {function|undefined}
     */
    Callbacks.prototype.get = function get(key) {
        return this.callbacks[key];
    };

    // This is a singleton class so return the instance only
    return new Callbacks();
});
pirequire.define('lib/Dependencies',[
    'jquery',
    'lib/Helper'
], function loadDependencies($, Helper) {

    /**
     * This class aims to handle dependencies between fields by comparing there values
     * Fields can have dependency configuration with an Array of dependencies consisting
     * either of strings or arrays. The string describes the name (path) of the required field.
     * If the value is an array the first index will describe the name and the second index describes the required value.
     * Example: ["name.of.field", "name.of.other.field"] or [["name.of.field", "someValue"], "name.of.other.field"]
     *
     * @constructor
     */
    function Dependencies() {
        this.dependencies = {};
    }

    /**
     * Register a field dependencies and observe the required values
     *
     * @param field {fields/Field} Field instance with dependencies
     */
    Dependencies.prototype.register = function register(field) {
        if (field.dependencies && field.dependencies.length) {
            for (var i = 0; i < field.dependencies.length; i++) {
                var dependency = Array.isArray(field.dependencies[i]) ? field.dependencies[i][0] : field.dependencies[i];
                // Register field dependency
                this.dependencies[dependency] = this.dependencies[dependency] || [];
                this.dependencies[dependency].push(field);
                // Create value observer to listen on value changes
                Helper.observeValue(field, dependency, field.render.bind(field));
            }
        }
    };

    /**
     * Check if the dependencies of a field fulfill the requirements
     * If so the field will be shown or hidden
     *
     * @param field {fields/Field} The field to check
     */
    Dependencies.prototype.checkDependencies = function checkDependencies(field) {
        var showElement = false;
        for (var i = 0; i < field.dependencies.length; i++) {
            var dependency = field.dependencies[i];
            var requiredValue = undefined;
            // Get required value if set
            if (Array.isArray(field.dependencies[i])) {
                dependency = field.dependencies[i][0];
                requiredValue = field.dependencies[i][1];
            }
            var newValue = Helper.getValueByPath(field, dependency);

            // Check if we have to validate a value
            if (requiredValue !== undefined) {
                // Compare required with actual value
                if (requiredValue == newValue ||
                    (Array.isArray(newValue) && newValue.indexOf(requiredValue) > -1) ||
                    (typeof newValue === "object" && newValue && newValue[requiredValue])) {
                    showElement = true;
                }
                // We don't need to continue dependency checks because one is not fulfilled
                else {
                    showElement = false;
                    break;
                }
            }
            // No specific value is expected so check if the value is truthy
            // Truthy means non empty array/object, a number, true or non empty string
            else if (newValue !== null && typeof newValue === 'object' ? Object.keys(newValue).length : typeof newValue === 'number' || newValue) {
                showElement = true;
            }
            else {
                showElement = false;
                break;
            }
        }
        return showElement;       
    };

    return new Dependencies();
});
pirequire.define('fields/Field', [
    'jquery',
    'lib/Helper',
    'lib/Callbacks',
    'lib/Dependencies',
    'lib/Captions'
], function loadField($, Helper, Callbacks, Dependencies, Captions) {

    /**
     * Base class for fields inside wizard form
     *
     * @constructor
     */
    function Field() {
        this.value = null;
        this.values = null;
        this.data = null;
        this.element = null;
        this.template = null;
        this.error = false;
        this.errorMsg = null;
        this.formWidget;
    }

    /**
     * Bind configured callbacks to their events on the given input.
     * This function can be called twice per field if multiple inputs generates one value like radio buttons.
     *
     * @param input {jquery}
     */
    Field.prototype.bindCallbacks = function (input) {
        input.on('change', this.onChange.bind(this));
        input.on('focus', this.onFoucus.bind(this));
        input.on('focusout', this.onFocusout.bind(this));

        // Bind all callbacks if specified
        if (this.callbacks) {
            for (var event in this.callbacks) {
                // Only iterate over real properties
                if (!this.callbacks.hasOwnProperty(event)) {
                    continue;
                }
                // Try to get callback and bind it on input
                var callback = Callbacks.get(this.callbacks[event]);
                if (!callback) {
                    throw new Error('The callback "' + this.callbacks[event] + '" for "' + event + '" is missing');
                }
                input.on(event, $.proxy(callback, this, this));
            }
        }
    };

    /**
     * Render the field into a DOMNode wrapped into jQuery Model
     *
     * @returns {jQuery}
     */
    Field.prototype.render = function () {
        if (!this.template) {
            throw new Error('Missing template: name  ' + this.name + ", type " + this.type);
        }

        this.loadMandatory();//reload, my be mandatory now

        Captions.setCaptions(this.formWidget.captions);//FIXME ugly!
        var element = $(this.template(this));
        if (this.element) {//FIXME this kill all callbacks? really want this?
            this.element.replaceWith(element);
        }
        this.element = element;
        this.bindCallbacks(this.element.find('input, select, textarea'));
        // Pre check if this field can be shown or not
        if (this.dependencies && this.dependencies.length) {
            if (Dependencies.checkDependencies(this)) {
                this.element.show();
                this.element.find('input, select, textarea').trigger('change');
                this.deleteFromHidden();
            } else {
                this.element.hide();
            }
        }

        //maybe a re-render?
        this.error = false;
        this.errorMsg = null;

        return element;
    };

    Field.prototype.hide = function () {
        this.element.hide();
    };

    Field.prototype.show = function () {
        this.element.show();
    };

    /**
     * If call with templateId, do it after setConfig
     * @param {mixed} template , precomplied handlebar template or templateId
     */
    Field.prototype.setTemplate = function (template) {
        if (typeof template === "string") {
            this.template = Helper.getTemplate(template, this.designSet);
        } else {
            this.template = template;
        }
    };

    /**
     * Set and parse the config for this field
     *
     * @param config {object} Configuration object
     */
    Field.prototype.setConfig = function (config) {
        for (var key in config) {
            this[key] = config[key];
        }

        // Create a unique field identifier if not set.
        // This is required to make use of label referencing to input
        if (!this.id) {
            if (this.name && this.type) {
                this.id = Helper.hashCode(this.name + this.type);
            } else {
                this.id = Math.random().toString(16).substr(2);
            }
        }

        // Check if validation is wished and possible
        if (this.validation && this.validation.length && (!window.pinuts || !window.pinuts.formvalidators)) {
            if (typeof console !== 'undefined' && console) { /* global console */
                console.error('The validators are missing which means validation isn\'t possible.');
            }
            this.validation = null;
        }

        this.getMaxlength();
        this.elementId = this.formWidget.idPrefix + '-' + this.id + '-' + this.widgetId;

        this.formErrorClass = window.pinuts.formErrorClass[this.designSet] || window.pinuts.formErrorClass.base;
        this.formSuccessClass = window.pinuts.formSuccessClass[this.designSet] || window.pinuts.formSuccessClass.base;

        //UM-164 Punkte als Option führen zu leerer Anzeige im Formular-Widget
        // leagacy für alte (custom?) elemente.
        if (this.options && this.options.length) {
            this.options.forEach(function(option) {
                if (option.name && !option.captionName) {
                    option.captionName = option.name.replace(/\./g, "_");
                }
            });
        }
    };

    /**
     * Extract maxlength from validatior for html attribute, if set.
     */
    Field.prototype.getMaxlength = function () {
        if (this.validation && this.validation.length) {
            for (var i = 0; i < this.validation.length; i++) {
                if (this.validation[i][0] === 'maxlength')
                    this.maxLength = this.validation[i][1].maxLength;
            }
        }
    };


    Field.prototype.loadMandatory = function () {
        if (this.validation && this.validation.length) {
            this.mandatory = window.pinuts.formvalidators.WidgetValidator.isMandatory(this.value, this.validation, this.values, this);
        }

        return false;
    };


    /**
     * Set data required for field to render properly
     *
     * @param data {object}
     */
//    Field.prototype.setData = function (data) {
//        this.data = data;
//    };


    /**
     * Set reference to global form values to make them better accessible
     *
     * @param values {object} Values of all fields inside wizard form
     */
    Field.prototype.setValues = function (values) {
        this.values = values;
        // Register the field dependencies if available
        if (this.dependencies && this.dependencies.length) {
            Dependencies.register(this);
        }

        if (this.refreshIfChanged) {//re-render if another field changes
            for (var i = 0; i < this.refreshIfChanged.length; i++) {
                var name = this.refreshIfChanged[i];
                Helper.observeValue(this.values, name, this.render.bind(this));
            }
        }
    };

    /**
     * Set value for this field. If wished the value will be propagated to global form values object
     *
     * @param value {*} Value for current field
     * @param propagate {boolean} If true the value will propagate to global form values object
     */
    Field.prototype.setValue = function (value, propagate, noValidate) {
        // Check if we have to cast the value to a specific data type
        this.value = this.cast ? Helper.cast(value, this.cast) : value;

        if (typeof this.value === "string") {
            this.value = this.value.trim();
        }

        // Propagate the value into values object
        if (propagate && this.name) {
            // Check if the field has no errors and propagate the value if so
            if (noValidate || !this.validate() || !this.value) {
                Helper.setValueByPath(this.values, this.name, this.value);
            }
        }
    };

    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    Field.prototype.onChange = function (event) {
        this.element.addClass('changed');
        if (window.pinuts.formIsEditClass[this.designSet]) {
            $('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
        }
        this.setValue($(event.target).val(), true);
    };

    Field.prototype.onFoucus = function (event) {
        this.element.addClass('focus');
    };

    Field.prototype.onFocusout = function (event) {
        this.element.removeClass('focus');
    };

    /**
     * Set gobal value and re-render field.
     * Used in custom js
     * @param {type} value
     */
    Field.prototype.setFormValue = function (value) {
        this.setValue(value, true);
        this.render();
    };

    Field.prototype.deleteFromHidden = function() {
        if (this.formWidget.hiddens.length && this.formWidget.hiddens.indexOf(this.name) > -1) {
            var self = this;
            this.formWidget.hiddens = this.formWidget.hiddens.filter(function (v) {
                return v !== self.name;
            });
        }
    };


    /**
     * Validate the value inserted into the current field input
     *
     * @returns {mixed} False if field is valid, true if not, a error msg if showMessage is set
     */
    Field.prototype.validate = function(noMandatory) {

        if (!this.validation || this.validation.length === 0) {
            return false;
        }

        var error, result, errorMsg; //errorVal array => 0 => error, 1 => options
        //only valdidate if field visible        
//FIXME geht nicht wegen server-side validation  if ((this.dependencies && this.dependencies.length && !Dependencies.checkDependencies(this)) || this.element.is(':hidden')) {
        if ((this.dependencies && this.dependencies.length && !Dependencies.checkDependencies(this))) {
            error = false;
            this.setNullValue();
        } else if (this.type !== "HiddenField" && this.element.is(':hidden')) {
            this.setNullValue();
            error = false;
        } else {
            // Validate the given value
            result = window.pinuts.formvalidators.WidgetValidator.validate(this.value, this.validation, this.values, this, noMandatory);
            error = result[0];
            errorMsg = null;
            if (result[1] && (result[1].showMessage || result[1].showMessageInline)) {
                result[1].name = this.getLabel();
                errorMsg = this.createErrorText(result[0], result[1]);
            }
            //
            this.deleteFromHidden();
        }

        // Check if we have to update the error
        //if (error != this.error) {
            //reset error msg
            this.element.find('.pi-form-error').html('');
            this.errorMsg = "";
            // Set new error string and change error class
            if (errorMsg) {
                if (result[1].showMessageInline) {
                    this.element.find('.pi-form-error').html(errorMsg || '');
                    this.element.find('#' + this.elementId).attr("aria-describedBy", "error_" + this.elementId);                    
                }
                if (result[1].showMessage) {
                    this.errorMsg = errorMsg;
                }
            }
            this.error = error;
            this.toggleErrorClass(!!error);
        //}

        this.element.toggleClass(this.formSuccessClass, (this.mandatory && !error && !!this.value));

        // Return true, false
        return !!error;
    };

    Field.prototype.setNullValue = function() {
        this.formWidget.hiddens.push(this.name);
        this.values[this.name] = undefined;
    };

    Field.prototype.toggleErrorClass = function (toggel) {       
        this.element.find('#' + this.elementId).attr("aria-invalid", toggel ? "true" : "false");
        if (!toggel) {
            this.element.find('#' + this.elementId).removeAttr("aria-describedBy");       
        }
        this.element.toggleClass(this.formErrorClass, toggel);
    };

    Field.prototype.getLabel = function () {
        return Captions.t("attributes." + this.name + ".label", null, this.formWidget.captions);
    };

    Field.prototype.createErrorText = function (errorId, options) {
        if (!errorId)
            return;

        options = options || {};
        options.name = this.getLabel();
        var msg = Captions.t("errors." + this.name + "." + errorId, options, this.formWidget.captions);
        if (!msg) msg = Captions.t("errors." + errorId, options, this.formWidget.captions);
        return  msg || errorId;
    };


    Field.prototype.unsetMandatoryValidator = function() {
        this.mandatory = false;
        if (this.validation && this.validation.length) {
            var manIdx = -1;
            for (var i = 0; i < this.validation.length; i++) {
                if (this.validation[i][0] === 'notempty') {
                    manIdx = i;
                    break;
                }
            }

            if (manIdx > -1) {
                this.validation.splice(manIdx, 1);
            }
        }
        this.render();
    };


    Field.prototype.setMandatoryValidator = function(showMessage, showMessageInline, showMessageText) {
        var validatorVals = {
            "name": "mandatory",
            "showMessage": showMessage,
            "showMessageText": {},
            "showMessageInline": showMessageInline
        }

        validatorVals.showMessageText[this.formWidget.locale] = showMessageText || '';

        this.mandatory = true;
        this.validation = this.validation || [];
        this.validation.push(
            [
                "notempty",
                validatorVals
            ]
            );
        this.render();
    };

    // Create namespace if not available
    window.pinuts = window.pinuts || {};
    window.pinuts.fields = {};

    return Field;
});

pirequire.define('fields/CalendarField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadCalendarField($, OO, Field) {

    var jCalLocale = {};
    jCalLocale.de = {};
    jCalLocale.de.daysOfWeek = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    jCalLocale.de.monthsLong = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    jCalLocale.de.monthsShort = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

    /**
     * A field containing a select input
     *
     * @constructor
     */
    function CalendarField() {
        CalendarField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(CalendarField, Field);

    CalendarField.prototype.render = function () {
        CalendarField.superClass.render.apply(this, arguments);
        //set select value
        //this.element.find("select").trigger("change");


        this.initCalendar();
        return this.element;
    };


    CalendarField.prototype.initCalendar = function () {
        var self = this;

        pirequire.require(['jquery-ui', 'jcal'], function () {           
            var today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);

            var dCheck = function (day) {
                var dayTime = day.getTime();

                if ((self.pastselectable === "no" || self.pastselectable === false) && dayTime < today.getTime()) {
                    return false;
                }

                var weekDay = day.getDay();
                weekDay = (weekDay === 0) ? 7 : weekDay;
                if (self.blockweekday && (!self.blockweekday['day' + weekDay]
                    || (self.blockweekday['day' + weekDay] !== "1" && self.blockweekday['day' + weekDay] !== true))) {
                    return false;
                }

                if ((self.isblockperiods === 'yes' || self.isblockedperiods === true) && self.blockedPeriods && self.blockedPeriods.length) {
                    var fromTime, toTime;
                    var umDay = calDay2UMDate(day);
                    for (var i = 0; i < self.blockedPeriods.length; i++) {
                        var period = self.blockedPeriods[i];
                        if (period.from && !period.to) {//single day
                            if (period.from === umDay) {
                                return false;
                            }
                        } else if (period.from && period.to) {
                            fromTime = getTime4UMDate(period.from);
                            toTime = getTime4UMDate(period.to);
                            if ((fromTime - dayTime) <= 0 && (toTime - dayTime) >= 0) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            };

            var jCalProps = {
                day: new Date(),
                days: 1,
                showMonths: 1,
                dayOffset: 1,
                monthSelect: true,
                callback: function (day) {
                    self.setValue(calDay2UMDate(day), true);
                },
                dCheck: dCheck
            };
            
            //FIXME ?richtig machen? 
            var deLocale = ["de", "DE", "deu", "DEU", "De"].indexOf(self.formWidget.locale);
            if (deLocale > -1) {
                jCalProps.dow = jCalLocale.de.daysOfWeek;
                jCalProps.ml = jCalLocale.de.monthsLong;
                jCalProps.ms = jCalLocale.de.monthsShort;
            }

            self.element.find(".piCalendar").jCal(jCalProps);
        });
    };


    function getTime4UMDate(umts) {
        var ts = umts.split("|", 2);
        var d = ts[0].split("-", 3); //date

        var t = new Array("00", "00", "00"); //time
        if (ts.length === 2)
            t = ts[1].split(":", 3);

        var dss = new Date(d[0], (d[1] - 1), d[2]); //jsDate Month 0-11
        dss.setHours(t[0]);
        dss.setMinutes(t[1]);
        dss.setSeconds(t[2]);

        return dss.getTime();
    }

    function calDay2UMDate(calday) {
        var dayMonth = (calday.getMonth() + 1) + "";
        if (dayMonth.length === 1) {
            dayMonth = "0" + dayMonth;
        }
        var dayDate = calday.getDate() + "";
        if (dayDate.length === 1) {
            dayDate = "0" + dayDate;
        }
        return calday.getFullYear() + "-" + dayMonth + "-" + dayDate;
    }

    // Make available the field type globally
    window.pinuts.fields.CalendarField = CalendarField;

    return CalendarField;
});

pirequire.define('fields/CaptchaEU', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Helper'
], function loadCaptchaEU($, OO, Field, Helper) {

    /**
     * A field containing Captcha EU
     * @constructor
     */
    function CaptchaEU() {
        CaptchaEU.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(CaptchaEU, Field);

    CaptchaEU.prototype.setConfig = function (config) {
        let notemptyElement = config.validation.find((element) => element[0] === 'notempty');
        if (config.attributes.showMessageText && notemptyElement) {
            if (notemptyElement && notemptyElement.length > 1) {
                notemptyElement[1].showMessageText = config.attributes.showMessageText;
            }
            config.validation.find((element) => element[0] === 'notempty').showMessageText = config.attributes.showMessageText;
        }
        config.isAnonymAttr = true;
        return CaptchaEU.superClass.setConfig.apply(this, arguments);
    }

    //for error msg
    CaptchaEU.prototype.getLabel = function () {
        return "Captcha EU";
    };

    CaptchaEU.prototype.setNullValue = function () {
        //never do this!
    };

    CaptchaEU.prototype.validate = function () {
        if (window.KROT) {
            return CaptchaEU.superClass.validate.apply(this, arguments);
        }
    };

    CaptchaEU.prototype.setScripttag = function () {
        if (this.passthrough.apiUrl && !window.KROT) { // if apiUrl is configuration
            const script = document.createElement("script");
            script.src = this.passthrough.apiUrl;
            script.async = true;
            const self = this;
            script.onload = () => {
                const wait = (window.KROT) ? 0 : 100;
                self.setupCaptcha(wait, 0);
            };
            document.body.appendChild(script);
        } else { // otherwise Captcha EU script tag can be added manually to html page
            const wait = (window.KROT) ? 0 : 100;
            this.setupCaptcha(wait, 0);
        }
    }

    CaptchaEU.prototype.setupCaptcha = function (wait, stopIdx) {
        const self = this;

        setTimeout(function () {

            if (window.KROT) {
                KROT.setup(self.attributes.publicKey);
                KROT.getSolution()
                    .then((solution) => {
                        self.setValue(JSON.stringify(solution), true);
                    });
            } else if (stopIdx < 15) {
                self.setupCaptcha(wait, ++stopIdx);
            } else {
                console.error('PiForm: Cannot render Captcha EU. Please check the configuration.')
            }
        }, wait);
    }

    CaptchaEU.prototype.render = function () {

        if (!this.attributes.publicKey) {
            console.error('PiForm: Missing Public Key for Captcha EU. Please check the configuration.')
            return;
        }

        this.formWidget.disableButtons();
        Helper.setValueByPath(this.values, '_captchaId', this.attributes.captchaId);
        this.setScripttag();

        if (this.attributes.cssClass) {
            this.cssClasses = this.cssClasses || '';
            this.cssClasses += this.attributes.cssClass;
        }

        if (this.attributes.showSpinner === 'yes' && this.attributes.loadingText && this.attributes.successText) {
            this.renderSpiner = true;
        }

        const element = CaptchaEU.superClass.render.apply(this, arguments);

        return element;
    }

    // Make available the field type globally
    window.pinuts.fields.CaptchaEU = CaptchaEU;

    return CaptchaEU;
})

;
pirequire.define("fields/CaptchaEU", function(){});

pirequire.define('fields/CheckboxField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadCheckboxField($, OO, Field, Helper) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function CheckboxField() {
        CheckboxField.superConstructor.apply(this, arguments);        
    }

    // Inherit fields/Field base class
    OO.extend(CheckboxField, Field);

    CheckboxField.prototype.setConfig = function (config) {
        CheckboxField.superClass.setConfig.apply(this, arguments);
        
        if (!this.cast) {
            this.cast = (this.options.length === 1) ? 'boolean' : 'array';
        }
        
        if (this.cast === 'boolean') {
            this.setTemplate("CheckboxTpl");
        } else {
            this.setTemplate("CheckboxesTpl");
        }
        
        this.cssClass = (this.display && this.display !== 'vertical') ? "pi-checkbox-control" : "pi-checkbox-control-vertical";
    };
    
    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    CheckboxField.prototype.onChange = function(event) {
        this.element.addClass('changed');
        if (this.cast === 'boolean') {
            this.setValue($(event.target).is(':checked'), true);            
        } else {
            var values = [];
            this.element.find("input[type=checkbox]:checked").each(function() {
                values.push($(this).val());
            });
            this.setValue(values, true);
        }
    };

    CheckboxField.prototype.toggleErrorClass = function (toggel) {       
        CheckboxField.superClass.toggleErrorClass.apply(this, arguments);
        var $cb =  this.element.find('input[id^=' + this.elementId + ']');
        $cb.attr("aria-invalid", toggel ? "true" : "false");
        if (toggel) {
            $cb.attr("aria-describedBy", "error_" + this.elementId);
        } else {
            $cb.removeAttr("aria-describedBy");
        }      
    };

    // Make available the field type globally
    window.pinuts.fields.CheckboxField = CheckboxField;

    return CheckboxField;
});

pirequire.define('fields/ChtmlField', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Helper'
], function ($, OO, Field, Helper) {

    /**
     * A field containing multiple inputs with type radio
     *
     * @constructor
     */
    function ChtmlField() {
        ChtmlField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(ChtmlField, Field);

    ChtmlField.prototype.setConfig = function (config) {
        ChtmlField.superClass.setConfig.apply(this, arguments);
        this.template = Helper.getTemplate(this.tplId, this.designSet);
    };


    ChtmlField.prototype.render = function () {
        if (!this.template) {
            throw new Error('Missing template');
        }

        var element = $(this.template(this.cmodel));
        if (this.element) {
            this.element.replaceWith(element);
        }
        this.element = element;
        this.bindCallbacks(this.element.find('input, select, textarea'));

        return element;
    };


    ChtmlField.prototype.getValue = function (event) {
        if (this.getValueFunction) {
            var c = new Function("chtml", this.getValueFunction);

            return c(this);
        }
    };

    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    ChtmlField.prototype.onChange = function (event) {
        var value = this.getValue();
        if (value) {
            this.setValue(value, true);
        }
    };


    ChtmlField.prototype.validate = function () {
        //nope
    };

    // Make available the field type globally
    window.pinuts.fields.ChtmlField = ChtmlField;

    return ChtmlField;
});

pirequire.define('fields/DateField', [
    'jquery',
    'lib/OO',
    'fields/Field',
], function loadDateField($, OO, Field) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd 
     *
     * @constructor
     */
    function DateField() {
        DateField.superConstructor.apply(this, arguments);

        this.formValue; //value in proper form format.
    }


    DateField.dateFormats = {
        de: "dd.mm.yyyy",
        um: "yyyy-mm-dd",
        uk: "dd/mm/yyyy",
        us: "mm/dd/yyyy"
    };

    DateField.placeholder = {
        de: "tt.mm.jjjj"
    };

    //some help values for transformation form GUI to UM Dates
    // s == separator
    // c == colums for custom date 
    // u == transer form UM to custom
    DateField.dateFormatsTrans = {
        de: {s: ".", c: {y: 2, m: 1, d: 0}, u: [2, 1, 0]},
        uk: {s: "/", c: {y: 2, m: 1, d: 0}, u: [2, 1, 0]},
        us: {s: "/", c: {y: 2, m: 0, d: 1}, u: [1, 2, 0]},
        um: {s: "-", c: {y: 0, m: 1, d: 2}, u: [0, 1, 2]}
    };

    //en not needed because default
    DateField.regional = {
        de: {
            closeText: 'Schlie&szlig;en',
            prevText: '&#x3C;Zur&uuml;ck',
            nextText: 'Vor&#x3E;',
            currentText: 'Heute',
            monthNames: ['Januar', 'Februar', 'M&auml;rz', 'April', 'Mai', 'Juni',
                'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthNamesShort: ['Jan', 'Feb', 'M&auml;r', 'Apr', 'Mai', 'Jun',
                'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            weekHeader: 'KW',
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ''}
    };

    // Inherit fields/Field base class
    OO.extend(DateField, Field);

    DateField.prototype.setConfig = function (config) {
        DateField.superClass.setConfig.apply(this, arguments);

        this.format = DateField.dateFormats[this.formatKey];
        this.placeholder = DateField.placeholder[this.formatKey] || this.format;
        this.picker = (this.picker && (this.picker === true || this.picker === "yes"));
    };

    DateField.prototype.render = function () {
        DateField.superClass.render.apply(this, arguments);

        if (this.picker) {
            this.initPicker();
        }

        return this.element;
    };

    DateField.prototype.setValue = function (value, propagate, noValidate) {
        value = (value) ? value.trim() : "";
        if (value) {
            value = this.parseDate(value);
        }

        DateField.superClass.setValue.apply(this, [value, propagate, noValidate]);
        this.setFormValue();
    };

    DateField.prototype.parseDate = function (value) {
        if (value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
            return value;
        }

        if (value.match(/^\d\d\d\d-\d{1,2}-\d{1,2}\|\d\d:\d\d:\d\d$/)) {//Timestamp
            return value.substr(0, value.indexOf('|'));
        }

        return this.cast2UMDate(value);
    };

    /**
     * @param {String} raw value from form
     * @returns {String} proper UM date string
     */
    DateField.prototype.cast2UMDate = function (value) {
        var fTrans = DateField.dateFormatsTrans[this.formatKey];
        var pa = value.split(fTrans.s);

        return pa[fTrans.c.y] + "-" + pa[fTrans.c.m] + "-" + pa[fTrans.c.d];
    };

    /**
     * 
     * @returns {String} date in chosen form format
     */
    DateField.prototype.setFormValue = function () {
        if (!this.value)
            return;

        var fTrans = DateField.dateFormatsTrans[this.formatKey];
        var pa = this.value.split("-");

        this.formValue = pa[fTrans.u[0]] + fTrans.s + pa[fTrans.u[1]] + fTrans.s + pa[fTrans.u[2]];
    };

    DateField.prototype.getDatepickerConf = function () {
        var defaultDate = null;
        if (this.rangeTo < 0) {
            defaultDate = this.rangeTo + "y";
        }

        var conf = {
            dateFormat: this.format.replace("yyyy", "yy"),
            yearRange: this.rangeFrom + " : " + this.rangeTo,
            changeYear: (this.changeYear && (this.changeYear === true || this.changeYear === "yes")),//leagcy
            defaultDate: defaultDate           
        };

        return conf;
    };


    DateField.prototype.initPicker = function () {
        var self = this;
        pirequire.require(['jquery-ui'], function () {
            if (DateField.regional[self.formatKey]) {
                $.datepicker.setDefaults(DateField.regional[self.formatKey]);
            }

            self.element.find(".date").datepicker(self.getDatepickerConf());
        });
    };


    // Make available the field type globally
    window.pinuts.fields.DateField = DateField;

    return DateField;
});

pirequire.define('fields/DateFieldNative', [
    'jquery',
    'lib/OO',
    'lib/Helper',
    'fields/Field',
], function loadDateFieldN($, OO, Helper, Field) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * Note: the entire date formatting is only needed for the free text field. The HTML5 date input element always has the format yyyy-mm-dd
     *
     * @constructor
     */
    function DateFieldNative() {
        DateFieldNative.superConstructor.apply(this, arguments);

        this.noPickerTpl = Helper.getTemplate('DateField', this.designSet);

        this.formValue; //value in proper form format.
    }


    DateFieldNative.dateFormats = {
        de: "dd.mm.yyyy",
        um: "yyyy-mm-dd",
        uk: "dd/mm/yyyy",
        us: "mm/dd/yyyy"
    };

    DateFieldNative.placeholder = {
        de: "tt.mm.jjjj"
    };

    //some help values for transformation form GUI to UM Dates
    // s == separator
    // c == colums for custom date 
    // u == transer form UM to custom
    DateFieldNative.dateFormatsTrans = {
        de: {s: ".", c: {y: 2, m: 1, d: 0}, u: [2, 1, 0]},
        uk: {s: "/", c: {y: 2, m: 1, d: 0}, u: [2, 1, 0]},
        us: {s: "/", c: {y: 2, m: 0, d: 1}, u: [1, 2, 0]},
        um: {s: "-", c: {y: 0, m: 1, d: 2}, u: [0, 1, 2]}
    };

    // Inherit fields/Field base class
    OO.extend(DateFieldNative, Field);

    DateFieldNative.prototype.setConfig = function (config) {
        DateFieldNative.superClass.setConfig.apply(this, arguments);

        this.format = DateFieldNative.dateFormats[this.formatKey];
        this.placeholder = DateFieldNative.placeholder[this.formatKey] || this.format;
        this.isPicker = (this.picker && (this.picker === true || this.picker === "yes"));
        this.isSetDateRange = (this.setDateRange && (this.setDateRange === true || this.setDateRange === "yes"));
        if (this.isSetDateRange) {
            if (this.rangeFrom && this.rangeFrom.match(/^\d\d\d\d-\d\d-\d\d/)) {
                this.min = this.rangeFrom;
            }
            if (this.rangeTo && this.rangeTo.match(/^\d\d\d\d-\d\d-\d\d/)) {
                this.max = this.rangeTo;
            }
        }
    };

    DateFieldNative.prototype.render = function () {
        if (!this.isPicker) {
            this.template = this.noPickerTpl;
        }
        DateFieldNative.superClass.render.apply(this, arguments);

        return this.element;
    };

    DateFieldNative.prototype.setValue = function (value, propagate, noValidate) {
        value = (value) ? value.trim() : "";
        if (value) {
            value = this.parseDate(value);
        }

        DateFieldNative.superClass.setValue.apply(this, [value, propagate, noValidate]);
        this.setFormValue();
    };

    DateFieldNative.prototype.parseDate = function (value) {
        if (value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
            return value;
        }

        if (value.match(/^\d\d\d\d-\d{1,2}-\d{1,2}\|\d\d:\d\d:\d\d$/)) {//Timestamp
            return value.substr(0, value.indexOf('|'));
        }

        return this.cast2UMDate(value);
    };

    /**
     * @param {String} raw value from form
     * @returns {String} proper UM date string
     */
    DateFieldNative.prototype.cast2UMDate = function (value) {
        var fTrans = DateFieldNative.dateFormatsTrans[this.formatKey];
        var pa = value.split(fTrans.s);

        return pa[fTrans.c.y] + "-" + pa[fTrans.c.m] + "-" + pa[fTrans.c.d];
    };

    /**
     * 
     * @returns {String} date in chosen form format
     */
    DateFieldNative.prototype.setFormValue = function () {
        if (!this.value)
            return;

        var fTrans = DateFieldNative.dateFormatsTrans[this.formatKey];
        var pa = this.value.split("-");

        this.formValue = pa[fTrans.u[0]] + fTrans.s + pa[fTrans.u[1]] + fTrans.s + pa[fTrans.u[2]];
    };


    // Make available the field type globally
    window.pinuts.fields.DateFieldNative = DateFieldNative;

    return DateFieldNative;
});

pirequire.define('fields/DisabledTextField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadDisabledTextField($, OO, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function DisabledTextField() {
        DisabledTextField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(DisabledTextField, Field);
    
    DisabledTextField.prototype.onChange = function (event) {
        //do nothing
    };
    
    DisabledTextField.prototype.validate = function () {
        //do nothing
    };
    
    // Make available the field type globally
    window.pinuts.fields.DisabledTextField = DisabledTextField;

    return DisabledTextField;
});

pirequire.define('fields/EmailConfirmField', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Captions'
], function loadEmailConfirmField($, OO, Field, Captions) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function EmailConfirmField() {
        EmailConfirmField.superConstructor.apply(this, arguments);
        this.validateConfirmField = false;
    }

    // Inherit fields/Field base class
    OO.extend(EmailConfirmField, Field);

    EmailConfirmField.prototype.setConfig = function (config) {
        EmailConfirmField.superClass.setConfig.apply(this, arguments);

        const self = this;
        this.formWidget.registerFormCallback("onSubmit", function() {
            self.validateConfirmField = true;
        });
    }

    EmailConfirmField.prototype.createConfirmErrorText = function () {

        const errorId = 'emailconfirm';
        const options = {};
        options.name = this.attributes.labelConfirmEmail;
        let msg = Captions.t("errors." + this.name + "." + errorId, options, this.formWidget.captions);
        if (!msg) msg = Captions.t("errors." + errorId, options, this.formWidget.captions);
        return  msg || errorId;
    };

    EmailConfirmField.prototype.toggleConfirmInputError = function (hasError, errorMsg) {
        const inputFieldId = this.elementId + '-confirm';
        const errorFieldId = "error_" + this.elementId + "-confirm";

        if (hasError) {
            this.element.find('#' + errorFieldId).html(errorMsg || '');
            this.element.find('#' + inputFieldId)
                .attr("aria-describedBy", errorFieldId)
                .attr("aria-invalid", "true");
            this.element.find('.pi-confirm-label').parent().toggleClass(this.formErrorClass, true);
        } else {
            this.element.find('#' + inputFieldId)
                .removeAttr("aria-describedBy")
                .attr("aria-invalid", "false");
            this.element.find('#' + errorFieldId).html('');
            this.element.find('.pi-confirm-label').parent().toggleClass(this.formErrorClass, false);
        }
    }

    EmailConfirmField.prototype.validate = function(noMandatory) {

        let mainError = EmailConfirmField.superClass.validate.apply(this, [noMandatory]);

        const inputFieldId = this.elementId + '-confirm';
        const errorFieldId = "error_" + this.elementId + "-confirm";

        if (!mainError && this.value) {
            if (this.validateConfirmField && this.value !== this.values[this.id + '-confirm']) {
                this.errorMsg = this.createConfirmErrorText();
                this.toggleConfirmInputError(true, this.errorMsg);
                // this.element.find('#' + errorFieldId).html(this.errorMsg || '');
                // this.element.find('#' + inputFieldId)
                //     .attr("aria-describedBy", errorFieldId)
                //     .attr("aria-invalid", "true");
                // this.element.find('.pi-confirm-label').parent().toggleClass(this.formErrorClass, true);
                mainError = true;
                this.error = mainError;
            }
        } else if (this.mandatory && this.validateConfirmField && !this.values[this.id + '-confirm']) {
            //mandatory check
            this.toggleConfirmInputError(true, this.createErrorText('notempty'));
            // this.element.find('#' + inputFieldId)
            //     .attr("aria-describedBy", errorFieldId)
            //     .attr("aria-invalid", "true");
            // this.element.find('.pi-confirm-label').parent().toggleClass(this.formErrorClass, true);
        } else {
            // no error
            this.toggleConfirmInputError(false, '');            
        }

        return mainError;
    }

    EmailConfirmField.prototype.onChange = function (event) {
        this.element.addClass('changed');
        if (window.pinuts.formIsEditClass[this.designSet]) {
            $('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
        }
        const inputId = $(event.target).attr('id');
        const inputVal = $(event.target).val();

        if (inputId === this.elementId + '-confirm' ) {
            this.values[this.id + '-confirm'] = inputVal;
            this.validateConfirmField = true;
            this.validate();
        } else {
            this.setValue(inputVal, true);
        }
    };

    // Make available the field type globally
    window.pinuts.fields.EmailConfirmField = EmailConfirmField;

    return EmailConfirmField;
});
pirequire.define('fields/FieldGroup', [
    'jquery',
    'lib/OO',
    'lib/Helper',
    'lib/Dependencies',
    'fields/Field',
    'lib/Captions'
], function loadFieldGroup($, OO, Helper, Dependencies, Field, Captions) {

    /**
     * A field which groups other fields
     *
     * @constructor
     */
    function FieldGroup() {
        FieldGroup.superConstructor.apply(this, arguments);
        this.fields = [];
        this.fieldObjects = [];
        this.errors = [];
        this.errorsMsg = [];
        this.error = null;
    }

    // Inherit fields/Field base class
    OO.extend(FieldGroup, Field);

    /**
     * Override Field.render function and render multiple fields in a group
     *
     * @returns {jQuery}
     */
    FieldGroup.prototype.render = function render() {
        this.element = FieldGroup.superClass.render.apply(this, arguments);

        var insertpoint = this.element.filter(".pigroup");
        if (!insertpoint || insertpoint.length === 0) insertpoint = this.element.find(".pigroup");
        if (!insertpoint || insertpoint.length === 0) insertpoint = this.element;

        this.values = this.formWidget.values;
        for (var i = 0; i < this.fields.length; i++) {
            var fieldConfig = this.fields[i];
            var field = this.getOrCreateField(fieldConfig);
            if (field) {
                Captions.setCaptions(this.formWidget.captions);//FIXME ugly!
                insertpoint.append(field.render());
            }
        }

        return this.element;
    };

    FieldGroup.prototype.getOrCreateField = function(fieldConfig) {
        for (var i = 0; i < this.fieldObjects.length; i++) {
            if (this.fieldObjects[i].id === fieldConfig.id) {
                return this.fieldObjects[i];
            }
        }

        // Check if class exists for field type and create field
        var field = Helper.createField(fieldConfig, this.formWidget);
        if (field) {
            Helper.observeValue(field, 'error', $.proxy(this.onErrorChange, this));
            this.fieldObjects.push(field);
            return field;
        }
    };

    FieldGroup.prototype.bindCallbacks = function (input) {
        //no callbacks
    };

    /**
     * Listen on changes of error's on fields within this fieldset
     *
     * @param field {object} The field object where the error status changed
     * @param path {string} The observed path
     */
    FieldGroup.prototype.onErrorChange = function onErrorChange(field, path) {
        var index = this.errors.indexOf(field.name);
        // Remove field from errors if there is no error but the field is still registered
        if (index !== -1) {
            this.errors.splice(index, 1);
            delete this.errorsMsg[field.name];
        }

        if (field.error) {
            this.errors.push(field.name);
            if (field.errorMsg) {
                this.errorsMsg[field.name] = {msg: field.errorMsg, label: field.getLabel()};
            }
        }
        // Show or hide error on tab entry
        this.error = !!this.errors.length;
    };


    FieldGroup.prototype.setNullValue = function() {
        for (var i = 0; i < this.fieldObjects.length; i++) {
            delete this.values[this.fieldObjects[i].name];
            this.formWidget.hiddens.push(this.fieldObjects[i].name);
        }
    };

    /**
     * Validate the fields within the field froup
     */
    FieldGroup.prototype.validate = function validate() {
        //TODO: marker für mandatory durchschleifen


        // Trigger the validation of all fields
        // The errors are catched within onErrorChange
        // Validate only if group is visible??
//        if (this.value && (!this.dependencies || !this.dependencies.length || Dependencies.checkDependencies(this))) {
        if (!this.dependencies || !this.dependencies.length || Dependencies.checkDependencies(this)) {
            for (var i = 0; i < this.fieldObjects.length; i++) {
                this.fieldObjects[i].validate();
            }
        } else {
            this.error = null;
            this.errors = [];
            this.errorsMsg = [];
            this.setNullValue();
        }

        return !!this.error;
    };


    FieldGroup.prototype.createErrorText = function (errorId, options) {
       //shuld never be used. see FormWidget::setFormErrors
    };


    // Make available the field type globally
    window.pinuts.fields.FieldGroup = FieldGroup;

    return FieldGroup;
});
pirequire.define('fields/FriendlyCaptcha', [
    'jquery',
    'lib/OO',
    'fields/Field',
], function loadFriendlyCaptcha($, OO, Field) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function FriendlyCaptcha() {
        FriendlyCaptcha.superConstructor.apply(this, arguments);

        this.myCustomWidget = null;
    }

    // Inherit fields/Field base class
    OO.extend(FriendlyCaptcha, Field);

    FriendlyCaptcha.prototype.setConfig = function (config) {
        config.isAnonymAttr = true
        return FriendlyCaptcha.superClass.setConfig.apply(this, arguments);
    }

    //for error msg
    FriendlyCaptcha.prototype.getLabel = function() {
        return "Friendly Captcha";
    };

    FriendlyCaptcha.prototype.getLanguage = function() {

        return this.langKey || this.locale;
    }

    FriendlyCaptcha.prototype.getPuzzleEndpoint = function() {
        return this.attributes.puzzleEndpoint || '';
    }

    FriendlyCaptcha.prototype.getSkipStyleInjection = function() {
        return this.attributes.skipStyleInjection === "true";
    }

    FriendlyCaptcha.prototype.getStartMode = function() {
        return this.attributes.startMode;
    }

    FriendlyCaptcha.prototype.setNullValue = function() {
       //never do this!
    };

    FriendlyCaptcha.prototype.validate = function () {
        if (window.friendlyChallenge) {//validate only if friendlyChallenge is really there
            return FriendlyCaptcha.superClass.validate.apply(this, arguments);
        }
    };

    FriendlyCaptcha.prototype.render = function() {
        var self = this;

        const capConfig = {
            sitekey: self.attributes.siteKey,
            language: self.getLanguage(),
            skipStyleInjection: self.getSkipStyleInjection(),
            startMode: self.getStartMode(),
            doneCallback: function(friendlyCaptchaResponse) {
                self.setValue(friendlyCaptchaResponse, true, false);
            },
        }

        if (this.getPuzzleEndpoint()) {
            capConfig.puzzleEndpoint = this.getPuzzleEndpoint();
        }

        function renderCaptcha(wait, stopIdx) {
            setTimeout(function() {
                if (window.friendlyChallenge && window.friendlyChallenge.WidgetInstance) {
                    const element = document.querySelector("#friendlyCaptcha" + self.formWidget.widgetId);
                    self.myCustomWidget = new window.friendlyChallenge.WidgetInstance(element, capConfig)
                    $(element).addClass('frc-captcha');
                } else if (stopIdx < 15) {
                    renderCaptcha(wait, ++stopIdx);
                } else {
                    console.error('PiForm: Cannot be render Friendly Captcha. Missing the Friendly Captcha API Code. Please check the configuration.')
                }
            }, wait);
        }

        this.formWidget.registerFormCallback("onRender", function() {
            var wait = (window.friendlyChallenge) ? 0 : 100;
            renderCaptcha(wait, 0);
        });

        this.formWidget.registerFormCallback("onFormReturn", function() {
            if (self.myCustomWidget && self.myCustomWidget.reset) {
                self.myCustomWidget.reset();
            }
        });

        const cssClasses = ["pi-form-control"];

        if (this.attributes.cssClass) {
            cssClasses.push(this.attributes.cssClass)
        }

        if (this.attributes.darkMode) {
            cssClasses.push(this.attributes.darkMode);
        }

        //element must be set and visible, for validation
        var divAttributes = {
            id: "friendlyCaptcha" + this.formWidget.widgetId,
            class: cssClasses.join(' '),
        };

        this.element = $("<div/>", divAttributes);

        return this.element;
    }

    // Make available the field type globally
    window.pinuts.fields.FriendlyCaptcha = FriendlyCaptcha;

    return FriendlyCaptcha;
})

;
pirequire.define("fields/FriendlyCaptcha", function(){});

pirequire.define('fields/HiddenField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadHiddenField($, OO, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function HiddenField() {
        HiddenField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(HiddenField, Field);
    
    HiddenField.prototype.validate = function () {
        //do nothing 
    };
    
    // Make available the field type globally
    window.pinuts.fields.HiddenField = HiddenField;

    return HiddenField;
});

pirequire.define('fields/SelectField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadSelectField($, OO, Field) {

    /**
     * A field containing a select input
     *
     * @constructor
     */
    function SelectField() {
        SelectField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(SelectField, Field);
    
    SelectField.prototype.render = function () {
        SelectField.superClass.render.apply(this, arguments);
        //set select init value: need this when no value is set but select box has no empty value
        var value = $(this.element.find("select")).val();
        if (value && (value !== "__" || value !== "_")) {
            this.setValue(value, true, true);
        }
       
        return this.element;
    };
    
    SelectField.prototype.setValue = function (value, propagate, noValidate) {
        if (value === "__" || value === "_") {
            value = null;
        }

        SelectField.superClass.setValue.apply(this, [value, propagate, noValidate]);
    };
    
    // Make available the field type globally
    window.pinuts.fields.SelectField = SelectField;

    return SelectField;
});
pirequire.define('fields/MultiSelectField', [
    'jquery',    
    'lib/OO',
    'fields/SelectField'
], function loadMultiSelectField($, OO, SelectField) {

    /**
     * A field containing a multi select input.
     *
     * @constructor
     */
    function MultiSelectField() {
        MultiSelectField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base classs
    OO.extend(MultiSelectField, SelectField);

    // Make available the field type globally
    window.pinuts.fields.MultiSelectField = MultiSelectField;

    return MultiSelectField;
});
pirequire.define('fields/TplField', [
    'jquery',
    'lib/OO',
    'fields/Field',
    "lib/Helper"
], function loadTextField($, OO, Field, Helper) {

    /**
     * A field to adding a passive template, withput any buisness logic 
     *
     * @constructor
     */
    function TplField() {
        TplField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(TplField, Field);


    TplField.prototype.onChange = function (event) {
        //do nothing
    };
    
    TplField.prototype.validate = function () {
        //do nothing 
    };

    TplField.prototype.toggleErrorClass = function () {
        //do nothing
    };

    // Make available the field type globally
    window.pinuts.fields.TplField = TplField;

    return TplField;
});

pirequire.define('fields/Nothing', [
    'jquery',
    'lib/OO',
    'fields/TplField',
    "lib/Helper"
], function loadNothing($, OO, TplField, Helper) {

    /**
     * A dummy field that do noting
     *
     * @constructor
     */
    function Nothing() {
        Nothing.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(Nothing, TplField);


    Nothing.prototype.render = function (event) {
        //do nothing
    };

    // Make available the field type globally
    window.pinuts.fields.Nothing = Nothing;

    return Nothing;
});
pirequire.define('fields/PasswordField', [
    'jquery',
    'lib/OO',
    'lib/Helper',
    'fields/Field'
], function loadPasswordField($, OO, Helper, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function PasswordField() {
        PasswordField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(PasswordField, Field);

    PasswordField.prototype.onChange = function (event) {
        var elementId = this.elementId;
        var name = this.name;

        var value = ($(event.target).val()).trim();

        if ($(event.target).attr("id") === this.elementId + "_2") {
            name += "_2";
            this.pw1 = value;
        } else {
            this.value = value;
            this.pw2 = value;
        }

        this.element.find("div[data-pi-id=" + name + "]").addClass('changed');

        if (this.pw1 && this.pw2 && !this.validate()) {
            Helper.setValueByPath(this.values, this.name + "_2", this.pw2);
            Helper.setValueByPath(this.values, this.name, this.pw1);

            if (window.pinuts.formIsEditClass[this.designSet]) {
                this.element.find('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
            }
        }
    };

    // Make available the field type globally
    window.pinuts.fields.PasswordField = PasswordField;

    return PasswordField;
});

pirequire.define('fields/PasswordLoginField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadPasswordLoginField($, OO, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function PasswordLoginField() {
        PasswordLoginField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/TextField class
    OO.extend(PasswordLoginField, Field);

    // Make available the field type globally
    window.pinuts.fields.PasswordLoginField = PasswordLoginField;

    return PasswordLoginField;
});
pirequire.define('fields/TextField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadTextField($, OO, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function TextField() {
        TextField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(TextField, Field);

    // Make available the field type globally
    window.pinuts.fields.TextField = TextField;

    return TextField;
});
pirequire.define('fields/Pino4Field', [
    'jquery',
    'lib/OO',
    'fields/TextField'
], function loadTextField($, OO, TextField) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function Pino4Field() {
        Pino4Field.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(Pino4Field, TextField);

    Pino4Field.prototype.render = function () {
        Pino4Field.superClass.render.apply(this, arguments);
        // alles verstecken. Workaround, für UM-1202 Refused to apply inline style
        this.element.find('.pi-form-label').parent().hide();

        return this.element;
    }

    Pino4Field.prototype.onChange = function (event) {
        if ($(event.target).val()) 
            this.values[$(event.target).attr('name')] = $(event.target).val();

        this.setValue(this.pinoid, true);
    };

    Pino4Field.prototype.setConfig = function (config) {
        Pino4Field.superClass.setConfig.apply(this, arguments);
        
        var self = this;
        this.formWidget.registerFormCallback("onRender", function() {
            self.setValue(this.pinoid, true);
        });
        
        this.formWidget.registerFormCallback("onSubmit", function() {
           self.element.find('input').trigger("change");
       });
    };
    
    Pino4Field.prototype.validate = function () {
        
    };
    
    // Make available the field type globally
    window.pinuts.fields.Pino4Field = Pino4Field;

    return TextField;
});
pirequire.define('fields/RadioField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function ($, OO, Field) {

    /**
     * A field containing multiple inputs with type radio
     *
     * @constructor
     */
    function RadioField() {
        RadioField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(RadioField, Field);

    RadioField.prototype.setConfig = function (config) {
        RadioField.superClass.setConfig.apply(this, arguments);

        this.cssClass = (this.display && this.display === 'vertical') ? "pi-radio-control-vertical" : "pi-radio-control";
    };

    RadioField.prototype.onChange = function (event) {
        this.element.addClass('changed');
        if (window.pinuts.formIsEditClass[this.designSet]) {
            $('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
        }

        var val = this.element.find("input[type=radio]:checked").val();
        this.setValue(val, true);
    };

    RadioField.prototype.toggleErrorClass = function (toggel) {       
        RadioField.superClass.toggleErrorClass.apply(this, arguments);
        var $cb =  this.element.find('input[id^=' + this.elementId + ']');
        $cb.attr("aria-invalid", toggel ? "true" : "false");
        if (toggel) {
            $cb.attr("aria-describedBy", "error_" + this.elementId);
        } else {
            $cb.removeAttr("aria-describedBy");
        }      
    };

    // Make available the field type globally
    window.pinuts.fields.RadioField = RadioField;

    return RadioField;
});

pirequire.define('fields/ReCaptchaV2', [
    'jquery',
    'lib/OO',
    'fields/Field',
], function loadReCaptchaV2($, OO, Field) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd 
     *
     * @constructor
     */
    function ReCaptchaV2() {
        ReCaptchaV2.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(ReCaptchaV2, Field);

    ReCaptchaV2.prototype.setConfig = function (config) {
        config.isAnonymAttr = true
        return ReCaptchaV2.superClass.setConfig.apply(this, arguments);
    }

    //for error msg
    ReCaptchaV2.prototype.getLabel = function () {
        return "Google Captcha";
    };

    ReCaptchaV2.prototype.setNullValue = function() {
        //never do this!
    };

    ReCaptchaV2.prototype.validate = function () {
        if (window.grecaptcha) {//validate only if grecaptcha is really there
            return ReCaptchaV2.superClass.validate.apply(this, arguments);
        }
    };


    ReCaptchaV2.prototype.render = function () {
        var self = this;
        window["submit" + this.formWidget.widgetId] = function (gReCaptchaV2Response) {
            self.setValue(gReCaptchaV2Response, true);
        };

        window["expired" + this.formWidget.widgetId] = function () {
            self.setValue(null, true);
        };

        function renderCaptcha(wait, stopIdx) {
            setTimeout(function () {
                if (window.grecaptcha && window.grecaptcha.render) {
                    self.opt_widget_id = window.grecaptcha.render('recaptcha' + self.formWidget.widgetId, {
                        'sitekey': self.attributes.siteKey,
                        'callback': "submit" + self.formWidget.widgetId,
                        'expired-callback': "expired" + self.formWidget.widgetId,
                        'size': self.attributes.size,
                        'theme': self.attributes.theme
                    });
                } else if (stopIdx < 15) {
                    renderCaptcha(100, ++stopIdx);
                } else {
                    console.error('PiForm: Cannot be render ReCaptcha. Missing the Google API Code. Please check the configuration.')
                }
            }, wait);
        }

        this.formWidget.registerFormCallback("serverSideValidationFailed", function () {
            if (window.grecaptcha) {
                window.grecaptcha.reset(self.opt_widget_id);
                self.setValue(null, true);
            }
        });
        
        this.formWidget.registerFormCallback("onRender", function () {
            var wait = (window.grecaptcha) ? 0 : 100;
            renderCaptcha(wait, 0);
        });

        //element must be set and visible, for validation
        var divAttributes = {id: "recaptcha" + this.formWidget.widgetId};
        if (this.attributes.cssClass) divAttributes.class = this.attributes.cssClass;
        this.element = $("<div/>", divAttributes);
        return this.element;
    };

    // Make available the field type globally
    window.pinuts.fields.ReCaptchaV2 = ReCaptchaV2;

    return ReCaptchaV2;
});
pirequire.define("fields/ReCaptchaV2", function(){});

pirequire.define('fields/StringField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadStringField($, OO, Field) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function StringField() {
        StringField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(StringField, Field);

    // Make available the field type globally
    window.pinuts.fields.StringField = StringField;

    return StringField;
});

pirequire.define('fields/TextareaField', [
    'jquery',
    'lib/OO',
    'fields/Field'    
], function loadTextareaField($, OO, Field, template) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function TextareaField() {
        TextareaField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(TextareaField, Field);

    // Make available the field type globally
    window.pinuts.fields.TextareaField = TextareaField;

    return TextareaField;
});
// Pinuts File Encoding: UTF-8 
pirequire.define('fields/TimeField', [
    'jquery',
    'lib/OO',
    'fields/DateField'
], function loadTimeField($, OO, DateField) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM time format: yyyy-mm-dd|hh-mm-ss
     *
     * @constructor
     */
    function TimeField() {
        TimeField.superConstructor.apply(this, arguments);

        this.format_time = "hh:mm";
        this.formValue;
        this.formValueTime;
    }

    TimeField.regional = {
        de: {
            timeOnlyTitle: 'Zeit wählen',
            timeText: 'Zeit',
            hourText: 'Stunde',
            minuteText: 'Minute',
            secondText: 'Sekunde',
            millisecText: 'Millisekunde',
            microsecText: 'Mikrosekunde',
            timezoneText: 'Zeitzone',
            currentText: 'Jetzt',
            closeText: 'Übernehmen',
            timeFormat: 'HH:mm:ss',
            amNames: ['vorm.', 'AM', 'A'],
            pmNames: ['nachm.', 'PM', 'P'],
            isRTL: false
        }
    };

    // Inherit fields/Field base class
    OO.extend(TimeField, DateField);

    TimeField.prototype.parseDate = function (value) {
        if (value.match(/^\d\d\d\d-\d{1,2}-\d{1,2}\|\d\d:\d\d:\d\d$/)) {//Timestamp
            return value;
        }

        if (value.match(/^\d\d\d\d-\d\d-\d\d$/)) {//Date
            return value + "|00:00:00";
        }

        return this.cast2UMDate(value);
    };
    
    
    /**
     * 
     * @returns {String} date in chosen form format
     */
    TimeField.prototype.setFormValue = function () {
        if (!this.value)
            return;

        var fTrans = DateField.dateFormatsTrans[this.formatKey];
        var t = this.value.split("|");
        var pa = t[0].split("-");
        var ta = t[1].split(":");
        
        this.formValue = pa[fTrans.u[0]] + fTrans.s + pa[fTrans.u[1]] + fTrans.s + pa[fTrans.u[2]];
        this.formValueTime = ta[0] + ":" + ta[1];
    };
    
    
    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    TimeField.prototype.onChange = function (event) {
        this.element.addClass('changed');
        if (window.pinuts.formIsEditClass[this.designSet]) {
            $('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
        }
        var date = this.element.find("#" + this.elementId).val();
        var time = this.element.find("#pitime_" + this.elementId).val();
        if (!date) {
            return;//no date, do nothing
        }

        date = this.cast2UMDate(date);

        this.setValue(date + "|" + time + ":00", true);
    };

    TimeField.prototype.initPicker = function () {
        var self = this;
        pirequire.require(['jquery-timepicker'], function () {
            if (TimeField.regional[self.formatKey]) {
                $.datepicker.setDefaults(DateField.regional[self.formatKey]);
                $.timepicker.setDefaults(TimeField.regional[self.formatKey]);
            }

            var conf = self.getDatepickerConf();
            conf.altField = self.element.find("#pitime_" + self.elementId);//yes, need here the $-Element, id dont work
            conf.altTimeFormat = conf.timeFormat = "HH:mm";
            self.element.find("#" + self.elementId).datetimepicker(conf);
        });
    };

    // Make available the field type globally
    window.pinuts.fields.TimeField = TimeField;

    return TimeField;
});


// Pinuts File Encoding: UTF-8 
pirequire.define('fields/TimeFieldNative', [
    'jquery',
    'lib/OO',
    'lib/Helper',
    'fields/DateFieldNative'
], function loadTimeFieldN($, OO, Helper, DateFieldNative) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM time format: yyyy-mm-dd|hh-mm-ss
     *
     * Note: the entire date formatting is only needed for the free text field. The HTML5 date input element always has the format yyyy-mm-dd hh:mm
     *
     * @constructor
     */
    function TimeFieldNative() {
        TimeFieldNative.superConstructor.apply(this, arguments);

        this.format_time = "hh:mm";
        this.formValue;
        this.formValueTime;

        this.noPickerTpl = Helper.getTemplate('TimeField', this.designSet);
    }


    // Inherit fields/Field base class
    OO.extend(TimeFieldNative, DateFieldNative);


    TimeFieldNative.prototype.render = function (config) {
        if (!this.isPicker) {
            this.template = this.noPickerTpl;
        }

        TimeFieldNative.superClass.render.apply(this, arguments);

        return this.element;
    }

    TimeFieldNative.prototype.parseDate = function (value) {
        if (value.match(/^\d\d\d\d-\d{1,2}-\d{1,2}\|\d\d:\d\d:\d\d$/)) {//Timestamp
            return value;
        }

        if (value.match(/^\d\d\d\d-\d\d-\d\d$/)) {//Date
            return value + "|00:00:00";
        }

        return this.cast2UMDate(value);
    };
    
    
    /**
     * 
     * @returns {String} date in chosen form format
     */
    TimeFieldNative.prototype.setFormValue = function () {
        if (!this.value)
            return;

        var fTrans = DateFieldNative.dateFormatsTrans[this.formatKey];
        var t = this.value.split("|");
        var pa = t[0].split("-");
        var ta = t[1].split(":");
        
        this.formValue = pa[fTrans.u[0]] + fTrans.s + pa[fTrans.u[1]] + fTrans.s + pa[fTrans.u[2]];
        this.formValueTime = ta[0] + ":" + ta[1];
    };
    
    
    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    TimeFieldNative.prototype.onChange = function (event) {
        this.element.addClass('changed');
        if (window.pinuts.formIsEditClass[this.designSet]) {
            $('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
        }

        var dateInput = this.element.find("#" + this.elementId).val();

        if (!dateInput) {
            return;//no date, do nothing
        }

        let date, time;
        if (dateInput.match(/^\d\d\d\d-\d\d-\d\dT\d\d:\d\d/)) {
            [date, time] = dateInput.split("T");
        } else {
            time = this.element.find("#pitime_" + this.elementId).val();
            date = this.cast2UMDate(dateInput);
        }

        this.setValue(date + "|" + time + ":00", true);
    };


    // Make available the field type globally
    window.pinuts.fields.TimeFieldNative = TimeFieldNative;

    return TimeFieldNative;
});


pirequire.define('fields/UploadField', [
    'jquery',
    'lib/OO',
    'fields/Field',
    "lib/Helper"
], function loadTextField($, OO, Field, Helper) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function UploadField() {
        UploadField.superConstructor.apply(this, arguments);

        this.files = [];
        this.hasAddEventListner = false;
    }

    // Inherit fields/Field base class
    OO.extend(UploadField, Field);

    UploadField.prototype.setConfig = function (config) {
        UploadField.superClass.setConfig.apply(this, arguments);

        this.templateUploadFileInfo = Helper.getTemplate('UploadFileinfo', this.designSet);
    };


    UploadField.prototype.setValue = function () {};

    UploadField.prototype.refreshValue = function () {
        var val = '';
        if (this.files.length > 0) {
            for (var idx in this.files) {
                val += this.files[idx].ticket + ' ';
            }          
        }
        this.value = val;
        Helper.setValueByPath(this.values, this.name, this.value);
    };
    /**
     * Adds a file entry to the upload list.
     */
    UploadField.prototype.__addToFileList = function (file) {
        this.files.push(file);
        this.$fileList.append(this.templateUploadFileInfo(file));

        if (this.files.length >= this.maxNumberOfFiles) {
            $('iframe', this.$uploadContainer).hide();
        }
        this.refreshValue();
    };


    /**
     * Removes the specified file from the list of uploaded files.
     */
    UploadField.prototype.__deleteFileFromList = function (ticket) {
        for (var idx in this.files) {
            if (this.files[idx].ticket == ticket) {
                this.files.splice(idx, 1);
                $('#upload-' + ticket).remove();
                $('iframe', this.$uploadContainer).show();
                this.refreshValue();
                return;
            }
        }
    };

    //FIXME helpText richtig machen!
    UploadField.prototype.render = function () {
        this.uploadIframeUrlQuery = this.formWidget.uploadIframeUrl
                + "?name=" + encodeURIComponent(this.formWidget.addOnName)
                + '&locale=' + encodeURIComponent(this.formWidget.locale)
                + '&attrName=' + encodeURIComponent(this.name);


        UploadField.superClass.render.apply(this, arguments);
        var element = $(this.template(this));

        this.$uploadContainer = $(".upload-container", this.element);
        this.$fileList = $('.upload-filelist', this.element);

        var self = this;

        var onMessage = function (data) {
            if (data.attrName != self.name)
                return;

            if (data.file) {
                self.__addToFileList(data.file);
            } else if (data.error) {
                alert(data.error);
            }
        };

        if (!this.hasAddEventListner) {
            if (window.addEventListener) {
                function hanldeIframeMessage (evtOrg) {                  
                    var evt = evtOrg.originalEvent;
                    if (evt.data == 'upload-started') {
                        self.formWidget.disableButtons();
                    } else if (evt.data && typeof evt.data == "string") {
                        self.formWidget.enableButtons();
                        var jData;
                        try {
                            jData = JSON.parse(evt.data);
                            onMessage(jData);
                        } catch (ex) {
                            return;
                        }
                    }
                };
                
                $(window).on('message', hanldeIframeMessage);
            } else {
                // IE 8 / 9:
                window.attachEvent("onmessage", function(evt) {
                    if (evt.data == 'upload-started') {
                        self.formWidget.disableButtons();
                    } else if (evt.data && typeof evt.data == "string") {
                        self.formWidget.enableButtons();
                        var jData;
                        try {
                            jData = JSON.parse(evt.data);
                            onMessage(jData);
                        } catch (ex) {
                            return;
                        }
                    }
                });
            }
            this.hasAddEventListner = true;
        }

        this.$uploadContainer.off('click', '.upload-delete-file');
        this.$uploadContainer.on('click', '.upload-delete-file', function (evt) {
            evt.preventDefault();
            self.__deleteFileFromList($(this).attr('data-ticket'));
        });

        this.files = [];
        this.refreshValue();

        return this.element;
    };


    // Make available the field type globally
    window.pinuts.fields.UploadField = UploadField;

    return UploadField;
});

//Field.prototype.render = function () {
//        if (!this.template) {
//            throw new Error('Missing template');
//        }
//        var element = $(this.template(this));
//        if (this.element) {
//            this.element.replaceWith(element);
//        }
//        this.element = element;
//        this.bindCallbacks(this.element.find('input, select, textarea'));
//        // Pre check if this field can be shown or not
//        if (this.dependencies && this.dependencies.length) {
//            if (Dependencies.checkDependencies(this)) {
//                this.element.show();
//            } else {
//                this.element.hide();
//            }
//        }
//
//        return element;
//    };
pirequire.define('fields/UploadField2', [
    'jquery',
    'lib/OO',
    'fields/Field',
    "lib/Helper"
], function loadUploadField2($, OO, Field, Helper) {

    /**
     * A field containing a input with type text
     *
     */
    function UploadField2() {
        UploadField2.superConstructor.apply(this, arguments);

        this.value = [];
        //FIXME baruchen wir das feature? this.allowDoubleFileNames = false;
    }
    
    // Inherit fields/Field base class
    OO.extend(UploadField2, Field);
    
    
    UploadField2.prototype.setConfig = function() {
        UploadField2.superClass.setConfig.apply(this, arguments);
        this.templateUploadFileInfo = Helper.getTemplate('UploadFileinfo2', this.designSet);
    };


    UploadField2.prototype.setValue = function() { };


    UploadField2.prototype.refreshValue = function() {
        this.maxFilesAllowed();
        Helper.setValueByPath(this.values, this.name, this.value);
    };

    
    UploadField2.prototype.resetError = function() {
        this.error = false;
        this.errorMsg = null;
        this.toggleErrorClass(false);
        this.element.find('.pi-form-error').html('');
    };


    UploadField2.prototype.setError = function(errorMsg) {
        this.error = "uploaderror"
        this.errorMsg = errorMsg;
        this.toggleErrorClass(true);
        this.element.find('.pi-form-error').html(errorMsg);
    };


    UploadField2.prototype.blockForm = function() {
        this.element.find('.pi-spinner').show();
        this.formWidget.disableButtons();
    };


    UploadField2.prototype.unBlockForm = function() {
        this.element.find('.pi-spinner').hide();
        this.formWidget.enableButtons();
    };


    UploadField2.prototype.uploadFile = function(file) {
        this.blockForm();

        var formData = new FormData();
        formData.append('name', this.formWidget.addOnName);
        formData.append('locale', this.formWidget.locale);
        formData.append('attrName', this.name);
        formData.append('file', file);

        var self = this;

        var url = this.formWidget.uploadAttachmentUrl;

        if (url.indexOf('?') === -1) {
            url += '?name=' + encodeURIComponent(this.formWidget.addOnName);
        }

        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-Safe': 'yes'
            },
            success: function(response) {
                if (response.success && self.maxFilesAllowed()) {
                    self.resetError.apply(self);
                    const uploadedFile = response.data.file;
                    self.addFileToList.apply(self, [uploadedFile]);
                } else {
                    self.setError(response.data.error || "Upload failed");
                }
                self.unBlockForm();
            },
            error: self.formWidget.onSubmitError.bind(self.formWidget)
        });
    };


    UploadField2.prototype.maxFilesAllowed = function() {
        if (this.value.length >= this.maxNumberOfFiles) {
            this.$uploadContainer.hide();
            return false;
        } else {
            this.$uploadContainer.show();
            return true;
        }
    };


    UploadField2.prototype.addFileToList = function(file) {
        var fileList = $(this.templateUploadFileInfo(file));
        var $deleteLink = fileList.find(".delicon");
        $deleteLink.on("click", this.deleteFileFromList.bind(this));

        this.$fileListAnchor.append(fileList);
        this.value.push(file.ticket);
        this.refreshValue();
    };


    UploadField2.prototype.deleteFileFromList = function(event) {
        event.preventDefault();
        var ticket = event.currentTarget.dataset.ticket;
        this.$fileListAnchor.find("#upload-" + ticket).remove();

        this.value = this.value.filter(function(element) {
            return element !== ticket;
        });

        this.refreshValue();
    };
    
    
    UploadField2.prototype.render = function() {
        var $element = UploadField2.superClass.render.apply(this, arguments);

        this.$uploadContainer = $element.find(".upload2-container");
        this.$uploadInput = $element.find(".upload2-input");
        this.$fileListAnchor = $element.find(".upload-filelist");

        var self = this;

        if (this.values && this.values.upload_files) {
            this.values.upload_files.forEach(function(upload) {
                if (upload.attrId === self.name) {
                    self.addFileToList(upload.upload, upload.attrId);
                }
            });
        }

        this.onUploadEvent = function(event) {
            var files = event.target.files
            if (files.length > 0) {
                for (var i = 0; i < files.length; i++) {
                    self.uploadFile(files[i]);
                }
            }

            $(event.target).val("");
        };

        this.$uploadInput.on("change", this.onUploadEvent.bind(this));

        return $element;
    };


    // Make available the field type globally
    window.pinuts.fields.UploadField2 = UploadField2;

    return UploadField2;
});

pirequire.define('lib/helpers/and', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper checks if both values are true
     * 
     */
   function and(a, b, options) {
        if (a && b) {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    // Register helper
    Handlebars.registerHelper('and', and);

    return and;
});
pirequire.define('lib/helpers/caption', [
    'handlebars',
    'lib/Captions'
], function loadHandlebarsHelper(Handlebars, Captions) {

    /**
     * This helper gets a translation for a specific path / key.
     * The path looks like normal property access path where properties are separated by a dot
     * Also the path value can consist of multiple path parts passed to that helper
     *
     * Usage:
     *  You can use this function in a single line by just returning the localized value
     *  or if no translation found return nothing
     *  {{i18n "test.translation" dynamicValue "label"}}
     *
     *  Or you can use it with content which only is rendered if a translation is available.
     *  To use the localized value access the variable "translation" inside the body.
     *  {{#i18n "test.translation" dynamicValue "description"}}
     *      <p class="come-content">
     *          {{translation}}
     *      </p>
     *  {{/i18n}}
     */
    function caption() {
        var key = '';
        var options = null;
        // Create i18n key from parameters
        for (var i = 0; i < arguments.length; i++) {
            if (typeof arguments[i] == 'string') {
                key += key ? '.' : '';
                key += arguments[i];
            }
            else {
                options = arguments[i];
                break;
            }
        }
        // Get translation for key
        var text = Captions.t(key);
      
        // Render content if content and translation is available
        if (options && options.fn && text) {
            return options.fn({text: text});
        }
        return text;
    }

    // Register helper
    Handlebars.registerHelper('caption', caption);

    return caption;
});

pirequire.define('lib/helpers/captionNoTags', [
    'handlebars',
    'lib/Captions',
    'jquery'
], function loadHandlebarsHelper(Handlebars, Captions, $) {

    /**
     * This helper gets a translation for a specific path / key.
     * The path looks like normal property access path where properties are separated by a dot
     * Also the path value can consist of multiple path parts passed to that helper
     *
     * Usage:
     *  You can use this function in a single line by just returning the localized value
     *  or if no translation found return nothing
     *  {{i18n "test.translation" dynamicValue "label"}}
     *
     *  Or you can use it with content which only is rendered if a translation is available.
     *  To use the localized value access the variable "translation" inside the body.
     *  {{#i18n "test.translation" dynamicValue "description"}}
     *      <p class="come-content">
     *          {{translation}}
     *      </p>
     *  {{/i18n}}
     */
    function captionNoTags() {
        var key = '';
        var options = null;
        // Create i18n key from parameters
        for (var i = 0; i < arguments.length; i++) {
            if (typeof arguments[i] == 'string') {
                key += key ? '.' : '';
                key += arguments[i];
            }
            else {
                options = arguments[i];
                break;
            }
        }
        // Get translation for key
        var text = Captions.t(key);

        // Render content if content and translation is available
        if (options && options.fn && text) {
            return options.fn({text: text});
        }

        text = text.replace(/<\/?[^>]+(>|$)/g, " ")
        return $("<div>" + text + "</div>").text()
    }

    // Register helper
    Handlebars.registerHelper('captionNoTags', captionNoTags);

    return captionNoTags;
});

pirequire.define('lib/helpers/contains', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper checks if a needle is in given array/string using indexOf method
     *
     * Usage: {{#contains arr key}}yes{{/contains}}
     */
    function contains(array, needle, options) {
        if (array && array.indexOf(needle) !== -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    // Register helper
    Handlebars.registerHelper('contains', contains);

    return contains;
});
pirequire.define('lib/helpers/dynamicPartial', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * Helper to render a template within a variable
     *
     * Usage: {{dynamicPartial snippet}}
     */
    function dynamicPartial(template, options) {
        options.depths = options.depths || [];
        options.depths.push(options.data.root);

        var compiled = Handlebars.compile(template);
        return compiled(this, options);
    }

    // Register helper
    Handlebars.registerHelper('dynamicPartial', dynamicPartial);

    return dynamicPartial;
});
pirequire.define('lib/helpers/has', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper checks if a object has the searched property set
     *
     * Usage: {{#has obj "property"}}yes{{/has}}
     */
   function has(object, needle, options) {
        if (object && typeof object[needle] !== 'undefined') {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    // Register helper
    Handlebars.registerHelper('has', has);

    return has;
});
pirequire.define('lib/helpers/ifCond', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {
    Handlebars.registerHelper('ifCond', function (lvalue, operator, rvalue, options) {

        var operators, result;
        if (arguments.length < 3) {
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        }
        if (options === undefined) {
            options = rvalue;
            rvalue = operator;
            operator = "===";
        }
        operators = {
            '==': function (l, r) { return l == r; },
            '===': function (l, r) { return l === r; },
            '!=': function (l, r) { return l != r; },
            '!==': function (l, r) { return l !== r; },
            '<': function (l, r) { return l < r; },
            '>': function (l, r) { return l > r; },
            '<=': function (l, r) { return l <= r; },
            '>=': function (l, r) { return l >= r; },
            'typeof': function (l, r) { return typeof l == r; }
        };
        if (!operators[operator]) {
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        }
        result = operators[operator](lvalue, rvalue);

        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
});
pirequire.define('lib/helpers/ifContains', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper checks whether value is contained in haystack.
     */
    function ifContains(value, haystack, options) {
        if (haystack && (typeof haystack !== 'object' || haystack.length === undefined)) {
            if (typeof console !== "undefined" && console.log) console.log("Warning: Input for ifContains not a array:", haystack); 
        }
        if (haystack && haystack.indexOf(value) > -1) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    }

    // Register helper
    Handlebars.registerHelper('ifContains', ifContains);

    return ifContains;
});
pirequire.define('lib/helpers/ifEq', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper compares two values to there not type safe equality.
     * If the values are equal it renders the body of the helper
     */
    function ifEq(value1, value2, options) {
        if (value1 == value2) {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    // Register helper
    Handlebars.registerHelper('ifEq', ifEq);

    return ifEq;
});
pirequire.define('lib/helpers/ifNot', [
    'handlebars'
], function loadHandlebarsHelper(Handlebars) {

    /**
     * This helper checks if the value is not true and renders the body if so.
     */
    function ifNot(value, options) {
        if (!value) {
            return options.fn(this);
        }
        return options.inverse(this);
    }

    // Register helper
    Handlebars.registerHelper('ifNot', ifNot);

    return ifNot;
});
pirequire.define('lib/helpers/valByPath', [
    'handlebars',
    'lib/Helper'
], function loadHandlebarsHelper(Handlebars, Helper) {

    /**
     * This helper gets a value of a property from an object by path definition
     * The path looks like normal property access path where properties are separated by a dot
     * Also the path value can consist of multiple path parts passed to that helper
     *
     * Usage: {{valByPath dataObj "test.property" dynamicValue "id"}}
     */
    function valByPath(object) {
        var pathParts = Array.prototype.slice.call(arguments, 1, -1);
        var path = pathParts.join('.');

        return Helper.getValueByPath(object, path);
    }

    // Register helper
    Handlebars.registerHelper('valByPath', valByPath);

    return valByPath;
});

pirequire.define("piform", function(){});
pirequire.define('fields/ConsentGroup', [
    'jquery',
    'lib/OO',
    'lib/Helper',
    'lib/Dependencies',
    'fields/Field'
], function loadConsentGroup($, OO, Helper, Dependencies, Field) {

    function ConsentGroup() {
        ConsentGroup.superConstructor.apply(this, arguments);
    }


    // Inherit fields/Field base class
    OO.extend(ConsentGroup, Field);


    ConsentGroup.prototype.render = function render() {
        //init values false, if not set
        this.value = this.value || {};
        this.checkedBoxes = [];
        var values = {};
        for (var attrId in this.attributes.consentFields) {
            values[attrId] = this.value[attrId] || false;
            if (values[attrId]) this.checkedBoxes.push(attrId);
        }

        this.setValue(values, true, true);

        this.element = ConsentGroup.superClass.render.apply(this, arguments);
        this.element.find("input[type=checkbox]").on("change", this.onChangeConsentValue.bind(this));

        return this.element;
    };


    ConsentGroup.prototype.setConfig = function setConfig(config) {
        ConsentGroup.superClass.setConfig.apply(this, arguments);
        //leagacy mapping configWizard/configWizard2
        for (var attrId in this.attributes.consentFields) {
            var attrConf = this.attributes.consentFields[attrId];
            if (!attrConf.value && attrConf.name) {
                attrConf.value = attrConf.name;
            }
        }
        this.optOutAttr = this.passthrough.optOutAttr;
    };

    // noinspection JSUnusedGlobalSymbols
    ConsentGroup.prototype.loadMandatory = function() {
        //set mandatory
        if (this.attributes.mandatory === "true" || this.attributes.mandatory === true) {
            this.mandatory = true;
            this.validation = this.validation || [];
            this.validation.push("consentGroupNotempty");
        }
    };

    // noinspection JSUnusedGlobalSymbols
    ConsentGroup.prototype.onChange = function(event) {
        //do nothing
    };

    ConsentGroup.prototype.onChangeConsentValue = function(event) {
        // If optOut is set, no other checkbox should be set.
        // If another checkbox is set, optOut should not be set.
        var thisId = $(event.target).val();
        if (thisId === this.optOutAttr) {
            var thisValue = $(event.target).prop("checked");
            this.element.find("input[type=checkbox]").prop("checked", false);
            $(event.target).prop("checked", thisValue);
        } else {
            this.element.find("input[type=checkbox][value=" + this.optOutAttr + "]").prop("checked", false);
        }

        var values = {};

        this.element.find("input[type=checkbox]").each(function() {
            values[$(this).val()] = $(this).is(':checked')
        });

        this.setValue(values, true);
    };

    // Make available the field type globally
    window.pinuts.fields.ConsentGroup = ConsentGroup;

    return ConsentGroup;
});

/* global pirequire: false, confirm: false */
pirequire.define('fields/NlFormWidget', [
    'jquery',
    'lib/OO',
    'FormWidget',
    'lib/Helper',
    'lib/Captions'
], function loadNlFormWidget($, OO, FormWidget, Helper, Captions) {
    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function NlFormWidget() {
        NlFormWidget.superConstructor.apply(this, arguments);

        this.registrationUrl = this.postUrlPrefix + ".ApiNewsletterRegistration/index";
        this.checkMsgidUrl = this.postUrlPrefix + ".ApiNewsletterRegistration/checkMsgid";
        this.profilUrl = this.postUrlPrefix + ".ApiProfile/index";
        this.authenticationUrl = this.postUrlPrefix + ".ApiAuthentication/index";
        this.loginUrl = this.postUrlPrefix + ".ApiProfile/login";

        this.submitUrl = this.registrationUrl;

        this.readUrlParams();
        this.key = this.k || this.urlParams.k;

        //0029434: mehrere Add-Ons auf einer Seite, deswegen beim Confirm die Instanz-ID pr�fen
        if (!this.key || this.key + "" === "" + this.addOnName.substr(2, 4) || this.key === "" + this.pk) {
            this.action = this.urlParams.action;
            this.cookie = this.urlParams.c;
        }

        //if actionName or actionCookie is set explicitly it always wins over urlParams
        if (this.actionName) this.action = this.actionName;
        if (this.actionCookie) this.cookie = this.actionCookie;
    }

    OO.extend(NlFormWidget, FormWidget);


    NlFormWidget.prototype.getBaseAjaxData = function () {
        var data = {
            name: this.addOnName,
            locale: this.locale,
            ctp: this.ctp
        };

        if (this.addToken2BaseAjaxData) {
            data.token = this.cookie;
        }
        if (window.umtrack) {
            data.tc = window.umtrack.getFormTrackValue();
        }

        if (this.urlParams.nl && this.action === "unsubscribe") {
            data.nl = this.urlParams.nl;
        }

        return data;
    };

    NlFormWidget.prototype.init = function () {
        if (!this.isCurrentActionAllowed()) {
            this.renderActionNotAllowed();
        } else if (this.action === "pwlink") {
            this.renderPwLinkForm();
        } else if (this.action === "login") {
            this.renderLoginForm();
        } else if (this.action === "confirm" && this.cookie) {
            this.confirm();
        } else if (this.action === "unsubscribe" && this.cookie) {
            this.unsubscribe();
        } else if (this.cookie) { //edit
            this.profilForm();
        } else if (!this.action) { //register
            this.render();
        } else {
            //show nothing
            $("#" + this.containerId + "-loader").remove();
        }
    };

    NlFormWidget.prototype.isCurrentActionAllowed = function () {
        if (!Array.isArray(this.allowedActions) || this.allowedActions.length === 0) {
            return true;
        }

        let actionToCheck = this.action;
        if ((!this.action && this.cookie) || this.action === 'pwlink' || this.action === 'login') {
            actionToCheck = 'profile';
        }

        if (!this.action) { // register
            actionToCheck = 'subscribe';
        }

        return this.allowedActions.includes(actionToCheck);
    }

    NlFormWidget.prototype.render = function () {
        NlFormWidget.superClass.render.apply(this, arguments);

        if (this.isSetOption("ajaxEmailCheck")) {
            this.initProfilPreCheck();
        }

        if (this.isSetOption("showLoginButton")) {
            this.showLoginButton();
        }

        if (this.isSetOption("anonymizedForm")) {
            this.showAnonymousLink();
        }
    };


    NlFormWidget.prototype.confirm = function () {
        var self = this;
        this.addToken2BaseAjaxData = true;
        var data = data || this.getBaseAjaxData();
        data.reason = null;
        data.nl = null;
        var ajaxOptions = {
            url: this.checkMsgidUrl,
            method: "POST",
            data: data,
            success: function (response) {
                self.response = response;
                if (response.success) {
                    self.renderConfirm(response);
                } else {
                    self.showError(response);
                }
            },
            error: this.ajaxCallError.bind(this)
        };
        this.ajaxCall(ajaxOptions);
    };


    NlFormWidget.prototype.confirmCall = function (data) {
        var self = this;
        this.addToken2BaseAjaxData = true;
        data = data || this.getBaseAjaxData();
        data.reason = null;
        data.nl = null;
        var ajaxOptions = {
            url: this.registrationUrl,
            method: "PUT",
            data: data,
            success: function (response) {
                self.response = response;
                self.renderConfirmResponse(response);
            },
            error: this.ajaxCallError.bind(this)
        };
        this.ajaxCall(ajaxOptions);
    };


    NlFormWidget.prototype.unsubscribe = function () {
        this.captions.form.heading = this.captions.messages.unsubscribeText;

        if (this.isSetOption("confirmUnsubscription")) {
            if (this.isSetOption("unsubscribeShowChannel")) {
                this.unsubscribeLoadChannels();
            } else {
                this.unsubscribeConfirm();
            }
        } else {
            this.unsubscribeDirect();
        }
    };


    NlFormWidget.prototype.unsubscribeLoadChannels = function () {
        var self = this;
        this.addToken2BaseAjaxData = true;
        var data = this.getBaseAjaxData();

        var ajaxOptions = {
            url: self.registrationUrl.replace(/\/index/, "/unsubscribeChannels"),
            method: "GET",
            data: data,
            cache: false,
            success: function (response) {
                self.response = response;
                self.unsubscribeConfirm(response);
            },
            error: this.ajaxCallError.bind(this)
        };
        this.ajaxCall(ajaxOptions);
    };

    NlFormWidget.prototype.unsubscribeConfirm = function (response) {
        this.captions.form.submitBtn = this.captions.buttons.unsubscribe;

        this.attributes = [];

        if (this.isSetOption("unsubscribeShowChannel")) {
            this.attributes.push(
                {
                    name: "unsubchannelsfield",
                    type: "ShowChannelField",
                    channelIds: response.channelIds,
                    channelGrps: response.channelGrps
                });
        }

        if (this.isSetOption("askForUnsubscribeReasons")) {
            this.attributes.push(
                {
                    name: "unsubscribereasons",
                    type: "UnsubscribeReasons",
                    options: this.unsubscribereasons,
                    cssClasses: this.unsubscribereasonsCssClasses
                });
        }


        this.submitUrl = this.registrationUrl;
        this.submitMethod = "DELETE";
        this.addToken2BaseAjaxData = true;

        NlFormWidget.superClass.render.apply(this, ["rendered-unsubscribe"]);

        if (this.isSetOption("showDeleteProfileButtonUnsubscribe")) {
            this.captions.form.deleteProfileBtn = this.captions.buttons.deleteProfileUnsubscribeBtn;
            this.captions.form.deleteProfileConfirm = this.captions.messages.deleteProfileUnsubscribe;
            this.captions.form.deleteProfileMsg = this.captions.messages.profileDeletedUnsubscribe;

            var delBtnTpl = Helper.getTemplate("nlBtnDeleteProfile", this.designSet);
            this.element.find(".pi-form-button").append(delBtnTpl(this));
            this.initDeleteProfileButton();
        }
    };


    NlFormWidget.prototype.initDeleteProfileButton = function () {
        var self = this;
        this.element.find('#' + this.elementId + "-btnDeleteProfile").click(function (e) {
            e.preventDefault();
            if (confirm(self.captions.form.deleteProfileConfirm)) {
                self.addToken2BaseAjaxData = true;
                var data = self.getBaseAjaxData();
                var ajaxOptions = {
                    url: self.profilUrl,
                    method: "DELETE",
                    data: data,
                    success: function (response) {
                        self.response = response;
                        if (response.success) {
                            self.hideForm();
                            self.triggerEvent("onDeleteProfil");
                            self.showMessage("form.deleteProfileMsg", self.cssClasses.successClass);
                        } else {
                            self.showError(response);
                        }
                    },
                    error: self.ajaxCallError.bind(self)
                };

                self.ajaxCall(ajaxOptions);
            }
        });
    };


    NlFormWidget.prototype.showLoginButton = function () {
        var loginBtnTpl = Helper.getTemplate("nlBtnLogin", this.designSet);
        this.element.find(".pi-form-button").append(loginBtnTpl(this));
        var self = this;
        this.element.find('#' + this.elementId + "-btnLogin").click(function (e) {
            e.preventDefault();
            self.renderLoginForm();
        });
    };

    NlFormWidget.prototype.renderActionNotAllowed = function () {
        NlFormWidget.superClass.render.apply(this, ["rendered-action-not-allowed"]);
        this.hideForm();
        if (this.captions.messages.actionNotAllowed) {
            this.showMessage("actionNotAllowed", this.cssClasses.errorClass);
        } else if (this.element) {
            this.element.replaceWith("<span></span>");
        }
    };

    NlFormWidget.prototype.renderLoginForm = function () {
        this.captions.form.submitBtn = this.captions.buttons.loginSend;
        this.captions.form.heading = this.captions.titles.loginTitle;
        this.attributesForm = this.attributes;
        this.attributes = this.loginAttributes;

        this.submitUrl = this.loginUrl;
        this.formModus = "login";

        NlFormWidget.superClass.render.apply(this, ["rendered-login"]);
    };

    NlFormWidget.prototype.renderPwLinkForm = function () {
        this.captions.form.submitBtn = this.captions.buttons.plinkSend;
        this.captions.form.heading = this.captions.titles.plinkTitle;
        this.attributesForm = this.attributes;
        this.attributes = this.pwLinkAttributes;

        this.submitUrl = this.authenticationUrl;
        this.submitMethod = "POST";
        this.formModus = "pwlink";

        NlFormWidget.superClass.render.apply(this, ["rendered-pwlink"]);
    };

    NlFormWidget.prototype.unsubscribeDirect = function () {
        this.attributes = [];
        NlFormWidget.superClass.render.apply(this, ["rendered-unsubscribe"]);
        this.hideForm();
        this.unsubscribeCall();
    };


    NlFormWidget.prototype.unsubscribeCall = function () {
        var self = this;

        this.addToken2BaseAjaxData = true;
        var data = this.getBaseAjaxData();
        data.reason = null;

        var ajaxOptions = {
            url: this.registrationUrl,
            method: "DELETE",
            data: data,
            success: function (response) {
                self.response = response;
                if (response.success) {
                    self.showMessage(response.message, self.cssClasses.successClass);
                } else {
                    self.showError(response);
                }
            },
            error: this.ajaxCallError.bind(this)
        };

        this.ajaxCall(ajaxOptions);
    };

    //render msb box only
    NlFormWidget.prototype.renderConfirm = function (response) {

        if (this.isSetOption('confirmSubscription')) {
            var confirmAttributes = [];

            this.captions.form.heading = this.captions.messages.subscribeText;
            this.captions.form.submitBtn = this.captions.buttons.subscribe;

            if (this.captions.messages.subscribeInfo) {
                this.captions.attributes.subscribeInfo = { label: this.captions.messages.subscribeInfo };//FIXME das sollte das besser in den Wizard?
                confirmAttributes.push({
                    name: "subscribeInfo",
                    type: "StringField"
                });
            }

            if (this.isSetOption("subscribeShowChannel")) {
                if (this.isSetOption("subscribeSelectChannel")) {
                    for (var i = 0; i < this.attributes.length; i++) {
                        if (response.channelGrps[this.attributes[i].name]) {
                            //FIXME nie mandatory?
                            if (this.attributes[i].validation) {
                                this.attributes[i].validation = this.attributes[i].validation.filter(function (v) {
                                    return v[0] !== "notempty";
                                });
                            }

                            confirmAttributes.push(this.attributes[i]);

                            this.values[this.attributes[i].name] = [];
                            var self = this;
                            response.channelGrps[this.attributes[i].name].forEach(function (chId) {
                                if (response.channelIds.indexOf(chId) > -1) {
                                    self.values[self.attributes[i].name].push(chId);
                                }
                            });
                        }
                    }
                } else {
                    confirmAttributes.push({
                        name: "unsubchannelsfield",
                        type: "ShowChannelField",
                        channelIds: response.channelIds,
                        channelGrps: response.channelGrps
                    });
                }

            }

            this.attributes = confirmAttributes;
            NlFormWidget.superClass.render.apply(this, ["rendered-confirm-request"]);

            this.addToken2BaseAjaxData = true;
            this.submitUrl = this.registrationUrl;
            this.submitMethod = "PUT";
        } else {
            this.confirmCall();
        }
    };

    NlFormWidget.prototype.renderConfirmResponse = function (response) {
        this.attributes = [];
        NlFormWidget.superClass.render.apply(this, ["rendered-confirm"]);
        this.hideForm();
        if (response.success) {
            this.showMessage(response.message, this.cssClasses.successClass);
        } else {
            this.showError(response);
        }
    };

    NlFormWidget.prototype.profilForm = function (modus, message) {
        var self = this;
        this.addToken2BaseAjaxData = true;
        var data = this.getBaseAjaxData();
        //load profil
        var ajaxOptions = {
            url: this.profilUrl,
            method: "GET",
            data: data,
            cache: false,
            success: function (response) {
                self.response = response;
                if (response.success) {
                    self.renderProfilForm(response, modus, message);
                } else {
                    self.showError(response);
                }
            },
            error: this.ajaxCallError.bind(this)
        };

        this.ajaxCall(ajaxOptions);
    };

    NlFormWidget.prototype.disableEmailField = function () {
        for (var i = 0; i < this.attributes.length; i++) {
            if (this.attributes[i].name === "email") {
                this.attributes[i].type = "DisabledTextField";
                this.attributes[i].validation = [];
                break;
            }
        }
    };

    NlFormWidget.prototype.deletePWField = function () {
        //never show PW in Profil 
        //no array.filter in IE8
        var tmpArr = [];
        for (var i = 0; i < this.attributes.length; i++) {
            if (this.attributes[i].type === "PasswordField") {
                this.hiddens.push(this.attributes[i].name);
            } else {
                tmpArr.push(this.attributes[i]);
            }
        }
        this.attributes = tmpArr;
    };

    NlFormWidget.prototype.renderProfilForm = function (response, modus, message) {
        this.values = response.values;
        this.captions.form.submitBtn = this.captions.buttons.update;
        this.captions.form.heading = this.captions.titles.profile;
        this.submitUrl = this.profilUrl;

        this.submitMethod = "PUT";
        this.addToken2BaseAjaxData = true;

        //email in profil nicht bearbeiten
        this.disableEmailField();
        //PW in profil nicht anzeigen
        this.deletePWField();
        this.formModus = "profil";

        NlFormWidget.superClass.render.apply(this, [modus || "rendered-profil"]);
        if (message) this.showMessage(message);
        this.initProfilForm();
    };

    NlFormWidget.prototype.initProfilForm = function () {
        if (this.isSetOption("showDeleteProfileButton")) {
            this.captions.form.deleteProfileBtn = this.captions.buttons.deleteProfileBtn;
            this.captions.form.deleteProfileConfirm = this.captions.messages.deleteProfile;
            this.captions.form.deleteProfileMsg = this.captions.messages.profileDeleted;

            var delBtnTpl = Helper.getTemplate("nlBtnDeleteProfile", this.designSet);
            this.element.find(".pi-form-button").append(delBtnTpl(this));
            this.initDeleteProfileButton();
        }

        if (this.isSetOption("anonymizedForm")) {
            //has any non anonymus values?
            var toggel = true;
            for (var i = 0; i < this.fields.length; i++) {
                var val = this.values[this.fields[i].name];
                if (val && Array.isArray(val) && val.length === 0) {
                    val = null;
                }
                if (val && !this.fields[i].isAnonymAttr) {
                    toggel = false;
                    break;
                }
            }
            if (toggel) {
                this.togelAnonymousForm();
            }
            this.showAnonymousLink();
        }
    };

    NlFormWidget.prototype.showError = function (response) {
        var hasProfilLink = false;
        if (!this.element) {
            NlFormWidget.superClass.render.apply(this, ["error"]);
            this.hideForm();
        }

        var cssClass = response.cssClass || this.cssClasses.errorClass;
        if (response.message === "alreadyRegistered") {
            this.showMessage(["alreadyRegistered", this.getProfilLink()], cssClass);
            hasProfilLink = true;
        } else if (Array.isArray(response.message) && response.message.indexOf("apierrors") > -1 && !this.isSetOption("showSystemErrors")) {
            this.showMessage("errorsOccurred", cssClass);
        } else {
            this.showMessage(response.message, cssClass);
        }

        if (hasProfilLink) {
            this.hideForm();
            this.initProfilLink();
        }
    };


    /*
     * ProfilLink
     */

    NlFormWidget.prototype.getProfilLink = function () {
        var linkProfilTpl = Helper.getTemplate("nlLinkProfile", this.designSet);
        return linkProfilTpl(this);
    };

    //FIXME stimmt das so? ist error eine echte fehlermeldung
    NlFormWidget.prototype.ajaxCallError = function (error) {
        var $msgFrom = $("#" + this.msgFromId);
        $msgFrom.addClass(this.cssClasses.errorClass);
        $msgFrom.append(error);
//                    self.runCustomScript({modus: 'formreturn', success: false, data: data, response: error});
//                    self.triggerEvent("onFormReturn");
    };

    //pre check email
    NlFormWidget.prototype.initProfilPreCheck = function () {
        var self = this;
        Helper.observeValue(this.values, "email", function () {
            var data = self.getBaseAjaxData();
            data.email = self.values.email;
            var ajaxOptions = {
                url: self.authenticationUrl,
                method: "GET",
                data: data,
                cache: false,
                success: function (response) {
                    self.response = response;
                    if (response.count && response.count > 0) {
                        self.showProfilLink();
                    } else {
                        self.hideProfilLink();
                    }
                },
                error: self.ajaxCallError.bind(self)
            };

            self.ajaxCall(ajaxOptions);
        });
    };


    NlFormWidget.prototype.showProfilLink = function () {
        var emailField = this.getFieldByName("email");
        emailField.element.find(".pi-form-error").html(this.getProfilLink()).show();
        this.initProfilLink();
    };

    NlFormWidget.prototype.hideProfilLink = function () {
        var emailField = this.getFieldByName("email");
        emailField.element.find(".pi-form-error").html("").hide();
    };

    NlFormWidget.prototype.initProfilLink = function () {
        var $link = this.element.find("#" + this.elementId + "-piEditProfile");
        var self = this;
        $link.click(function () {
            self.hideMessage();
            self.hideForm();
            var data = self.getBaseAjaxData();
            data.email = self.values.email;
            var ajaxOptions = {
                url: self.authenticationUrl,
                method: "POST",
                data: data,
                success: function (response) {
                    self.response = response;
                    if (response.success) {
                        self.showMessage("editProfileRequested");
                    } else {
                        self.showError(response);
                        $('.status').attr('class', 'status error');
                    }
                },
                error: self.ajaxCallError.bind(self)
            };
            self.ajaxCall(ajaxOptions);
        });
    };

    NlFormWidget.prototype._getAnonymousLinkText = function () {
        if (this.values.isanonymous) {
            return (this.formModus === 'profil') ? "notAnonymousUpdate" : "notAnonymous";
        } else {
            return (this.formModus === 'profil') ? "anonymousUpdate" : "anonymous";
        }
    };

    NlFormWidget.prototype.showAnonymousLink = function () {
        var btnText = this._getAnonymousLinkText();

        this.captions.form.btnAnonymous = this.captions.buttons[btnText];

        var btnAnonymousTpl = Helper.getTemplate("nlAnonymLink", this.designSet);
        this.element.find(".pi-form-button").append(btnAnonymousTpl(this));
        var self = this;
        this.element.find('#' + this.elementId + "-btnAnonymous").click(function (e) {
            e.preventDefault();
            self.togelAnonymousForm();
        });
    };

    NlFormWidget.prototype.togelAnonymousForm = function () {
        for (var i = 0; i < this.fields.length; i++) {
            this.fields[i].showinform = (this.values.isanonymous) ? true : !!this.fields[i].isAnonymAttr;
            if (!this.fields[i].showinform) {
                delete this.values[this.fields[i].name];
                this.fields[i].value = null;
            }
        }
        this.values.isanonymous = !this.values.isanonymous;
        var btnText = this._getAnonymousLinkText();
        this.element.find('#' + this.elementId + "-btnAnonymous").html(this.captions.buttons[btnText]);
    };

    NlFormWidget.prototype.onSubmit = function (event) {
        event.preventDefault();
        this.submitEvent = event;
        this.triggerEvent("onSubmit");

        if (this.blockSubmit) {
            return false;
        }

        this.continueSubmit(event);
    }

    NlFormWidget.prototype.continueSubmit = function (event) {
        event = event || this.submitEvent;
        event.preventDefault();

        // Check if we have errors
        if (this.validate()) {
            return false;
        }

        var self = this;

        // Send data to backend
        var data = this.getBaseAjaxData();
        data.values = JSON.stringify(this.values);
        data.hiddens = JSON.stringify(this.hiddens);
        data._ = Date.now();//nocache

        if (window.umtrack) {
            data.tc = window.umtrack.getFormTrackValue();
        }

        this.triggerEvent("onFormSend");
        this.disableButtons();

        var ajaxOptions = {
            url: this.submitUrl,
            method: this.submitMethod,
            data: data,
            success: function (response) {
                // Check if update was successful
                if (response.success) {
                    if (self.formModus === "login") {
                        self.hideForm();
                        self.attributes = self.attributesForm;
                        self.cookie = response.token;
                        self.profilForm();
                    } else if (self.formModus === "profil") {
                        self.values = response.attributes;
                        //    NlFormWidget.superClass.render.apply(self, ["rendered-profil-update"]);
                        self.profilForm("rendered-profil-update", response.message);
                    } else {
                        self.hideForm();
                    }

                    if (response.message) {
                        self.showMessage(response.message, response.cssClass, true);
                    }
                    self.scrollFormTop();
                } else {
                    if (response.type === "formerror") {//server site validation failed
                        self.setFormErrors(response.errors || {});
                        self.showMessage(response.message, response.cssClass);
                        self.enableButtons();
                    } else {
                        self.showError(response);
                    }
                    $('.status').attr('class', 'status error');
                    self.enableButtons();
                }
                if (response.callback && typeof self[response.callback] === 'function') {
                    self[response.callback](response);
                }
                var modus = (self.formModus === "profil") ? "profilformreturn" : "formreturn";
                self.response = response;
                self.runCustomScript({ modus: modus, success: response.success, data: data, response: response });
                self.triggerEvent("onFormReturn");
            },
            error: this.ajaxCallError.bind(this)
        };

        this.ajaxCall(ajaxOptions);
        return false;
    };


    NlFormWidget.prototype.isSetOption = function (option) {
        return this.options[option] === "1";
    };

    // Make available the field type globally
    window.pinuts.fields.NlFormWidget = NlFormWidget;

    return NlFormWidget;
});

/*
 * Copyright (C) 2017 Pinuts media+science GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 */
pirequire.define('fields/ShowChannelField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function ($, OO, Field) {

    /**
     * A field containing multiple inputs with type radio
     *
     * @constructor
     */
    function ShowChannelField() {
        ShowChannelField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(ShowChannelField, Field);

    ShowChannelField.prototype.setConfig = function (config) {
        ShowChannelField.superClass.setConfig.apply(this, arguments);
        
        // if (this.channelGrps.length === 1) {
        //     this.single = this.channelIds;
        // } else {
            this.groups = [];
            for (var grpName in this.channelGrps) {
                var channels = [];
                for (var j = 0; j < this.channelIds.length; j++) {
                    if (this.channelGrps[grpName].indexOf(this.channelIds[j]) > -1) {
                        channels.push(this.channelIds[j]);
                    }
                }
                if (channels.length) {
                    this.groups.push({
                        name: grpName,
                        channels: channels
                    });
                }
            }
        // }
    };

    // Make available the field type globally
    window.pinuts.fields.ShowChannelField = ShowChannelField;

    return ShowChannelField;
});



/*
 * Copyright (C) 2017 Pinuts media+science GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 */
pirequire.define('fields/UnsubscribeReasons', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Helper'
], function ($, OO, Field, Helper) {

    /**
     * A field containing multiple inputs with type radio
     *
     * @constructor
     */
    function UnsubscribeReasons() {
        UnsubscribeReasons.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(UnsubscribeReasons, Field);

    UnsubscribeReasons.prototype.setConfig = function (config) {
        UnsubscribeReasons.superClass.setConfig.apply(this, arguments);

        this.setTemplate("CheckboxesTpl");
        this.cssClass = "pi-checkbox-control-vertical";
    };


    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    UnsubscribeReasons.prototype.onChange = function (event) {
        this.element.addClass('changed');
        var values = [];
        this.element.find("input[type=checkbox]:checked").each(function () {
            values.push($(this).val());
        });
        this.setValue(values, true);
        $(this.otherText).toggle(this.value.indexOf("other") > -1 );
    };


    UnsubscribeReasons.prototype.render = function () {
        UnsubscribeReasons.superClass.render.apply(this, arguments);

        var otherTextTpl = Helper.getTemplate("UnsubscribeReasonsOther", this.designSet);
        
        this.element.find(".pi-form-input").append(otherTextTpl(this));
        this.otherText = this.element.find("#otherTextDiv");
        
        var self = this;
        this.element.find("#otherText").on("change", function(event) {
            self.values.otherText = $(this).val();            
        });
        
        return this.element;
    };

    // Make available the field type globally
    window.pinuts.fields.UnsubscribeReasons = UnsubscribeReasons;

    return UnsubscribeReasons;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2022 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire, */
pirequire.define('fields/CustomDataLoader', [
        'jquery',
        'lib/OO',
        'fields/Field',
    ], function loadCustomDataLoader($, OO, Field) {

        function CustomDataLoader() {
            CustomDataLoader.superConstructor.apply(this, arguments);
        }

        // Inherit fields/Field base class
        OO.extend(CustomDataLoader, Field);

        CustomDataLoader.prototype.onChange = function(event) {
            //nothing
        };

        CustomDataLoader.prototype.validate = function() {
            //nothing
        };

        CustomDataLoader.prototype.render = function() {
            //nothing
        };

        CustomDataLoader.prototype.setConfig = function() {
            CustomDataLoader.superClass.setConfig.apply(this, arguments);
            const attributes = this.attributes;
            const mode = attributes.mode;

            let readData;

            if (mode === "localStorage") {
                readData = this.readLocalStorage.bind(this);
            } else if (mode === "sessionStorage") {
                readData = this.readSession.bind(this);
            } else if (mode === "cookie") {
                readData = this.readCookie.bind(this);
            } else if (mode === "htmlAttribute") {
                readData = this.readHTMLDataAttribute.bind(this);
            } else if (mode === "jsCallback") {
                readData = this.callbackFunc.bind(this);
            } else if (mode === "urlQuery") {
                readData = this.getUrlParams.bind(this);
            }

            const self = this;
            this.formWidget.registerFormCallback("onSubmit", function(ctx) {
                const data = readData(attributes.dataOrigin, attributes.dataId);
                self.setValue(data, true, true);
            });
        }

        // readLocalstorage
        CustomDataLoader.prototype.readLocalStorage = function(localStorageKey) {
            return localStorage.getItem(localStorageKey);
        }

        // readSession
        CustomDataLoader.prototype.readSession = function(sessionKey) {
            return sessionStorage.getItem(sessionKey)
        }

        // cookie
        CustomDataLoader.prototype.readCookie = function(cookieKey) {
            const cookie = document.cookie
                .split('; ')
                .find(row => row.startsWith(`${cookieKey}=`))

            let cookieValue;
            if (cookie) {
                cookieValue = cookie.split('=')[1]
            }

            return cookieValue;
        }

        // html attribute
        CustomDataLoader.prototype.readHTMLDataAttribute = function(dataOrigin, dataId) {
            const foundAttr = $('#' + dataOrigin);
            if (foundAttr) {
                return $(foundAttr)[0].getAttribute(dataId);
            }
        }

        // callback function
        CustomDataLoader.prototype.callbackFunc = function(callbackFunction) {
            if (window[callbackFunction] && typeof window[callbackFunction] === 'function') {
                return window[callbackFunction]();
            } else {
                console.error("ERROR: Misconfiguration in Form Wizard.")
            }
        }

        CustomDataLoader.prototype.getUrlParams = function() {
            this.formWidget.readUrlParams();
            return JSON.stringify(this.formWidget.urlParams);
        }

        window.pinuts.fields.CustomDataLoader = CustomDataLoader;

        return CustomDataLoader;
    },
);
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2022 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire, */
pirequire.define('fields/EncryptedEditorMail', [
        'jquery',
        'lib/OO',
        'fields/Field',
    ], function loadEncryptedEditorMail($, OO, Field) {

        function EncryptedEditorMail() {
            EncryptedEditorMail.superConstructor.apply(this, arguments);
        }

        // Inherit fields/Field base class
        OO.extend(EncryptedEditorMail, Field);

        EncryptedEditorMail.prototype.onChange = function(event) {
            //nothing
        };

        EncryptedEditorMail.prototype.validate = function() {
            //nothing
        };

        EncryptedEditorMail.prototype.render = function() {
            //nothing
        };

        EncryptedEditorMail.prototype.setConfig = function() {
            EncryptedEditorMail.superClass.setConfig.apply(this, arguments);
            const attributes = this.attributes;
            const mode = attributes.mode;

            let readData;

            switch (mode) {
                case "localStorage":
                    readData = this.readLocalStorage.bind(this);
                    break;
                case "sessionStorage":
                    readData = this.readSession.bind(this);
                    break;
                case "cookie":
                    readData = this.readCookie.bind(this);
                    break;
                case "htmlAttribute":
                    readData = this.readHTMLDataAttribute.bind(this);
                    break;
                case "jsCallback":
                    readData = this.callbackFunc.bind(this);
                    break;
                case "urlQuery":
                    readData = this.getUrlParams.bind(this);
                    break;
                default:
                    console.error("ERROR: Misconfiguration in EncryptedEditorMail. Please check the mode.", mode);
            }

            const self = this;
            this.formWidget.registerFormCallback("onSubmit", function(ctx) {
                const data = readData(attributes.dataOrigin, attributes.dataId);
                self.setValue(data, true, true);
            });
        }

        // readLocalstorage
        EncryptedEditorMail.prototype.readLocalStorage = function(localStorageKey) {
            return localStorage.getItem(localStorageKey);
        }

        // readSession
        EncryptedEditorMail.prototype.readSession = function(sessionKey) {
            return sessionStorage.getItem(sessionKey)
        }

        // cookie
        EncryptedEditorMail.prototype.readCookie = function(cookieKey) {
            const cookie = document.cookie
                .split('; ')
                .find(row => row.startsWith(`${cookieKey}=`))

            let cookieValue;
            if (cookie) {
                cookieValue = cookie.split('=')[1]
            }

            return cookieValue;
        }

        // html attribute
        EncryptedEditorMail.prototype.readHTMLDataAttribute = function(dataOrigin, dataId) {
            try {
                let attributeId = (dataOrigin || '').replace(/\{containerId\}/g, this.formWidget.containerId);

                const foundAttr = $('#' + attributeId);
                if (foundAttr) {
                    return $(foundAttr)[0].getAttribute(dataId);
                }
            } catch (error) {
                // ignore
            }

            console.error("ERROR: Misconfiguration in EncryptedEditorMail. Please check the dataOrigin and dataId");
        }

        // callback function
        EncryptedEditorMail.prototype.callbackFunc = function(callbackFunction) {
            if (window[callbackFunction] && typeof window[callbackFunction] === 'function') {
                return window[callbackFunction]();
            } else {
                console.error("ERROR: Misconfiguration in Form Wizard.")
            }
        }

        EncryptedEditorMail.prototype.getUrlParams = function() {
            this.formWidget.readUrlParams();
            return JSON.stringify(this.formWidget.urlParams);
        }

        window.pinuts.fields.EncryptedEditorMail = EncryptedEditorMail;

        return EncryptedEditorMail;
    },
);
/* global pirequire */
pirequire.define(
    "fields/NLArchive",
    ["jquery", "lib/Helper"],
    function loadNLArchiveWidget($, Helper) {
        function NLArchiveWidget(config) {
            // No inheritance, because there's no form.

            // Get 'formconf' from WidgetController mixin (remember, no form here...)
            // via param and write into class properties for use in JSP templates
            for (var key in config) {
                this[key] = config[key];
            }
        }

        // No field inheritance, because there's no form.

        // No form lifecycle methods (on submit, etc.) because... you guessed it

        // Override (though execute!) render() to access form DOM elements
        NLArchiveWidget.prototype.render = function() {
            var template = Helper.getTemplate("NLArchive", this.designSet);
            var element = $(template(this));
            $("#" + this.containerId + "-loader").remove();
            $("#" + this.containerId).append(element);
        };

        // Make available the field type globally
        window.pinuts.fields.NLArchiveWidget = NLArchiveWidget;

        return NLArchiveWidget;
    }
);

/*
 * See: http://docfluence/x/xamx
 *
 * FIXME Here you have to place your own field classes. You can either overwrite existing classes or create your own.
 *
 * If you don't have your own field classes you can delete the whole folder.
 */
pirequire.define('fields/IndustryCardList', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadIndustryCardList($, OO, Field) {

    function IndustryCardList() {
        IndustryCardList.superConstructor.apply(this, arguments);
    }

    OO.extend(IndustryCardList, Field);

    IndustryCardList.prototype.setConfig = function (config) {
        IndustryCardList.superClass.setConfig.apply(this, arguments);

        // Provide user upload data to template
        this.uploadList = this.formWidget.uploadList.map(function(upload) {
            var formattedUpload = {};
            var file = upload.files[0];
            formattedUpload.date = upload.date;
            formattedUpload.link = file.url;
            formattedUpload.name = file.name;
            formattedUpload.validity = upload.validity;
            return formattedUpload;
        });
    }

    window.pinuts.fields.IndustryCardList = IndustryCardList;

    return IndustryCardList;
});

/*
 * Copyright (C) 2019 Pinuts media+science GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 */

/* global pirequire */
pirequire.define(
    "fields/IndustryCardUploadForm",
    ['jquery', 'lib/OO', 'FormWidget', 'lib/Helper'],
    function loadIndustryCardUploadForm($, OO, FormWidget, Helper) {
        function IndustryCardUploadForm(config) {
            IndustryCardUploadForm.superConstructor.apply(this, arguments);
        }

        OO.extend(IndustryCardUploadForm, FormWidget);

        window.pinuts.fields.IndustryCardUploadForm = IndustryCardUploadForm;

        return IndustryCardUploadForm;
    }
);
//Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2017 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire: false, confirm: false */
pirequire.define('fields/EMFormWidget', [
    'jquery',
    'lib/OO',
    'FormWidget',
    'lib/Helper',
    'lib/Captions'
], function loadNlFormWidget($, OO, FormWidget, Helper, Captions) {
    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function EMFormWidget() {
        EMFormWidget.superConstructor.apply(this, arguments);

        this.postUrl = this.apiUrl + "/index";
        this.confimrUrl = this.apiUrl + "/confirm";
        this.cancelUrl = this.apiUrl + "/cancel";
        this.bookingkeyUrl = this.apiUrl + "/ci";
        this.refusalUrl = this.apiUrl + "/refuse";

        this.readUrlParams();
        this.bookingKey = this.bookingKey || this.urlParams.key;

        //if actionName or actionCookie is set explicitly it always wins over urlParams
        if (this.actionName) {
            this.action = this.actionName;
        } else {
            this.action = this.urlParams.action;
        }

        this.ajaxWithCredentials(true); //always send cookies
    }

    OO.extend(EMFormWidget, FormWidget);

    EMFormWidget.prototype.init = function() {
        if (this.action !== "edit" && this.attributes.length && this.attributes[0].name === "nope") {
            this.attributes = this.attributes.filter(function(attr) {
                return attr.cattrId === "eventDescription" || attr.cattrId === "eventInfoBox" || attr.name === "nope";
            });
        }

        if (this.msgOnly) {
            this.renderMsg();
        } else if (this.bookingKey && (!this.action || this.action === "confirm")) {
            this.confirm();
        } else if (this.bookingKey && this.action === "invitation") {
            this.invitation();
        } else if (this.bookingKey && this.action === "refuse") {
            this.refusal();
        } else if (this.bookingKey && this.action === "edit") {
            this.edit();
        } else if (this.action === "collection") {
            this.collectingRegistration();
        } else if (!this.action) {
            this.renderForm();
        } else {
            //show nothing
            $("#" + this.containerId + "-loader").remove();
        }
    };

    EMFormWidget.prototype.addSubmitAndNextBookingBtn = function() {
        this.nextBookingButtonClicked = false;

        var self = this;
        this.evBtnSaveAndNextBookingTpl = Helper.getTemplate("evBtnSubmitAndNextBooking", this.designSet);
        var renderedTpl = $(this.evBtnSaveAndNextBookingTpl(this));

        this.element.find(".pi-form-button").not(".pi-participants-form-button").append(renderedTpl);
        this.element.find("#" + this.elementId + "-evSubmitAndNextBooking").on('click', function(e) {
            e.preventDefault();
            self.nextBookingButtonClicked = true;
            self.onSubmit.apply(self, arguments);
        });
    };

    EMFormWidget.prototype.edit = function() {
        var self = this;
        this.checkBookingKey(function(response) {
            if (response.success && response.values && response.attrConf) {

                //re-set participants limits
                var eventParticipantsAttr = self.attributes.find(function(obj) {
                    return obj.cattrId === "eventParticipants";
                })

                if (eventParticipantsAttr) {
                    eventParticipantsAttr.freePlaces = response.attrConf.freePlaces;
                    eventParticipantsAttr.maxBooking = response.attrConf.maxBooking;
                    for (var pos in eventParticipantsAttr.participants) {
                        for (var participantPos in response.attrConf.participants) {
                            if (eventParticipantsAttr.participants[pos].type === response.attrConf.participants[participantPos].type) {
                                eventParticipantsAttr.participants[pos].max = response.attrConf.participants[participantPos].max;
                                eventParticipantsAttr.participants[pos].num = response.attrConf.participants[participantPos].num;
                            }
                        }
                    }
                }

                self.options.isBookable = true;
                self.values = self.values || {};
                var bookedWorkshops;
                for (var attrId in response.values) {
                    self.values[attrId] = response.values[attrId];

                    if (attrId.indexOf('ws_grp_') === 0) {
                        bookedWorkshops = bookedWorkshops || {};
                        bookedWorkshops[attrId] = self.values[attrId];
                    }
                }

                //re-set workshops limits
                if (bookedWorkshops) {
                    self.attributes.forEach(function(attr) {
                        if (bookedWorkshops[attr.name]) {
                            attr.members.forEach(function(wsConf) {
                                if(bookedWorkshops[attr.name].indexOf(wsConf.ws_oid) > -1) {
                                    wsConf.bookable = true;
                                    wsConf.booking_info = "";
                                }
                            });
                        }
                    });
                }

                self.captions.form.submitBtn = self.captions.form.editBtn;
                self.renderForm();
                self.element.find('.eventtext.pi-form-control').hide();
                if (response.isCancellable) {
                    self.addCancelBookingBtn();
                }
                self.element.find('input[name$="email"]').each(function() {
                    $(this).attr('readonly', "true");
                    $(this).attr("disabled", "disabled");
                });
            } else {
                self.renderForm();
                self.hideForm();
                self.showMessage(response.message, self.cssClasses.errorClass, true);
                self.scrollFormTop();
            }
        });
    };

    EMFormWidget.prototype.addCancelBookingBtn = function() {
        var self = this;
        this.evBtnDeleteBookingTpl = Helper.getTemplate("evBtnDeleteBooking", this.designSet);
        var renderedTpl = $(this.evBtnDeleteBookingTpl(this));

        this.element.find(".pi-form-button").not(".pi-participants-form-button").prepend(renderedTpl);

        this.element.find("#" + self.elementId + "-evDeleteBooking").on('click', function() {
            self.disableButtons(this.id);

            var data = {
                name: self.addOnName,
                loclae: self.locale,
                evcookie: self.values.evcookie,
                bookingKey: self.bookingKey
            };

            var ajaxOptions = {
                url: self.cancelUrl,
                method: "POST",
                data: data,
                xhrFields: {
                    withCredentials: true
                },
                success: function(response) {
                    var cssClass = (response.success) ? self.cssClasses.successClass : self.cssClasses.errorClass;
                    self.hideForm();
                    self.showMessage(response.message, cssClass, true);
                    self.scrollFormTop();
                },
                error: function(response) {
                    self.enableButtons(this);
                    self.showMessage(response, self.cssClasses.errorClass, true);
                    self.scrollFormTop();
                }
            };
            self.ajaxCall(ajaxOptions);
        });
    };

    EMFormWidget.prototype.disableButtons = function(btnId) {
        var btnQuery = '.pi-form-button > button';

        // disable all action buttons
        this.element.find(btnQuery).attr("disabled", "disabled");

        // show loader
        if (btnId) {
            btnQuery += '[id="' + btnId + '"]';
        } else {
            btnQuery += '[type="submit"]';
        }

        this.element.find(btnQuery)
            .addClass("pi-btn-loading")
            .append($("<i/>", {class: "pi-spinner", id: "piSpinner"}))
            .off();
    };

    EMFormWidget.prototype.enableButtons = function() {
        this.element.find(".pi-form-button > button > #piSpinner").remove();
        this.element.find(".pi-form-button > button")
            .removeAttr("disabled")
            .removeClass("pi-btn-loading")
    }

    EMFormWidget.prototype.renderForm = function() {
        EMFormWidget.superClass.render.apply(this, arguments);

        if (!this.options.isBookable) {
            this.element.find(".pi-form-actions").remove();
        }
    };

    EMFormWidget.prototype.renderMsg = function() {
        var template = Helper.getTemplate("eventMsg", this.designSet);
        var element = $(template(this));
        if (this.element) {
            this.element.replaceWith(element);
        }

        this.element = element;
        this.$messageContainer = this.element.find("#" + this.msgWidgetId);

        this.showMessage(this.msgOnly.msg, (this.msgOnly.success) ? this.cssClasses.successClass : this.cssClasses.errorClass);

        $("#" + this.containerId + "-loader").remove();
        $("#" + this.containerId).append(this.element);
    };

    EMFormWidget.prototype.collectingRegistration = function(response) {

        if (response && !response.isBookable && !response.useWaitlist) {
            this.attributes = response.attributesBookedout;
            this.options.isBookable = false;
            this.renderForm();
            this.showMessage(response.message, this.cssClasses.successClass);
            return;
        } else if (!this.options.isBookable) {
            this.renderForm();
            return;
        }

        if (response && !this.isMultiple) {
            this.values = { //re-set values
                evcookie: this.values.evcookie,
            };
            this.collectionKey = response.collectionKey;
        }

        this.renderForm();

        if (!this.isMultiple) {
            this.addSubmitAndNextBookingBtn();

            if (response) {
                this.showMessage(response.message, this.cssClasses.successClass);

                // Warteliste Info anzeigen, wenn nicht bereits da
                var firstChildInform = this.$form.children(":first");
                var hasWaitingInfo = firstChildInform.hasClass("eventtext");

                if (response.useWaitlist && response.waitlistMsg && !hasWaitingInfo) {
                    var msgTpl = Helper.getTemplate("EventCustomText", this.designSet);
                    var renderedTpl = $(msgTpl({
                        attributes: {
                            customText: response.waitlistMsg
                        }
                    }));

                    this.$form.prepend(renderedTpl);
                }
            }
        }
    };

    EMFormWidget.prototype.onSubmitSuccess = function(response) {
        EMFormWidget.superClass.onSubmitSuccess.apply(this, arguments);

        if (this.nextBookingButtonClicked && this.action === "collection") {
            this.collectingRegistration(response);
        }
    };

    EMFormWidget.prototype.refusal = function() {
        var self = this;
        this.attributes = this.attributesRefusal;
        this.captions.form.submitBtn = this.captions.form.refusalBtn;
        this.values.bookingKey = this.bookingKey;

        this.checkBookingKey(function(response) {
            if (response.success && response.values) {
                self.postUrl = self.refusalUrl;
                self.renderForm();
            } else {
                self.renderForm();
                self.hideForm();
                self.showMessage(response.message, self.cssClasses.errorClass, true);
                self.scrollFormTop();
            }
        });
    };

    EMFormWidget.prototype.invitation = function() {
        var attrId, pos, fieldValidators, idx;
        var self = this;
        this.checkBookingKey(function(response) {
            if (response.success && response.values) {
                self.values = self.values || {};
                self.participantsNoMandatory = self.participantsNoMandatory || [];
                for (attrId in response.values) {
                    self.values[attrId] = response.values[attrId];
                }
                self.captions.form.submitBtn = self.captions.form.invitationBtn;

                var hiddenFieldIds = [];
                var disabledFieldIds = [];
                if (self.mainParticipantConf) {
                    for (attrId in self.mainParticipantConf) {
                        var attrConf = self.mainParticipantConf[attrId];
                        var filteredAttributes = self.attributes.filter(function(attribute) {
                            if (attribute.name === attrId) return attribute;
                        });

                        if (filteredAttributes.length > 0) {
                            var fieldValidators = filteredAttributes[0].validation;
                            if (!!attrConf.hide) {
                                hiddenFieldIds.push(attrId);
                            } else if (!!attrConf.readonly) {
                                disabledFieldIds.push(attrId);
                                self.removeMandatoryOption(fieldValidators);
                            } else if (attrConf.hasOwnProperty("mandatory")) {
                                if (!attrConf.mandatory) {
                                    self.removeMandatoryOption(fieldValidators);
                                    self.participantsNoMandatory.push(attrId);
                                } else {
                                    var setMandatory = false;
                                    for (pos in fieldValidators) {
                                        if (fieldValidators[pos].indexOf("notempty") < 0) {
                                            setMandatory = true;
                                        }
                                    }

                                    if (setMandatory) {
                                        fieldValidators.push(["notempty", {
                                            name: "mandatory",
                                            showMessage: false,
                                            showMessageInline: false
                                        }]);
                                    }
                                }
                            }
                        }
                    }
                }

                self.renderForm();

                for (pos in hiddenFieldIds) {
                    self.element.find('[data-pi-id="' + hiddenFieldIds[pos] + '"]').hide();
                }

                for (pos in disabledFieldIds) {
                    self.disable(self.element.find('[name="' + disabledFieldIds[pos] + '"]'));
                    self.participantsNoMandatory.push(disabledFieldIds[pos]);
                }

            } else {
                self.renderForm();
                self.hideForm();
                self.showMessage(response.message, self.cssClasses.errorClass, true);
                self.scrollFormTop();
            }
        });
    };

    EMFormWidget.prototype.removeMandatoryOption = function(fieldValidators) {
        var idx;
        for (var pos in fieldValidators) {
            if (fieldValidators[pos].indexOf("notempty") >= 0) idx = pos;
        }

        if (idx) fieldValidators.splice(idx, 1);
    };

    EMFormWidget.prototype.confirm = function() {
        this.renderForm();
        this.hideForm();
        var self = this;
        var data = {
            name: this.addOnName,
            loclae: this.locale,
            evcookie: this.values.evcookie,
            bookingKey: this.bookingKey
        };

        var ajaxOptions = {
            url: this.confimrUrl,
            method: "POST",
            data: data,
            xhrFields: {
                withCredentials: true
            },
            success: function(response) {
                var cssClass = (response.success) ? self.cssClasses.successClass : self.cssClasses.errorClass;
                self.showMessage(response.message, cssClass, true);
                self.scrollFormTop();
            },
            error: function(response) {
                self.showMessage(response, self.cssClasses.errorClass, true);
                self.scrollFormTop();
            }

        };
        this.ajaxCall(ajaxOptions);
    };

    EMFormWidget.prototype.onSubmit = function() {
        this.data = this.data || {};

        if (this.action === "edit") {
            this.data.action = "edit";
        }


        if (this.participantsNoMandatory && this.participantsNoMandatory.length > 0) {
            this.data.participantsNoMandatory = JSON.stringify(this.participantsNoMandatory);
        }


        if (this.action === "collection") {
            this.values.collectionKey = this.collectionKey;
            this.values.collection = true;
        }

        EMFormWidget.superClass.onSubmit.apply(this, arguments);
    };

    EMFormWidget.prototype.disable = function($el) {
        $el.attr('readonly', "readonly");
        $el.prop("disabled", true);
        return $el;
    };

    EMFormWidget.prototype.hideElement = function($el) {
        $el.hide();
        return $el;
    };

    EMFormWidget.prototype.checkBookingKey = function(successFunc) {
        var data = {
            name: this.addOnName,
            evcookie: this.values.evcookie,
            bookingKey: this.bookingKey,
            action: this.action,
            _: Date.now()
        };

        var self = this;
        var ajaxOptions = {
            url: this.bookingkeyUrl,
            method: "POST",
            data: data,
            xhrFields: {
                withCredentials: true
            },
            success: successFunc,
            error: function(response) {
                self.showMessage(response, self.cssClasses.errorClass, true);
                self.scrollFormTop();
            }

        };
        this.ajaxCall(ajaxOptions);
    };

    // Make available the field type globally
    window.pinuts.fields.EMFormWidget = EMFormWidget;

    return EMFormWidget;
});

// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2018 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */

/* global pirequire, */
pirequire.define('fields/EventAdditionalTexts', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadEventAdditionalTexts($, OO, Field) {

    function EventAdditionalTexts() {
        EventAdditionalTexts.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(EventAdditionalTexts, Field);

    EventAdditionalTexts.prototype.onChange = function(event) {
        //nothing
    };

    EventAdditionalTexts.prototype.validate = function() {
        //nothing
    };

    window.pinuts.fields.EventAdditionalTexts = EventAdditionalTexts;

    return EventAdditionalTexts;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2017 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */

/* global pirequire, */
pirequire.define('fields/EventDescription', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadEventDescription($, OO, Field) {

    function EventDescription() {
        EventDescription.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(EventDescription, Field);

    EventDescription.prototype.onChange = function(event) {
        //nothing
    };

    EventDescription.prototype.validate = function() {
        //nothing
    };

    window.pinuts.fields.EventDescription = EventDescription;

    return EventDescription;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2018 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire, */
pirequire.define('fields/EventInfoBox', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadEventInfoBox($, OO, Field) {

    function EventInfoBox() {
        EventInfoBox.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(EventInfoBox, Field);

    EventInfoBox.prototype.onChange = function(event) {
        //nothing
    };

    EventInfoBox.prototype.validate = function() {
        //nothing
    };

    window.pinuts.fields.EventInfoBox = EventInfoBox;

    return EventInfoBox;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2018 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire, */
pirequire.define('fields/EventListWidget', [
    'jquery',
    'lib/OO',
    'FormWidget',
    'lib/Helper',
    'lib/Captions'
], function loadEventListWidget($, OO, FormWidget, Helper, Captions) {

    function EventListWidget(config) {
        EventListWidget.superConstructor.apply(this, arguments);
        this.template = Helper.getTemplate("EventListWidget", this.designSet);
    }

    OO.extend(EventListWidget, FormWidget);

    EventListWidget.prototype.render = function() {
        if (this.eventFormOverwriteUrl) {
            var urlElement = $("#" + this.eventFormSetUrlById);
            if (urlElement) {
                var formUrl = urlElement.data("eventFormUrl");
                if (formUrl) {
                    this.evenList = this.evenList.map(function(ed) {
                        ed.ed_altformurl = formUrl
                        return ed;
                    });
                }
            }
        }
        var element = $(this.template(this));
        if (this.element) {
            this.element.replaceWith(element);
        }
        this.element = element;

        $("#" + this.containerId + "-loader").remove();
        $("#" + this.containerId).append(this.element);

        this.$messageContainer = this.element.find("#" + this.msgWidgetId);
    };


    // Make available the field type globally
    window.pinuts.fields.EventListWidget = EventListWidget;

    return EventListWidget;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2023 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */
/* global pirequire, */
pirequire.define('fields/EventNewsletter', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadEventNewsletter($, OO, Field) {

    function EventNewsletter() {
        EventNewsletter.superConstructor.apply(this, arguments);

        // just a dummy class,  should never be displayed
    }

    // Inherit fields/Field base class
    OO.extend(EventNewsletter, Field);

    EventNewsletter.prototype.onChange = function(event) {
        //nothing
    };

    EventNewsletter.prototype.validate = function() {
        //nothing
    };

    window.pinuts.fields.EventNewsletter = EventNewsletter;

    return EventNewsletter;
});
//Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2017 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */

/* global pirequire, */
pirequire.define('fields/EventParticipants', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Captions'
], function loadEventParticipants($, OO, Field, captions) {

    function EventParticipants() {
        EventParticipants.superConstructor.apply(this, arguments);
        this.countMapO = null;
    }

    OO.extend(EventParticipants, Field);


    EventParticipants.prototype.setConfig = function(config) {
        EventParticipants.superClass.setConfig.apply(this, arguments);

        // just add collection button if single event
        if (!!this.participants) this.formWidget.isMultiple = true;

        if (this.freePlaces) {
            this.participantLimit = captions.t("errors.participantlimit", {num: this.freePlaces}, this.formWidget.captions);
        }
    };


    EventParticipants.prototype.render = function(config) {
        EventParticipants.superClass.render.apply(this, arguments);
        if (this.value) {
            var self = this;
            this.element.find(".participants_select").each(function() {
                var type = $(this).data("type");
                if (self.value[type]) {
                    $(this).val(self.value[type]);
                }
            });
        }

        return this.element;
    };


    EventParticipants.prototype.onChange = function() {
        var values = {};
        var totalprice = 0, $sel, num;
        this.element.find(".participants_select").each(function() {
            $sel = $(this);
            num = parseInt($sel.val());
            values[$sel.data("type")] = num;
            totalprice += num * parseInt($sel.data("fee") || 0);
        });

        this.setValue(values, true);
        var tsum = (totalprice / 100).toFixed(2) + "";
        $("#pitotalprice").html(tsum.replace(".", ","));
    };


    EventParticipants.prototype.getParticipantsMap = function() {
        if (!this.countMapO) {
            this.countMapO = {};
            for (var i = 0; i < this.participants.length; i++) {
                this.countMapO[this.participants[i].type] = {
                    count: this.participants[i].count,
                    min: this.participants[i].min,
                    max: this.participants[i].max
                };
            }
        }
        return this.countMapO;
    };


    EventParticipants.prototype.validate = function() {
        this.errorMsg = null;
        var error = null;
        var totalNum = 0, mid;
        if (this.value) {
            var participantsMap = this.getParticipantsMap();
            for (var type in this.value) {
                if (this.value.hasOwnProperty(type) && participantsMap[type].count) {
                    totalNum += parseInt(this.value[type]);
                }

                var $errorMsg = this.element.find("#errorMsg" + this.elementId + type);
                if (this.value[type] < participantsMap[type].min) {
                    mid = (participantsMap[type].min === 1) ? "errors.noparticipantsingle" : "errors.noparticipant";
                    $errorMsg.html(captions.t(mid, {"num": participantsMap[type].min + ""}), this.formWidget.captions);
                    $errorMsg.show();
                    error = true;
                } else {
                    $errorMsg.html("");
                }
            }
        }

        if (totalNum < this.minBooking) {
            mid = (this.minBooking === 1) ? "errors.noparticipantsingle" : "errors.noparticipant";
            this.errorMsg = error = captions.t(mid, {"num": this.minBooking}, this.formWidget.captions);
        } else if (totalNum > this.maxBooking) {
            this.errorMsg = error = captions.t("errors.tomanyparticipant", {"num": this.maxBooking}, this.formWidget.captions);
        }

        if (error !== this.error) {
            this.toggleErrorClass(!!error);
        }
        this.error = !!error;

        return !!this.error;
    };


    EventParticipants.prototype.getLabel = function() {
        return "Teilnehmer";//FIXME muss in i18n & config
    };


    window.pinuts.fields.EventParticipants = EventParticipants;

    return EventParticipants;
});
// Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2018 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */

/* global pirequire, */
pirequire.define('fields/EventPersonalizedParticipants', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Helper',
    'lib/Captions'
], function loadEventPersonalizedParticipants($, OO, Field, Helper, captions) {

    function EventPersonalizedParticipants() {
        EventPersonalizedParticipants.superConstructor.apply(this, arguments);
        this.countMapO = null;
        this.participantNr = 1;
        this.personalizedFields = [];
        this.personalizedValues = {};
        this.minParticipantsPerType = {};
        this.maxParticipantsPerType = {};
        this.typeInfo = {};
        this.personalizedParticipantTpl = Helper.getTemplate("EventPersonalizedParticipant", this.designSet);
    }

    OO.extend(EventPersonalizedParticipants, Field);


    EventPersonalizedParticipants.prototype.setConfig = function(config) {
        EventPersonalizedParticipants.superClass.setConfig.apply(this, arguments);
        if (this.participantFormFieldsInvitation && this.formWidget.bookingKey && this.formWidget.action === "invitation") {
            this.participantFormFields = this.participantFormFieldsInvitation;
        }

        this.formWidget.isMultiple = true;

        if (this.minBooking && this.minBooking > 1) this.mandatory = true;
        if (this.freePlaces) {
            this.participantLimit = captions.t("errors.participantlimit", {num: this.freePlaces}, this.formWidget.captions);
        }
        this.setTypeInfo();
        this.setPriceList();
        this.setMinAndMaxParticipantsInfo();
    };

    EventPersonalizedParticipants.prototype.render = function(config) {
        EventPersonalizedParticipants.superClass.render.apply(this, arguments);
        this.setSelectableParticipantTypes();
        this.formWidget.registerFormCallback("onSubmit", this.validatePersonalizedParticipants.bind(this));
        this.formWidget.registerFormCallback("onRender", this.setTotalCostsCallback.bind(this));

        // check if its a restricted invitation
        var companion = this.formWidget.urlParams.companion;

        if (this.value && (!companion || (companion !== "deny"))) {

            var self = this;
            this.value.forEach(function(participant) {
                self.addParticipant(participant.type, participant);
            });
        } else if (this.formWidget.action === "invitation" && companion === "deny") {
            this.element.find(".participants_select_button").remove();
        }

        return this.element;
    };

    EventPersonalizedParticipants.prototype.bindCallbacks = function() {
        var self = this;
        this.element.find(".participants_select_button")
            .off('click')
            .on('click', function() {
            var type = $(this).data("type");
            self.addParticipant(type);
        });

        this.element.find(".participants_select")
            .off('change')
            .on('change',  function() {
            self.addParticipant($(this).find(":selected").val() || "");
            $(this).val("");
        });
    };

    EventPersonalizedParticipants.prototype.setTypeInfo = function() {
        for (var pos in this.participants) {
            var participant = this.participants[pos];
            this.typeInfo[participant.type] = participant;
        }
    };

    EventPersonalizedParticipants.prototype.buildFields = function(type, id) {
        var label = this.locales.type_title + " " + (this.typeInfo[type].label || type);
        var renderedTpl = $(this.personalizedParticipantTpl({
            type: type,
            num: id,
            label: Object.keys(this.typeInfo).length > 1 ? label : "",
            buttonLabel: this.locales.remove_btn
        }));

        for (var fieldName in this.participantFormFields) {
            var formFieldConf = this.participantFormFields[fieldName];

            if (this.personalizedValues[id] && this.personalizedValues[id].hasOwnProperty(fieldName)) {
                formFieldConf.value = this.personalizedValues[id][fieldName];
            } else {
                formFieldConf.value = "";
            }

            renderedTpl.append(this.buildField(fieldName, formFieldConf, id));
        }

        return renderedTpl;
    };

    EventPersonalizedParticipants.prototype.buildField = function(fieldName, fieldConf, id) {
        fieldConf.name = fieldName + "_" + id;

        this.formWidget.captions.attributes[fieldConf.name] = {label: fieldConf.label && fieldConf.label[this.locale] ? fieldConf.label[this.locale] : fieldConf.name};

        if (fieldConf.options) {
            var options = {};

            for (var pos in fieldConf.options) {
                var option = fieldConf.options[pos];
                options[option.name] = {
                    text: option.text || null,
                    label: option.label && option.label[this.locale] ? option.label[this.locale] : null
                };
            }
            this.formWidget.captions.attributes[fieldConf.name].options = options;
        }

        fieldConf.validation = [];

        fieldConf.validation.push([
            "maxlength",
            {
                "name": "maxLength",
                "showMessage": true,
                "maxLength": fieldConf.fieldMaxLength || 128
            }
        ]);

        if (fieldConf.mandatory) {
            fieldConf.validation.push([
                "notempty",
                {
                    "name": "mandatory",
                    "showMessage": true,
                    "showMessageInline": false
                }
            ]);
        }

        var field = this.createField(fieldConf, id);
        this.personalizedFields.push(field);

        var renderedField = field.render();

        if (!!fieldConf.hide) {
            this.formWidget.hideElement(renderedField);
        }

        if (!!fieldConf.readonly) {
            var $el = renderedField.find('[name="' + fieldConf.name + '"]');
            if ($el) this.formWidget.disable($el);
        }

        return renderedField;
    };


    EventPersonalizedParticipants.prototype.createField = function(config, id) {
        // Create Field if the field type has a valid class
        if (typeof window.pinuts.fields[config.fieldType] === 'undefined') {
            throw new Error('No class for field type ' + config.type);
        }
        var field = new window.pinuts.fields[config.fieldType]();

        config.designSet = this.formWidget.designSet;
        config.widgetId = this.formWidget.widgetId;
        config.locale = this.formWidget.locale;
        config.useLabelAsPlaceholder = this.formWidget.useLabelAsPlaceholder;
        config.formWidget = this.formWidget;
        field.setConfig(config);

        // Set values for using other fields values
        field.setValues(this.personalizedValues[id], true);

        var tplset = window.pinuts.formtpl[this.formWidget.designSet] || window.pinuts.formtpl.base;
        if (typeof tplset[config.fieldType] !== 'undefined') {
            field.setTemplate(config.fieldType);
        } else if (typeof tplset[config.templateId] !== 'undefined') {
            field.setTemplate(config.templateId);
        }

        return field;
    };


    EventPersonalizedParticipants.prototype.addParticipant = function(type, participantVals) {
        var self = this;

        if (type !== "") {
            this.participantNr++;
            var id = "p_" + this.participantNr;
            this.personalizedValues[id] = participantVals || {is_main: false, type: type};

            var renderedTpl = this.buildFields(type, id);
            this.element.find(".personalize_participants").append(renderedTpl);

            this.element.find("#participant_remove_" + id).on('click', function(ev) {
                ev.stopPropagation();
                ev.preventDefault();

                self.element.find("#participant_" + $(this).data("num")).off();
                self.element.find("#participant_" + $(this).data("num")).remove();

                delete self.personalizedValues[id];

                self.setTotalCosts();
                self.setSelectableParticipantTypes();
                self.validatePersonalizedParticipants();
            });
        }

        this.setTotalCosts();
        this.setSelectableParticipantTypes();

        if (this.hasNumErrors) this.validatePersonalizedParticipants();
    };


    EventPersonalizedParticipants.prototype.validate = function() {
        var hasFieldErrors = false;
        for (var fieldPos in this.personalizedFields) {
            if (this.personalizedFields[fieldPos].validate()) {
                hasFieldErrors = true;
            }
        }

        if (this.hasNumErrors || hasFieldErrors) {
            this.error = true;
        } else {
            this.error = false;
            this.toggleErrorClass(false);
        }
        return this.error;
    };


    EventPersonalizedParticipants.prototype.validatePersonalizedParticipants = function() {
        var values = [];
        var mainParticipant = {};
        var self = this;
        this.hasNumErrors = false;
        var mid, errMsgText = "";

        // set main participant
        Object.keys(this.values).filter(function(key) {
            if (key.startsWith("participant_")) mainParticipant[key] = self.values[key];
        });
        mainParticipant.is_main = true;
        mainParticipant.type = this.participants[0].type;
        values.push(mainParticipant);

        // set additonal participants
        for (var key in this.personalizedValues) {
            values.push(this.personalizedValues[key]);
        }

        this.setValue(values, true);

        var $errorMsg = $(this.element.find("#errorMsg" + this.elementId + this.type));
        for (var pos in this.participants) {
            var participant = this.participants[pos];
            var type = participant.type;
            var typeInfo = this.typeInfo[type];

            var numParticipantsPerType = this.value.filter(function(obj) {
                return obj.type === type
            }).length;

            if (numParticipantsPerType > this.maxParticipantsPerType[type]) {
                errMsgText += captions.t("errors.tomanypersonalizedparticipant", {
                    "num": this.maxParticipantsPerType[type] + "",
                    "type": typeInfo.label
                }) + "</br>";
                this.hasNumErrors = true;
            }

            if (numParticipantsPerType < this.minParticipantsPerType[type]) {
                mid = (this.minParticipantsPerType[type] === 1) ? "errors.nopersonalizedparticipanttypesingle" : "errors.nopersonalizedparticipanttype";
                errMsgText += captions.t(mid, {
                    "num": this.minParticipantsPerType[type] + "",
                    "type": typeInfo.label
                }) + "</br>";
                this.hasNumErrors = true;
            }
        }

        // auf max teilnehmer zahl je anmeldung prüfen
        if (this.value.length > this.maxBooking) {
            this.hasNumErrors = true;
            errMsgText += captions.t("errors.tomanypersonalizedparticipant", {"num": this.maxBooking + ""}) + "</br>";
        }

        //auf min teilnehmerzahl je anmeldung prüfen
        if (this.value.length < this.minBooking) {
            this.hasNumErrors = true;
            mid = (this.minBooking === 1) ? "errors.noparticipantsingle" : "errors.nopersonalizedparticipant";
            errMsgText += captions.t(mid, {"num": this.minBooking + ""}) + "</br>";
        }

        //auf verfügbare von plätzen validieren
        if (this.value.length > this.freePlaces) {
            this.hasNumErrors = true;
            errMsgText += captions.t("errors.participantLimit", {"num": this.freePlaces + ""}) + "</br>";
        }

        //Show error Messages
        if (this.hasNumErrors) {
            $errorMsg.html(errMsgText);
            $(this.element.find(".participants")).addClass("pi-form-control__has-error");
        } else {
            $errorMsg.html("");
            $(this.element.find(".participants")).removeClass("pi-form-control__has-error").addClass("pi-form-control__has-success");

        }
    };

    EventPersonalizedParticipants.prototype.setMinAndMaxParticipantsInfo = function() {
        for (var pos in this.participants) {
            var participantTypeSettings = this.participants[pos];

            this.minParticipantsPerType[participantTypeSettings.type] = participantTypeSettings.min || 0;
            this.maxParticipantsPerType[participantTypeSettings.type] = participantTypeSettings.max;
        }
    };

    EventPersonalizedParticipants.prototype.setPriceList = function() {
        this.prices = [];
        for (var pos in this.participants) {
            var participant = this.participants[pos];
            if (!this.prices[participant.type]) this.prices[participant.type] = participant.fee || 0;
        }
    };

    EventPersonalizedParticipants.prototype.setTotalCostsCallback = function(ctx, jQuery) {
        this.setTotalCosts();
    };

    EventPersonalizedParticipants.prototype.setTotalCosts = function() {
        var price = 0;
        var self = this;

        this.element.find(".personalize_participants").children().each(function() {
            var type = $(this).data("type");
            price += parseInt(self.prices[type]);
        });

        //add price of main participant
        var type = this.participants[0].type;
        price += parseInt(this.prices[type] || 0);

        //write to gui
        var totalprice = (price / 100).toFixed(2) + "";
        $("#pitotalprice").html(totalprice.replace(".", ","));
    };

    EventPersonalizedParticipants.prototype.setSelectableParticipantTypes = function() {
        var selectedParticipants = {}, option = "";
        var maxBookingReached = false, selectedParticipantsNum = 1;

        this.element.find(".personalize_participants").children().each(function(el) {
            selectedParticipantsNum++;
            var type = $(this).data("type");
            selectedParticipants[type] ? selectedParticipants[type]++ : selectedParticipants[type] = 1;
        });

        if (selectedParticipantsNum >= this.maxBooking) maxBookingReached = true;

        if (this.participants.length === 1) {
            option = "button";
            $(this.element.find(".participants_select_button")).parents(".pi-form-actions").show();
            $(this.element.find(".participants_select")).hide();
            $(this.element.find(".no_participants_select_info")).hide();
            $(this.element.find('label[for="' + this.elementId + "_" + this.type + '"]')).hide();
        } else if (this.participants.length > 1) {
            option = "select";
            $(this.element.find(".participants_select_button")).parents(".pi-form-actions").hide();
            $(this.element.find(".participants_select")).show();
            $(this.element.find(".no_participants_select_info")).hide();
            $(this.element.find('label[for="' + this.elementId + "_" + this.type + '"]')).show();
        } else {
            option = "";
            $(this.element.find(".no_participants_select_info")).show();
        }

        for (var pos in this.participants) {
            var type = this.participants[pos].type;

            // Add main contact to selected Participants (main type is always selected  and always first participant type)
            if (pos == 0) selectedParticipants[type] ? selectedParticipants[type]++ : selectedParticipants[type] = 1;

            //Show/ Hide selectable types
            var select_option = this.element.find(".participants_select option[value='" + type + "']");
            var button_option = this.element.find(".participants_select_button[data-type='" + type + "']");

            if (!maxBookingReached && (!selectedParticipants[type] || selectedParticipants[type] < this.participants[pos].max)) {
                if (option === "button") {
                    button_option[0].disabled = false;
                    button_option[0].innerHTML = $(button_option).data("label");
                } else if (option === "select") {
                    select_option[0].disabled = false;
                    select_option[0].text = $(select_option).data("label");
                }
            } else {
                if (option === "button") {
                    button_option[0].disabled = true;
                    button_option[0].innerHTML = $(button_option).data("label") + " " + ($(button_option).data("maxreached") || "");
                } else if (option === "select") {
                    select_option[0].disabled = true;
                    select_option[0].text = $(select_option).data("label") + " " + ($(select_option).data("maxreached") || "");
                }

                if (maxBookingReached) $(this.element.find(".no_participants_select_info")).show();
            }
        }
    };

    window.pinuts.fields.EventPersonalizedParticipants = EventPersonalizedParticipants;

    return EventPersonalizedParticipants;
});
//Pinuts File Encoding: UTF-8
/*
 * Copyright (C) 2019 Pinuts digital thinking GmbH * All Rights Reserved
 *
 * The copyright notice above does not evidence any
 * actual or intended publication of this source code.
 *
 */

/* global pirequire, */
pirequire.define('fields/EventWorkshopGroup', [
    'jquery',
    'lib/OO',
    'fields/Field',
    'lib/Helper',
    'lib/Captions'
], function loadEventWorkshopGroup($, OO, Field, Helper, captions) {

    function EventWorkshopGroup() {
        EventWorkshopGroup.superConstructor.apply(this, arguments);

        this.template = Helper.getTemplate("EventWorkshopGroup", this.designSet);
    }

    OO.extend(EventWorkshopGroup, Field);

    EventWorkshopGroup.prototype.render = function(config) {
        this.element = EventWorkshopGroup.superClass.render.apply(this, arguments);


        return this.element;
    };

    EventWorkshopGroup.prototype.setConfig = function(config) {
        EventWorkshopGroup.superClass.setConfig.apply(this, arguments);

        if (this.mode === 'radio') {
            this.cssClass = (this.display && this.display !== 'vertical') ? "pi-radio-control" : "pi-radio-control-vertical";
            this.onChange = this.onChangeRadio;
        } else {
            this.cssClass = (this.display && this.display !== 'vertical') ? "pi-checkbox-control" : "pi-checkbox-control-vertical";
            this.onChange = this.onChangeCheckbox;
        }

        //adapt the validation to the real bookable ws
        this.bookableWs = this.members.reduce(function(num, wsConf) {
            if (wsConf.bookable) {
                num++;
            }
            return num;
        }, 0);

        if (this.min_booking > this.bookableWs) {
            this.min_booking = this.bookableWs
        }
    };

    /**
     * Set value for field when it changes. This propagates to form values object
     *
     * @param event {object} JavaScript event object
     */
    EventWorkshopGroup.prototype.onChangeCheckbox = function(event) {
        this.element.addClass('changed');

        var values = [];
        this.element.find("input[type=checkbox]:checked").each(function() {
            values.push($(this).val());
        });
        this.setValue(values, true);
    };


    EventWorkshopGroup.prototype.onChangeRadio = function (event) {
        this.element.addClass('changed');

        var val = this.element.find("input[type=radio]:checked").val();
        this.setValue(val, true);
    };


    EventWorkshopGroup.prototype.validate = function(noMandatory) {
        this.error = undefined;
        this.element.find('.pi-form-error').html('');
        this.errorMsg = "";

        if (this.mode === 'radio') {
            if(this.min_booking && !this.value) {
                this.error = "keines?"
            }
        } else if (this.mode === 'checkbox') {
            if (this.min_booking  && (!this.value || this.value.length < this.min_booking)) {
                this.error = "zu wenig"
            }

            if (this.max_booking && this.value && this.value.length > this.max_booking) {
                this.error = "zu viele";
            }
        }

        if (this.error) {
            this.element.find('.pi-form-error').html(this.error || '');
            this.errorMsg = this.error;
        }

        this.toggleErrorClass(!!this.error);
        return !!this.error;
    };

    window.pinuts.fields.EventWorkshopGroup = EventWorkshopGroup;

    return EventWorkshopGroup;
});

pirequire.define('fields/BaseSliderField', [
    'jquery',
    'lib/OO',
    'fields/Field',
], function loadBaseSliderField($, OO, Field) {

    /**
     * A field containing an input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function BaseSliderField() {
        BaseSliderField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(BaseSliderField, Field);

    BaseSliderField.prototype.setConfig = function(config) {
        BaseSliderField.superClass.setConfig.apply(this, arguments);
        const fields = ["sliderMin", "sliderMax", "sliderStartValue", "sliderStartValueMin", "sliderStartValueMax"];

        let i, value;
        for (i = 0; i < fields.length; i++) {
            value = this.attributes[fields[i]];
            if (value) {
                value += ""; //cast to string
                if (this.attributes.isTime === "yes" || this.attributes.isTime === true) {
                    this.attributes[fields[i]] = this.convertTimeToMinutes(value);
                } else if (value.indexOf("0") === 0) {
                    this.attributes[fields[i]] = value.substr(1);
                }
            }
        }

        //das change event wird von muc blockiert
        const self = this;
        this.formWidget.registerFormCallback("onSubmit", function() {
            self.setValue($("#" + self.elementId).val(), true);
        });
    };

    BaseSliderField.prototype.convertMinutesToTime = function(minutes) {
        let hours = Math.floor(minutes / 60);
        let min = (minutes - (hours * 60))+"";

        if ((min+"").length === 1) {
            min = "0" + min;
        }

        if ((hours+"").length === 1) {
            hours = "0" + hours;
        }

        return hours + ":" + min;
    };

    /**
     * Convert hh:mm to minutes, 12:34 = 754
     * @param {string} time
     * @return {int} 1234
     */
    BaseSliderField.prototype.convertTimeToMinutes = function(time) {
        if (!time) return 0;
        const t = time.split(":");
        const hours = t[0];
        const min = t[1];
        let minutes = parseInt(hours, 10) * 60;
        minutes += parseInt(min, 10);

        return minutes;
    };

    // Make available the field type globally
    window.pinuts.fields.BaseSliderField = BaseSliderField;

    return BaseSliderField;
});

pirequire.define('fields/DateFieldFmg', [
    'jquery',
    'lib/OO',
    'fields/DateField',
], function loadDateFieldFmg($, OO, DateField) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function DateFieldFmg() {
        DateFieldFmg.superConstructor.apply(this, arguments);

        this.formValue; //value in proper form format.
    }

    // Inherit fields/Field base class
    OO.extend(DateFieldFmg, DateField);


    DateFieldFmg.prototype.setConfig = function (config) {
        DateField.superClass.setConfig.apply(this, arguments);

        this.format = DateField.dateFormats[this.formatKey];
        this.picker = (this.picker && (this.picker === "yes" || this.picker === true));

        //das change event wird von muc blockiert
        var self = this;
        this.formWidget.registerFormCallback("onSubmit", function () {
            self.setValue($("#" + self.elementId).val(), true);
        });
    };


    DateFieldFmg.prototype.initPicker = function () {
        var self = this;

        if (window.$) {
            this.formWidget.registerFormCallback("onRender", function () {
                window.$(function () {
                    if (DateField.regional[self.formatKey]) {
                        window.$.datepicker.setDefaults(DateField.regional[self.formatKey]);
                    }
                    var conf = self.getDatepickerConf();

                    if(self.validator && self.validator.fmgMinDate && self.validator.fmgMinDate.option){
                        conf.minDate = self.validator.fmgMinDate.option;
                        if(conf.minDate > 0){
                            conf.minDate  = conf.minDate * -1;
                        }

                    }

                    if(self.validator && self.validator.fmgMaxDate && self.validator.fmgMaxDate.option){
                        conf.maxDate = self.validator.fmgMaxDate.option;
                    }

                    window.$("#" + self.elementId).datepicker(conf);
                });
            });
        }
    };


    // Make available the field type globally
    window.pinuts.fields.DateField = DateFieldFmg;

    return DateFieldFmg;
});

pirequire.define('fields/DeleteProfileField', [
    'jquery',
    'lib/OO',
    'fields/Field',
    "lib/Helper"
], function loadDeleteProfileField($, OO, Field, Helper) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function DeleteProfileField() {
        DeleteProfileField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(DeleteProfileField, Field);

    DeleteProfileField.prototype.render = function() {
        var self = this;

        DeleteProfileField.superClass.render.apply(this, arguments);

        this.formWidget.registerFormCallback("onSubmit", function(formWidget) {
            var $submitBtn = formWidget.element.find('button[type="submit"]:focus');

            if ($submitBtn && !!$submitBtn.data('submitbtn')) {
                self.formWidget.postUrl = self.formWidget.deleteProfileUrl;
            }
        });
    };

    // Make available the field type globally
    window.pinuts.fields.DeleteProfileField = DeleteProfileField;

    return DeleteProfileField;
});

pirequire.define('fields/EventParticipantsFmg', [
    'jquery',
    'lib/OO',
    'fields/EventParticipants',
], function loadEventParticipantsFmg($, OO, EventParticipants) {

    function EventParticipantsFmg() {
        EventParticipantsFmg.superConstructor.apply(this, arguments);
    }
    
    OO.extend(EventParticipantsFmg, EventParticipants);
    
    EventParticipantsFmg.prototype.setConfig = function(config) {
        EventParticipantsFmg.superClass.setConfig.apply(this, arguments);

        //das change event wird von muc blockiert        
        var self = this;

        this.formWidget.registerFormCallback("onRender", function() {
            var countertx = 0;
            var itx = window.setInterval(function () {
                if (window.$j) {
                    self.element.find('a.participants_select').remove();
                    self.element.find('select.participants_select').show();
                    window.clearInterval(itx);
                }

                if (countertx++ >= 100) {
                    console.error("window.$j missing!");
                    window.clearInterval(itx);
                }
            }, 150);
        });
    };

    // Make available the field type globally
    window.pinuts.fields.EventParticipants = EventParticipantsFmg;

    return EventParticipantsFmg;
});
pirequire.define('fields/EventPersonalizedParticipantsFmg', [
    'jquery',
    'lib/OO',
    'fields/EventPersonalizedParticipants',
], function loadEventPersonalizedParticipantsFmg($, OO, EventPersonalizedParticipants) {

    function EventPersonalizedParticipantsFmg() {
        EventPersonalizedParticipantsFmg.superConstructor.apply(this, arguments);
    }
    
    OO.extend(EventPersonalizedParticipantsFmg, EventPersonalizedParticipants);
    
    EventPersonalizedParticipantsFmg.prototype.setConfig = function(config) {
        EventPersonalizedParticipantsFmg.superClass.setConfig.apply(this, arguments);

        //das change event wird von muc blockiert        
        var self = this;
        this.formWidget.registerFormCallback("onRender", function() {
            var countertx = 0;
            var itx = window.setInterval(function () {
                if (window.$j) {

                    if (self.element.find('.participants_select_button').is(':visible')) {
                        self.element.find('a.participants_select').remove();
                    }
                    window.$j(document).on("selectChange", function(e, select) {
                        var elementId = self.elementId + "_" + self.type;

                        if ($(select).attr('id') === elementId) {
                            self.element.find('a.participants_select').remove();
                            self.addParticipant($(select).find(":selected").val() || "");
                            $(select).val("");
                        }
                    });
                    window.clearInterval(itx);
                }

                if (countertx++ >= 100) {
                    console.error("window.$j missing!");
                    window.clearInterval(itx);
                }
            }, 150);
        });
    };

    // Make available the field type globally
    window.pinuts.fields.EventPersonalizedParticipants = EventPersonalizedParticipantsFmg;

    return EventPersonalizedParticipantsFmg;
});
pirequire.define('fields/FromToField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadFromToField($, OO, Field, Helper) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function FromToField() {
        FromToField.superConstructor.apply(this, arguments);        
    }

    // Inherit fields/Field base class
    OO.extend(FromToField, Field);
              

    // Make available the field type globally
    window.pinuts.fields.FromToField = FromToField;

    return FromToField;
});
pirequire.define('fields/LoungeCodeField', [
    'jquery',
    'lib/OO',
    'fields/SelectFieldFmg'
], function loadLoungeCodeField($, OO, SelectFieldFmg, Helper) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function LoungeCodeField() {
        LoungeCodeField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/SelectFieldFmg base class
    OO.extend(LoungeCodeField, SelectFieldFmg);

    LoungeCodeField.prototype.setConfig = function() {
        LoungeCodeField.superClass.setConfig.apply(this, arguments);
        this.mandatory = true;
        this.validation = this.validation || [];
        this.validation.push(["notempty", {showMessage: true}]);
        this.validation.push(["number", {showMessage: true}]);

        var self = this;
        this.formWidget.registerFormCallback("onRender", function() {
            var countertx = 0;
            var itx = window.setInterval(function () {
                if (window.$j) {
                    window.$j(document).on("selectChange", function(e, select) {
                        if ($(select).attr('id') === self.elementId) {
                            self.setValue($(self.element).find("#" + self.elementId).val(), true);
                        }
                    });
                    window.clearInterval(itx);
                }

                if (countertx++ >= 100) {
                    console.error("window.$j missing!");
                    window.clearInterval(itx);
                }
            }, 150);
        });

    };

    LoungeCodeField.prototype.render = function() {
        LoungeCodeField.superClass.render.apply(this, arguments);
        var self = this;

        $(this.element).find("#" + this.elementId).append('<option value="">--</option>');
        for (var pos = 1;  pos <= parseInt(this.attributes.num_codes); pos++) {
            $(this.element).find("#" + this.elementId).append('<option value="' + pos + '">' + pos + '</option>');
        }

        $(this.element).find("#" + this.elementId).on("change", function() {
            self.onChange();
        })

        return this.element;
    };

    LoungeCodeField.prototype.onChange = function () {
        //do nothing
    };


    // Make available the field type globally
    window.pinuts.fields.LoungeCodeField = LoungeCodeField;

    return LoungeCodeField;
});

pirequire.define('fields/ParkingCalenderField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadParkingCalenderField($, OO, Field, Helper) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function ParkingCalenderField() {
        ParkingCalenderField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(ParkingCalenderField, Field);

    ParkingCalenderField.prototype.render = function() {
        var self = this;
        this.element = ParkingCalenderField.superClass.render.apply(this, arguments);
        this.$arrival = this.element.find('#parking-date-from');
        this.$departure = this.element.find('#parking-date-to');
        this.$arrivalTime = this.element.find('#parking-time-arrival');
        this.$departureTime = this.element.find('#parking-time-departure');

        addSelectOptions(this.$arrivalTime);
        addSelectOptions(this.$departureTime);

        this.$arrival.prop('readonly', true);
        this.$departure.prop('readonly', true);

        this.initPicker();

        this.formWidget.registerFormCallback("onSubmit", function() {
            self.setValueAndValidate();
        });

        return this.element;
    };

    ParkingCalenderField.prototype.toggleErrorClass = function (toggel) {
        //do nothing
    };

    ParkingCalenderField.prototype.getLabel = function () {
        return this.attributes.calendar_label;
    };

    ParkingCalenderField.prototype.createErrorText = function (errorId, options) {
        var msg = errorId;

        if (errorId === 'parkingDateRange.departure') {
            msg = this.attributes.errormsg_departure;
        }
        if (errorId === 'parkingDateRange.arrival') {
            msg = this.attributes.errormsg_arrival;
        }
        if (errorId === 'parkingDateRange.values') {
            msg = this.attributes.errormsg_invalidtime;
        }
        if (errorId === 'parkingDateRange.timespan') {
            msg = this.attributes.errormsg_timespan;
        }
        if (errorId === 'parkingDateRange.time_paradox') {
            msg = this.attributes.errormsg_time_paradox;
        }

        return msg;
    };

    function addSelectOptions($select) {
        $select.append('<option value="00:05">00:05</option>');
        for (var i = 1; i < 24; i++) {
            var time = ((i + '').length === 1) ? '0' + i: i;
            time += ':00';
            $select.append('<option value="'+ time + '">' + time + '</option>');
        }
        $select.append('<option value="23:55">23:55</option>');
    }

    ParkingCalenderField.prototype.onChange = function () {
        //do nothing
    };

    ParkingCalenderField.prototype.setValue = function () {
        //do nothing
    };

    ParkingCalenderField.prototype.setValueAndValidate = function () {
        var value = {};
        var errorData = {};

        if (this.$calendarFrom && this.$arrival && this.$arrival.val() != "") {
            var arrival = this.$calendarFrom.data("datepicker");

            value.arrival_time = this.$arrivalTime.val();
            value.parking_start = arrival.currentYear + "-" + (arrival.currentMonth+1) + "-" + arrival.currentDay + "|" + this.$arrivalTime.val() + ":00";
            value.arrival = {
                "currentYear": arrival.currentYear,
                "currentMonth": arrival.currentMonth,
                "currentDay": arrival.currentDay
            };
        }

        if (this.$calendarTo && this.$departure && this.$departure.val() != ""){
            var departure = this.$calendarTo.data("datepicker");

            value.departure_time = this.$departureTime.val();
            value.parking_end = departure.currentYear + "-" + (departure.currentMonth+1) + "-" + departure.currentDay + "|" + this.$departureTime.val() + ":00";
            value.departure = {
                "currentYear": departure.currentYear,
                "currentMonth": departure.currentMonth,
                "currentDay": departure.currentDay
            };
        }

        ParkingCalenderField.superClass.setValue.apply(this, [value, true, false]);
    };

    ParkingCalenderField.prototype.initPicker = function () {
        var self = this;
        var calendarSettings = {
            numberOfMonths: 1,
            minDate: '+0d',
            maxDate: '+12m',
            onSelect: function onSelect(dateText, inst) {
                window.$("#" + this.id.replace('parking-calendar', 'parking-date')).val(dateText);
                var option = this.id.indexOf("from") > -1 ? "minDate" : "maxDate",
                    instance = window.$(this).data("datepicker"),
                    date = window.$.datepicker.parseDate(instance.settings.dateFormat || window.$.datepicker._defaults.dateFormat, dateText, instance.settings);
                window.$('.parking-calendar').not(this).datepicker("option", option, date);
            }
        };

        if (window.$) {
            this.formWidget.registerFormCallback("onRender", function () {

                window.$(function () {
                    self.$calendarFrom = window.$('#parking-calendar-from').datepicker(calendarSettings);
                    self.$calendarTo = window.$('#parking-calendar-to').datepicker(calendarSettings);

                    self.$arrival.val(self.$calendarFrom.val());
                    self.$arrival.addClass('is-active');

                    self.$departure.on('focus', function (evt) {
                        self.$calendarTo.removeClass('hidden');
                        self.$calendarFrom.addClass('hidden');
                        $(this).addClass('is-active');
                        self.$arrival.removeClass('is-active');
                    });

                    self.$arrival.on('focus', function (evt) {
                        self.$calendarFrom.removeClass('hidden');
                        self.$calendarTo.addClass('hidden');
                        $(this).addClass('is-active');
                        self.$departure.removeClass('is-active');
                    });
                });
            });
        }

    };

    // Make available the field type globally
    window.pinuts.fields.ParkingCalenderField = ParkingCalenderField;

    return ParkingCalenderField;
});

pirequire.define('fields/PasswordFieldFmg', [
    'jquery',
    'lib/OO',
    'fields/PasswordField',
    "lib/Helper"
], function loadPasswordFieldFmg($, OO, PasswordField, Helper) {

    /**
     * A field containing a input with type text
     *
     * @constructor
     */
    function PasswordFieldFmg() {
        PasswordFieldFmg.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(PasswordFieldFmg, PasswordField);

    PasswordFieldFmg.prototype.onChange = function (event) {
        var elementId = this.elementId;
        var name = this.name;
        var value = ($(event.target).val()).trim();
        
        this.value = this.value || {};

        if ($(event.target).attr("id") === this.elementId + "_2") {
            name += "_2";
            this.value.pw2 = value;
        } else {
            this.value.pw1 = value;
        }

        this.element.find("div[data-pi-id=" + name + "]").addClass('changed');

        if (this.value.pw1 && this.value.pw2 && !this.validate()) {
            Helper.setValueByPath(this.values, this.name + "_2", this.value.pw2);
            Helper.setValueByPath(this.values, this.name, this.value.pw1);

            if (window.pinuts.formIsEditClass[this.designSet]) {
                this.element.find('.pi-form-status').attr('class', window.pinuts.formIsEditClass[this.designSet]);//FIXME need this?
            }
        }
    };


    // Make available the field type globally
    window.pinuts.fields.PasswordField = PasswordFieldFmg;

    return PasswordFieldFmg;
});
pirequire.define('fields/Phone3Field', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadSliderField($, OO, Field) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function Phone3Field() {
        Phone3Field.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(Phone3Field, Field);

    Phone3Field.prototype.setConfig = function (config) {//jshint ignore:line
       Phone3Field.superClass.setConfig.apply(this, arguments);
       this.mandatory = (this.attributes.mandatory === 'yes' || this.attributes.mandatory === true);
       this.options = [];
       var t;
       if (this.attributes.countries) {
           for (var idx in this.attributes.countries) {
               t = this.attributes.countries[idx].value.split(";");
               this.options.push({name: t[0].trim(), label: (t[1]) ? t[1].trim() : t[0].trim()});
           }
       }

       this.validation = this.validation || [];
       this.validation.push(["isphone3", {showMessageInline: true}]);

       if (this.mandatory) {
           this.validation.push("notempty");
       }

       //das change event wird von muc blockiert
       var self = this;
       this.formWidget.registerFormCallback("onSubmit", function() {
           self.setValue($("#" + self.elementId).val(), true);
       });
   };

    Phone3Field.prototype.setValue = function(inValue, propagate, noValidate) {
        if (inValue && inValue.match(/^[+0-9]*-[0-9()]*-[-+\/0-9()]*$/)) {//set by init
            var t = inValue.split("-");
            this.valueCountry = t[0];
            this.valueCity = t[1];
            this.valuePhone = t[2];
        } else {
            this.valueCountry = $("#" + this.elementId + "-country").val();
            this.valueCity = $("#" + this.elementId + "-city").val();
            this.valuePhone = $("#" + this.elementId + "-phone").val();
        }

        var value = (this.valueCountry && this.valueCity && this.valuePhone) ? this.valueCountry + "-" + this.valueCity + "-" + this.valuePhone : null;

        Phone3Field.superClass.setValue.apply(this, [value, propagate, noValidate]);
    };

    // Make available the field type globally
    window.pinuts.fields.Phone3Field = Phone3Field;

    return Phone3Field;
});

pirequire.define('fields/RangeSliderField', [
    'jquery',
    'lib/OO',
    'fields/BaseSliderField',
], function loadRangeSliderField($, OO, BaseSliderField) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function RangeSliderField() {
        RangeSliderField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(RangeSliderField, BaseSliderField);

    RangeSliderField.prototype.setValue = function (value, propagate, noValidate) {
        if (value && (this.attributes.isTime === "yes" || this.attributes.isTime === true)) {
            //slider works with seconds, we want time hh:mm
            var t = value.split(",");
            var timeValue = this.convertMinutesToTime(t[0].trim());
            if (t[1]) timeValue += "," + this.convertMinutesToTime(t[1].trim());
            value = timeValue;
        }

        RangeSliderField.superClass.setValue.apply(this, [value, propagate, noValidate]);
    };

    // Make available the field type globally
    window.pinuts.fields.RangeSliderField = RangeSliderField;

    return RangeSliderField;
});

pirequire.define('fields/SelectFieldFmg', [
    'jquery',
    'lib/OO',
    'fields/SelectField',
], function loadSelectFieldFmg($, OO, SelectField) {

    function SelectFieldFmg() {
        SelectFieldFmg.superConstructor.apply(this, arguments);
    }
    
    OO.extend(SelectFieldFmg, SelectField);
    
    SelectFieldFmg.prototype.setConfig = function(config) {
        SelectFieldFmg.superClass.setConfig.apply(this, arguments);

        //das change event wird von muc blockiert        
        var self = this;
        this.formWidget.registerFormCallback("onSubmit", function() {
            self.setValue($("#" + self.elementId).val(), true, true);
        });
    };

    // Make available the field type globally
    window.pinuts.fields.SelectField = SelectFieldFmg;

    return SelectField;
});
pirequire.define('fields/SliderField', [
    'jquery',
    'lib/OO',
    'fields/BaseSliderField'
], function loadSliderField($, OO, BaseSliderField) {

    /**
     * A field containing a input with type text
     * invariant: this.value is alwasy in proper UM date format: yyyy-mm-dd
     *
     * @constructor
     */
    function SliderField() {
        SliderField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(SliderField, BaseSliderField);


    SliderField.prototype.setValue = function(value, propagate, noValidate) {
        if (value && (this.attributes.isTime === "yes" || this.attributes.isTime === true)) {
            //slider works with seconds, we want time hh:mm
            value = this.convertMinutesToTime(value);
        }

        SliderField.superClass.setValue.apply(this, [value, propagate, noValidate]);
    };


    // Make available the field type globally
    window.pinuts.fields.SliderField = SliderField;

    return SliderField;
});

pirequire.define('fields/ToggelField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadToggelField($, OO, Field, Helper) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function ToggelField() {
        ToggelField.superConstructor.apply(this, arguments);        
    }

    // Inherit fields/Field base class
    OO.extend(ToggelField, Field);
    
    ToggelField.prototype.setConfig = function (config) {
       ToggelField.superClass.setConfig.apply(this, arguments);
        this.cast = 'boolean';                   
   };
   
   /**
    * Set value for field when it changes. This propagates to form values object
    *
    * @param event {object} JavaScript event object
    */
   ToggelField.prototype.onChange = function(event) {
       this.element.addClass('changed');      
       this.setValue($(event.target).is(':checked'), true);                  
   };

    // Make available the field type globally
    window.pinuts.fields.ToggelField = ToggelField;

    return ToggelField;
});
pirequire.define('fields/UploadValidationDateField', [
    'jquery',
    'lib/OO',
    'fields/Field'
], function loadUploadValidationDateField($, OO, Field) {

    /**
     * A field containing a input with type checkbox
     *
     * @constructor
     */
    function UploadValidationDateField() {
        UploadValidationDateField.superConstructor.apply(this, arguments);
    }

    // Inherit fields/Field base class
    OO.extend(UploadValidationDateField, Field);
              
    UploadValidationDateField.prototype.setConfig = function() {
        UploadValidationDateField.superClass.setConfig.apply(this, arguments);

        this.month = this.formWidget.upload_validationdate.month;
        this.year = this.formWidget.upload_validationdate.year;
        this.selectedMonth = false;
        this.selectedYear = false;
    };

    UploadValidationDateField.prototype.render = function() {
        this.element = UploadValidationDateField.superClass.render.apply(this, arguments);
        var self = this;

        this.formWidget.registerFormCallback("onSubmit", function() {
            self.setValueAndValidate();
        });

        this.formWidget.registerFormCallback("onRender", function() {
            var countertx = 0;
            var itx = window.setInterval(function() {
                if (window.$j) {
                    window.$j(document).on("selectChange", function(e, select) {

                        var monthId = self.elementId + "-month";
                        var yearId = self.elementId + "-year";

                        if ($(select).attr('id') === monthId) {
                            self.selectedMonth = true;
                        }

                        if ($(select).attr('id') === yearId) {
                            self.selectedYear = true;
                        }

                        if (!!self.selectedMonth && !!self.selectedYear && ($(select).attr('id') === monthId || $(select).attr('id') === yearId)) {
                            self.setValueAndValidate();
                        }
                    });
                    window.clearInterval(itx);
                }

                if (countertx++ >= 100) {
                    console.error("window.$j missing!");
                    window.clearInterval(itx);
                }
            }, 150);
        });

        return this.element;
    };

    UploadValidationDateField.prototype.setValueAndValidate = function() {
        var month = this.element.find('select[id="' + this.elementId + '-month"]').val();
        var year = this.element.find('select[id="' + this.elementId + '-year"]').val();

        this.value = this.value || {};
        this.value.month = month;
        this.value.year = year;

        this.validate();

        UploadValidationDateField.superClass.setValue.apply(this, [this.value, true, false]);
    };
        

    // Make available the field type globally
    window.pinuts.fields.UploadValidationDateField = UploadValidationDateField;

    return UploadValidationDateField;
});

pirequire.define('ChangePassword', [
    'jquery',
    'lib/OO',
    'FormWidget'
], function loadChangePassword($, OO, FormWidget) {

    function ChangePassword(config) {
        ChangePassword.superConstructor.apply(this, arguments);

        this.readUrlParams();
        this.token = this.urlParams.c || null;

        this.captions.messages = this.captions.messages || {};
        this.captions.form = this.captions.form || {};
        if (this.token) {
            this.attributes = this.attributesChange;
            this.captions.form.heading = this.captions.passwordChange.formTitle;
            this.captions.form.submitBtn = this.captions.passwordChange.submitButton;
            this.captions.messages.messageChanged = this.captions.passwordChange.messageChanged;                        
            this.messageForm = this.captions.passwordChange.messageForm;
            this.values.id = this.token;
            this.submitMethod = "PUT";
            this.checkToken();
            this.registerFormCallback("onFormReturn", function(ctx) {
                if (ctx.response && ctx.response.redirect) {
                    window.location = ctx.response.redirect;
                }  
            });
        } else {
            this.attributes = this.attributesRequest;
            this.captions.form.heading = this.captions.passwordRequest.formTitle;
            this.captions.form.submitBtn = this.captions.passwordRequest.submitButton;
            this.captions.messages.messageSend = this.captions.passwordRequest.messageSend;
            this.messageForm = this.captions.passwordRequest.messageForm;
        }

        this.captions.errors = this.captions.formErrors;
        this.captions.errors.notempty = this.captions.formErrors.mandatory;

        for (var key in this.captions.apiErrors) {
            if (!this.captions.errors[key]) {
                this.captions.errors[key] = this.captions.apiErrors[key];
            }
        }

        //set urls
        this.postUrl = this.controllerUrl + "index";
    }

    OO.extend(ChangePassword, FormWidget);


    /**
     *  Test if cookie is valid
     */
    ChangePassword.prototype.checkToken = function () {
        if (this.token) {
            var data = {
                name: this.addOnName,
                key: this.key,
                id: this.token
            };
            
            var self = this;
            var ajaxOptions = {
                url: this.controllerUrl + "index",
                method: 'GET',
                data: data,
                success: function (response) {
                    if (response.success) {

                    } else {
                        self.hideForm();
                        self.showMessage(self.captions.formErrors.invalidCookie, "errorClass", true);
                        $('.status').attr('class', 'status error');
                        self.enableButtons();
                    }

                }
            };

            this.ajaxCall(ajaxOptions);
        }
    };



    ChangePassword.prototype.render = function () {
        ChangePassword.superClass.render.apply(this);
        this.showMessage(this.messageForm, "", true);
    };

    return ChangePassword;
});
window.pinuts = window.pinuts || {};
window.pinuts.formCallbacks = window.pinuts.formCallbacks || {};
window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform"] = window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform"] || {};

window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform"].onRender = function(ctx) {
    if (window.muc && window.muc.refresh) {
        window.muc.refresh(window.$("#" + ctx.elementId), "initForms");
    }
};

window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform2"] = window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform2"] || {};

window.pinuts.formCallbacks["de.pinuts.cmsbs.contactform2"].onRender = function(ctx) {
    if (window.muc && window.muc.refresh) {
        window.muc.refresh(window.$("#" + ctx.elementId), "initForms");
    }
};

pirequire.require(['lib/OO'], function(OO) {function WidgetValidator() {
    this.error = null;
}

/**
 * Check if a value is valid
 *
 * @param value {*} The value to check
 * @param options {*} Optional options for this validator
 * @param server {boolean} True if the validator is running on server side
 * @param {Object} values All values for cross validation.
 * @param {Object} field field Configuration (server side only)
 * @returns {boolean}
 */
WidgetValidator.prototype.isValid = function (value, options, values, field) {
    //TBI in sub class
};


/**
 * Retrieve triggered error
 *
 * @returns {*}
 */
WidgetValidator.prototype.getError = function () {
    return this.error;
};

/**
 * Register a new validator in available namespace
 *
 * @param {string} name The name of the validator
 * @param {string} validator The validator class
 */
WidgetValidator.register = function (name, validator) {
    // Check if the argument is really a validator
    if (!(validator.prototype instanceof WidgetValidator) && validator.prototype.constructor != WidgetValidator) {
        throw new Error('The given validator is not a instance of \'WidgetValidator\' class');
    }
    // Put validator into server namespace
    if (typeof de !== 'undefined' && de.pinuts) {
        de.pinuts.cmsbs.lib.widget.validators = de.pinuts.cmsbs.lib.widget.validators || {};
        de.pinuts.cmsbs.lib.widget.validators[name] = validator;
    }

    // Put the validator into client namespace
    if (typeof window !== 'undefined') {
        window.pinuts = window.pinuts || {};
        window.pinuts.formvalidators = window.pinuts.formvalidators || {};
        window.pinuts.formvalidators[name] = validator;
    }
};

/**
 * Validate the given value using the given validation
 *
 * @param value {*}
 * @param validation {string|Array}
 * @param {Object} values All values (for cross validation)
 * @param {Object} field field Configuration (server side only)
 * @returns {Array}
 */
WidgetValidator.validate = function(value, validation, values, field, noMandatory) {
    // Loop through validators
    for (var i = 0; i < validation.length; i++) {
        var validator = validation[i];
        var options = null;
        // Get validator and options from array
        if (Array.isArray(validation[i])) {
            validator = validation[i][0];
            options = validation[i][1];
        }

        // Check if the validator is invalid
        var validatorInstance = WidgetValidator.get(validator);
        if (validatorInstance === null) {
            throw new Error('noSuchValidator: ' + validator + ". Check form constrains and don't forget the custom fields.");
        }

        if (noMandatory && field.name !== "email" && typeof validatorInstance.isMandatory === 'function' && validatorInstance.isMandatory(value, options, values, field)) {
            continue;
        }

        if (!validatorInstance.isValid(value, options, values, field)) {
            return [validatorInstance.getError(), options];
        }
    }

    return [false, null];
};

/**
 * Check if the validator make the foed madory
 *
 * @param value {*}
 * @param validation {string|Array}
 * @param {Object} values All values (for cross validation)
 * @param {Object} field field Configuration (server side only)
 * @returns {boolean}
 */
WidgetValidator.isMandatory = function (value, validation, values, field) {
    // Loop through validators
    for (var i = 0; i < validation.length; i++) {
        var validator = validation[i];
        var options = null;
        // Get validator and options from array
        if (Array.isArray(validation[i])) {
            validator = validation[i][0];
            options = validation[i][1];
        }

        // Check if the validator is invalid
        var validatorInstance = WidgetValidator.get(validator);
        if (validatorInstance === null) {
            throw new Error('noSuchValidator: ' + validator + ". Check form constrains and don't forget the custom fields.");
        }

        if (typeof validatorInstance.isMandatory === 'function' && validatorInstance.isMandatory(value, options, values, field)) {
            return true;
        }
    }

    return false;
};

/**
 * Validate a form values by it's given config
 *
 * @param wizard {Array}
 * @param values {Object}
 * @returns {Object}
 */
WidgetValidator.validateServer = function (formConf, values, data, noMandatory) {
    var dependencies = new WidgetDependencies(values, data);
    var errors = {};
    var hiddens = data && data.hiddens;

    function validateFields (attributes) {
        for (var i = 0; i < attributes.length; i++) {
            var field = attributes[i];

            if (field.dependencies && field.dependencies.length && !dependencies.checkDependencies(field)) {
                continue;
            }

            if (hiddens && hiddens.indexOf(field.name) > -1 && field.name !== "email" && field.name.indexOf("captcha") === -1) {
                delete values[field.name];
                continue;
            }

            // Check if current index is a field and have validation
            if (field.name && field.validation && field.type !== "ChtmlField") {//ChtmlField are old and have no validations
                var value = values[field.name];
                // Validate the given value
                var result = WidgetValidator.validate(value, field.validation, values, field, noMandatory);
                if (result && result[0]) {
                    errors[field.name] = [result[0] || "error", result[1]];
                }
            }

            // Check if the field contains other fields
            if (field.fields) {
                validateFields(field.fields);
            }
        }

    }
    validateFields(formConf.attributes);

    return errors;
};

WidgetValidator.instances = {};

/**
 * Retrieve a validator by it's registered name
 *
 * @param name {string} The name the validator is registered with
 */
WidgetValidator.get = function (name) {
    // Check if we have no instance yet
    if (!WidgetValidator.instances[name]) {
        // Create instance from client (window.pinuts) or server (de.pinuts) namespace
        try {
            WidgetValidator.instances[name] = new window.pinuts.formvalidators[name];
        } catch (e) {
            try {
                WidgetValidator.instances[name] = new de.pinuts.cmsbs.lib.widget.validators[name];
            } catch (er) {
                WidgetValidator.instances[name] = null;
            }
        }
    }

    return WidgetValidator.instances[name];
};

// Register the abstract validator class
WidgetValidator.register('WidgetValidator', WidgetValidator);

if (!Array.isArray) {//for IE8 and below
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
};function ArrayValidator() {}

// Inherit abstract Validator class
OO.extend(ArrayValidator, WidgetValidator);

/**
 * Check if the value is an valid array
 * This validator uses other validators to validate the entries
 *
 * @param value {Array}
 * @param validation {Array}
 * @returns {boolean}
 */
ArrayValidator.prototype.isValid = function (value, validation) {
    if (!Array.isArray(value)) {
        this.error = 'notAList';
        return false;
    }
    // If we don't have options or they are no array we can abort here
    if (!validation || !Array.isArray(validation)) {
        return true;
    }
    var isValid = true;
    this.error = {};
    // Loop through items in array and validate each
    for (var i = 0; i < value.length; i++) {
        var error = de.pinuts.cmsbs.lib.widget.Validator.validate(value[i], validation);
        if (error) {
            this.error = {};
            this.error[i] = error;
            isValid = false;
        }
    }
    return isValid;
};

// Register validator
WidgetValidator.register('array', ArrayValidator);;function CaptchaEUValidator() {}

// Inherit abstract Validator class
OO.extend(CaptchaEUValidator, WidgetValidator);

CaptchaEUValidator.prototype.isValid = function (value, options, values, field) {
    var isValid = !!value;

    if (typeof de !== "undefined" && de.pinuts && de.pinuts.cmsbs) {
        isValid = de.pinuts.cmsbs.lib.widget.validateCaptchaEU(value, field);
    }
    // Set error if not valid
    this.error = isValid ? null : 'captchaEU';

    //check if formWidget is defined before calling enableButtons (Newsletter/CF2)
    if (isValid && field.formWidget) {
        field.formWidget.enableButtons()
    };

    return isValid;
};

// Register validator
WidgetValidator.register('captchaEU', CaptchaEUValidator);
;/**
 * This class aims to handle dependencies between fields by comparing there values
 * Fields can have dependency configuration with an Array of dependencies consisting
 * either of strings or arrays. The string describes the name (path) of the required field.
 * If the value is an array the first index will describe the name and the second index describes the required value.
 * Example: ["name.of.field", "name.of.other.field"] or [["name.of.field", "someValue"], "name.of.other.field"]
 *
 * @constructor
 */
function WidgetDependencies(values, data) {
    this.values = values;
    this.data = data;
}

WidgetDependencies.prototype.getValueByPath = function (path) {
    if (!path) {
        return;
    }
    var keys = path.split('.');
    var value = this;
    for (var i = 0; i < keys.length; i++) {
        value = value ? value[keys[i]] : undefined;
    }

    return value;
};

/**
 * Check if the dependencies of a field fulfill the requirements
 * If so the field will be shown or hidden
 *
 * @param field {fields/Field} The field to check
 */
WidgetDependencies.prototype.checkDependencies = function (field) {

    var showElement = false;
    for (var i = 0; i < field.dependencies.length; i++) {
        var dependency = field.dependencies[i];
        var requiredValue = undefined;
        // Get required value if set
        if (Array.isArray(field.dependencies[i])) {
            dependency = field.dependencies[i][0];
            requiredValue = field.dependencies[i][1];
        }
        var newValue = this.getValueByPath(dependency);

        // Check if we have to validate a value
        if (requiredValue !== undefined) {
            // Compare required with actual value
            if (requiredValue == newValue ||
                (Array.isArray(newValue) && newValue.indexOf(requiredValue) > -1) ||
                (typeof newValue === "object" && newValue && newValue[requiredValue])) {
                showElement = true;
            }
            // We don't need to continue dependency checks because one is not fulfilled
            else {
                showElement = false;
                break;
            }
        }
        // No specific value is expected so check if the value is truthy
        // Truthy means non empty array/object, a number, true or non empty string
        else if (newValue !== null && typeof newValue === 'object' ? Object.keys(newValue).length : typeof newValue === 'number' || newValue) {
            showElement = true;
        } else {
            showElement = false;
            break;
        }
    }

    return showElement;
};;function EmailConfirmValidator() {}

// Inherit abstract Validator class
OO.extend(EmailConfirmValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param pattern {string}
 * @returns {boolean}
 */
EmailConfirmValidator.prototype.isValid = function (value, options, values, field) {

    if (typeof de !== "undefined" && de.pinuts &&  de.pinuts.cmsbs) {
        // server side validation
        if (value !== values[field.id + '-confirm']) {
            this.error = 'emailconfirm';
            return false;
        }
    }

    // no client side validation

    return true;
};

// Register validator -> lowercase name of the class
WidgetValidator.register('emailconfirm', EmailConfirmValidator);;function FriendlyCaptchaValidator() {}

// Inherit abstract Validator class
OO.extend(FriendlyCaptchaValidator, WidgetValidator);


FriendlyCaptchaValidator.prototype.isValid = function (value, options, values, field) {
    var isValid = !!value;
    if (typeof de !== "undefined" && de.pinuts &&  de.pinuts.cmsbs) {
        isValid = de.pinuts.cmsbs.lib.widget.validateFriendlyCaptcha(value, field);
    }
    // Set error if not valid
    if (!isValid) {
        this.error = 'friendlycaptcha';
    }
    return isValid;
};

// Register validator
WidgetValidator.register('friendlycaptcha', FriendlyCaptchaValidator);
;function IsDateValidator() {}

// Inherit abstract Validator class
OO.extend(IsDateValidator, WidgetValidator);


/**
 *
 * @param year
 * @param month 0 for January to 11 for December.
 * @param day
 * @return {boolean}
 */
IsDateValidator.prototype.validateDaysInMonth = function(ts) {
    var date = ts.substr(0, 10).split("-");
    var year = parseInt(date[0], 10);
    //0 for January to 11 for December.
    var month = parseInt(date[1], 10) - 1;
    var day = parseInt(date[2], 10);

    return (1 <= day && day <= 31 && (new Date(year, month, day)).getMonth() === month)
};

IsDateValidator.prototype.validateTime = function(ts) {
    var time = ts.substr(11).split(":");
    if (time.length !== 3) return true; //no time is valid time

    var hours = parseInt(time[0], 10);
    var min = parseInt(time[1], 10);
    var sec = (time[2]) ?  parseInt(time[2], 10) : 0;

    return (0 <=  hours && hours < 24 &&  0 <= min && min < 60 && 0 <= sec && sec < 60);
};

IsDateValidator.prototype.validateSyntax = function(value) {
    var regexDate = new RegExp("^\\d\\d\\d\\d-\\d{1,2}-\\d{1,2}$");
    var regexTime = new RegExp("^\\d\\d\\d\\d-\\d{1,2}-\\d{1,2}\\|\\d\\d:\\d\\d:\\d\\d$");
    return (regexDate.test(value) || regexTime.test(value));
};

/**
 * test if value is a valid UM Date
 *
 * @param value {string}
 * @param pattern {string}
 * @returns {boolean}
 */
IsDateValidator.prototype.isValid = function (value) {
    var valid = true;
    try {
      if (value && (!this.validateSyntax(value) || !this.validateDaysInMonth(value) || !this.validateTime(value))) {
          valid = false
      }
    } catch (e) {
        valid = false;
    }

    if (!valid) this.error = 'isdate';

    return valid;

};

// Register validator
WidgetValidator.register('isdate', IsDateValidator);

;function IsEmailValidator() {}

// Inherit abstract Validator class
OO.extend(IsEmailValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param pattern {string}
 * @returns {boolean}
 */
IsEmailValidator.prototype.isValid = function (value, options) {
    //var regex = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
    //var regex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    //var regex = /^\S+@\S+$/;
    var regex = /^[^öäüßÖÄÜ\s]+@\S+$/; // UM-573 EMail Adressen sollte keine Umlaute erlauben
    if (!value || regex.test(value)) {
        return true;
    } else {
        options = options || {};
        this.error = options.errorCode || 'isemail';
        return false;
    }
};

// Register validator
WidgetValidator.register('isemail', IsEmailValidator);
;function IsGreaterThanValidator() {}

// Inherit abstract Validator class
OO.extend(IsGreaterThanValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param IsGreaterThan {string}
 * @returns {boolean}
 */
IsGreaterThanValidator.prototype.isValid = function (value, options, values, field) {
    let error;
    let compVal;

    if (options.value && field.validator.isgreaterthanvalue && field.validator.isgreaterthanvalue.option === options.value) {
        error ='isgreaterthanvalue';
        compVal = parseInt(values[options.value]);
    } else {
        error ='isgreaterthan';
        compVal = parseInt(options.value);
    }

    if (!value || parseInt(value) > compVal) {
        return true;
    } else {
        this.error = options.errorCode || error;
        return false;
    }
};

// Register validator
WidgetValidator.register('isgreaterthan', IsGreaterThanValidator);
WidgetValidator.register('isgreaterthanvalue', IsGreaterThanValidator);;function IsLessThanValidator() {}

// Inherit abstract Validator class
OO.extend(IsLessThanValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param IsLessThan {string}
 * @returns {boolean}
 */
IsLessThanValidator.prototype.isValid = function (value, options, values, field) {
    let error;
    let compVal;

    if (options.value && field.validator.islessthanvalue && field.validator.islessthanvalue.option === options.value) {
        error ='islessthanvalue';
        compVal = parseInt(values[options.value]);
    } else {
        error ='islessthan';
        compVal = parseInt(options.value);
    }

    if (!value || parseInt(value) < compVal) {
        return true;
    } else {
        this.error = options.errorCode || error;
        return false;
    }
};

// Register validator
WidgetValidator.register('islessthan', IsLessThanValidator);
WidgetValidator.register('islessthanvalue', IsLessThanValidator);;function IsMobileValidator() {}

// Inherit abstract Validator class
OO.extend(IsMobileValidator, WidgetValidator);

/**
 * test if value is a valid UM Date
 *
 * @param value {string}
 * @param pattern {string}
 * @returns {boolean}
 */
IsMobileValidator.prototype.isValid = function (value) {    
    if (!value) {
        return true;
    }
    
    value = (value+"").trim();
    var numbers = value.replace(/\D/g,'');
    var regexPhone = /^\s*[\d\s-\(\)+\/]*\s*$/;   
    if (value === "" || (regexPhone.test(value) && numbers.length <= 15)) {        
        return true;
    } else {
        this.error = 'ismobile';
        return false;
    }
};

// Register validator
WidgetValidator.register('ismobile', IsMobileValidator);
;function IsPhoneValidator() {}

// Inherit abstract Validator class
OO.extend(IsPhoneValidator, WidgetValidator);

/**
 * test if value is a valid UM Date
 *
 * @param value {string}
 * @param pattern {string}
 * @returns {boolean}
 */
IsPhoneValidator.prototype.isValid = function (value) {
    return true;//FIXME richitg?
//    var regexPhone = /^\s*[\d\s-\(\)+\/]*\s*$/;     
//    if (!value || regexPhone.test(value)) {
//        return true;
//    } else {
//        this.error = 'isphone';
//        return false;
//    }
};

// Register validator
WidgetValidator.register('isphone', IsPhoneValidator);
;function MandatoryIfValidator() {
}

// Inherit abstract Validator class
OO.extend(MandatoryIfValidator, WidgetValidator);



MandatoryIfValidator.prototype.hasValue = function (value) {
    switch (typeof value) {
        case 'string':
            return !!value;
        case 'object':
            if (Array.isArray(value)) return !!value.length
            else return !!(value && Object.keys(value).length);
        case 'number':
            return !isNaN(value);
            break;
        case 'undefined':
            return false;
        case 'boolean':
            return value;
    }
};

/**
 * @param {string} value
 * @param {object} options
 * @returns {boolean}
 */
MandatoryIfValidator.prototype.isValid = function (value, options, values) {
    this.error = null;

    if (options.attrval) {
        var compVal = values[options.attrval];
        if (!this.hasValue(value) && (options.value == compVal ||
                (Array.isArray(compVal) && compVal.indexOf(options.value) > -1) ||
                (typeof compVal === "object" && compVal && compVal[options.value]))) {
            this.error = 'mandatoryifvalue';
            return false;
        }
    } else if (this.hasValue(values[options.value]) && !this.hasValue(value)) {
        this.error = 'mandatoryif';
        return false;
    }

    return true;
};


MandatoryIfValidator.prototype.isMandatory = function (value, options, values) {
    if (options.attrval) {
        var compVal = values[options.attrval];
        if ((options.value == compVal ||
                (Array.isArray(compVal) && compVal.indexOf(options.value) > -1) ||
                (typeof compVal === "object" && compVal && compVal[options.value]))) {
            return true;
        }
    } else if (this.hasValue(values[options.value])) {
        return true;
    }

    return false;
};

// Register validator
WidgetValidator.register('mandatoryifvalue', MandatoryIfValidator);
WidgetValidator.register('mandatoryif', MandatoryIfValidator);
;function MaxLengthValidator() {

}

// Inherit abstract Validator class
OO.extend(MaxLengthValidator, WidgetValidator);

/**
 * Validate strings or arrays if the have below n characters or entries
 *
 * @param value {string|Array}
 * @param options {number}
 * @returns {boolean}
 */
MaxLengthValidator.prototype.isValid = function (value, options) {
    // Only objects and strings can have length property
    if (value && (typeof value == 'string' || typeof value == 'object')) {
        // Compare if the length of value in above max length
        // The value can be empty or has to have a maximum length
        if (!value.length || value.length <= options.maxLength) {
            return true;
        } else {
            this.error = 'maxlength';
            return false;
        }
    }
//    this.error = 'noLength';
//    return false;
    //no length to test
    return true;
};

// Register validator
WidgetValidator.register('maxlength', MaxLengthValidator);;function MinLengthValidator() {

}

// Inherit abstract Validator class
OO.extend(MinLengthValidator, WidgetValidator);

/**
 * Validate strings or arrays if the have above n characters or entries
 *
 * @param value {string|Array}
 * @param minLength {number}
 * @returns {boolean}
 */
MinLengthValidator.prototype.isValid = function (value, options) {
    // Only objects and strings can have length property
    if (typeof value == 'string' || typeof value == 'object') {
        // Compare if the length of value in above minimum length
        // The value can be empty or must have a minimum length
        if (!value.length || value.length >= options.minLength) {
            return true;
        } else {
            this.error = 'minlength';
            return false;
        }
    }
    this.error = 'noLength';
    return false;
};

// Register validator
WidgetValidator.register('minlength', MinLengthValidator);;function NotEmptyValidator() {

}

// Inherit abstract Validator class
OO.extend(NotEmptyValidator, WidgetValidator);

/**
 * Check if there is any value
 *
 * @param value {*}
 * @param options {*}
 * @returns {boolean}
 */
NotEmptyValidator.prototype.isValid = function (value, options) {
    var isValid = true;
    switch (typeof value) {
        case 'string':
            isValid = !!value;
            break;
        case 'object':
            isValid = !!(value && Object.keys(value).length);
            break;
        case 'number':
            isValid = !isNaN(value);
            break;
        case 'undefined':
            isValid = false;
            break;
        case 'boolean':
            isValid = value;
            break;
    }
    // Set empty error if not valid
    if (!isValid) {
        this.error = 'notempty';
    }
    return isValid;
};

NotEmptyValidator.prototype.isMandatory = function () {
    return true;
};

// Register validator
WidgetValidator.register('notempty', NotEmptyValidator);
;function NumberValidator() {

}

// Inherit abstract Validator class
OO.extend(NumberValidator, WidgetValidator);

/**
 * Validate if the given value is a number
 *
 * @param value {string|number}
 * @returns {boolean}
 */
NumberValidator.prototype.isValid = function (value) {
    if (isFinite(value)) {
        return true;
    } else {
        this.error = 'notANumber';
        return false;
    }
};

// Register validator
WidgetValidator.register('number', NumberValidator);;function ObjectValidator() {
    this.error = null;
}

// Inherit abstract Validator class
OO.extend(ObjectValidator, WidgetValidator);

/**
 * Check if the value is an valid object
 * This validator uses other validators to validate the properties
 *
 * @param value {object}
 * @param validation {object}
 * @returns {boolean}
 */
ObjectValidator.prototype.isValid = function (value, validation) {
    if (typeof value !== 'object') {
        this.error = 'notAObject';
        return false;
    }
    // If we don't have options or they are no object we can abort here
    if (!validation || typeof validation !== 'object') {
        return true;
    }
    var isValid = true;
    this.error = {};
    // Loop through items in array and validate each
    for (var key in validation) {
        if (!validation.hasOwnProperty(key)) {
            continue;
        }
        // Get property from value object
        var propertyValue = this.getValueByPath(value, key);
        // Validate the property by defined validation
        var error = WidgetValidator.validate(propertyValue, validation[key]);
        if (error) {
            this.error[key] = error;
            isValid = false;
        }
    }
    return isValid;
};

/**
 * This function is exactly the same a in Helper class but it is easier to have a bit redundancy than resolving
 * the problem to get the function on server and client side and all scopes.
 *
 * @param object {object} Object containing the value
 * @param key {string} The property path
 */
ObjectValidator.prototype.getValueByPath = function (object, key) {
    if (!key) {
        return;
    }
    var keys = key.split('.');
    var value = object;
    for (var i = 0; i < keys.length; i++) {
        value = value ? value[keys[i]] : undefined;
    }

    return value;
};

// Register validator
WidgetValidator.register('object', ObjectValidator);;function PasswordEqualValidator() {}

// Inherit abstract Validator class
OO.extend(PasswordEqualValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param pattern {string}
 * @returns {boolean}
 */
PasswordEqualValidator.prototype.isValid = function (value, options, values, field) {
    var isValid;
    if (typeof UM !== "undefined" && typeof de !== "undefined" && de.pinuts &&  de.pinuts.cmsbs) {
        //server
        isValid = values[field.name] === values[field.name + "_2"];
    } else {
        isValid = typeof field.pw1 !== "undefined" && (field.pw1 === field.pw2);
    }

    if (isValid) {
        return true;
    }

    this.error = 'password';
    return false;
};

// Register validator
WidgetValidator.register('passwordequal', PasswordEqualValidator);
;function PatternValidator() {}

// Inherit abstract Validator class
OO.extend(PatternValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 *
 * @param value {string|number}
 * @param pattern {string}
 * @returns {boolean}
 */
PatternValidator.prototype.isValid = function (value, options) {
    var regex = new RegExp(options.pattern);
    if (!value || regex.test(value)) {
        return true;
    } else {
        this.error = options.errorCode || 'patternMismatch';
        return false;
    }
};

// Register validator
WidgetValidator.register('pattern', PatternValidator);;function Pino4Validator() {}

// Inherit abstract Validator class
OO.extend(Pino4Validator, WidgetValidator);


Pino4Validator.prototype.isValid = function (value, options, values, field) {
    var isValid = true;
    if (typeof de !== "undefined" && de.pinuts &&  de.pinuts.cmsbs) { 
        isValid = de.pinuts.cmsbs.lib.widget.pino4Validate(value, values, field);        
    }
    // Set error if not valid
    if (!isValid) {
        this.error = 'pino4';
    }
    return isValid;
};

// Register validator
WidgetValidator.register('pino4', Pino4Validator);

;function ReCaptchaV2Validator() {}

// Inherit abstract Validator class
OO.extend(ReCaptchaV2Validator, WidgetValidator);


ReCaptchaV2Validator.prototype.isValid = function (value, options, values, field) {
    var isValid = !!value;
    if (typeof de !== "undefined" && de.pinuts &&  de.pinuts.cmsbs) {        
        isValid = de.pinuts.cmsbs.lib.widget.validateGoogleReCaptcha(value, field);
    }
    // Set error if not valid
    if (!isValid) {
        this.error = 'recaptchav2';
    }
    return isValid;
};

// Register validator
WidgetValidator.register('recaptchav2', ReCaptchaV2Validator);;function UrlInjectionPreventionValidator() {}

// Inherit abstract Validator class
OO.extend(UrlInjectionPreventionValidator, WidgetValidator);

/**
 * Match the given value against a regular expression
 * JIRA: UM-417 Eingabe von URLs nur f�r spezielle Felder im Formularassistent zulassen
 *
 * @param value {string|number}
 * @param pattern {string}
 * @returns {boolean}
 */
UrlInjectionPreventionValidator.prototype.isValid = function (value, options) {
    var regex = /:\/\/|mailto|www\.\w+|\w\.\w{2,}\//gi;

    if (!value || !regex.test(value)) {

        return true;
    } else {
        options = options || {};
        this.error =  options.errorCode || 'urlinjectionprevention';

        return false;
    }
};

// Register validator
WidgetValidator.register('urlinjectionprevention', UrlInjectionPreventionValidator);
;function ConsentGroupNotempty() {

}

// Inherit abstract Validator class
OO.extend(ConsentGroupNotempty, WidgetValidator);

/**
 * Check if there is any value
 *
 * @param value {*}
 * @returns {boolean}
 */
ConsentGroupNotempty.prototype.isValid = function (value) {
    let isValid = false;

    for (let conset in value) {
       if(value[conset]) {
           isValid = true;
           break;
       }
    }

    // Set empty error if not valid
    if (!isValid) {
        this.error = 'notempty';
    }
    return isValid;
};

ConsentGroupNotempty.prototype.isMandatory = function () {
    return true;
};

// Register validator
WidgetValidator.register('consentGroupNotempty', ConsentGroupNotempty);;function CompareRepeatValueValidator() {}

// Inherit abstract Validator class
OO.extend(CompareRepeatValueValidator, WidgetValidator);

/**
 * Compare the given value with the value from given compare field
 *
 * @param value {string|number} current value to compare
 * @param options {Object} validator conf, must contain compAttr
 * @param values {Object} all set form values
 * @returns {boolean}
 */
CompareRepeatValueValidator.prototype.isValid = function (value, options, values) {
    this.error = null;

    if (!value || !(options.compAttr && values[options.compAttr]) || (options.compAttr && values[options.compAttr] === value)) {
        return true;
    }
    this.error = 'isEqual';
    return false;
};

// Register validator
WidgetValidator.register('comparerepeatvalue', CompareRepeatValueValidator);
;function PasswordValidator() {}

// Inherit abstract Validator class
OO.extend(PasswordValidator, WidgetValidator);

/**
 * Compare the given value with the value from given compare field
 *
 * @param value {string|number} current value to compare
 * @param options {Object} validator conf, must contain compAttr
 * @param values {Object} all set form values
 * @returns {boolean}
 */
PasswordValidator.prototype.isValid = function(value, options, values) {
    var ok = true;
    this.error = null;
    value = value + "";
    if (value.length < options.minLength) {
        ok = false;
    }

    if (options.pwUppercase && !value.match(/[A-Z]/)) {
        ok = false;
    }

    if (options.pwNumber && !value.match(/\d/)) {
        ok = false;
    }

    if (options.pwSpecialSign && !value.match(/[#+?=!$%&*_.:;'"()-]/)) {
        ok = false;
    }

    if (!ok) {
        this.error = 'password';
    }

    if (typeof UM !== 'undefined' && typeof de !== "undefined" && de.pinuts && de.pinuts.cmsbs && de.pinuts.cmsbs.changepassword.PasswordStrength) {
        const errorMsg = de.pinuts.cmsbs.changepassword.PasswordStrength.validateValue(value, options.locale);
        if (errorMsg) {
            this.error = errorMsg;

            ok = false;
        }
    }

    return ok;
};

// Register validator
WidgetValidator.register('password', PasswordValidator);

;function IsValidUploadValidationDateValidator() {}

// Inherit abstract Validator class
OO.extend(IsValidUploadValidationDateValidator, WidgetValidator);

/**
 * Compare the given value with the value from given compare field
 *
 * @param value {string|number} current value to compare
 * @param options {Object} validator conf, must contain compAttr
 * @param values {Object} all set form values
 * @returns {boolean}
 */
IsValidUploadValidationDateValidator.prototype.isValid = function(value) {
    var ok = true;
    this.error = null;

    if (!value || !value.year || !value.month) {
        this.error = 'notempty';
        return false;
    }

    var now = new Date();
    var selectedDate = new Date(value.year, value.month-1, 1, 0, 0, 0, 0);

    if (selectedDate.getTime() <= now.getTime()) {
        this.error = 'dateInFuture';
        return false;
    }

    return ok;
}

// Register validator
WidgetValidator.register('isvaliduploadvalidationdate', IsValidUploadValidationDateValidator);
;function ParkingDateRangeValidator() {}

// Inherit abstract Validator class
OO.extend(ParkingDateRangeValidator, WidgetValidator);

/**
 * test if value is a valid UM Date
 *
 * @param value {string}
 * @param pattern {string}
 * @returns {boolean}
 */
ParkingDateRangeValidator.prototype.isValid = function (value) {

    if (value && value.parking_start && value.parking_end) {

        var now = new Date();
        var arrival = value.arrival;
        var departure = value.departure;
        var arrivalTime = value.arrival_time.split(':');
        var departureTime = value.departure_time.split(':');
        var start = new Date(arrival.currentYear, arrival.currentMonth, arrival.currentDay, arrivalTime[0], arrivalTime[1], 0);
        var end = new Date(departure.currentYear, departure.currentMonth, departure.currentDay, departureTime[0], departureTime[1], 0);

        var diffStartNow = start.getTime() - now.getTime();
        if (diffStartNow/1000/60/60 < 1) {
            this.error = 'parkingDateRange.timespan';
            return false;
        }

        var diffStartEnd = end.getTime() - start.getTime();
        if (diffStartEnd/1000/60/60 <= 0) {
            this.error = 'parkingDateRange.time_paradox';
            return false;
        }
        return true;

    } else {
        if (!value) this.error = 'parkingDateRange.values';
        else if (!value.parking_start) this.error = 'parkingDateRange.arrival';
        else this.error = 'parkingDateRange.departure';

        return false;
    }
};

// Register validator
WidgetValidator.register('parkingdaterange', ParkingDateRangeValidator);;function IsPhone3Validator() {}

// Inherit abstract Validator class
OO.extend(IsPhone3Validator, WidgetValidator);

/**
 * test if value is a valid UM Date
 *
 * @param value {string}
 * @param pattern {string}
 * @returns {boolean}
 */
IsPhone3Validator.prototype.isValid = function (value) {
   var regexPhone = /^[+0-9]*-[0-9()]*-[-+\/0-9()]*$/;     
   if (!value || regexPhone.test(value)) {
       return true;
   } else {
       this.error = 'isphone3';
       return false;
   }
};

// Register validator
WidgetValidator.register('isphone3', IsPhone3Validator);;function IsValidFmgMaxDate() {}

// Inherit abstract Validator class
OO.extend(IsValidFmgMaxDate, WidgetValidator);

/**
 * Check maxDate set for Datepicker
 *
 * @param value {string}
 * @param options {object}
 * @returns {boolean}
 */
IsValidFmgMaxDate.prototype.isValid = function (value, options) {
    // console.log('---------------------------------');
    // console.log(value);
    // console.log(options);
    let diff = parseInt(options.value);

    if (isNaN(diff)) {
        diff = 0;
    }

    let valueDate = new Date(value);
    valueDate.setHours(0,0,0,0);

    let maxDate = new Date(new Date().toString());
    maxDate.setDate(maxDate.getDate() + diff);
    maxDate.setHours(0,0,0,0);
    // console.log(diff);
    // console.log(valueDate.toString());
    // console.log(maxDate.toString());
    // console.log(diff !== 0);
    // console.log(valueDate > maxDate);
    if(diff !== 0 && (valueDate > maxDate)) {
        this.error = 'fmgMaxDate';
        return false;
    }

    return true;
};

// Register validator
WidgetValidator.register('fmgMaxDate', IsValidFmgMaxDate);
;function IsValidFmgMinDate() {}

// Inherit abstract Validator class
OO.extend(IsValidFmgMinDate, WidgetValidator);

/**
 * Check minDate set for Datepicker
 *
 * @param value {string}
 * @param options {object}
 * @returns {boolean}
 */
IsValidFmgMinDate.prototype.isValid = function (value, options) {
    // console.log('---------------------------------');
    // console.log(value);
    // console.log(options);
    let diff = parseInt(options.value);

    if (isNaN(diff)) {
        diff = 0;
    }

    if(diff > 0) {
        diff = diff * -1;
    }

    let valueDate = new Date(value);
    valueDate.setHours(0,0,0,0);

    let minDate = new Date(new Date().toString());
    minDate.setDate(minDate.getDate() + diff);
    minDate.setHours(0,0,0,0);

    // console.log(diff);
    // console.log(valueDate.toString());
    // console.log(minDate.toString());
    // console.log(diff !== 0);
    // console.log(valueDate < minDate);
    if(diff !== 0 && (valueDate < minDate)) {
        this.error = 'fmgMinDate';
        return false;
    }

    return true;
};

// Register validator
WidgetValidator.register('fmgMinDate', IsValidFmgMinDate);
;function IsValidPasswordValidator() {}

// Inherit abstract Validator class
OO.extend(IsValidPasswordValidator, WidgetValidator);

/**
 * Compare the given value with the value from given compare field
 *
 * @param value {string|number} current value to compare
 * @param options {Object} validator conf, must contain compAttr
 * @param values {Object} all set form values
 * @returns {boolean}
 */
IsValidPasswordValidator.prototype.isValid = function(value, options, values) {
    var ok = true;
    this.error = null;

    if (!value || !value.pw1 || !value.pw2) {
        this.error = 'pwNotEmpty';
        return false;
    }

    if (value.pw1 !== value.pw2) {
        this.error = 'pwEqual';
        return false;
    }

    if (value.pw1.length < options.minLength) {
        ok = false;
    }
    
    if (options.pwUppercase && !value.pw1.match(/[A-Z]/)) {
        ok = false;
    }
    
    if (options.pwNumber && !value.pw1.match(/\d/)) {
        ok = false;
    }
    
    if (options.pwSpecialSign && !value.pw1.match(/[#+?=!$%&*_.:()-]/)) {
        ok = false;
    }

    if (!ok) { 
        this.error = 'pwRules'; 
    }

    return ok;
}

// Register validator
WidgetValidator.register('isvalidpassword', IsValidPasswordValidator);
;
});window.pirequire = pirequire;window.pinuts.piForm = PiLib;})();